/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.9.0 (NJsonSchema v10.6.8.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

import { UserStore, LoadingSpinnerService } from "@/store";
import router, { ROUTES } from "@/router";
export default class ApiClientBase {
  protected transformOptions(options: RequestInit) {
    var token = UserStore.getJWT;
    var headers = options.headers as { [key: string]: string };

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    return Promise.resolve(options);
  }

  protected async transformResult(
    url: string,
    response: Response,
    processor: (response: Response) => any,
    options: RequestInit
  ) {
    if (response.status === 401) {
      if (response.headers.get("refresh-token-expired")) {
        if (UserStore.refreshTokenMatches(options)) {
          return this.sessionExpired();
        }
      } else if (response.headers.get("token-expired")) {
        // Attempt to refresh token
        try {
          await UserStore.RefreshAuthToken();
          const transformedOptions_ = await this.transformOptions(options);
          const newResponse = await fetch(url, transformedOptions_);
          return processor(newResponse);
        } catch (e) {
          return this.sessionExpired();
        }
      } else {
        return this.sessionExpired();
      }
    } else {
      UserStore.RefreshSessionTimer();
      return processor(response);
    }
  }

  private sessionExpired() {
    LoadingSpinnerService.Hide();
    return router.push({ name: ROUTES.sessionTimeout }).catch(err => {});
  }
}

export class ClientPortalApiClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
      super();
      this.http = http ? http : <any>window;
       this.baseUrl = baseUrl ? baseUrl : "http://localhost:55197";
    //   this.baseUrl =  "http://localhost:55197";
  }

  depositAccounts_Policies(): Promise<DepositAccountsDto[]> {
      let url_ = this.baseUrl + "/api/DepositAccounts";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "POST",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processDepositAccounts_Policies(_response), options_);
      });
  }

  protected processDepositAccounts_Policies(response: Response): Promise<DepositAccountsDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(DepositAccountsDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<DepositAccountsDto[]>(null as any);
  }

  benefits_Policies(policyID: number | undefined): Promise<PolicyBenefitGroupDto[]> {
      let url_ = this.baseUrl + "/api/Benefits?";
      if (policyID === null)
          throw new Error("The parameter 'policyID' cannot be null.");
      else if (policyID !== undefined)
          url_ += "policyID=" + encodeURIComponent("" + policyID) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "POST",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBenefits_Policies(_response), options_);
      });
  }

  protected processBenefits_Policies(response: Response): Promise<PolicyBenefitGroupDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyBenefitGroupDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyBenefitGroupDto[]>(null as any);
  }

  funds_GetFunds(contactId: number, policyId: number): Promise<PolicyFundDto[]> {
      let url_ = this.baseUrl + "/api/Profile/{contactId}/Policies/{policyId}/Funds";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (policyId === undefined || policyId === null)
          throw new Error("The parameter 'policyId' must be defined.");
      url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFunds_GetFunds(_response), options_);
      });
  }

  protected processFunds_GetFunds(response: Response): Promise<PolicyFundDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyFundDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyFundDto[]>(null as any);
  }

  funds_GetFundManagerMix(contactId: number, clientSelector: ClientSelector, typeId: number): Promise<{ [key: string]: number; }> {
      let url_ = this.baseUrl + "/api/Funds/chartdata/fundManangerMix/{contactId}/{clientSelector}/{typeId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (clientSelector === undefined || clientSelector === null)
          throw new Error("The parameter 'clientSelector' must be defined.");
      url_ = url_.replace("{clientSelector}", encodeURIComponent("" + clientSelector));
      if (typeId === undefined || typeId === null)
          throw new Error("The parameter 'typeId' must be defined.");
      url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFunds_GetFundManagerMix(_response), options_);
      });
  }

  protected processFunds_GetFundManagerMix(response: Response): Promise<{ [key: string]: number; }> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200) {
              result200 = {} as any;
              for (let key in resultData200) {
                  if (resultData200.hasOwnProperty(key))
                      (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
              }
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<{ [key: string]: number; }>(null as any);
  }

  funds_GetFundMix(contactId: number, policyId: number, typeId: number): Promise<{ [key: string]: number; }> {
      let url_ = this.baseUrl + "/api/Funds/chartdata/fundMix/{contactId}/{policyId}/{typeId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (policyId === undefined || policyId === null)
          throw new Error("The parameter 'policyId' must be defined.");
      url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
      if (typeId === undefined || typeId === null)
          throw new Error("The parameter 'typeId' must be defined.");
      url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFunds_GetFundMix(_response), options_);
      });
  }

  protected processFunds_GetFundMix(response: Response): Promise<{ [key: string]: number; }> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200) {
              result200 = {} as any;
              for (let key in resultData200) {
                  if (resultData200.hasOwnProperty(key))
                      (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
              }
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<{ [key: string]: number; }>(null as any);
  }

  funds_GetPortfolioPerformance(contactId: number, clientSelector: ClientSelector, typeId: number): Promise<{ [key: string]: number; }> {
      let url_ = this.baseUrl + "/api/Funds/chartdata/portfolioPerformance/{contactId}/{clientSelector}/{typeId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (clientSelector === undefined || clientSelector === null)
          throw new Error("The parameter 'clientSelector' must be defined.");
      url_ = url_.replace("{clientSelector}", encodeURIComponent("" + clientSelector));
      if (typeId === undefined || typeId === null)
          throw new Error("The parameter 'typeId' must be defined.");
      url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFunds_GetPortfolioPerformance(_response), options_);
      });
  }

  protected processFunds_GetPortfolioPerformance(response: Response): Promise<{ [key: string]: number; }> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200) {
              result200 = {} as any;
              for (let key in resultData200) {
                  if (resultData200.hasOwnProperty(key))
                      (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
              }
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<{ [key: string]: number; }>(null as any);
  }

  funds_GetFundPerformance(contactId: number, policyId: number, months: number): Promise<PerformanceChartDataDto> {
      let url_ = this.baseUrl + "/api/Funds/chartdata/fundPerformance/{contactId}/{policyId}/{months}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (policyId === undefined || policyId === null)
          throw new Error("The parameter 'policyId' must be defined.");
      url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
      if (months === undefined || months === null)
          throw new Error("The parameter 'months' must be defined.");
      url_ = url_.replace("{months}", encodeURIComponent("" + months));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFunds_GetFundPerformance(_response), options_);
      });
  }

  protected processFunds_GetFundPerformance(response: Response): Promise<PerformanceChartDataDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PerformanceChartDataDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PerformanceChartDataDto>(null as any);
  }

  funds_GetFundValuePerformance(policyId: number, months: number): Promise<PerformanceChartDataDto> {
      let url_ = this.baseUrl + "/api/Funds/chartdata/fundValuePerformance/{policyId}/{months}";
      if (policyId === undefined || policyId === null)
          throw new Error("The parameter 'policyId' must be defined.");
      url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
      if (months === undefined || months === null)
          throw new Error("The parameter 'months' must be defined.");
      url_ = url_.replace("{months}", encodeURIComponent("" + months));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFunds_GetFundValuePerformance(_response), options_);
      });
  }

  protected processFunds_GetFundValuePerformance(response: Response): Promise<PerformanceChartDataDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PerformanceChartDataDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PerformanceChartDataDto>(null as any);
  }

  funds_GetTotalFundValuePerformance(contactId: number, months: number, typeID: number): Promise<PerformanceChartDataDto> {
      let url_ = this.baseUrl + "/api/Funds/chartdata/fundTotalValuePerformance/{contactId}/{months}/{typeID}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (months === undefined || months === null)
          throw new Error("The parameter 'months' must be defined.");
      url_ = url_.replace("{months}", encodeURIComponent("" + months));
      if (typeID === undefined || typeID === null)
          throw new Error("The parameter 'typeID' must be defined.");
      url_ = url_.replace("{typeID}", encodeURIComponent("" + typeID));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFunds_GetTotalFundValuePerformance(_response), options_);
      });
  }

  protected processFunds_GetTotalFundValuePerformance(response: Response): Promise<PerformanceChartDataDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PerformanceChartDataDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PerformanceChartDataDto>(null as any);
  }

  funds_GetOverallFundValuePerformance(contactId: number, typeID: number): Promise<PerformanceChartDataDto> {
      let url_ = this.baseUrl + "/api/Funds/fundOverallValuePerformance/{contactId}/{typeID}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (typeID === undefined || typeID === null)
          throw new Error("The parameter 'typeID' must be defined.");
      url_ = url_.replace("{typeID}", encodeURIComponent("" + typeID));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFunds_GetOverallFundValuePerformance(_response), options_);
      });
  }

  protected processFunds_GetOverallFundValuePerformance(response: Response): Promise<PerformanceChartDataDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PerformanceChartDataDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PerformanceChartDataDto>(null as any);
  }

  policies_Policies(query: ListByPolicyIdQuery): Promise<PolicyDto[]> {
      let url_ = this.baseUrl + "/api/Policies";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(query);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicies_Policies(_response), options_);
      });
  }

  protected processPolicies_Policies(response: Response): Promise<PolicyDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyDto[]>(null as any);
  }

  policies_GetByContactId(contactId: number): Promise<PolicyDto[]> {
      let url_ = this.baseUrl + "/api/Profile/{contactId}/Policies";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicies_GetByContactId(_response), options_);
      });
  }

  protected processPolicies_GetByContactId(response: Response): Promise<PolicyDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyDto[]>(null as any);
  }

  policies_GetByPolicyId(contactId: number, policyId: number): Promise<PolicyDto> {
      let url_ = this.baseUrl + "/api/Profile/{contactId}/Policies/{policyId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (policyId === undefined || policyId === null)
          throw new Error("The parameter 'policyId' must be defined.");
      url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicies_GetByPolicyId(_response), options_);
      });
  }

  protected processPolicies_GetByPolicyId(response: Response): Promise<PolicyDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PolicyDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyDto>(null as any);
  }

  policies_GetRolesByPolicyId(contactId: number, policyId: number): Promise<PolicyRoleDto[]> {
      let url_ = this.baseUrl + "/api/Profile/{contactId}/Policies/{policyId}/Roles";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (policyId === undefined || policyId === null)
          throw new Error("The parameter 'policyId' must be defined.");
      url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicies_GetRolesByPolicyId(_response), options_);
      });
  }

  protected processPolicies_GetRolesByPolicyId(response: Response): Promise<PolicyRoleDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyRoleDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyRoleDto[]>(null as any);
  }

  policies_GetSummaryCountByContactId(contactId: number): Promise<PolicyCountSummaryDto> {
      let url_ = this.baseUrl + "/api/Profile/{contactId}/Policies/Count";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicies_GetSummaryCountByContactId(_response), options_);
      });
  }

  protected processPolicies_GetSummaryCountByContactId(response: Response): Promise<PolicyCountSummaryDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PolicyCountSummaryDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyCountSummaryDto>(null as any);
  }

  values_Policies(policyID: number | undefined): Promise<PolicyValuesDto[]> {
      let url_ = this.baseUrl + "/api/Values?";
      if (policyID === null)
          throw new Error("The parameter 'policyID' cannot be null.");
      else if (policyID !== undefined)
          url_ += "policyID=" + encodeURIComponent("" + policyID) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "POST",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processValues_Policies(_response), options_);
      });
  }

  protected processValues_Policies(response: Response): Promise<PolicyValuesDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyValuesDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyValuesDto[]>(null as any);
  }

  profile_ContactProfiles(): Promise<ProfileDto[]> {
      let url_ = this.baseUrl + "/api/Profile";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processProfile_ContactProfiles(_response), options_);
      });
  }

  protected processProfile_ContactProfiles(response: Response): Promise<ProfileDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(ProfileDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ProfileDto[]>(null as any);
  }

  profile_getByContactId(contactId: number): Promise<ContactProfileDto> {
      let url_ = this.baseUrl + "/api/Profile/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processProfile_getByContactId(_response), options_);
      });
  }

  protected processProfile_getByContactId(response: Response): Promise<ContactProfileDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContactProfileDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ContactProfileDto>(null as any);
  }

  profile_getByContactOwnerId(contactOwnerId: number): Promise<ContactProfileDto[]> {
      let url_ = this.baseUrl + "/api/Profile/getByContactOwnerId/{contactOwnerId}";
      if (contactOwnerId === undefined || contactOwnerId === null)
          throw new Error("The parameter 'contactOwnerId' must be defined.");
      url_ = url_.replace("{contactOwnerId}", encodeURIComponent("" + contactOwnerId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processProfile_getByContactOwnerId(_response), options_);
      });
  }

  protected processProfile_getByContactOwnerId(response: Response): Promise<ContactProfileDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(ContactProfileDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ContactProfileDto[]>(null as any);
  }

  profile_getByName(name: string | null): Promise<ContactProfileDto[]> {
      let url_ = this.baseUrl + "/api/Profile/getByName/{name}";
      if (name === undefined || name === null)
          throw new Error("The parameter 'name' must be defined.");
      url_ = url_.replace("{name}", encodeURIComponent("" + name));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processProfile_getByName(_response), options_);
      });
  }

  protected processProfile_getByName(response: Response): Promise<ContactProfileDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(ContactProfileDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ContactProfileDto[]>(null as any);
  }

  riskProfile_GetQuestions(): Promise<RiskProfileQuestionDto[]> {
      let url_ = this.baseUrl + "/api/RiskProfile/questions";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processRiskProfile_GetQuestions(_response), options_);
      });
  }

  protected processRiskProfile_GetQuestions(response: Response): Promise<RiskProfileQuestionDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(RiskProfileQuestionDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<RiskProfileQuestionDto[]>(null as any);
  }

  riskProfile_GetContactResponses(contactId: number, clientSelector: ClientSelector): Promise<RiskProfileResponseDto[]> {
      let url_ = this.baseUrl + "/api/RiskProfile/{contactId}/{clientSelector}/responses";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (clientSelector === undefined || clientSelector === null)
          throw new Error("The parameter 'clientSelector' must be defined.");
      url_ = url_.replace("{clientSelector}", encodeURIComponent("" + clientSelector));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processRiskProfile_GetContactResponses(_response), options_);
      });
  }

  protected processRiskProfile_GetContactResponses(response: Response): Promise<RiskProfileResponseDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(RiskProfileResponseDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<RiskProfileResponseDto[]>(null as any);
  }

  riskProfile_PostContactResponses(contactId: number, clientSelector: ClientSelector, request: PostRiskProfileRepsonseDto[]): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/RiskProfile/{contactId}/{clientSelector}/responses";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (clientSelector === undefined || clientSelector === null)
          throw new Error("The parameter 'clientSelector' must be defined.");
      url_ = url_.replace("{clientSelector}", encodeURIComponent("" + clientSelector));
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(request);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processRiskProfile_PostContactResponses(_response), options_);
      });
  }

  protected processRiskProfile_PostContactResponses(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  riskProfile_GetContactResult(contactId: number, clientSelector: ClientSelector): Promise<RiskProfileResultDto> {
      let url_ = this.baseUrl + "/api/RiskProfile/{contactId}/{clientSelector}/result";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (clientSelector === undefined || clientSelector === null)
          throw new Error("The parameter 'clientSelector' must be defined.");
      url_ = url_.replace("{clientSelector}", encodeURIComponent("" + clientSelector));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processRiskProfile_GetContactResult(_response), options_);
      });
  }

  protected processRiskProfile_GetContactResult(response: Response): Promise<RiskProfileResultDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RiskProfileResultDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<RiskProfileResultDto>(null as any);
  }

  riskProfile_SendRequest(contactId: number, clientSelector: ClientSelector, emailClientSelector: ClientSelector): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/RiskProfile/{contactId}/{clientSelector}/{emailClientSelector}/request";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (clientSelector === undefined || clientSelector === null)
          throw new Error("The parameter 'clientSelector' must be defined.");
      url_ = url_.replace("{clientSelector}", encodeURIComponent("" + clientSelector));
      if (emailClientSelector === undefined || emailClientSelector === null)
          throw new Error("The parameter 'emailClientSelector' must be defined.");
      url_ = url_.replace("{emailClientSelector}", encodeURIComponent("" + emailClientSelector));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "POST",
          headers: {
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processRiskProfile_SendRequest(_response), options_);
      });
  }

  protected processRiskProfile_SendRequest(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  riskProfile_SendRequest2(contactId: number, clientSelector: ClientSelector): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/RiskProfile/{contactId}/{clientSelector}/request";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (clientSelector === undefined || clientSelector === null)
          throw new Error("The parameter 'clientSelector' must be defined.");
      url_ = url_.replace("{clientSelector}", encodeURIComponent("" + clientSelector));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "POST",
          headers: {
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processRiskProfile_SendRequest2(_response), options_);
      });
  }

  protected processRiskProfile_SendRequest2(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  riskProfile_CompleteRequest(contactId: number, clientSelector: ClientSelector): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/RiskProfile/{contactId}/{clientSelector}/request";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      if (clientSelector === undefined || clientSelector === null)
          throw new Error("The parameter 'clientSelector' must be defined.");
      url_ = url_.replace("{clientSelector}", encodeURIComponent("" + clientSelector));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "PUT",
          headers: {
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processRiskProfile_CompleteRequest(_response), options_);
      });
  }

  protected processRiskProfile_CompleteRequest(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  riskProfile_GetRequests(contactId: number): Promise<RiskProfileRequestDto[]> {
      let url_ = this.baseUrl + "/api/RiskProfile/{contactId}/request";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processRiskProfile_GetRequests(_response), options_);
      });
  }

  protected processRiskProfile_GetRequests(response: Response): Promise<RiskProfileRequestDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(RiskProfileRequestDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<RiskProfileRequestDto[]>(null as any);
  }

  riskProfile_PostValidateResponses(request: RiskProfileValidateQuestionDto[]): Promise<RiskProfileValidationErrorDto[]> {
      let url_ = this.baseUrl + "/api/RiskProfile/validate";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(request);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processRiskProfile_PostValidateResponses(_response), options_);
      });
  }

  protected processRiskProfile_PostValidateResponses(response: Response): Promise<RiskProfileValidationErrorDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(RiskProfileValidationErrorDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<RiskProfileValidationErrorDto[]>(null as any);
  }

  policyTransactions_GetByPolicyId(policyId: number | undefined): Promise<PolicyTransactionDto[]> {
      let url_ = this.baseUrl + "/api/PolicyTransactions?";
      if (policyId === null)
          throw new Error("The parameter 'policyId' cannot be null.");
      else if (policyId !== undefined)
          url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicyTransactions_GetByPolicyId(_response), options_);
      });
  }

  protected processPolicyTransactions_GetByPolicyId(response: Response): Promise<PolicyTransactionDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyTransactionDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyTransactionDto[]>(null as any);
  }

  approvalStatus_IndexAll(): Promise<ApprovalStatusDto[]> {
      let url_ = this.baseUrl + "/api/ApprovalStatus";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processApprovalStatus_IndexAll(_response), options_);
      });
  }

  protected processApprovalStatus_IndexAll(response: Response): Promise<ApprovalStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(ApprovalStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ApprovalStatusDto[]>(null as any);
  }

  approvalStatus_IndexAll2(sort: SortOrder | null): Promise<ApprovalStatusDto[]> {
      let url_ = this.baseUrl + "/api/ApprovalStatus/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processApprovalStatus_IndexAll2(_response), options_);
      });
  }

  protected processApprovalStatus_IndexAll2(response: Response): Promise<ApprovalStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(ApprovalStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ApprovalStatusDto[]>(null as any);
  }

  approvalStatus_Index(id: number): Promise<ApprovalStatusDto> {
      let url_ = this.baseUrl + "/api/ApprovalStatus/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processApprovalStatus_Index(_response), options_);
      });
  }

  protected processApprovalStatus_Index(response: Response): Promise<ApprovalStatusDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApprovalStatusDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ApprovalStatusDto>(null as any);
  }

  assetClassification_IndexAll(): Promise<AssetClassificationDto[]> {
      let url_ = this.baseUrl + "/api/AssetClassification";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processAssetClassification_IndexAll(_response), options_);
      });
  }

  protected processAssetClassification_IndexAll(response: Response): Promise<AssetClassificationDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(AssetClassificationDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<AssetClassificationDto[]>(null as any);
  }

  assetClassification_IndexAll2(sort: SortOrder | null): Promise<AssetClassificationDto[]> {
      let url_ = this.baseUrl + "/api/AssetClassification/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processAssetClassification_IndexAll2(_response), options_);
      });
  }

  protected processAssetClassification_IndexAll2(response: Response): Promise<AssetClassificationDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(AssetClassificationDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<AssetClassificationDto[]>(null as any);
  }

  assetClassification_Index(id: number): Promise<AssetClassificationDto> {
      let url_ = this.baseUrl + "/api/AssetClassification/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processAssetClassification_Index(_response), options_);
      });
  }

  protected processAssetClassification_Index(response: Response): Promise<AssetClassificationDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AssetClassificationDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<AssetClassificationDto>(null as any);
  }

  assetType_IndexAll(): Promise<AssetTypeDto[]> {
      let url_ = this.baseUrl + "/api/AssetType";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processAssetType_IndexAll(_response), options_);
      });
  }

  protected processAssetType_IndexAll(response: Response): Promise<AssetTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(AssetTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<AssetTypeDto[]>(null as any);
  }

  assetType_IndexAll2(sort: SortOrder | null): Promise<AssetTypeDto[]> {
      let url_ = this.baseUrl + "/api/AssetType/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processAssetType_IndexAll2(_response), options_);
      });
  }

  protected processAssetType_IndexAll2(response: Response): Promise<AssetTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(AssetTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<AssetTypeDto[]>(null as any);
  }

  assetType_Index(id: number): Promise<AssetTypeDto> {
      let url_ = this.baseUrl + "/api/AssetType/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processAssetType_Index(_response), options_);
      });
  }

  protected processAssetType_Index(response: Response): Promise<AssetTypeDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AssetTypeDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<AssetTypeDto>(null as any);
  }

  benefitType_IndexAll(): Promise<PolicyBenefitTypeDTO[]> {
      let url_ = this.baseUrl + "/api/BenefitType";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBenefitType_IndexAll(_response), options_);
      });
  }

  protected processBenefitType_IndexAll(response: Response): Promise<PolicyBenefitTypeDTO[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyBenefitTypeDTO.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyBenefitTypeDTO[]>(null as any);
  }

  benefitType_IndexAll2(sort: SortOrder | null): Promise<PolicyBenefitTypeDTO[]> {
      let url_ = this.baseUrl + "/api/BenefitType/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBenefitType_IndexAll2(_response), options_);
      });
  }

  protected processBenefitType_IndexAll2(response: Response): Promise<PolicyBenefitTypeDTO[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyBenefitTypeDTO.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyBenefitTypeDTO[]>(null as any);
  }

  benefitType_Index(id: number): Promise<PolicyBenefitTypeDTO> {
      let url_ = this.baseUrl + "/api/BenefitType/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBenefitType_Index(_response), options_);
      });
  }

  protected processBenefitType_Index(response: Response): Promise<PolicyBenefitTypeDTO> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PolicyBenefitTypeDTO.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyBenefitTypeDTO>(null as any);
  }

  country_IndexAll(): Promise<CountryDto[]> {
      let url_ = this.baseUrl + "/api/Country";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCountry_IndexAll(_response), options_);
      });
  }

  protected processCountry_IndexAll(response: Response): Promise<CountryDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(CountryDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<CountryDto[]>(null as any);
  }

  country_IndexAll2(sort: SortOrder | null): Promise<CountryDto[]> {
      let url_ = this.baseUrl + "/api/Country/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCountry_IndexAll2(_response), options_);
      });
  }

  protected processCountry_IndexAll2(response: Response): Promise<CountryDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(CountryDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<CountryDto[]>(null as any);
  }

  country_Index(id: number): Promise<CountryDto> {
      let url_ = this.baseUrl + "/api/Country/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCountry_Index(_response), options_);
      });
  }

  protected processCountry_Index(response: Response): Promise<CountryDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CountryDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<CountryDto>(null as any);
  }

  county_IndexAll(): Promise<CountyDto[]> {
      let url_ = this.baseUrl + "/api/County";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCounty_IndexAll(_response), options_);
      });
  }

  protected processCounty_IndexAll(response: Response): Promise<CountyDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(CountyDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<CountyDto[]>(null as any);
  }

  county_IndexAll2(sort: SortOrder | null): Promise<CountyDto[]> {
      let url_ = this.baseUrl + "/api/County/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCounty_IndexAll2(_response), options_);
      });
  }

  protected processCounty_IndexAll2(response: Response): Promise<CountyDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(CountyDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<CountyDto[]>(null as any);
  }

  county_Index(id: number): Promise<CountyDto> {
      let url_ = this.baseUrl + "/api/County/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCounty_Index(_response), options_);
      });
  }

  protected processCounty_Index(response: Response): Promise<CountyDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CountyDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<CountyDto>(null as any);
  }

  employmentStatus_IndexAll(): Promise<EmploymentStatusDto[]> {
      let url_ = this.baseUrl + "/api/EmploymentStatus";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processEmploymentStatus_IndexAll(_response), options_);
      });
  }

  protected processEmploymentStatus_IndexAll(response: Response): Promise<EmploymentStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(EmploymentStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<EmploymentStatusDto[]>(null as any);
  }

  employmentStatus_IndexAll2(sort: SortOrder | null): Promise<EmploymentStatusDto[]> {
      let url_ = this.baseUrl + "/api/EmploymentStatus/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processEmploymentStatus_IndexAll2(_response), options_);
      });
  }

  protected processEmploymentStatus_IndexAll2(response: Response): Promise<EmploymentStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(EmploymentStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<EmploymentStatusDto[]>(null as any);
  }

  employmentStatus_Index(id: number): Promise<EmploymentStatusDto> {
      let url_ = this.baseUrl + "/api/EmploymentStatus/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processEmploymentStatus_Index(_response), options_);
      });
  }

  protected processEmploymentStatus_Index(response: Response): Promise<EmploymentStatusDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EmploymentStatusDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<EmploymentStatusDto>(null as any);
  }

  expenseType_IndexAll(): Promise<ExpenseTypeDto[]> {
      let url_ = this.baseUrl + "/api/ExpenseType";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processExpenseType_IndexAll(_response), options_);
      });
  }

  protected processExpenseType_IndexAll(response: Response): Promise<ExpenseTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(ExpenseTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ExpenseTypeDto[]>(null as any);
  }

  expenseType_IndexAll2(sort: SortOrder | null): Promise<ExpenseTypeDto[]> {
      let url_ = this.baseUrl + "/api/ExpenseType/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processExpenseType_IndexAll2(_response), options_);
      });
  }

  protected processExpenseType_IndexAll2(response: Response): Promise<ExpenseTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(ExpenseTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ExpenseTypeDto[]>(null as any);
  }

  expenseType_Index(id: number): Promise<ExpenseTypeDto> {
      let url_ = this.baseUrl + "/api/ExpenseType/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processExpenseType_Index(_response), options_);
      });
  }

  protected processExpenseType_Index(response: Response): Promise<ExpenseTypeDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExpenseTypeDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ExpenseTypeDto>(null as any);
  }

  gender_IndexAll(): Promise<GenderDto[]> {
      let url_ = this.baseUrl + "/api/Gender";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processGender_IndexAll(_response), options_);
      });
  }

  protected processGender_IndexAll(response: Response): Promise<GenderDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(GenderDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<GenderDto[]>(null as any);
  }

  gender_IndexAll2(sort: SortOrder | null): Promise<GenderDto[]> {
      let url_ = this.baseUrl + "/api/Gender/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processGender_IndexAll2(_response), options_);
      });
  }

  protected processGender_IndexAll2(response: Response): Promise<GenderDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(GenderDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<GenderDto[]>(null as any);
  }

  gender_Index(id: number): Promise<GenderDto> {
      let url_ = this.baseUrl + "/api/Gender/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processGender_Index(_response), options_);
      });
  }

  protected processGender_Index(response: Response): Promise<GenderDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GenderDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<GenderDto>(null as any);
  }

  healthStatus_IndexAll(): Promise<HealthStatusDto[]> {
      let url_ = this.baseUrl + "/api/HealthStatus";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processHealthStatus_IndexAll(_response), options_);
      });
  }

  protected processHealthStatus_IndexAll(response: Response): Promise<HealthStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(HealthStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<HealthStatusDto[]>(null as any);
  }

  healthStatus_IndexAll2(sort: SortOrder | null): Promise<HealthStatusDto[]> {
      let url_ = this.baseUrl + "/api/HealthStatus/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processHealthStatus_IndexAll2(_response), options_);
      });
  }

  protected processHealthStatus_IndexAll2(response: Response): Promise<HealthStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(HealthStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<HealthStatusDto[]>(null as any);
  }

  healthStatus_Index(id: number): Promise<HealthStatusDto> {
      let url_ = this.baseUrl + "/api/HealthStatus/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processHealthStatus_Index(_response), options_);
      });
  }

  protected processHealthStatus_Index(response: Response): Promise<HealthStatusDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = HealthStatusDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<HealthStatusDto>(null as any);
  }

  illnessType_IndexAll(): Promise<IllnessTypeDto[]> {
      let url_ = this.baseUrl + "/api/IllnessType";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processIllnessType_IndexAll(_response), options_);
      });
  }

  protected processIllnessType_IndexAll(response: Response): Promise<IllnessTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(IllnessTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<IllnessTypeDto[]>(null as any);
  }

  illnessType_IndexAll2(sort: SortOrder | null): Promise<IllnessTypeDto[]> {
      let url_ = this.baseUrl + "/api/IllnessType/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processIllnessType_IndexAll2(_response), options_);
      });
  }

  protected processIllnessType_IndexAll2(response: Response): Promise<IllnessTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(IllnessTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<IllnessTypeDto[]>(null as any);
  }

  illnessType_Index(id: number): Promise<IllnessTypeDto> {
      let url_ = this.baseUrl + "/api/IllnessType/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processIllnessType_Index(_response), options_);
      });
  }

  protected processIllnessType_Index(response: Response): Promise<IllnessTypeDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IllnessTypeDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<IllnessTypeDto>(null as any);
  }

  incomeCategory_IndexAll(): Promise<IncomeCategoryDto[]> {
      let url_ = this.baseUrl + "/api/IncomeCategory";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processIncomeCategory_IndexAll(_response), options_);
      });
  }

  protected processIncomeCategory_IndexAll(response: Response): Promise<IncomeCategoryDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(IncomeCategoryDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<IncomeCategoryDto[]>(null as any);
  }

  incomeCategory_IndexAll2(sort: SortOrder | null): Promise<IncomeCategoryDto[]> {
      let url_ = this.baseUrl + "/api/IncomeCategory/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processIncomeCategory_IndexAll2(_response), options_);
      });
  }

  protected processIncomeCategory_IndexAll2(response: Response): Promise<IncomeCategoryDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(IncomeCategoryDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<IncomeCategoryDto[]>(null as any);
  }

  incomeCategory_Index(id: number): Promise<IncomeCategoryDto> {
      let url_ = this.baseUrl + "/api/IncomeCategory/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processIncomeCategory_Index(_response), options_);
      });
  }

  protected processIncomeCategory_Index(response: Response): Promise<IncomeCategoryDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IncomeCategoryDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<IncomeCategoryDto>(null as any);
  }

  incomeType_IndexAll(): Promise<IncomeTypeDto[]> {
      let url_ = this.baseUrl + "/api/IncomeType";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processIncomeType_IndexAll(_response), options_);
      });
  }

  protected processIncomeType_IndexAll(response: Response): Promise<IncomeTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(IncomeTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<IncomeTypeDto[]>(null as any);
  }

  incomeType_IndexAll2(sort: SortOrder | null): Promise<IncomeTypeDto[]> {
      let url_ = this.baseUrl + "/api/IncomeType/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processIncomeType_IndexAll2(_response), options_);
      });
  }

  protected processIncomeType_IndexAll2(response: Response): Promise<IncomeTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(IncomeTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<IncomeTypeDto[]>(null as any);
  }

  incomeType_Index(id: number): Promise<IncomeTypeDto> {
      let url_ = this.baseUrl + "/api/IncomeType/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processIncomeType_Index(_response), options_);
      });
  }

  protected processIncomeType_Index(response: Response): Promise<IncomeTypeDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IncomeTypeDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<IncomeTypeDto>(null as any);
  }

  liabilityType_IndexAll(): Promise<LiabilityTypeDto[]> {
      let url_ = this.baseUrl + "/api/LiabilityType";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processLiabilityType_IndexAll(_response), options_);
      });
  }

  protected processLiabilityType_IndexAll(response: Response): Promise<LiabilityTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(LiabilityTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<LiabilityTypeDto[]>(null as any);
  }

  liabilityType_IndexAll2(sort: SortOrder | null): Promise<LiabilityTypeDto[]> {
      let url_ = this.baseUrl + "/api/LiabilityType/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processLiabilityType_IndexAll2(_response), options_);
      });
  }

  protected processLiabilityType_IndexAll2(response: Response): Promise<LiabilityTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(LiabilityTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<LiabilityTypeDto[]>(null as any);
  }

  liabilityType_Index(id: number): Promise<LiabilityTypeDto> {
      let url_ = this.baseUrl + "/api/LiabilityType/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processLiabilityType_Index(_response), options_);
      });
  }

  protected processLiabilityType_Index(response: Response): Promise<LiabilityTypeDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LiabilityTypeDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<LiabilityTypeDto>(null as any);
  }

  maritalStatus_IndexAll(): Promise<MaritalStatusDto[]> {
      let url_ = this.baseUrl + "/api/MaritalStatus";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMaritalStatus_IndexAll(_response), options_);
      });
  }

  protected processMaritalStatus_IndexAll(response: Response): Promise<MaritalStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(MaritalStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MaritalStatusDto[]>(null as any);
  }

  maritalStatus_IndexAll2(sort: SortOrder | null): Promise<MaritalStatusDto[]> {
      let url_ = this.baseUrl + "/api/MaritalStatus/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMaritalStatus_IndexAll2(_response), options_);
      });
  }

  protected processMaritalStatus_IndexAll2(response: Response): Promise<MaritalStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(MaritalStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MaritalStatusDto[]>(null as any);
  }

  maritalStatus_Index(id: number): Promise<MaritalStatusDto> {
      let url_ = this.baseUrl + "/api/MaritalStatus/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMaritalStatus_Index(_response), options_);
      });
  }

  protected processMaritalStatus_Index(response: Response): Promise<MaritalStatusDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MaritalStatusDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MaritalStatusDto>(null as any);
  }

  mortgageCategory_IndexAll(): Promise<MortgageCategoryDto[]> {
      let url_ = this.baseUrl + "/api/MortgageCategory";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMortgageCategory_IndexAll(_response), options_);
      });
  }

  protected processMortgageCategory_IndexAll(response: Response): Promise<MortgageCategoryDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(MortgageCategoryDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MortgageCategoryDto[]>(null as any);
  }

  mortgageCategory_IndexAll2(sort: SortOrder | null): Promise<MortgageCategoryDto[]> {
      let url_ = this.baseUrl + "/api/MortgageCategory/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMortgageCategory_IndexAll2(_response), options_);
      });
  }

  protected processMortgageCategory_IndexAll2(response: Response): Promise<MortgageCategoryDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(MortgageCategoryDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MortgageCategoryDto[]>(null as any);
  }

  mortgageCategory_Index(id: number): Promise<MortgageCategoryDto> {
      let url_ = this.baseUrl + "/api/MortgageCategory/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMortgageCategory_Index(_response), options_);
      });
  }

  protected processMortgageCategory_Index(response: Response): Promise<MortgageCategoryDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MortgageCategoryDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MortgageCategoryDto>(null as any);
  }

  mortgageRate_IndexAll(): Promise<MortgageRateDto[]> {
      let url_ = this.baseUrl + "/api/MortgageRate";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMortgageRate_IndexAll(_response), options_);
      });
  }

  protected processMortgageRate_IndexAll(response: Response): Promise<MortgageRateDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(MortgageRateDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MortgageRateDto[]>(null as any);
  }

  mortgageRate_IndexAll2(sort: SortOrder | null): Promise<MortgageRateDto[]> {
      let url_ = this.baseUrl + "/api/MortgageRate/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMortgageRate_IndexAll2(_response), options_);
      });
  }

  protected processMortgageRate_IndexAll2(response: Response): Promise<MortgageRateDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(MortgageRateDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MortgageRateDto[]>(null as any);
  }

  mortgageRate_Index(id: number): Promise<MortgageRateDto> {
      let url_ = this.baseUrl + "/api/MortgageRate/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMortgageRate_Index(_response), options_);
      });
  }

  protected processMortgageRate_Index(response: Response): Promise<MortgageRateDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MortgageRateDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MortgageRateDto>(null as any);
  }

  mortgageType_IndexAll(): Promise<MortgageTypeDto[]> {
      let url_ = this.baseUrl + "/api/MortgageType";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMortgageType_IndexAll(_response), options_);
      });
  }

  protected processMortgageType_IndexAll(response: Response): Promise<MortgageTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(MortgageTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MortgageTypeDto[]>(null as any);
  }

  mortgageType_IndexAll2(sort: SortOrder | null): Promise<MortgageTypeDto[]> {
      let url_ = this.baseUrl + "/api/MortgageType/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMortgageType_IndexAll2(_response), options_);
      });
  }

  protected processMortgageType_IndexAll2(response: Response): Promise<MortgageTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(MortgageTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MortgageTypeDto[]>(null as any);
  }

  mortgageType_Index(id: number): Promise<MortgageTypeDto> {
      let url_ = this.baseUrl + "/api/MortgageType/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processMortgageType_Index(_response), options_);
      });
  }

  protected processMortgageType_Index(response: Response): Promise<MortgageTypeDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MortgageTypeDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<MortgageTypeDto>(null as any);
  }

  occupation_IndexAll(): Promise<OccupationDto[]> {
      let url_ = this.baseUrl + "/api/Occupation";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOccupation_IndexAll(_response), options_);
      });
  }

  protected processOccupation_IndexAll(response: Response): Promise<OccupationDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(OccupationDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<OccupationDto[]>(null as any);
  }

  occupation_IndexAll2(sort: SortOrder | null): Promise<OccupationDto[]> {
      let url_ = this.baseUrl + "/api/Occupation/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOccupation_IndexAll2(_response), options_);
      });
  }

  protected processOccupation_IndexAll2(response: Response): Promise<OccupationDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(OccupationDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<OccupationDto[]>(null as any);
  }

  occupation_Index(id: number): Promise<OccupationDto> {
      let url_ = this.baseUrl + "/api/Occupation/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOccupation_Index(_response), options_);
      });
  }

  protected processOccupation_Index(response: Response): Promise<OccupationDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OccupationDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<OccupationDto>(null as any);
  }

  owner_Index(contactId: number): Promise<OwnerDto[]> {
      let url_ = this.baseUrl + "/api/Owner/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOwner_Index(_response), options_);
      });
  }

  protected processOwner_Index(response: Response): Promise<OwnerDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(OwnerDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<OwnerDto[]>(null as any);
  }

  paymentFrequency_IndexAll(): Promise<PaymentFrequencyDto[]> {
      let url_ = this.baseUrl + "/api/PaymentFrequency";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPaymentFrequency_IndexAll(_response), options_);
      });
  }

  protected processPaymentFrequency_IndexAll(response: Response): Promise<PaymentFrequencyDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PaymentFrequencyDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PaymentFrequencyDto[]>(null as any);
  }

  paymentFrequency_IndexAll2(sort: SortOrder | null): Promise<PaymentFrequencyDto[]> {
      let url_ = this.baseUrl + "/api/PaymentFrequency/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPaymentFrequency_IndexAll2(_response), options_);
      });
  }

  protected processPaymentFrequency_IndexAll2(response: Response): Promise<PaymentFrequencyDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PaymentFrequencyDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PaymentFrequencyDto[]>(null as any);
  }

  paymentFrequency_Index(id: number): Promise<PaymentFrequencyDto> {
      let url_ = this.baseUrl + "/api/PaymentFrequency/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPaymentFrequency_Index(_response), options_);
      });
  }

  protected processPaymentFrequency_Index(response: Response): Promise<PaymentFrequencyDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PaymentFrequencyDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PaymentFrequencyDto>(null as any);
  }

  paymentMethod_IndexAll(): Promise<PaymentMethodDto[]> {
      let url_ = this.baseUrl + "/api/PaymentMethod";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPaymentMethod_IndexAll(_response), options_);
      });
  }

  protected processPaymentMethod_IndexAll(response: Response): Promise<PaymentMethodDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PaymentMethodDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PaymentMethodDto[]>(null as any);
  }

  paymentMethod_IndexAll2(sort: SortOrder | null): Promise<PaymentMethodDto[]> {
      let url_ = this.baseUrl + "/api/PaymentMethod/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPaymentMethod_IndexAll2(_response), options_);
      });
  }

  protected processPaymentMethod_IndexAll2(response: Response): Promise<PaymentMethodDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PaymentMethodDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PaymentMethodDto[]>(null as any);
  }

  paymentMethod_Index(id: number): Promise<PaymentMethodDto> {
      let url_ = this.baseUrl + "/api/PaymentMethod/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPaymentMethod_Index(_response), options_);
      });
  }

  protected processPaymentMethod_Index(response: Response): Promise<PaymentMethodDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PaymentMethodDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PaymentMethodDto>(null as any);
  }

  pensionStatus_IndexAll(): Promise<PensionStatusDto[]> {
      let url_ = this.baseUrl + "/api/PensionStatus";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPensionStatus_IndexAll(_response), options_);
      });
  }

  protected processPensionStatus_IndexAll(response: Response): Promise<PensionStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PensionStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PensionStatusDto[]>(null as any);
  }

  pensionStatus_IndexAll2(sort: SortOrder | null): Promise<PensionStatusDto[]> {
      let url_ = this.baseUrl + "/api/PensionStatus/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPensionStatus_IndexAll2(_response), options_);
      });
  }

  protected processPensionStatus_IndexAll2(response: Response): Promise<PensionStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PensionStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PensionStatusDto[]>(null as any);
  }

  pensionStatus_Index(id: number): Promise<PensionStatusDto> {
      let url_ = this.baseUrl + "/api/PensionStatus/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPensionStatus_Index(_response), options_);
      });
  }

  protected processPensionStatus_Index(response: Response): Promise<PensionStatusDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PensionStatusDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PensionStatusDto>(null as any);
  }

  pensionType_IndexAll(): Promise<PensionTypeDto[]> {
      let url_ = this.baseUrl + "/api/PensionType";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPensionType_IndexAll(_response), options_);
      });
  }

  protected processPensionType_IndexAll(response: Response): Promise<PensionTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PensionTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PensionTypeDto[]>(null as any);
  }

  pensionType_IndexAll2(sort: SortOrder | null): Promise<PensionTypeDto[]> {
      let url_ = this.baseUrl + "/api/PensionType/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPensionType_IndexAll2(_response), options_);
      });
  }

  protected processPensionType_IndexAll2(response: Response): Promise<PensionTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PensionTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PensionTypeDto[]>(null as any);
  }

  pensionType_Index(id: number): Promise<PensionTypeDto> {
      let url_ = this.baseUrl + "/api/PensionType/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPensionType_Index(_response), options_);
      });
  }

  protected processPensionType_Index(response: Response): Promise<PensionTypeDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PensionTypeDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PensionTypeDto>(null as any);
  }

  personalRelation_IndexAll(): Promise<PersonalRelationDto[]> {
      let url_ = this.baseUrl + "/api/PersonalRelation";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPersonalRelation_IndexAll(_response), options_);
      });
  }

  protected processPersonalRelation_IndexAll(response: Response): Promise<PersonalRelationDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PersonalRelationDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PersonalRelationDto[]>(null as any);
  }

  personalRelation_IndexAll2(sort: SortOrder | null): Promise<PersonalRelationDto[]> {
      let url_ = this.baseUrl + "/api/PersonalRelation/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPersonalRelation_IndexAll2(_response), options_);
      });
  }

  protected processPersonalRelation_IndexAll2(response: Response): Promise<PersonalRelationDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PersonalRelationDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PersonalRelationDto[]>(null as any);
  }

  personalRelation_Index(id: number): Promise<PersonalRelationDto> {
      let url_ = this.baseUrl + "/api/PersonalRelation/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPersonalRelation_Index(_response), options_);
      });
  }

  protected processPersonalRelation_Index(response: Response): Promise<PersonalRelationDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PersonalRelationDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PersonalRelationDto>(null as any);
  }

  policyBasis_IndexAll(): Promise<PolicyBasisDto[]> {
      let url_ = this.baseUrl + "/api/PolicyBasis";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicyBasis_IndexAll(_response), options_);
      });
  }

  protected processPolicyBasis_IndexAll(response: Response): Promise<PolicyBasisDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyBasisDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyBasisDto[]>(null as any);
  }

  policyBasis_IndexAll2(sort: SortOrder | null): Promise<PolicyBasisDto[]> {
      let url_ = this.baseUrl + "/api/PolicyBasis/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicyBasis_IndexAll2(_response), options_);
      });
  }

  protected processPolicyBasis_IndexAll2(response: Response): Promise<PolicyBasisDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyBasisDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyBasisDto[]>(null as any);
  }

  policyBasis_Index(id: number): Promise<PolicyBasisDto> {
      let url_ = this.baseUrl + "/api/PolicyBasis/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicyBasis_Index(_response), options_);
      });
  }

  protected processPolicyBasis_Index(response: Response): Promise<PolicyBasisDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PolicyBasisDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyBasisDto>(null as any);
  }

  policyStatus_IndexAll(): Promise<PolicyStatusDto[]> {
      let url_ = this.baseUrl + "/api/PolicyStatus";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicyStatus_IndexAll(_response), options_);
      });
  }

  protected processPolicyStatus_IndexAll(response: Response): Promise<PolicyStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyStatusDto[]>(null as any);
  }

  policyStatus_IndexAll2(sort: SortOrder | null): Promise<PolicyStatusDto[]> {
      let url_ = this.baseUrl + "/api/PolicyStatus/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicyStatus_IndexAll2(_response), options_);
      });
  }

  protected processPolicyStatus_IndexAll2(response: Response): Promise<PolicyStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyStatusDto[]>(null as any);
  }

  policyStatus_Index(id: number): Promise<PolicyStatusDto> {
      let url_ = this.baseUrl + "/api/PolicyStatus/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicyStatus_Index(_response), options_);
      });
  }

  protected processPolicyStatus_Index(response: Response): Promise<PolicyStatusDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PolicyStatusDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyStatusDto>(null as any);
  }

  policyType_IndexAll(): Promise<PolicyTypeDto[]> {
      let url_ = this.baseUrl + "/api/PolicyType";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicyType_IndexAll(_response), options_);
      });
  }

  protected processPolicyType_IndexAll(response: Response): Promise<PolicyTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyTypeDto[]>(null as any);
  }

  policyType_IndexAll2(sort: SortOrder | null): Promise<PolicyTypeDto[]> {
      let url_ = this.baseUrl + "/api/PolicyType/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicyType_IndexAll2(_response), options_);
      });
  }

  protected processPolicyType_IndexAll2(response: Response): Promise<PolicyTypeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PolicyTypeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyTypeDto[]>(null as any);
  }

  policyType_Index(id: number): Promise<PolicyTypeDto> {
      let url_ = this.baseUrl + "/api/PolicyType/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPolicyType_Index(_response), options_);
      });
  }

  protected processPolicyType_Index(response: Response): Promise<PolicyTypeDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PolicyTypeDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyTypeDto>(null as any);
  }

  productProvider_IndexAll(): Promise<ProductProviderDto[]> {
      let url_ = this.baseUrl + "/api/ProductProvider";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processProductProvider_IndexAll(_response), options_);
      });
  }

  protected processProductProvider_IndexAll(response: Response): Promise<ProductProviderDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(ProductProviderDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ProductProviderDto[]>(null as any);
  }

  productProvider_IndexAll2(sort: SortOrder | null): Promise<ProductProviderDto[]> {
      let url_ = this.baseUrl + "/api/ProductProvider/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processProductProvider_IndexAll2(_response), options_);
      });
  }

  protected processProductProvider_IndexAll2(response: Response): Promise<ProductProviderDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(ProductProviderDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ProductProviderDto[]>(null as any);
  }

  productProvider_Index(id: number): Promise<ProductProviderDto> {
      let url_ = this.baseUrl + "/api/ProductProvider/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processProductProvider_Index(_response), options_);
      });
  }

  protected processProductProvider_Index(response: Response): Promise<ProductProviderDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProductProviderDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ProductProviderDto>(null as any);
  }

  propertyStatus_IndexAll(): Promise<PropertyStatusDto[]> {
      let url_ = this.baseUrl + "/api/PropertyStatus";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPropertyStatus_IndexAll(_response), options_);
      });
  }

  protected processPropertyStatus_IndexAll(response: Response): Promise<PropertyStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PropertyStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PropertyStatusDto[]>(null as any);
  }

  propertyStatus_IndexAll2(sort: SortOrder | null): Promise<PropertyStatusDto[]> {
      let url_ = this.baseUrl + "/api/PropertyStatus/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPropertyStatus_IndexAll2(_response), options_);
      });
  }

  protected processPropertyStatus_IndexAll2(response: Response): Promise<PropertyStatusDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(PropertyStatusDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PropertyStatusDto[]>(null as any);
  }

  propertyStatus_Index(id: number): Promise<PropertyStatusDto> {
      let url_ = this.baseUrl + "/api/PropertyStatus/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPropertyStatus_Index(_response), options_);
      });
  }

  protected processPropertyStatus_Index(response: Response): Promise<PropertyStatusDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PropertyStatusDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PropertyStatusDto>(null as any);
  }

  taxBasisAssessment_IndexAll(): Promise<TaxBasisAssessmentDto[]> {
      let url_ = this.baseUrl + "/api/TaxBasisAssessment";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTaxBasisAssessment_IndexAll(_response), options_);
      });
  }

  protected processTaxBasisAssessment_IndexAll(response: Response): Promise<TaxBasisAssessmentDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(TaxBasisAssessmentDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TaxBasisAssessmentDto[]>(null as any);
  }

  taxBasisAssessment_IndexAll2(sort: SortOrder | null): Promise<TaxBasisAssessmentDto[]> {
      let url_ = this.baseUrl + "/api/TaxBasisAssessment/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTaxBasisAssessment_IndexAll2(_response), options_);
      });
  }

  protected processTaxBasisAssessment_IndexAll2(response: Response): Promise<TaxBasisAssessmentDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(TaxBasisAssessmentDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TaxBasisAssessmentDto[]>(null as any);
  }

  taxBasisAssessment_Index(id: number): Promise<TaxBasisAssessmentDto> {
      let url_ = this.baseUrl + "/api/TaxBasisAssessment/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTaxBasisAssessment_Index(_response), options_);
      });
  }

  protected processTaxBasisAssessment_Index(response: Response): Promise<TaxBasisAssessmentDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TaxBasisAssessmentDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TaxBasisAssessmentDto>(null as any);
  }

  taxTreatment_IndexAll(): Promise<TaxTreatmentDto[]> {
      let url_ = this.baseUrl + "/api/TaxTreatment";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTaxTreatment_IndexAll(_response), options_);
      });
  }

  protected processTaxTreatment_IndexAll(response: Response): Promise<TaxTreatmentDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(TaxTreatmentDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TaxTreatmentDto[]>(null as any);
  }

  taxTreatment_IndexAll2(sort: SortOrder | null): Promise<TaxTreatmentDto[]> {
      let url_ = this.baseUrl + "/api/TaxTreatment/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTaxTreatment_IndexAll2(_response), options_);
      });
  }

  protected processTaxTreatment_IndexAll2(response: Response): Promise<TaxTreatmentDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(TaxTreatmentDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TaxTreatmentDto[]>(null as any);
  }

  taxTreatment_Index(id: number): Promise<TaxTreatmentDto> {
      let url_ = this.baseUrl + "/api/TaxTreatment/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTaxTreatment_Index(_response), options_);
      });
  }

  protected processTaxTreatment_Index(response: Response): Promise<TaxTreatmentDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TaxTreatmentDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TaxTreatmentDto>(null as any);
  }

  timeframe_IndexAll(): Promise<TimeframeDto[]> {
      let url_ = this.baseUrl + "/api/Timeframe";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTimeframe_IndexAll(_response), options_);
      });
  }

  protected processTimeframe_IndexAll(response: Response): Promise<TimeframeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(TimeframeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TimeframeDto[]>(null as any);
  }

  timeframe_IndexAll2(sort: SortOrder | null): Promise<TimeframeDto[]> {
      let url_ = this.baseUrl + "/api/Timeframe/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTimeframe_IndexAll2(_response), options_);
      });
  }

  protected processTimeframe_IndexAll2(response: Response): Promise<TimeframeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(TimeframeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TimeframeDto[]>(null as any);
  }

  timeframe_Index(id: number): Promise<TimeframeDto> {
      let url_ = this.baseUrl + "/api/Timeframe/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTimeframe_Index(_response), options_);
      });
  }

  protected processTimeframe_Index(response: Response): Promise<TimeframeDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TimeframeDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TimeframeDto>(null as any);
  }

  title_IndexAll(): Promise<TitleDto[]> {
      let url_ = this.baseUrl + "/api/Title";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTitle_IndexAll(_response), options_);
      });
  }

  protected processTitle_IndexAll(response: Response): Promise<TitleDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(TitleDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TitleDto[]>(null as any);
  }

  title_IndexAll2(sort: SortOrder | null): Promise<TitleDto[]> {
      let url_ = this.baseUrl + "/api/Title/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTitle_IndexAll2(_response), options_);
      });
  }

  protected processTitle_IndexAll2(response: Response): Promise<TitleDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(TitleDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TitleDto[]>(null as any);
  }

  title_Index(id: number): Promise<TitleDto> {
      let url_ = this.baseUrl + "/api/Title/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTitle_Index(_response), options_);
      });
  }

  protected processTitle_Index(response: Response): Promise<TitleDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TitleDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<TitleDto>(null as any);
  }

  yesNoDefault_IndexAll(): Promise<YesNoDefaultDto[]> {
      let url_ = this.baseUrl + "/api/YesNoDefault";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processYesNoDefault_IndexAll(_response), options_);
      });
  }

  protected processYesNoDefault_IndexAll(response: Response): Promise<YesNoDefaultDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(YesNoDefaultDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<YesNoDefaultDto[]>(null as any);
  }

  yesNoDefault_IndexAll2(sort: SortOrder | null): Promise<YesNoDefaultDto[]> {
      let url_ = this.baseUrl + "/api/YesNoDefault/sort/{sort}";
      if (sort === undefined || sort === null)
          throw new Error("The parameter 'sort' must be defined.");
      url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processYesNoDefault_IndexAll2(_response), options_);
      });
  }

  protected processYesNoDefault_IndexAll2(response: Response): Promise<YesNoDefaultDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(YesNoDefaultDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<YesNoDefaultDto[]>(null as any);
  }

  yesNoDefault_Index(id: number): Promise<YesNoDefaultDto> {
      let url_ = this.baseUrl + "/api/YesNoDefault/{id}";
      if (id === undefined || id === null)
          throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processYesNoDefault_Index(_response), options_);
      });
  }

  protected processYesNoDefault_Index(response: Response): Promise<YesNoDefaultDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = YesNoDefaultDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<YesNoDefaultDto>(null as any);
  }

  factFindAsset_IndexAll(contactId: number): Promise<FactFindAssetDto[]> {
      let url_ = this.baseUrl + "/api/FactFindAsset/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindAsset_IndexAll(_response), options_);
      });
  }

  protected processFactFindAsset_IndexAll(response: Response): Promise<FactFindAssetDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindAssetDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindAssetDto[]>(null as any);
  }

  factFindAsset_IndexPOST(command: CreateAssetCommand): Promise<number> {
      let url_ = this.baseUrl + "/api/FactFindAsset";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindAsset_IndexPOST(_response), options_);
      });
  }

  protected processFactFindAsset_IndexPOST(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  factFindAsset_IndexPUT(command: UpdateAssetCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindAsset";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindAsset_IndexPUT(_response), options_);
      });
  }

  protected processFactFindAsset_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindDependent_IndexAll(contactId: number): Promise<FactFindDependentDto[]> {
      let url_ = this.baseUrl + "/api/FactFindDependent/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindDependent_IndexAll(_response), options_);
      });
  }

  protected processFactFindDependent_IndexAll(response: Response): Promise<FactFindDependentDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindDependentDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindDependentDto[]>(null as any);
  }

  factFindDependent_IndexPOST(command: CreateDependantCommand): Promise<number> {
      let url_ = this.baseUrl + "/api/FactFindDependent";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindDependent_IndexPOST(_response), options_);
      });
  }

  protected processFactFindDependent_IndexPOST(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  factFindDependent_IndexPUT(command: UpdateDependantCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindDependent";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindDependent_IndexPUT(_response), options_);
      });
  }

  protected processFactFindDependent_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindDetails_IndexGET(contactId: number): Promise<FactFindDetailsDto> {
      let url_ = this.baseUrl + "/api/FactFindDetails/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindDetails_IndexGET(_response), options_);
      });
  }

  protected processFactFindDetails_IndexGET(response: Response): Promise<FactFindDetailsDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FactFindDetailsDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindDetailsDto>(null as any);
  }

  factFindDetails_IndexPUT(cmd: UpdateDetailsCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindDetails";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(cmd);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindDetails_IndexPUT(_response), options_);
      });
  }

  protected processFactFindDetails_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindEmployment_IndexAll(contactId: number): Promise<FactFindEmploymentDto[]> {
      let url_ = this.baseUrl + "/api/FactFindEmployment/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindEmployment_IndexAll(_response), options_);
      });
  }

  protected processFactFindEmployment_IndexAll(response: Response): Promise<FactFindEmploymentDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindEmploymentDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindEmploymentDto[]>(null as any);
  }

  factFindEmployment_IndexPOST(command: CreateEmploymentCommand): Promise<number> {
      let url_ = this.baseUrl + "/api/FactFindEmployment";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindEmployment_IndexPOST(_response), options_);
      });
  }

  protected processFactFindEmployment_IndexPOST(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  factFindEmployment_IndexPUT(command: UpdateEmploymentCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindEmployment";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindEmployment_IndexPUT(_response), options_);
      });
  }

  protected processFactFindEmployment_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindExpense_IndexAll(contactId: number): Promise<FactFindExpenseDto[]> {
      let url_ = this.baseUrl + "/api/FactFindExpense/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindExpense_IndexAll(_response), options_);
      });
  }

  protected processFactFindExpense_IndexAll(response: Response): Promise<FactFindExpenseDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindExpenseDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindExpenseDto[]>(null as any);
  }

  factFindExpense_IndexPOST(command: CreateExpenseCommand): Promise<number> {
      let url_ = this.baseUrl + "/api/FactFindExpense";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindExpense_IndexPOST(_response), options_);
      });
  }

  protected processFactFindExpense_IndexPOST(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  factFindExpense_IndexPUT(command: UpdateExpenseCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindExpense";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindExpense_IndexPUT(_response), options_);
      });
  }

  protected processFactFindExpense_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindIncome_IndexAll(contactId: number): Promise<FactFindIncomeDto[]> {
      let url_ = this.baseUrl + "/api/FactFindIncome/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindIncome_IndexAll(_response), options_);
      });
  }

  protected processFactFindIncome_IndexAll(response: Response): Promise<FactFindIncomeDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindIncomeDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindIncomeDto[]>(null as any);
  }

  factFindIncome_IndexPOST(command: CreateIncomeCommand): Promise<number> {
      let url_ = this.baseUrl + "/api/FactFindIncome";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindIncome_IndexPOST(_response), options_);
      });
  }

  protected processFactFindIncome_IndexPOST(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  factFindIncome_IndexPUT(command: UpdateIncomeCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindIncome";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindIncome_IndexPUT(_response), options_);
      });
  }

  protected processFactFindIncome_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindLiabilityCard_IndexAll(contactId: number): Promise<FactFindLiabilityCardDto[]> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityCard/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityCard_IndexAll(_response), options_);
      });
  }

  protected processFactFindLiabilityCard_IndexAll(response: Response): Promise<FactFindLiabilityCardDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindLiabilityCardDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindLiabilityCardDto[]>(null as any);
  }

  factFindLiabilityCard_IndexPOST(command: CreateLiabilityCardCommand): Promise<number> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityCard";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityCard_IndexPOST(_response), options_);
      });
  }

  protected processFactFindLiabilityCard_IndexPOST(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  factFindLiabilityCard_IndexPUT(command: UpdateLiabilityCardCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityCard";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityCard_IndexPUT(_response), options_);
      });
  }

  protected processFactFindLiabilityCard_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindLiabilityLoan_IndexAll(contactId: number): Promise<FactFindLiabilityLoanDto[]> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityLoan/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityLoan_IndexAll(_response), options_);
      });
  }

  protected processFactFindLiabilityLoan_IndexAll(response: Response): Promise<FactFindLiabilityLoanDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindLiabilityLoanDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindLiabilityLoanDto[]>(null as any);
  }

  factFindLiabilityLoan_IndexPOST(command: CreateLiabilityLoanCommand): Promise<number> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityLoan";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityLoan_IndexPOST(_response), options_);
      });
  }

  protected processFactFindLiabilityLoan_IndexPOST(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  factFindLiabilityLoan_IndexPUT(command: UpdateLiabilityLoanCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityLoan";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityLoan_IndexPUT(_response), options_);
      });
  }

  protected processFactFindLiabilityLoan_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindLiabilityMortgage_IndexAll(contactId: number): Promise<FactFindPolicyDto[]> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityMortgage/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityMortgage_IndexAll(_response), options_);
      });
  }

  protected processFactFindLiabilityMortgage_IndexAll(response: Response): Promise<FactFindPolicyDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindPolicyDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindPolicyDto[]>(null as any);
  }

  factFindLiabilityMortgage_IndexPOST(command: CreateLiabilityMortgageCommand): Promise<number> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityMortgage";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityMortgage_IndexPOST(_response), options_);
      });
  }

  protected processFactFindLiabilityMortgage_IndexPOST(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  factFindLiabilityMortgage_IndexPUT(command: UpdateLiabilityMortgageCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityMortgage";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityMortgage_IndexPUT(_response), options_);
      });
  }

  protected processFactFindLiabilityMortgage_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindLiabilityOther_IndexAll(contactId: number): Promise<FactFindLiabilityOtherDto[]> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityOther/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityOther_IndexAll(_response), options_);
      });
  }

  protected processFactFindLiabilityOther_IndexAll(response: Response): Promise<FactFindLiabilityOtherDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindLiabilityOtherDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindLiabilityOtherDto[]>(null as any);
  }

  factFindLiabilityOther_IndexPOST(command: CreateLiabilityOtherCommand): Promise<number> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityOther";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityOther_IndexPOST(_response), options_);
      });
  }

  protected processFactFindLiabilityOther_IndexPOST(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  factFindLiabilityOther_IndexPUT(command: UpdateLiabilityOtherCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindLiabilityOther";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindLiabilityOther_IndexPUT(_response), options_);
      });
  }

  protected processFactFindLiabilityOther_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindPension_IndexAll(contactId: number): Promise<FactFindPolicyDto[]> {
      let url_ = this.baseUrl + "/api/FactFindPension/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindPension_IndexAll(_response), options_);
      });
  }

  protected processFactFindPension_IndexAll(response: Response): Promise<FactFindPolicyDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindPolicyDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindPolicyDto[]>(null as any);
  }

  factFindPension_IndexPOST(command: CreatePensionCommand): Promise<number> {
      let url_ = this.baseUrl + "/api/FactFindPension";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindPension_IndexPOST(_response), options_);
      });
  }

  protected processFactFindPension_IndexPOST(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  factFindPension_IndexPUT(command: UpdatePensionCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindPension";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindPension_IndexPUT(_response), options_);
      });
  }

  protected processFactFindPension_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindPolicy_IndexAll(contactId: number): Promise<FactFindPolicyDto[]> {
      let url_ = this.baseUrl + "/api/FactFindPolicy/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindPolicy_IndexAll(_response), options_);
      });
  }

  protected processFactFindPolicy_IndexAll(response: Response): Promise<FactFindPolicyDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindPolicyDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindPolicyDto[]>(null as any);
  }

  factFindPolicy_IndexPOST(command: CreatePolicyCommand): Promise<number> {
      let url_ = this.baseUrl + "/api/FactFindPolicy";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindPolicy_IndexPOST(_response), options_);
      });
  }

  protected processFactFindPolicy_IndexPOST(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  factFindPolicy_IndexPUT(command: UpdatePolicyCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindPolicy";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "PUT",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindPolicy_IndexPUT(_response), options_);
      });
  }

  protected processFactFindPolicy_IndexPUT(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindRequest_CreateRequest(command: CreateFactFindRequestCommand): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindRequest/create";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(command);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindRequest_CreateRequest(_response), options_);
      });
  }

  protected processFactFindRequest_CreateRequest(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindRequest_RequestForContact(query: FindFactFindRequestByContactQuery): Promise<FactFindRequestDto> {
      let url_ = this.baseUrl + "/api/FactFindRequest/getbycontact";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(query);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindRequest_RequestForContact(_response), options_);
      });
  }

  protected processFactFindRequest_RequestForContact(response: Response): Promise<FactFindRequestDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FactFindRequestDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindRequestDto>(null as any);
  }

  factFindRequest_RequestAllForOwner(query: FindAllFactFindRequestsByOwnerQuery): Promise<FactFindRequestDto[]> {
      let url_ = this.baseUrl + "/api/FactFindRequest/getbycontactowner";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(query);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindRequest_RequestAllForOwner(_response), options_);
      });
  }

  protected processFactFindRequest_RequestAllForOwner(response: Response): Promise<FactFindRequestDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindRequestDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindRequestDto[]>(null as any);
  }

  factFindRequest_RequestForOwner(query: FindFactFindRequestByOwnerAndContactQuery): Promise<FactFindRequestDto[]> {
      let url_ = this.baseUrl + "/api/FactFindRequest/getallbycontactowner";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(query);

      let options_ = <RequestInit>{
          body: content_,
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindRequest_RequestForOwner(_response), options_);
      });
  }

  protected processFactFindRequest_RequestForOwner(response: Response): Promise<FactFindRequestDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(FactFindRequestDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FactFindRequestDto[]>(null as any);
  }

  factFindRequest_Complete(): Promise<FileResponse> {
      let url_ = this.baseUrl + "/api/FactFindRequest/complete";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/octet-stream"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindRequest_Complete(_response), options_);
      });
  }

  protected processFactFindRequest_Complete(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200 || status === 206) {
          const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
          let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
          let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
          if (fileName) {
              fileName = decodeURIComponent(fileName);
          } else {
              fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
              fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
          }
          return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<FileResponse>(null as any);
  }

  factFindRequest_IsCompleted(contactId: number): Promise<boolean> {
      let url_ = this.baseUrl + "/api/FactFindRequest/iscomplete/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFactFindRequest_IsCompleted(_response), options_);
      });
  }

  protected processFactFindRequest_IsCompleted(response: Response): Promise<boolean> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<boolean>(null as any);
  }

  externalBroker_GetBrokerDetails(): Promise<BrokerDetailsDto> {
      let url_ = this.baseUrl + "/api/ExternalBroker";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processExternalBroker_GetBrokerDetails(_response), options_);
      });
  }

  protected processExternalBroker_GetBrokerDetails(response: Response): Promise<BrokerDetailsDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BrokerDetailsDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<BrokerDetailsDto>(null as any);
  }

  externalBroker_GetBrokerClientList(): Promise<ClientListRowDto[]> {
      let url_ = this.baseUrl + "/api/ExternalBroker/clients";
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processExternalBroker_GetBrokerClientList(_response), options_);
      });
  }

  protected processExternalBroker_GetBrokerClientList(response: Response): Promise<ClientListRowDto[]> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
              result200 = [] as any;
              for (let item of resultData200)
                  result200!.push(ClientListRowDto.fromJS(item));
          }
          else {
              result200 = <any>null;
          }
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<ClientListRowDto[]>(null as any);
  }

  externalBroker_GetTotalTransfersIn(contactId: number): Promise<number> {
      let url_ = this.baseUrl + "/api/ExternalBroker/tranfersIn/total/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processExternalBroker_GetTotalTransfersIn(_response), options_);
      });
  }

  protected processExternalBroker_GetTotalTransfersIn(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<number>(null as any);
  }

  externalBroker_DownloadPolicyTransactionData(policyId: number): Promise<PolicyTransacionExportDto> {
      let url_ = this.baseUrl + "/api/ExternalBroker/extract/transactions/{policyId}";
      if (policyId === undefined || policyId === null)
          throw new Error("The parameter 'policyId' must be defined.");
      url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processExternalBroker_DownloadPolicyTransactionData(_response), options_);
      });
  }

  protected processExternalBroker_DownloadPolicyTransactionData(response: Response): Promise<PolicyTransacionExportDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PolicyTransacionExportDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<PolicyTransacionExportDto>(null as any);
  }

    externalBroker_DownloadClientAssetSchedule(contactId: number): Promise<PolicyTransacionExportDto> {
        let url_ = this.baseUrl + "/api/ExternalBroker/extract/assetschedule/{contactId}";
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExternalBroker_DownloadClientAssetSchedule(_response), options_);
        });
    }

    protected processExternalBroker_DownloadClientAssetSchedule(response: Response): Promise<PolicyTransacionExportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PolicyTransacionExportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyTransacionExportDto>(null as any);
    }
    externalBroker_DownloadAUMReport(): Promise<PolicyTransacionExportDto> {
        let url_ = this.baseUrl + "/api/ExternalBroker/aum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExternalBroker_DownloadAUMReport(_response), options_);
        });
    }
    protected processExternalBroker_DownloadAUMReport(response: Response): Promise<PolicyTransacionExportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PolicyTransacionExportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyTransacionExportDto>(null as any);
    }
    externalBroker_DownloadPolicyTransaction(policyId: number): Promise<PolicyTransacionExportDto> {
        let url_ = this.baseUrl + "/api/ExternalBroker/extract/policytransaction/{policyId}";
        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExternalBroker_DownloadPolicyTransaction(_response), options_);
        });
    }

    protected processExternalBroker_DownloadPolicyTransaction(response: Response): Promise<PolicyTransacionExportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PolicyTransacionExportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyTransacionExportDto>(null as any);
    }

  companies_getCompanyDetails(contactId: number): Promise<CompanyDto> {
      let url_ = this.baseUrl + "/api/Companies/{contactId}";
      if (contactId === undefined || contactId === null)
          throw new Error("The parameter 'contactId' must be defined.");
      url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCompanies_getCompanyDetails(_response), options_);
      });
  }

  protected processCompanies_getCompanyDetails(response: Response): Promise<CompanyDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompanyDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<CompanyDto>(null as any);
  }

  companies_getCentralCompanyDetails(companyId: string): Promise<CompanyDetailsDto> {
      let url_ = this.baseUrl + "/api/Companies/central/{companyId}";
      if (companyId === undefined || companyId === null)
          throw new Error("The parameter 'companyId' must be defined.");
      url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
      url_ = url_.replace(/[?&]$/, "");

      let options_ = <RequestInit>{
          method: "GET",
          headers: {
              "Accept": "application/json"
          }
      };

      return this.transformOptions(options_).then(transformedOptions_ => {
          return this.http.fetch(url_, transformedOptions_);
      }).then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCompanies_getCentralCompanyDetails(_response), options_);
      });
  }

  protected processCompanies_getCentralCompanyDetails(response: Response): Promise<CompanyDetailsDto> {
      const status = response.status;
      let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
      if (status === 200) {
          return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompanyDetailsDto.fromJS(resultData200);
          return result200;
          });
      } else if (status !== 200 && status !== 204) {
          return response.text().then((_responseText) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
          });
      }
      return Promise.resolve<CompanyDetailsDto>(null as any);
  }
}

export class DepositAccountsDto implements IDepositAccountsDto {
  depositAccountNumber!: string | undefined;
  depositAccountSortCode!: string | undefined;
  depositAccountName!: string | undefined;
  depositAccountStartDate!: string | undefined;
  depositAccountMaturityDate!: string | undefined;
  depositAccountNotes!: string | undefined;
  depositAccountBalance_AccountCurrency!: string | undefined;
  contact!: ProfileDto | undefined;
  depostAccountStatusType!: DepostAccountStatusTypeDto | undefined;
  depositProducts!: DepositProductsDto | undefined;

  constructor(data?: IDepositAccountsDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.contact = data.contact && !(<any>data.contact).toJSON ? new ProfileDto(data.contact) : <ProfileDto>this.contact;
          this.depostAccountStatusType = data.depostAccountStatusType && !(<any>data.depostAccountStatusType).toJSON ? new DepostAccountStatusTypeDto(data.depostAccountStatusType) : <DepostAccountStatusTypeDto>this.depostAccountStatusType;
          this.depositProducts = data.depositProducts && !(<any>data.depositProducts).toJSON ? new DepositProductsDto(data.depositProducts) : <DepositProductsDto>this.depositProducts;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.depositAccountNumber = _data["depositAccountNumber"];
          this.depositAccountSortCode = _data["depositAccountSortCode"];
          this.depositAccountName = _data["depositAccountName"];
          this.depositAccountStartDate = _data["depositAccountStartDate"];
          this.depositAccountMaturityDate = _data["depositAccountMaturityDate"];
          this.depositAccountNotes = _data["depositAccountNotes"];
          this.depositAccountBalance_AccountCurrency = _data["depositAccountBalance_AccountCurrency"];
          this.contact = _data["contact"] ? ProfileDto.fromJS(_data["contact"]) : <any>undefined;
          this.depostAccountStatusType = _data["depostAccountStatusType"] ? DepostAccountStatusTypeDto.fromJS(_data["depostAccountStatusType"]) : <any>undefined;
          this.depositProducts = _data["depositProducts"] ? DepositProductsDto.fromJS(_data["depositProducts"]) : <any>undefined;
      }
  }

  static fromJS(data: any): DepositAccountsDto {
      data = typeof data === 'object' ? data : {};
      let result = new DepositAccountsDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["depositAccountNumber"] = this.depositAccountNumber;
      data["depositAccountSortCode"] = this.depositAccountSortCode;
      data["depositAccountName"] = this.depositAccountName;
      data["depositAccountStartDate"] = this.depositAccountStartDate;
      data["depositAccountMaturityDate"] = this.depositAccountMaturityDate;
      data["depositAccountNotes"] = this.depositAccountNotes;
      data["depositAccountBalance_AccountCurrency"] = this.depositAccountBalance_AccountCurrency;
      data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
      data["depostAccountStatusType"] = this.depostAccountStatusType ? this.depostAccountStatusType.toJSON() : <any>undefined;
      data["depositProducts"] = this.depositProducts ? this.depositProducts.toJSON() : <any>undefined;
      return data;
  }
}

export interface IDepositAccountsDto {
  depositAccountNumber: string | undefined;
  depositAccountSortCode: string | undefined;
  depositAccountName: string | undefined;
  depositAccountStartDate: string | undefined;
  depositAccountMaturityDate: string | undefined;
  depositAccountNotes: string | undefined;
  depositAccountBalance_AccountCurrency: string | undefined;
  contact: IProfileDto | undefined;
  depostAccountStatusType: IDepostAccountStatusTypeDto | undefined;
  depositProducts: IDepositProductsDto | undefined;
}

export class ProfileDto implements IProfileDto {
  id!: number;
  firstName!: string | undefined;
  lastName!: string | undefined;
  titleId!: number;
  title!: TitleDto | undefined;
  dateOfBirth!: string;
  workEmail!: string | undefined;
  personalEmail!: string | undefined;
  phoneNo!: string | undefined;
  mobileNo!: string | undefined;
  workNo!: string | undefined;
  faxNo!: string | undefined;
  addressLine_1!: string | undefined;
  addressLine_2!: string | undefined;
  addressLine_3!: string | undefined;
  addressLine_4!: string | undefined;
  addressCountyId!: number;
  addressCounty!: CountyDto | undefined;
  addressCountryId!: number;
  addressCountry!: CountryDto | undefined;
  brokerId!: number;

  constructor(data?: IProfileDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.title = data.title && !(<any>data.title).toJSON ? new TitleDto(data.title) : <TitleDto>this.title;
          this.addressCounty = data.addressCounty && !(<any>data.addressCounty).toJSON ? new CountyDto(data.addressCounty) : <CountyDto>this.addressCounty;
          this.addressCountry = data.addressCountry && !(<any>data.addressCountry).toJSON ? new CountryDto(data.addressCountry) : <CountryDto>this.addressCountry;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          this.titleId = _data["titleId"];
          this.title = _data["title"] ? TitleDto.fromJS(_data["title"]) : <any>undefined;
          this.dateOfBirth = _data["dateOfBirth"];
          this.workEmail = _data["workEmail"];
          this.personalEmail = _data["personalEmail"];
          this.phoneNo = _data["phoneNo"];
          this.mobileNo = _data["mobileNo"];
          this.workNo = _data["workNo"];
          this.faxNo = _data["faxNo"];
          this.addressLine_1 = _data["addressLine_1"];
          this.addressLine_2 = _data["addressLine_2"];
          this.addressLine_3 = _data["addressLine_3"];
          this.addressLine_4 = _data["addressLine_4"];
          this.addressCountyId = _data["addressCountyId"];
          this.addressCounty = _data["addressCounty"] ? CountyDto.fromJS(_data["addressCounty"]) : <any>undefined;
          this.addressCountryId = _data["addressCountryId"];
          this.addressCountry = _data["addressCountry"] ? CountryDto.fromJS(_data["addressCountry"]) : <any>undefined;
          this.brokerId = _data["brokerId"];
      }
  }

  static fromJS(data: any): ProfileDto {
      data = typeof data === 'object' ? data : {};
      let result = new ProfileDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["titleId"] = this.titleId;
      data["title"] = this.title ? this.title.toJSON() : <any>undefined;
      data["dateOfBirth"] = this.dateOfBirth;
      data["workEmail"] = this.workEmail;
      data["personalEmail"] = this.personalEmail;
      data["phoneNo"] = this.phoneNo;
      data["mobileNo"] = this.mobileNo;
      data["workNo"] = this.workNo;
      data["faxNo"] = this.faxNo;
      data["addressLine_1"] = this.addressLine_1;
      data["addressLine_2"] = this.addressLine_2;
      data["addressLine_3"] = this.addressLine_3;
      data["addressLine_4"] = this.addressLine_4;
      data["addressCountyId"] = this.addressCountyId;
      data["addressCounty"] = this.addressCounty ? this.addressCounty.toJSON() : <any>undefined;
      data["addressCountryId"] = this.addressCountryId;
      data["addressCountry"] = this.addressCountry ? this.addressCountry.toJSON() : <any>undefined;
      data["brokerId"] = this.brokerId;
      return data;
  }
}

export interface IProfileDto {
  id: number;
  firstName: string | undefined;
  lastName: string | undefined;
  titleId: number;
  title: ITitleDto | undefined;
  dateOfBirth: string;
  workEmail: string | undefined;
  personalEmail: string | undefined;
  phoneNo: string | undefined;
  mobileNo: string | undefined;
  workNo: string | undefined;
  faxNo: string | undefined;
  addressLine_1: string | undefined;
  addressLine_2: string | undefined;
  addressLine_3: string | undefined;
  addressLine_4: string | undefined;
  addressCountyId: number;
  addressCounty: ICountyDto | undefined;
  addressCountryId: number;
  addressCountry: ICountryDto | undefined;
  brokerId: number;
}

export class _LookupDtoBase implements I_LookupDtoBase {
  id!: number;
  name!: string | undefined;
  visibleInClientPortal!: boolean | undefined;

  constructor(data?: I_LookupDtoBase) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.visibleInClientPortal = _data["visibleInClientPortal"];
      }
  }

  static fromJS(data: any): _LookupDtoBase {
      data = typeof data === 'object' ? data : {};
      let result = new _LookupDtoBase();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["visibleInClientPortal"] = this.visibleInClientPortal;
      return data;
  }
}

export interface I_LookupDtoBase {
  id: number;
  name: string | undefined;
  visibleInClientPortal: boolean | undefined;
}

export class TitleDto extends _LookupDtoBase implements ITitleDto {

  constructor(data?: ITitleDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): TitleDto {
      data = typeof data === 'object' ? data : {};
      let result = new TitleDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface ITitleDto extends I_LookupDtoBase {
}

export class CountyDto extends _LookupDtoBase implements ICountyDto {
  customSortId!: number;

  constructor(data?: ICountyDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.customSortId = _data["customSortId"];
      }
  }

  static fromJS(data: any): CountyDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountyDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["customSortId"] = this.customSortId;
      super.toJSON(data);
      return data;
  }
}

export interface ICountyDto extends I_LookupDtoBase {
  customSortId: number;
}

export class CountryDto extends _LookupDtoBase implements ICountryDto {

  constructor(data?: ICountryDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): CountryDto {
      data = typeof data === 'object' ? data : {};
      let result = new CountryDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface ICountryDto extends I_LookupDtoBase {
}

export class DepostAccountStatusTypeDto implements IDepostAccountStatusTypeDto {
  name!: string | undefined;

  constructor(data?: IDepostAccountStatusTypeDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): DepostAccountStatusTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new DepostAccountStatusTypeDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["name"] = this.name;
      return data;
  }
}

export interface IDepostAccountStatusTypeDto {
  name: string | undefined;
}

export class DepositProductsDto implements IDepositProductsDto {
  fK_DepositProviderID!: number;
  policyProvider!: ProductProviderDto | undefined;

  constructor(data?: IDepositProductsDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.policyProvider = data.policyProvider && !(<any>data.policyProvider).toJSON ? new ProductProviderDto(data.policyProvider) : <ProductProviderDto>this.policyProvider;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.fK_DepositProviderID = _data["fK_DepositProviderID"];
          this.policyProvider = _data["policyProvider"] ? ProductProviderDto.fromJS(_data["policyProvider"]) : <any>undefined;
      }
  }

  static fromJS(data: any): DepositProductsDto {
      data = typeof data === 'object' ? data : {};
      let result = new DepositProductsDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["fK_DepositProviderID"] = this.fK_DepositProviderID;
      data["policyProvider"] = this.policyProvider ? this.policyProvider.toJSON() : <any>undefined;
      return data;
  }
}

export interface IDepositProductsDto {
  fK_DepositProviderID: number;
  policyProvider: IProductProviderDto | undefined;
}

export class ProductProviderDto extends _LookupDtoBase implements IProductProviderDto {

  constructor(data?: IProductProviderDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): ProductProviderDto {
      data = typeof data === 'object' ? data : {};
      let result = new ProductProviderDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IProductProviderDto extends I_LookupDtoBase {
}

export class PolicyBenefitGroupDto implements IPolicyBenefitGroupDto {
  contactName!: string | undefined;
  benefits!: PolicyBenefitDto[] | undefined;

  constructor(data?: IPolicyBenefitGroupDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          if (data.benefits) {
              this.benefits = [];
              for (let i = 0; i < data.benefits.length; i++) {
                  let item = data.benefits[i];
                  this.benefits[i] = item && !(<any>item).toJSON ? new PolicyBenefitDto(item) : <PolicyBenefitDto>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.contactName = _data["contactName"];
          if (Array.isArray(_data["benefits"])) {
              this.benefits = [] as any;
              for (let item of _data["benefits"])
                  this.benefits!.push(PolicyBenefitDto.fromJS(item));
          }
      }
  }

  static fromJS(data: any): PolicyBenefitGroupDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyBenefitGroupDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["contactName"] = this.contactName;
      if (Array.isArray(this.benefits)) {
          data["benefits"] = [];
          for (let item of this.benefits)
              data["benefits"].push(item.toJSON());
      }
      return data;
  }
}

export interface IPolicyBenefitGroupDto {
  contactName: string | undefined;
  benefits: IPolicyBenefitDto[] | undefined;
}

export class PolicyBenefitDto implements IPolicyBenefitDto {
  id!: number;
  policyId!: number;
  type!: PolicyBenefitTypeDTO | undefined;
  client!: ClientSelector;
  benefitAmount!: number;
  benefitNotes!: string | undefined;
  contactName!: string | undefined;
  roleTypeName!: string | undefined;
  typeName!: string | undefined;
  statusName!: string | undefined;

  constructor(data?: IPolicyBenefitDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.type = data.type && !(<any>data.type).toJSON ? new PolicyBenefitTypeDTO(data.type) : <PolicyBenefitTypeDTO>this.type;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.policyId = _data["policyId"];
          this.type = _data["type"] ? PolicyBenefitTypeDTO.fromJS(_data["type"]) : <any>undefined;
          this.client = _data["client"];
          this.benefitAmount = _data["benefitAmount"];
          this.benefitNotes = _data["benefitNotes"];
          this.contactName = _data["contactName"];
          this.roleTypeName = _data["roleTypeName"];
          this.typeName = _data["typeName"];
          this.statusName = _data["statusName"];
      }
  }

  static fromJS(data: any): PolicyBenefitDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyBenefitDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["policyId"] = this.policyId;
      data["type"] = this.type ? this.type.toJSON() : <any>undefined;
      data["client"] = this.client;
      data["benefitAmount"] = this.benefitAmount;
      data["benefitNotes"] = this.benefitNotes;
      data["contactName"] = this.contactName;
      data["roleTypeName"] = this.roleTypeName;
      data["typeName"] = this.typeName;
      data["statusName"] = this.statusName;
      return data;
  }
}

export interface IPolicyBenefitDto {
  id: number;
  policyId: number;
  type: IPolicyBenefitTypeDTO | undefined;
  client: ClientSelector;
  benefitAmount: number;
  benefitNotes: string | undefined;
  contactName: string | undefined;
  roleTypeName: string | undefined;
  typeName: string | undefined;
  statusName: string | undefined;
}

export class PolicyBenefitTypeDTO extends _LookupDtoBase implements IPolicyBenefitTypeDTO {

  constructor(data?: IPolicyBenefitTypeDTO) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): PolicyBenefitTypeDTO {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyBenefitTypeDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IPolicyBenefitTypeDTO extends I_LookupDtoBase {
}

export enum ClientSelector {
  Main = 1,
  Partner = 2,
  Both = 3,
  PensionClientMain = 5,
  PensionClientPartner = 6,
}

export class PolicyFundDto implements IPolicyFundDto {
  rateFundDescription!: string | undefined;
  value!: number;
  rateValueDate!: string | undefined;
  notes!: string | undefined;
  typeName!: string | undefined;

  constructor(data?: IPolicyFundDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.rateFundDescription = _data["rateFundDescription"];
          this.value = _data["value"];
          this.rateValueDate = _data["rateValueDate"];
          this.notes = _data["notes"];
          this.typeName = _data["typeName"];
      }
  }

  static fromJS(data: any): PolicyFundDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyFundDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["rateFundDescription"] = this.rateFundDescription;
      data["value"] = this.value;
      data["rateValueDate"] = this.rateValueDate;
      data["notes"] = this.notes;
      data["typeName"] = this.typeName;
      return data;
  }
}

export interface IPolicyFundDto {
  rateFundDescription: string | undefined;
  value: number;
  rateValueDate: string | undefined;
  notes: string | undefined;
  typeName: string | undefined;
}

export class PerformanceChartDataDto implements IPerformanceChartDataDto {
  fundSeries!: PerformanceChartSeriesDto[] | undefined;
  totalSeries!: PerformanceChartSeriesDto[] | undefined;
  fundSeriesMinValue!: number;
  totalSeriesMinValue!: number;
  oneYearPercentageChange!: KeyValuePairOfDateTimeAndDecimal;
  threeYearPercentageChange!: KeyValuePairOfDateTimeAndDecimal;
  oneYearPercentageMonthlyChange!: KeyValuePairOfDateTimeAndDecimal;
  oneYearPercentageChangeLessAmountInvested!: KeyValuePairOfDateTimeAndDecimal;

  constructor(data?: IPerformanceChartDataDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          if (data.fundSeries) {
              this.fundSeries = [];
              for (let i = 0; i < data.fundSeries.length; i++) {
                  let item = data.fundSeries[i];
                  this.fundSeries[i] = item && !(<any>item).toJSON ? new PerformanceChartSeriesDto(item) : <PerformanceChartSeriesDto>item;
              }
          }
          if (data.totalSeries) {
              this.totalSeries = [];
              for (let i = 0; i < data.totalSeries.length; i++) {
                  let item = data.totalSeries[i];
                  this.totalSeries[i] = item && !(<any>item).toJSON ? new PerformanceChartSeriesDto(item) : <PerformanceChartSeriesDto>item;
              }
          }
          this.oneYearPercentageChange = data.oneYearPercentageChange && !(<any>data.oneYearPercentageChange).toJSON ? new KeyValuePairOfDateTimeAndDecimal(data.oneYearPercentageChange) : <KeyValuePairOfDateTimeAndDecimal>this.oneYearPercentageChange;
          this.threeYearPercentageChange = data.threeYearPercentageChange && !(<any>data.threeYearPercentageChange).toJSON ? new KeyValuePairOfDateTimeAndDecimal(data.threeYearPercentageChange) : <KeyValuePairOfDateTimeAndDecimal>this.threeYearPercentageChange;
          this.oneYearPercentageMonthlyChange = data.oneYearPercentageMonthlyChange && !(<any>data.oneYearPercentageMonthlyChange).toJSON ? new KeyValuePairOfDateTimeAndDecimal(data.oneYearPercentageMonthlyChange) : <KeyValuePairOfDateTimeAndDecimal>this.oneYearPercentageMonthlyChange;
          this.oneYearPercentageChangeLessAmountInvested = data.oneYearPercentageChangeLessAmountInvested && !(<any>data.oneYearPercentageChangeLessAmountInvested).toJSON ? new KeyValuePairOfDateTimeAndDecimal(data.oneYearPercentageChangeLessAmountInvested) : <KeyValuePairOfDateTimeAndDecimal>this.oneYearPercentageChangeLessAmountInvested;
      }
  }

  init(_data?: any) {
      if (_data) {
          if (Array.isArray(_data["fundSeries"])) {
              this.fundSeries = [] as any;
              for (let item of _data["fundSeries"])
                  this.fundSeries!.push(PerformanceChartSeriesDto.fromJS(item));
          }
          if (Array.isArray(_data["totalSeries"])) {
              this.totalSeries = [] as any;
              for (let item of _data["totalSeries"])
                  this.totalSeries!.push(PerformanceChartSeriesDto.fromJS(item));
          }
          this.fundSeriesMinValue = _data["fundSeriesMinValue"];
          this.totalSeriesMinValue = _data["totalSeriesMinValue"];
          this.oneYearPercentageChange = _data["oneYearPercentageChange"] ? KeyValuePairOfDateTimeAndDecimal.fromJS(_data["oneYearPercentageChange"]) : <any>undefined;
          this.threeYearPercentageChange = _data["threeYearPercentageChange"] ? KeyValuePairOfDateTimeAndDecimal.fromJS(_data["threeYearPercentageChange"]) : <any>undefined;
          this.oneYearPercentageMonthlyChange = _data["oneYearPercentageMonthlyChange"] ? KeyValuePairOfDateTimeAndDecimal.fromJS(_data["oneYearPercentageMonthlyChange"]) : <any>undefined;
          this.oneYearPercentageChangeLessAmountInvested = _data["oneYearPercentageChangeLessAmountInvested"] ? KeyValuePairOfDateTimeAndDecimal.fromJS(_data["oneYearPercentageChangeLessAmountInvested"]) : <any>undefined;
      }
  }

  static fromJS(data: any): PerformanceChartDataDto {
      data = typeof data === 'object' ? data : {};
      let result = new PerformanceChartDataDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.fundSeries)) {
          data["fundSeries"] = [];
          for (let item of this.fundSeries)
              data["fundSeries"].push(item.toJSON());
      }
      if (Array.isArray(this.totalSeries)) {
          data["totalSeries"] = [];
          for (let item of this.totalSeries)
              data["totalSeries"].push(item.toJSON());
      }
      data["fundSeriesMinValue"] = this.fundSeriesMinValue;
      data["totalSeriesMinValue"] = this.totalSeriesMinValue;
      data["oneYearPercentageChange"] = this.oneYearPercentageChange ? this.oneYearPercentageChange.toJSON() : <any>undefined;
      data["threeYearPercentageChange"] = this.threeYearPercentageChange ? this.threeYearPercentageChange.toJSON() : <any>undefined;
      data["oneYearPercentageMonthlyChange"] = this.oneYearPercentageMonthlyChange ? this.oneYearPercentageMonthlyChange.toJSON() : <any>undefined;
      data["oneYearPercentageChangeLessAmountInvested"] = this.oneYearPercentageChangeLessAmountInvested ? this.oneYearPercentageChangeLessAmountInvested.toJSON() : <any>undefined;
      return data;
  }
}

export interface IPerformanceChartDataDto {
  fundSeries: IPerformanceChartSeriesDto[] | undefined;
  totalSeries: IPerformanceChartSeriesDto[] | undefined;
  fundSeriesMinValue: number;
  totalSeriesMinValue: number;
  oneYearPercentageChange: IKeyValuePairOfDateTimeAndDecimal;
  threeYearPercentageChange: IKeyValuePairOfDateTimeAndDecimal;
  oneYearPercentageMonthlyChange: IKeyValuePairOfDateTimeAndDecimal;
  oneYearPercentageChangeLessAmountInvested: IKeyValuePairOfDateTimeAndDecimal;
}

export class PerformanceChartSeriesDto implements IPerformanceChartSeriesDto {
  name!: string | undefined;
  data!: { [key: string]: number; } | undefined;

  constructor(data?: IPerformanceChartSeriesDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.name = _data["name"];
          if (_data["data"]) {
              this.data = {} as any;
              for (let key in _data["data"]) {
                  if (_data["data"].hasOwnProperty(key))
                      (<any>this.data)![key] = _data["data"][key];
              }
          }
      }
  }

  static fromJS(data: any): PerformanceChartSeriesDto {
      data = typeof data === 'object' ? data : {};
      let result = new PerformanceChartSeriesDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["name"] = this.name;
      if (this.data) {
          data["data"] = {};
          for (let key in this.data) {
              if (this.data.hasOwnProperty(key))
                  (<any>data["data"])[key] = (<any>this.data)[key];
          }
      }
      return data;
  }
}

export interface IPerformanceChartSeriesDto {
  name: string | undefined;
  data: { [key: string]: number; } | undefined;
}

export class KeyValuePairOfDateTimeAndDecimal implements IKeyValuePairOfDateTimeAndDecimal {
  key!: string;
  value!: number;

  constructor(data?: IKeyValuePairOfDateTimeAndDecimal) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.key = _data["key"];
          this.value = _data["value"];
      }
  }

  static fromJS(data: any): KeyValuePairOfDateTimeAndDecimal {
      data = typeof data === 'object' ? data : {};
      let result = new KeyValuePairOfDateTimeAndDecimal();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["key"] = this.key;
      data["value"] = this.value;
      return data;
  }
}

export interface IKeyValuePairOfDateTimeAndDecimal {
  key: string;
  value: number;
}

export class PolicyDto implements IPolicyDto {
  id!: number;
  statusName!: string | undefined;
  categoryName!: string | undefined;
  subCategoryName!: string | undefined;
  categoryMasterCategoryConstant!: string | undefined;
  statusMasterCategoryConstant!: string | undefined;
  policyNo!: string | undefined;
  inceptionDate!: string;
  maturityDate!: string;
  fundValueDate!: string;
  premium!: number;
  providerName!: string | undefined;
  totalFundValue!: number;
  totalPremiumsPaid!: number;
  indexation!: boolean;
  convertible!: boolean;
  paymentFrequencyName!: string | undefined;
  annualPolicyPremium!: number;
  policyRoles!: PolicyRoleDto[] | undefined;
  perf!: number;

  constructor(data?: IPolicyDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          if (data.policyRoles) {
              this.policyRoles = [];
              for (let i = 0; i < data.policyRoles.length; i++) {
                  let item = data.policyRoles[i];
                  this.policyRoles[i] = item && !(<any>item).toJSON ? new PolicyRoleDto(item) : <PolicyRoleDto>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.statusName = _data["statusName"];
          this.categoryName = _data["categoryName"];
          this.subCategoryName = _data["subCategoryName"];
          this.categoryMasterCategoryConstant = _data["categoryMasterCategoryConstant"];
          this.statusMasterCategoryConstant = _data["statusMasterCategoryConstant"];
          this.policyNo = _data["policyNo"];
          this.inceptionDate = _data["inceptionDate"];
          this.maturityDate = _data["maturityDate"];
          this.fundValueDate = _data["fundValueDate"];
          this.premium = _data["premium"];
          this.providerName = _data["providerName"];
          this.totalFundValue = _data["totalFundValue"];
          this.totalPremiumsPaid = _data["totalPremiumsPaid"];
          this.indexation = _data["indexation"];
          this.convertible = _data["convertible"];
          this.paymentFrequencyName = _data["paymentFrequencyName"];
          this.annualPolicyPremium = _data["annualPolicyPremium"];
          if (Array.isArray(_data["policyRoles"])) {
              this.policyRoles = [] as any;
              for (let item of _data["policyRoles"])
                  this.policyRoles!.push(PolicyRoleDto.fromJS(item));
          }
          this.perf = _data["perf"];
      }
  }

  static fromJS(data: any): PolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["statusName"] = this.statusName;
      data["categoryName"] = this.categoryName;
      data["subCategoryName"] = this.subCategoryName;
      data["categoryMasterCategoryConstant"] = this.categoryMasterCategoryConstant;
      data["statusMasterCategoryConstant"] = this.statusMasterCategoryConstant;
      data["policyNo"] = this.policyNo;
      data["inceptionDate"] = this.inceptionDate;
      data["maturityDate"] = this.maturityDate;
      data["fundValueDate"] = this.fundValueDate;
      data["premium"] = this.premium;
      data["providerName"] = this.providerName;
      data["totalFundValue"] = this.totalFundValue;
      data["totalPremiumsPaid"] = this.totalPremiumsPaid;
      data["indexation"] = this.indexation;
      data["convertible"] = this.convertible;
      data["paymentFrequencyName"] = this.paymentFrequencyName;
      data["annualPolicyPremium"] = this.annualPolicyPremium;
      if (Array.isArray(this.policyRoles)) {
          data["policyRoles"] = [];
          for (let item of this.policyRoles)
              data["policyRoles"].push(item.toJSON());
      }
      data["perf"] = this.perf;
      return data;
  }
}

export interface IPolicyDto {
  id: number;
  statusName: string | undefined;
  categoryName: string | undefined;
  subCategoryName: string | undefined;
  categoryMasterCategoryConstant: string | undefined;
  statusMasterCategoryConstant: string | undefined;
  policyNo: string | undefined;
  inceptionDate: string;
  maturityDate: string;
  fundValueDate: string;
  premium: number;
  providerName: string | undefined;
  totalFundValue: number;
  totalPremiumsPaid: number;
  indexation: boolean;
  convertible: boolean;
  paymentFrequencyName: string | undefined;
  annualPolicyPremium: number;
  policyRoles: IPolicyRoleDto[] | undefined;
  perf: number;
}

export class PolicyRoleDto implements IPolicyRoleDto {
  id!: number;
  policyId!: number;
  contactId!: number;
  clientSelector!: ClientSelector;
  typeName!: string | undefined;
  contactName!: string | undefined;
  typeId!: number;

  constructor(data?: IPolicyRoleDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.policyId = _data["policyId"];
          this.contactId = _data["contactId"];
          this.clientSelector = _data["clientSelector"];
          this.typeName = _data["typeName"];
          this.contactName = _data["contactName"];
          this.typeId = _data["typeId"];
      }
  }

  static fromJS(data: any): PolicyRoleDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyRoleDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["policyId"] = this.policyId;
      data["contactId"] = this.contactId;
      data["clientSelector"] = this.clientSelector;
      data["typeName"] = this.typeName;
      data["contactName"] = this.contactName;
      data["typeId"] = this.typeId;
      return data;
  }
}

export interface IPolicyRoleDto {
  id: number;
  policyId: number;
  contactId: number;
  clientSelector: ClientSelector;
  typeName: string | undefined;
  contactName: string | undefined;
  typeId: number;
}

export abstract class _BaseRequestOfListOfPolicyDto implements I_BaseRequestOfListOfPolicyDto {

  constructor(data?: I_BaseRequestOfListOfPolicyDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
  }

  static fromJS(data: any): _BaseRequestOfListOfPolicyDto {
      data = typeof data === 'object' ? data : {};
      throw new Error("The abstract class '_BaseRequestOfListOfPolicyDto' cannot be instantiated.");
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
  }
}

export interface I_BaseRequestOfListOfPolicyDto {
}

export class ListByPolicyIdQuery extends _BaseRequestOfListOfPolicyDto implements IListByPolicyIdQuery {
  policyRoles!: PolicyRoleDto[] | undefined;

  constructor(data?: IListByPolicyIdQuery) {
      super(data);
      if (data) {
          if (data.policyRoles) {
              this.policyRoles = [];
              for (let i = 0; i < data.policyRoles.length; i++) {
                  let item = data.policyRoles[i];
                  this.policyRoles[i] = item && !(<any>item).toJSON ? new PolicyRoleDto(item) : <PolicyRoleDto>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          if (Array.isArray(_data["policyRoles"])) {
              this.policyRoles = [] as any;
              for (let item of _data["policyRoles"])
                  this.policyRoles!.push(PolicyRoleDto.fromJS(item));
          }
      }
  }

  static fromJS(data: any): ListByPolicyIdQuery {
      data = typeof data === 'object' ? data : {};
      let result = new ListByPolicyIdQuery();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.policyRoles)) {
          data["policyRoles"] = [];
          for (let item of this.policyRoles)
              data["policyRoles"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IListByPolicyIdQuery extends I_BaseRequestOfListOfPolicyDto {
  policyRoles: IPolicyRoleDto[] | undefined;
}

export class PolicyCountSummaryDto implements IPolicyCountSummaryDto {
  protection!: number;
  investments!: number;
  pensions!: number;

  constructor(data?: IPolicyCountSummaryDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.protection = _data["protection"];
          this.investments = _data["investments"];
          this.pensions = _data["pensions"];
      }
  }

  static fromJS(data: any): PolicyCountSummaryDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyCountSummaryDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["protection"] = this.protection;
      data["investments"] = this.investments;
      data["pensions"] = this.pensions;
      return data;
  }
}

export interface IPolicyCountSummaryDto {
  protection: number;
  investments: number;
  pensions: number;
}

export class PolicyValuesDto implements IPolicyValuesDto {
  value!: number;
  date!: string | undefined;
  notes!: string | undefined;
  policyId!: number;
  typeName!: string | undefined;

  constructor(data?: IPolicyValuesDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.value = _data["value"];
          this.date = _data["date"];
          this.notes = _data["notes"];
          this.policyId = _data["policyId"];
          this.typeName = _data["typeName"];
      }
  }

  static fromJS(data: any): PolicyValuesDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyValuesDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["value"] = this.value;
      data["date"] = this.date;
      data["notes"] = this.notes;
      data["policyId"] = this.policyId;
      data["typeName"] = this.typeName;
      return data;
  }
}

export interface IPolicyValuesDto {
  value: number;
  date: string | undefined;
  notes: string | undefined;
  policyId: number;
  typeName: string | undefined;
}

export class ContactProfileDto implements IContactProfileDto {
  id!: number;
  titleName!: string | undefined;
  firstName!: string | undefined;
  lastName!: string | undefined;
  schemeName!: string | undefined;
  dateOfBirth!: string;
  genderName!: string | undefined;
  maritalStatusName!: string | undefined;
  phoneNo!: string | undefined;
  mobileNo!: string | undefined;
  workNo!: string | undefined;
  faxNo!: string | undefined;
  smokerStatusName!: string | undefined;
  healthStatusName!: string | undefined;
  healthStatusOther!: string | undefined;
  ppsNumber!: string | undefined;
  nationalDomicileName!: string | undefined;
  addressLine1!: string | undefined;
  addressLine2!: string | undefined;
  addressLine3!: string | undefined;
  addressLine4!: string | undefined;
  addressCountyName!: string | undefined;
  addressCountryName!: string | undefined;
  postCode!: string | undefined;
  addressBlock!: string | undefined;
  email!: string | undefined;
  employmentStatusName!: string | undefined;
  mainOccupationName!: string | undefined;
  employerName!: string | undefined;
  sP_FirstName!: string | undefined;
  sP_LastName!: string | undefined;
  sP_SchemeName!: string | undefined;
  sP_DateOfBirth!: string | undefined;
  sP_TitleName!: string | undefined;
  sP_GenderName!: string | undefined;
  sP_MaritalStatusName!: string | undefined;
  sP_TaxBasisAssessment_Name!: string | undefined;
  sP_PhoneNo!: string | undefined;
  sP_MobileNo!: string | undefined;
  sP_WorkNo!: string | undefined;
  sP_SmokerStatusName!: string | undefined;
  sP_HealthStatusName!: string | undefined;
  sP_HealthStatusOther!: string | undefined;
  sP_PPSNumber!: string | undefined;
  sP_NationalDomicileName!: string | undefined;
  sP_AddressLine_1!: string | undefined;
  sP_AddressLine_2!: string | undefined;
  sP_AddressLine_3!: string | undefined;
  sP_AddressLine_4!: string | undefined;
  sP_AddressCountyName!: string | undefined;
  sP_AddressCountryName!: string | undefined;
  sP_PostCode!: string | undefined;
  sP_AddressBlock!: string | undefined;
  sP_Email!: string | undefined;
  sP_EmploymentStatusName!: string | undefined;
  sP_MainOccupationName!: string | undefined;
  sP_EmployerName!: string | undefined;
  ownerId!: number;
  ownerName!: string | undefined;
  ownerEmail!: string | undefined;
  riskLevel!: string | undefined;
  sP_RiskLevel!: string | undefined;
  brokerId!: number;
  contactStatusName!: string | undefined;
  fileRef!: string | undefined;
  brokerCompanyEmailAddress!: string | undefined;
  brokerBrokerName!: string | undefined;
  constructor(data?: IContactProfileDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.titleName = _data["titleName"];
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          this.schemeName = _data["schemeName"];
          this.dateOfBirth = _data["dateOfBirth"];
          this.genderName = _data["genderName"];
          this.maritalStatusName = _data["maritalStatusName"];
          this.phoneNo = _data["phoneNo"];
          this.mobileNo = _data["mobileNo"];
          this.workNo = _data["workNo"];
          this.faxNo = _data["faxNo"];
          this.smokerStatusName = _data["smokerStatusName"];
          this.healthStatusName = _data["healthStatusName"];
          this.healthStatusOther = _data["healthStatusOther"];
          this.ppsNumber = _data["ppsNumber"];
          this.nationalDomicileName = _data["nationalDomicileName"];
          this.addressLine1 = _data["addressLine1"];
          this.addressLine2 = _data["addressLine2"];
          this.addressLine3 = _data["addressLine3"];
          this.addressLine4 = _data["addressLine4"];
          this.addressCountyName = _data["addressCountyName"];
          this.addressCountryName = _data["addressCountryName"];
          this.postCode = _data["postCode"];
          this.addressBlock = _data["addressBlock"];
          this.email = _data["email"];
          this.employmentStatusName = _data["employmentStatusName"];
          this.mainOccupationName = _data["mainOccupationName"];
          this.employerName = _data["employerName"];
          this.sP_FirstName = _data["sP_FirstName"];
          this.sP_LastName = _data["sP_LastName"];
          this.sP_SchemeName = _data["sP_SchemeName"];
          this.sP_DateOfBirth = _data["sP_DateOfBirth"];
          this.sP_TitleName = _data["sP_TitleName"];
          this.sP_GenderName = _data["sP_GenderName"];
          this.sP_MaritalStatusName = _data["sP_MaritalStatusName"];
          this.sP_TaxBasisAssessment_Name = _data["sP_TaxBasisAssessment_Name"];
          this.sP_PhoneNo = _data["sP_PhoneNo"];
          this.sP_MobileNo = _data["sP_MobileNo"];
          this.sP_WorkNo = _data["sP_WorkNo"];
          this.sP_SmokerStatusName = _data["sP_SmokerStatusName"];
          this.sP_HealthStatusName = _data["sP_HealthStatusName"];
          this.sP_HealthStatusOther = _data["sP_HealthStatusOther"];
          this.sP_PPSNumber = _data["sP_PPSNumber"];
          this.sP_NationalDomicileName = _data["sP_NationalDomicileName"];
          this.sP_AddressLine_1 = _data["sP_AddressLine_1"];
          this.sP_AddressLine_2 = _data["sP_AddressLine_2"];
          this.sP_AddressLine_3 = _data["sP_AddressLine_3"];
          this.sP_AddressLine_4 = _data["sP_AddressLine_4"];
          this.sP_AddressCountyName = _data["sP_AddressCountyName"];
          this.sP_AddressCountryName = _data["sP_AddressCountryName"];
          this.sP_PostCode = _data["sP_PostCode"];
          this.sP_AddressBlock = _data["sP_AddressBlock"];
          this.sP_Email = _data["sP_Email"];
          this.sP_EmploymentStatusName = _data["sP_EmploymentStatusName"];
          this.sP_MainOccupationName = _data["sP_MainOccupationName"];
          this.sP_EmployerName = _data["sP_EmployerName"];
          this.ownerId = _data["ownerId"];
          this.ownerName = _data["ownerName"];
          this.ownerEmail = _data["ownerEmail"];
          this.riskLevel = _data["riskLevel"];
          this.sP_RiskLevel = _data["sP_RiskLevel"];
          this.brokerId = _data["brokerId"];
          this.contactStatusName = _data["contactStatusName"];
          this.fileRef = _data["fileRef"];
          this.brokerCompanyEmailAddress = _data["brokerCompanyEmailAddress"];
          this.brokerBrokerName = _data["brokerBrokerName"];
      }
  }

  static fromJS(data: any): ContactProfileDto {
      data = typeof data === 'object' ? data : {};
      let result = new ContactProfileDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["titleName"] = this.titleName;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["schemeName"] = this.schemeName;
      data["dateOfBirth"] = this.dateOfBirth;
      data["genderName"] = this.genderName;
      data["maritalStatusName"] = this.maritalStatusName;
      data["phoneNo"] = this.phoneNo;
      data["mobileNo"] = this.mobileNo;
      data["workNo"] = this.workNo;
      data["faxNo"] = this.faxNo;
      data["smokerStatusName"] = this.smokerStatusName;
      data["healthStatusName"] = this.healthStatusName;
      data["healthStatusOther"] = this.healthStatusOther;
      data["ppsNumber"] = this.ppsNumber;
      data["nationalDomicileName"] = this.nationalDomicileName;
      data["addressLine1"] = this.addressLine1;
      data["addressLine2"] = this.addressLine2;
      data["addressLine3"] = this.addressLine3;
      data["addressLine4"] = this.addressLine4;
      data["addressCountyName"] = this.addressCountyName;
      data["addressCountryName"] = this.addressCountryName;
      data["postCode"] = this.postCode;
      data["addressBlock"] = this.addressBlock;
      data["email"] = this.email;
      data["employmentStatusName"] = this.employmentStatusName;
      data["mainOccupationName"] = this.mainOccupationName;
      data["employerName"] = this.employerName;
      data["sP_FirstName"] = this.sP_FirstName;
      data["sP_LastName"] = this.sP_LastName;
      data["sP_SchemeName"] = this.sP_SchemeName;
      data["sP_DateOfBirth"] = this.sP_DateOfBirth;
      data["sP_TitleName"] = this.sP_TitleName;
      data["sP_GenderName"] = this.sP_GenderName;
      data["sP_MaritalStatusName"] = this.sP_MaritalStatusName;
      data["sP_TaxBasisAssessment_Name"] = this.sP_TaxBasisAssessment_Name;
      data["sP_PhoneNo"] = this.sP_PhoneNo;
      data["sP_MobileNo"] = this.sP_MobileNo;
      data["sP_WorkNo"] = this.sP_WorkNo;
      data["sP_SmokerStatusName"] = this.sP_SmokerStatusName;
      data["sP_HealthStatusName"] = this.sP_HealthStatusName;
      data["sP_HealthStatusOther"] = this.sP_HealthStatusOther;
      data["sP_PPSNumber"] = this.sP_PPSNumber;
      data["sP_NationalDomicileName"] = this.sP_NationalDomicileName;
      data["sP_AddressLine_1"] = this.sP_AddressLine_1;
      data["sP_AddressLine_2"] = this.sP_AddressLine_2;
      data["sP_AddressLine_3"] = this.sP_AddressLine_3;
      data["sP_AddressLine_4"] = this.sP_AddressLine_4;
      data["sP_AddressCountyName"] = this.sP_AddressCountyName;
      data["sP_AddressCountryName"] = this.sP_AddressCountryName;
      data["sP_PostCode"] = this.sP_PostCode;
      data["sP_AddressBlock"] = this.sP_AddressBlock;
      data["sP_Email"] = this.sP_Email;
      data["sP_EmploymentStatusName"] = this.sP_EmploymentStatusName;
      data["sP_MainOccupationName"] = this.sP_MainOccupationName;
      data["sP_EmployerName"] = this.sP_EmployerName;
      data["ownerId"] = this.ownerId;
      data["ownerName"] = this.ownerName;
      data["ownerEmail"] = this.ownerEmail;
      data["riskLevel"] = this.riskLevel;
      data["sP_RiskLevel"] = this.sP_RiskLevel;
      data["brokerId"] = this.brokerId;
      data["contactStatusName"] = this.contactStatusName;
      data["fileRef"] = this.fileRef;
      data["brokerCompanyEmailAddress"] = this.brokerCompanyEmailAddress;
      data["brokerBrokerName"] = this.brokerBrokerName;
      return data;
  }
}

export interface IContactProfileDto {
  id: number;
  titleName: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  schemeName: string | undefined;
  dateOfBirth: string;
  genderName: string | undefined;
  maritalStatusName: string | undefined;
  phoneNo: string | undefined;
  mobileNo: string | undefined;
  workNo: string | undefined;
  faxNo: string | undefined;
  smokerStatusName: string | undefined;
  healthStatusName: string | undefined;
  healthStatusOther: string | undefined;
  ppsNumber: string | undefined;
  nationalDomicileName: string | undefined;
  addressLine1: string | undefined;
  addressLine2: string | undefined;
  addressLine3: string | undefined;
  addressLine4: string | undefined;
  addressCountyName: string | undefined;
  addressCountryName: string | undefined;
  postCode: string | undefined;
  addressBlock: string | undefined;
  email: string | undefined;
  employmentStatusName: string | undefined;
  mainOccupationName: string | undefined;
  employerName: string | undefined;
  sP_FirstName: string | undefined;
  sP_LastName: string | undefined;
  sP_SchemeName: string | undefined;
  sP_DateOfBirth: string | undefined;
  sP_TitleName: string | undefined;
  sP_GenderName: string | undefined;
  sP_MaritalStatusName: string | undefined;
  sP_TaxBasisAssessment_Name: string | undefined;
  sP_PhoneNo: string | undefined;
  sP_MobileNo: string | undefined;
  sP_WorkNo: string | undefined;
  sP_SmokerStatusName: string | undefined;
  sP_HealthStatusName: string | undefined;
  sP_HealthStatusOther: string | undefined;
  sP_PPSNumber: string | undefined;
  sP_NationalDomicileName: string | undefined;
  sP_AddressLine_1: string | undefined;
  sP_AddressLine_2: string | undefined;
  sP_AddressLine_3: string | undefined;
  sP_AddressLine_4: string | undefined;
  sP_AddressCountyName: string | undefined;
  sP_AddressCountryName: string | undefined;
  sP_PostCode: string | undefined;
  sP_AddressBlock: string | undefined;
  sP_Email: string | undefined;
  sP_EmploymentStatusName: string | undefined;
  sP_MainOccupationName: string | undefined;
  sP_EmployerName: string | undefined;
  ownerId: number;
  ownerName: string | undefined;
  ownerEmail: string | undefined;
  riskLevel: string | undefined;
  sP_RiskLevel: string | undefined;
  brokerId: number;
  contactStatusName: string | undefined;
  fileRef: string | undefined;
  brokerCompanyEmailAddress: string | undefined;
  brokerBrokerName: string | undefined;
}

export class RiskProfileQuestionDto implements IRiskProfileQuestionDto {
  id!: number;
  sortOrder!: number;
  text!: string | undefined;
  multipleAnswersAllowed!: boolean;
  includesImage!: boolean;
  imageUrl!: string | undefined;
  uiControlType!: UIControlType;
  uiControlWidth!: number;
  answerRequired!: boolean;
  answers!: RiskProfileAnswerDto[] | undefined;

  constructor(data?: IRiskProfileQuestionDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          if (data.answers) {
              this.answers = [];
              for (let i = 0; i < data.answers.length; i++) {
                  let item = data.answers[i];
                  this.answers[i] = item && !(<any>item).toJSON ? new RiskProfileAnswerDto(item) : <RiskProfileAnswerDto>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.sortOrder = _data["sortOrder"];
          this.text = _data["text"];
          this.multipleAnswersAllowed = _data["multipleAnswersAllowed"];
          this.includesImage = _data["includesImage"];
          this.imageUrl = _data["imageUrl"];
          this.uiControlType = _data["uiControlType"];
          this.uiControlWidth = _data["uiControlWidth"];
          this.answerRequired = _data["answerRequired"];
          if (Array.isArray(_data["answers"])) {
              this.answers = [] as any;
              for (let item of _data["answers"])
                  this.answers!.push(RiskProfileAnswerDto.fromJS(item));
          }
      }
  }

  static fromJS(data: any): RiskProfileQuestionDto {
      data = typeof data === 'object' ? data : {};
      let result = new RiskProfileQuestionDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["sortOrder"] = this.sortOrder;
      data["text"] = this.text;
      data["multipleAnswersAllowed"] = this.multipleAnswersAllowed;
      data["includesImage"] = this.includesImage;
      data["imageUrl"] = this.imageUrl;
      data["uiControlType"] = this.uiControlType;
      data["uiControlWidth"] = this.uiControlWidth;
      data["answerRequired"] = this.answerRequired;
      if (Array.isArray(this.answers)) {
          data["answers"] = [];
          for (let item of this.answers)
              data["answers"].push(item.toJSON());
      }
      return data;
  }
}

export interface IRiskProfileQuestionDto {
  id: number;
  sortOrder: number;
  text: string | undefined;
  multipleAnswersAllowed: boolean;
  includesImage: boolean;
  imageUrl: string | undefined;
  uiControlType: UIControlType;
  uiControlWidth: number;
  answerRequired: boolean;
  answers: IRiskProfileAnswerDto[] | undefined;
}

export enum UIControlType {
  RadioButtons = 1,
  DropDownList = 2,
  Numeric = 3,
}

export class RiskProfileAnswerDto implements IRiskProfileAnswerDto {
  id!: number;
  text!: string | undefined;
  score!: number;
  maxScore!: number | undefined;
  sortOrder!: number;

  constructor(data?: IRiskProfileAnswerDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.text = _data["text"];
          this.score = _data["score"];
          this.maxScore = _data["maxScore"];
          this.sortOrder = _data["sortOrder"];
      }
  }

  static fromJS(data: any): RiskProfileAnswerDto {
      data = typeof data === 'object' ? data : {};
      let result = new RiskProfileAnswerDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["text"] = this.text;
      data["score"] = this.score;
      data["maxScore"] = this.maxScore;
      data["sortOrder"] = this.sortOrder;
      return data;
  }
}

export interface IRiskProfileAnswerDto {
  id: number;
  text: string | undefined;
  score: number;
  maxScore: number | undefined;
  sortOrder: number;
}

export class RiskProfileResponseDto implements IRiskProfileResponseDto {
  answerQuestionId!: number;
  answerQuestionText!: string | undefined;
  answerId!: number;
  answerText!: string | undefined;

  constructor(data?: IRiskProfileResponseDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.answerQuestionId = _data["answerQuestionId"];
          this.answerQuestionText = _data["answerQuestionText"];
          this.answerId = _data["answerId"];
          this.answerText = _data["answerText"];
      }
  }

  static fromJS(data: any): RiskProfileResponseDto {
      data = typeof data === 'object' ? data : {};
      let result = new RiskProfileResponseDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["answerQuestionId"] = this.answerQuestionId;
      data["answerQuestionText"] = this.answerQuestionText;
      data["answerId"] = this.answerId;
      data["answerText"] = this.answerText;
      return data;
  }
}

export interface IRiskProfileResponseDto {
  answerQuestionId: number;
  answerQuestionText: string | undefined;
  answerId: number;
  answerText: string | undefined;
}

export class PostRiskProfileRepsonseDto implements IPostRiskProfileRepsonseDto {
  answerId!: number;

  constructor(data?: IPostRiskProfileRepsonseDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.answerId = _data["answerId"];
      }
  }

  static fromJS(data: any): PostRiskProfileRepsonseDto {
      data = typeof data === 'object' ? data : {};
      let result = new PostRiskProfileRepsonseDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["answerId"] = this.answerId;
      return data;
  }
}

export interface IPostRiskProfileRepsonseDto {
  answerId: number;
}

export class RiskProfileResultDto implements IRiskProfileResultDto {
  contactId!: number;
  clientSelector!: ClientSelector;
  completedDate!: string | undefined;
  sectionResults!: RiskProfileResultSectionDto[] | undefined;

  constructor(data?: IRiskProfileResultDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          if (data.sectionResults) {
              this.sectionResults = [];
              for (let i = 0; i < data.sectionResults.length; i++) {
                  let item = data.sectionResults[i];
                  this.sectionResults[i] = item && !(<any>item).toJSON ? new RiskProfileResultSectionDto(item) : <RiskProfileResultSectionDto>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.contactId = _data["contactId"];
          this.clientSelector = _data["clientSelector"];
          this.completedDate = _data["completedDate"];
          if (Array.isArray(_data["sectionResults"])) {
              this.sectionResults = [] as any;
              for (let item of _data["sectionResults"])
                  this.sectionResults!.push(RiskProfileResultSectionDto.fromJS(item));
          }
      }
  }

  static fromJS(data: any): RiskProfileResultDto {
      data = typeof data === 'object' ? data : {};
      let result = new RiskProfileResultDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["contactId"] = this.contactId;
      data["clientSelector"] = this.clientSelector;
      data["completedDate"] = this.completedDate;
      if (Array.isArray(this.sectionResults)) {
          data["sectionResults"] = [];
          for (let item of this.sectionResults)
              data["sectionResults"].push(item.toJSON());
      }
      return data;
  }
}

export interface IRiskProfileResultDto {
  contactId: number;
  clientSelector: ClientSelector;
  completedDate: string | undefined;
  sectionResults: IRiskProfileResultSectionDto[] | undefined;
}

export class RiskProfileResultSectionDto implements IRiskProfileResultSectionDto {
  title!: string | undefined;
  subtitle!: string | undefined;
  description!: string | undefined;
  rangeGraphicType!: RangeGraphicType;
  rangeLow!: number;
  rangeHigh!: number;
  score!: number;
  reverseOrder!: boolean;

  constructor(data?: IRiskProfileResultSectionDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.title = _data["title"];
          this.subtitle = _data["subtitle"];
          this.description = _data["description"];
          this.rangeGraphicType = _data["rangeGraphicType"];
          this.rangeLow = _data["rangeLow"];
          this.rangeHigh = _data["rangeHigh"];
          this.score = _data["score"];
          this.reverseOrder = _data["reverseOrder"];
      }
  }

  static fromJS(data: any): RiskProfileResultSectionDto {
      data = typeof data === 'object' ? data : {};
      let result = new RiskProfileResultSectionDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["title"] = this.title;
      data["subtitle"] = this.subtitle;
      data["description"] = this.description;
      data["rangeGraphicType"] = this.rangeGraphicType;
      data["rangeLow"] = this.rangeLow;
      data["rangeHigh"] = this.rangeHigh;
      data["score"] = this.score;
      data["reverseOrder"] = this.reverseOrder;
      return data;
  }
}

export interface IRiskProfileResultSectionDto {
  title: string | undefined;
  subtitle: string | undefined;
  description: string | undefined;
  rangeGraphicType: RangeGraphicType;
  rangeLow: number;
  rangeHigh: number;
  score: number;
  reverseOrder: boolean;
}

export enum RangeGraphicType {
  None = 0,
  Radial = 1,
  Bars = 2,
}

export class RiskProfileRequestDto implements IRiskProfileRequestDto {
  id!: number;
  contactId!: number;
  clientSelector!: ClientSelector;
  contactFullName!: string | undefined;
  contactOwnerId!: number;
  sentDate!: string;
  completedDate!: string;
  riskProfileType!: string | undefined;

  constructor(data?: IRiskProfileRequestDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.contactId = _data["contactId"];
          this.clientSelector = _data["clientSelector"];
          this.contactFullName = _data["contactFullName"];
          this.contactOwnerId = _data["contactOwnerId"];
          this.sentDate = _data["sentDate"];
          this.completedDate = _data["completedDate"];
          this.riskProfileType = _data["riskProfileType"];
      }
  }

  static fromJS(data: any): RiskProfileRequestDto {
      data = typeof data === 'object' ? data : {};
      let result = new RiskProfileRequestDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["contactId"] = this.contactId;
      data["clientSelector"] = this.clientSelector;
      data["contactFullName"] = this.contactFullName;
      data["contactOwnerId"] = this.contactOwnerId;
      data["sentDate"] = this.sentDate;
      data["completedDate"] = this.completedDate;
      data["riskProfileType"] = this.riskProfileType;
      return data;
  }
}

export interface IRiskProfileRequestDto {
  id: number;
  contactId: number;
  clientSelector: ClientSelector;
  contactFullName: string | undefined;
  contactOwnerId: number;
  sentDate: string;
  completedDate: string;
  riskProfileType: string | undefined;
}

export class RiskProfileValidationErrorDto implements IRiskProfileValidationErrorDto {
  questionId!: number;
  message!: string | undefined;

  constructor(data?: IRiskProfileValidationErrorDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.questionId = _data["questionId"];
          this.message = _data["message"];
      }
  }

  static fromJS(data: any): RiskProfileValidationErrorDto {
      data = typeof data === 'object' ? data : {};
      let result = new RiskProfileValidationErrorDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["questionId"] = this.questionId;
      data["message"] = this.message;
      return data;
  }
}

export interface IRiskProfileValidationErrorDto {
  questionId: number;
  message: string | undefined;
}

export class RiskProfileValidateQuestionDto implements IRiskProfileValidateQuestionDto {
  questionId!: number;
  answers!: number[] | undefined;

  constructor(data?: IRiskProfileValidateQuestionDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.questionId = _data["questionId"];
          if (Array.isArray(_data["answers"])) {
              this.answers = [] as any;
              for (let item of _data["answers"])
                  this.answers!.push(item);
          }
      }
  }

  static fromJS(data: any): RiskProfileValidateQuestionDto {
      data = typeof data === 'object' ? data : {};
      let result = new RiskProfileValidateQuestionDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["questionId"] = this.questionId;
      if (Array.isArray(this.answers)) {
          data["answers"] = [];
          for (let item of this.answers)
              data["answers"].push(item);
      }
      return data;
  }
}

export interface IRiskProfileValidateQuestionDto {
  questionId: number;
  answers: number[] | undefined;
}

export class PolicyTransactionDto implements IPolicyTransactionDto {
  id!: number;
  policyID!: number;
  transactionType!: string | undefined;
  transactionDate!: string;
  transactionAmount!: number;
  transactionNotes!: string | undefined;
  balance!: number;
  entryDate!: string;

  constructor(data?: IPolicyTransactionDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.policyID = _data["policyID"];
          this.transactionType = _data["transactionType"];
          this.transactionDate = _data["transactionDate"];
          this.transactionAmount = _data["transactionAmount"];
          this.transactionNotes = _data["transactionNotes"];
          this.balance = _data["balance"];
          this.entryDate = _data["entryDate"];
      }
  }

  static fromJS(data: any): PolicyTransactionDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyTransactionDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["policyID"] = this.policyID;
      data["transactionType"] = this.transactionType;
      data["transactionDate"] = this.transactionDate;
      data["transactionAmount"] = this.transactionAmount;
      data["transactionNotes"] = this.transactionNotes;
      data["balance"] = this.balance;
      data["entryDate"] = this.entryDate;
      return data;
  }
}

export interface IPolicyTransactionDto {
  id: number;
  policyID: number;
  transactionType: string | undefined;
  transactionDate: string;
  transactionAmount: number;
  transactionNotes: string | undefined;
  balance: number;
  entryDate: string;
}

export class ApprovalStatusDto extends _LookupDtoBase implements IApprovalStatusDto {

  constructor(data?: IApprovalStatusDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): ApprovalStatusDto {
      data = typeof data === 'object' ? data : {};
      let result = new ApprovalStatusDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IApprovalStatusDto extends I_LookupDtoBase {
}

export enum SortOrder {
  Alphabetical = 0,
  AlphabeticalReverse = 1,
  Natural = 2,
}

export class AssetClassificationDto extends _LookupDtoBase implements IAssetClassificationDto {

  constructor(data?: IAssetClassificationDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): AssetClassificationDto {
      data = typeof data === 'object' ? data : {};
      let result = new AssetClassificationDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IAssetClassificationDto extends I_LookupDtoBase {
}

export class AssetTypeDto extends _LookupDtoBase implements IAssetTypeDto {

  constructor(data?: IAssetTypeDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): AssetTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new AssetTypeDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IAssetTypeDto extends I_LookupDtoBase {
}

export class EmploymentStatusDto extends _LookupDtoBase implements IEmploymentStatusDto {

  constructor(data?: IEmploymentStatusDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): EmploymentStatusDto {
      data = typeof data === 'object' ? data : {};
      let result = new EmploymentStatusDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IEmploymentStatusDto extends I_LookupDtoBase {
}

export class ExpenseTypeDto extends _LookupDtoBase implements IExpenseTypeDto {

  constructor(data?: IExpenseTypeDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): ExpenseTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new ExpenseTypeDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IExpenseTypeDto extends I_LookupDtoBase {
}

export class GenderDto extends _LookupDtoBase implements IGenderDto {

  constructor(data?: IGenderDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): GenderDto {
      data = typeof data === 'object' ? data : {};
      let result = new GenderDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IGenderDto extends I_LookupDtoBase {
}

export class HealthStatusDto extends _LookupDtoBase implements IHealthStatusDto {

  constructor(data?: IHealthStatusDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): HealthStatusDto {
      data = typeof data === 'object' ? data : {};
      let result = new HealthStatusDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IHealthStatusDto extends I_LookupDtoBase {
}

export class IllnessTypeDto extends _LookupDtoBase implements IIllnessTypeDto {

  constructor(data?: IIllnessTypeDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): IllnessTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new IllnessTypeDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IIllnessTypeDto extends I_LookupDtoBase {
}

export class IncomeCategoryDto extends _LookupDtoBase implements IIncomeCategoryDto {

  constructor(data?: IIncomeCategoryDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): IncomeCategoryDto {
      data = typeof data === 'object' ? data : {};
      let result = new IncomeCategoryDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IIncomeCategoryDto extends I_LookupDtoBase {
}

export class IncomeTypeDto extends _LookupDtoBase implements IIncomeTypeDto {

  constructor(data?: IIncomeTypeDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): IncomeTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new IncomeTypeDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IIncomeTypeDto extends I_LookupDtoBase {
}

export class LiabilityTypeDto extends _LookupDtoBase implements ILiabilityTypeDto {

  constructor(data?: ILiabilityTypeDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): LiabilityTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new LiabilityTypeDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface ILiabilityTypeDto extends I_LookupDtoBase {
}

export class MaritalStatusDto extends _LookupDtoBase implements IMaritalStatusDto {

  constructor(data?: IMaritalStatusDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): MaritalStatusDto {
      data = typeof data === 'object' ? data : {};
      let result = new MaritalStatusDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IMaritalStatusDto extends I_LookupDtoBase {
}

export class MortgageCategoryDto extends _LookupDtoBase implements IMortgageCategoryDto {

  constructor(data?: IMortgageCategoryDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): MortgageCategoryDto {
      data = typeof data === 'object' ? data : {};
      let result = new MortgageCategoryDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IMortgageCategoryDto extends I_LookupDtoBase {
}

export class MortgageRateDto extends _LookupDtoBase implements IMortgageRateDto {

  constructor(data?: IMortgageRateDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): MortgageRateDto {
      data = typeof data === 'object' ? data : {};
      let result = new MortgageRateDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IMortgageRateDto extends I_LookupDtoBase {
}

export class MortgageTypeDto extends _LookupDtoBase implements IMortgageTypeDto {

  constructor(data?: IMortgageTypeDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): MortgageTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new MortgageTypeDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IMortgageTypeDto extends I_LookupDtoBase {
}

export class OccupationDto extends _LookupDtoBase implements IOccupationDto {

  constructor(data?: IOccupationDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): OccupationDto {
      data = typeof data === 'object' ? data : {};
      let result = new OccupationDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IOccupationDto extends I_LookupDtoBase {
}

export class OwnerDto implements IOwnerDto {
  id!: number;
  name!: string | undefined;

  constructor(data?: IOwnerDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): OwnerDto {
      data = typeof data === 'object' ? data : {};
      let result = new OwnerDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      return data;
  }
}

export interface IOwnerDto {
  id: number;
  name: string | undefined;
}

export class PaymentFrequencyDto extends _LookupDtoBase implements IPaymentFrequencyDto {

  constructor(data?: IPaymentFrequencyDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): PaymentFrequencyDto {
      data = typeof data === 'object' ? data : {};
      let result = new PaymentFrequencyDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IPaymentFrequencyDto extends I_LookupDtoBase {
}

export class PaymentMethodDto extends _LookupDtoBase implements IPaymentMethodDto {

  constructor(data?: IPaymentMethodDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): PaymentMethodDto {
      data = typeof data === 'object' ? data : {};
      let result = new PaymentMethodDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IPaymentMethodDto extends I_LookupDtoBase {
}

export class PensionStatusDto extends _LookupDtoBase implements IPensionStatusDto {

  constructor(data?: IPensionStatusDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): PensionStatusDto {
      data = typeof data === 'object' ? data : {};
      let result = new PensionStatusDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IPensionStatusDto extends I_LookupDtoBase {
}

export class PensionTypeDto extends _LookupDtoBase implements IPensionTypeDto {

  constructor(data?: IPensionTypeDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): PensionTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new PensionTypeDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IPensionTypeDto extends I_LookupDtoBase {
}

export class PersonalRelationDto extends _LookupDtoBase implements IPersonalRelationDto {

  constructor(data?: IPersonalRelationDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): PersonalRelationDto {
      data = typeof data === 'object' ? data : {};
      let result = new PersonalRelationDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IPersonalRelationDto extends I_LookupDtoBase {
}

export class PolicyBasisDto extends _LookupDtoBase implements IPolicyBasisDto {

  constructor(data?: IPolicyBasisDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): PolicyBasisDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyBasisDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IPolicyBasisDto extends I_LookupDtoBase {
}

export class PolicyStatusDto extends _LookupDtoBase implements IPolicyStatusDto {

  constructor(data?: IPolicyStatusDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): PolicyStatusDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyStatusDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IPolicyStatusDto extends I_LookupDtoBase {
}

export class PolicyTypeDto extends _LookupDtoBase implements IPolicyTypeDto {

  constructor(data?: IPolicyTypeDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): PolicyTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyTypeDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IPolicyTypeDto extends I_LookupDtoBase {
}

export class PropertyStatusDto extends _LookupDtoBase implements IPropertyStatusDto {

  constructor(data?: IPropertyStatusDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): PropertyStatusDto {
      data = typeof data === 'object' ? data : {};
      let result = new PropertyStatusDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IPropertyStatusDto extends I_LookupDtoBase {
}

export class TaxBasisAssessmentDto extends _LookupDtoBase implements ITaxBasisAssessmentDto {

  constructor(data?: ITaxBasisAssessmentDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): TaxBasisAssessmentDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxBasisAssessmentDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface ITaxBasisAssessmentDto extends I_LookupDtoBase {
}

export class TaxTreatmentDto extends _LookupDtoBase implements ITaxTreatmentDto {

  constructor(data?: ITaxTreatmentDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): TaxTreatmentDto {
      data = typeof data === 'object' ? data : {};
      let result = new TaxTreatmentDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface ITaxTreatmentDto extends I_LookupDtoBase {
}

export class TimeframeDto extends _LookupDtoBase implements ITimeframeDto {

  constructor(data?: ITimeframeDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): TimeframeDto {
      data = typeof data === 'object' ? data : {};
      let result = new TimeframeDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface ITimeframeDto extends I_LookupDtoBase {
}

export class YesNoDefaultDto extends _LookupDtoBase implements IYesNoDefaultDto {

  constructor(data?: IYesNoDefaultDto) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
  }

  static fromJS(data: any): YesNoDefaultDto {
      data = typeof data === 'object' ? data : {};
      let result = new YesNoDefaultDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      super.toJSON(data);
      return data;
  }
}

export interface IYesNoDefaultDto extends I_LookupDtoBase {
}

export class FactFindAssetDto implements IFactFindAssetDto {
  id!: number;
  contactId!: number;
  clientSelector!: ClientSelector;
  owner!: ClientSelector;
  ownerName!: string | undefined;
  type!: AssetTypeDto | undefined;
  otherType!: string | undefined;
  approximateValue!: number;
  isOutsideCountry!: YesNoDefaultDto | undefined;
  location!: string | undefined;
  isFamilyHome!: YesNoDefaultDto | undefined;
  canBeSold!: YesNoDefaultDto | undefined;
  approximateTimeframe!: TimeframeDto | undefined;
  classification!: AssetClassificationDto | undefined;
  annualGrowthDecline!: number;
  notes!: string | undefined;

  constructor(data?: IFactFindAssetDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.type = data.type && !(<any>data.type).toJSON ? new AssetTypeDto(data.type) : <AssetTypeDto>this.type;
          this.isOutsideCountry = data.isOutsideCountry && !(<any>data.isOutsideCountry).toJSON ? new YesNoDefaultDto(data.isOutsideCountry) : <YesNoDefaultDto>this.isOutsideCountry;
          this.isFamilyHome = data.isFamilyHome && !(<any>data.isFamilyHome).toJSON ? new YesNoDefaultDto(data.isFamilyHome) : <YesNoDefaultDto>this.isFamilyHome;
          this.canBeSold = data.canBeSold && !(<any>data.canBeSold).toJSON ? new YesNoDefaultDto(data.canBeSold) : <YesNoDefaultDto>this.canBeSold;
          this.approximateTimeframe = data.approximateTimeframe && !(<any>data.approximateTimeframe).toJSON ? new TimeframeDto(data.approximateTimeframe) : <TimeframeDto>this.approximateTimeframe;
          this.classification = data.classification && !(<any>data.classification).toJSON ? new AssetClassificationDto(data.classification) : <AssetClassificationDto>this.classification;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.contactId = _data["contactId"];
          this.clientSelector = _data["clientSelector"];
          this.owner = _data["owner"];
          this.ownerName = _data["ownerName"];
          this.type = _data["type"] ? AssetTypeDto.fromJS(_data["type"]) : <any>undefined;
          this.otherType = _data["otherType"];
          this.approximateValue = _data["approximateValue"];
          this.isOutsideCountry = _data["isOutsideCountry"] ? YesNoDefaultDto.fromJS(_data["isOutsideCountry"]) : <any>undefined;
          this.location = _data["location"];
          this.isFamilyHome = _data["isFamilyHome"] ? YesNoDefaultDto.fromJS(_data["isFamilyHome"]) : <any>undefined;
          this.canBeSold = _data["canBeSold"] ? YesNoDefaultDto.fromJS(_data["canBeSold"]) : <any>undefined;
          this.approximateTimeframe = _data["approximateTimeframe"] ? TimeframeDto.fromJS(_data["approximateTimeframe"]) : <any>undefined;
          this.classification = _data["classification"] ? AssetClassificationDto.fromJS(_data["classification"]) : <any>undefined;
          this.annualGrowthDecline = _data["annualGrowthDecline"];
          this.notes = _data["notes"];
      }
  }

  static fromJS(data: any): FactFindAssetDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindAssetDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["contactId"] = this.contactId;
      data["clientSelector"] = this.clientSelector;
      data["owner"] = this.owner;
      data["ownerName"] = this.ownerName;
      data["type"] = this.type ? this.type.toJSON() : <any>undefined;
      data["otherType"] = this.otherType;
      data["approximateValue"] = this.approximateValue;
      data["isOutsideCountry"] = this.isOutsideCountry ? this.isOutsideCountry.toJSON() : <any>undefined;
      data["location"] = this.location;
      data["isFamilyHome"] = this.isFamilyHome ? this.isFamilyHome.toJSON() : <any>undefined;
      data["canBeSold"] = this.canBeSold ? this.canBeSold.toJSON() : <any>undefined;
      data["approximateTimeframe"] = this.approximateTimeframe ? this.approximateTimeframe.toJSON() : <any>undefined;
      data["classification"] = this.classification ? this.classification.toJSON() : <any>undefined;
      data["annualGrowthDecline"] = this.annualGrowthDecline;
      data["notes"] = this.notes;
      return data;
  }
}

export interface IFactFindAssetDto {
  id: number;
  contactId: number;
  clientSelector: ClientSelector;
  owner: ClientSelector;
  ownerName: string | undefined;
  type: IAssetTypeDto | undefined;
  otherType: string | undefined;
  approximateValue: number;
  isOutsideCountry: IYesNoDefaultDto | undefined;
  location: string | undefined;
  isFamilyHome: IYesNoDefaultDto | undefined;
  canBeSold: IYesNoDefaultDto | undefined;
  approximateTimeframe: ITimeframeDto | undefined;
  classification: IAssetClassificationDto | undefined;
  annualGrowthDecline: number;
  notes: string | undefined;
}

export abstract class _BaseRequestOfInteger implements I_BaseRequestOfInteger {

  constructor(data?: I_BaseRequestOfInteger) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
  }

  static fromJS(data: any): _BaseRequestOfInteger {
      data = typeof data === 'object' ? data : {};
      throw new Error("The abstract class '_BaseRequestOfInteger' cannot be instantiated.");
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
  }
}

export interface I_BaseRequestOfInteger {
}

export abstract class _FactFindCreateCommandBase extends _BaseRequestOfInteger implements I_FactFindCreateCommandBase {
  contactId!: number;

  constructor(data?: I_FactFindCreateCommandBase) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.contactId = _data["contactId"];
      }
  }

  static fromJS(data: any): _FactFindCreateCommandBase {
      data = typeof data === 'object' ? data : {};
      throw new Error("The abstract class '_FactFindCreateCommandBase' cannot be instantiated.");
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["contactId"] = this.contactId;
      super.toJSON(data);
      return data;
  }
}

export interface I_FactFindCreateCommandBase extends I_BaseRequestOfInteger {
  contactId: number;
}

export class CreateAssetCommand extends _FactFindCreateCommandBase implements ICreateAssetCommand {
  owner!: ClientSelector;
  typeId!: number;
  otherType!: string | undefined;
  approximateValue!: number;
  isOutsideContryId!: number;
  location!: string | undefined;
  isFamilyHomeId!: number;
  canBeSoldId!: number;
  approximateTimeframeId!: number;
  classificationId!: number;
  annualGrowthDecline!: number;
  liabilityId!: number;
  notes!: string | undefined;

  constructor(data?: ICreateAssetCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.owner = _data["owner"];
          this.typeId = _data["typeId"];
          this.otherType = _data["otherType"];
          this.approximateValue = _data["approximateValue"];
          this.isOutsideContryId = _data["isOutsideContryId"];
          this.location = _data["location"];
          this.isFamilyHomeId = _data["isFamilyHomeId"];
          this.canBeSoldId = _data["canBeSoldId"];
          this.approximateTimeframeId = _data["approximateTimeframeId"];
          this.classificationId = _data["classificationId"];
          this.annualGrowthDecline = _data["annualGrowthDecline"];
          this.liabilityId = _data["liabilityId"];
          this.notes = _data["notes"];
      }
  }

  static fromJS(data: any): CreateAssetCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateAssetCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["owner"] = this.owner;
      data["typeId"] = this.typeId;
      data["otherType"] = this.otherType;
      data["approximateValue"] = this.approximateValue;
      data["isOutsideContryId"] = this.isOutsideContryId;
      data["location"] = this.location;
      data["isFamilyHomeId"] = this.isFamilyHomeId;
      data["canBeSoldId"] = this.canBeSoldId;
      data["approximateTimeframeId"] = this.approximateTimeframeId;
      data["classificationId"] = this.classificationId;
      data["annualGrowthDecline"] = this.annualGrowthDecline;
      data["liabilityId"] = this.liabilityId;
      data["notes"] = this.notes;
      super.toJSON(data);
      return data;
  }
}

export interface ICreateAssetCommand extends I_FactFindCreateCommandBase {
  owner: ClientSelector;
  typeId: number;
  otherType: string | undefined;
  approximateValue: number;
  isOutsideContryId: number;
  location: string | undefined;
  isFamilyHomeId: number;
  canBeSoldId: number;
  approximateTimeframeId: number;
  classificationId: number;
  annualGrowthDecline: number;
  liabilityId: number;
  notes: string | undefined;
}

/** A Basic Request via the Mediator */
export abstract class _BaseRequest implements I_BaseRequest {

  constructor(data?: I_BaseRequest) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
  }

  static fromJS(data: any): _BaseRequest {
      data = typeof data === 'object' ? data : {};
      throw new Error("The abstract class '_BaseRequest' cannot be instantiated.");
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
  }
}

/** A Basic Request via the Mediator */
export interface I_BaseRequest {
}

export abstract class _FactFindUpdateCommandBase extends _BaseRequest implements I_FactFindUpdateCommandBase {
  id!: number;
  contactId!: number;

  constructor(data?: I_FactFindUpdateCommandBase) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.contactId = _data["contactId"];
      }
  }

  static fromJS(data: any): _FactFindUpdateCommandBase {
      data = typeof data === 'object' ? data : {};
      throw new Error("The abstract class '_FactFindUpdateCommandBase' cannot be instantiated.");
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["contactId"] = this.contactId;
      super.toJSON(data);
      return data;
  }
}

export interface I_FactFindUpdateCommandBase extends I_BaseRequest {
  id: number;
  contactId: number;
}

export class UpdateAssetCommand extends _FactFindUpdateCommandBase implements IUpdateAssetCommand {
  id!: number;
  owner!: ClientSelector;
  typeId!: number;
  otherType!: string | undefined;
  approximateValue!: number;
  isOutsideContryId!: number;
  location!: string | undefined;
  isFamilyHomeId!: number;
  canBeSoldId!: number;
  approximateTimeframeId!: number;
  classificationId!: number;
  annualGrowthDecline!: number;
  liabilityId!: number;
  notes!: string | undefined;

  constructor(data?: IUpdateAssetCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.owner = _data["owner"];
          this.typeId = _data["typeId"];
          this.otherType = _data["otherType"];
          this.approximateValue = _data["approximateValue"];
          this.isOutsideContryId = _data["isOutsideContryId"];
          this.location = _data["location"];
          this.isFamilyHomeId = _data["isFamilyHomeId"];
          this.canBeSoldId = _data["canBeSoldId"];
          this.approximateTimeframeId = _data["approximateTimeframeId"];
          this.classificationId = _data["classificationId"];
          this.annualGrowthDecline = _data["annualGrowthDecline"];
          this.liabilityId = _data["liabilityId"];
          this.notes = _data["notes"];
      }
  }

  static fromJS(data: any): UpdateAssetCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateAssetCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["owner"] = this.owner;
      data["typeId"] = this.typeId;
      data["otherType"] = this.otherType;
      data["approximateValue"] = this.approximateValue;
      data["isOutsideContryId"] = this.isOutsideContryId;
      data["location"] = this.location;
      data["isFamilyHomeId"] = this.isFamilyHomeId;
      data["canBeSoldId"] = this.canBeSoldId;
      data["approximateTimeframeId"] = this.approximateTimeframeId;
      data["classificationId"] = this.classificationId;
      data["annualGrowthDecline"] = this.annualGrowthDecline;
      data["liabilityId"] = this.liabilityId;
      data["notes"] = this.notes;
      super.toJSON(data);
      return data;
  }
}

export interface IUpdateAssetCommand extends I_FactFindUpdateCommandBase {
  id: number;
  owner: ClientSelector;
  typeId: number;
  otherType: string | undefined;
  approximateValue: number;
  isOutsideContryId: number;
  location: string | undefined;
  isFamilyHomeId: number;
  canBeSoldId: number;
  approximateTimeframeId: number;
  classificationId: number;
  annualGrowthDecline: number;
  liabilityId: number;
  notes: string | undefined;
}

export class FactFindDependentDto implements IFactFindDependentDto {
  id!: number;
  guardian!: ClientSelector;
  firstName!: string | undefined;
  lastName!: string | undefined;
  dateOfBirth!: string;
  age!: number;
  taxNumber!: string | undefined;
  relation!: PersonalRelationDto | undefined;
  employmentStatus!: EmploymentStatusDto | undefined;
  sex!: string | undefined;
  isIncapacitated!: YesNoDefaultDto | undefined;
  isOver65!: YesNoDefaultDto | undefined;
  isWidowWidower!: YesNoDefaultDto | undefined;
  isFinanciallyDependant!: YesNoDefaultDto | undefined;

  constructor(data?: IFactFindDependentDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.relation = data.relation && !(<any>data.relation).toJSON ? new PersonalRelationDto(data.relation) : <PersonalRelationDto>this.relation;
          this.employmentStatus = data.employmentStatus && !(<any>data.employmentStatus).toJSON ? new EmploymentStatusDto(data.employmentStatus) : <EmploymentStatusDto>this.employmentStatus;
          this.isIncapacitated = data.isIncapacitated && !(<any>data.isIncapacitated).toJSON ? new YesNoDefaultDto(data.isIncapacitated) : <YesNoDefaultDto>this.isIncapacitated;
          this.isOver65 = data.isOver65 && !(<any>data.isOver65).toJSON ? new YesNoDefaultDto(data.isOver65) : <YesNoDefaultDto>this.isOver65;
          this.isWidowWidower = data.isWidowWidower && !(<any>data.isWidowWidower).toJSON ? new YesNoDefaultDto(data.isWidowWidower) : <YesNoDefaultDto>this.isWidowWidower;
          this.isFinanciallyDependant = data.isFinanciallyDependant && !(<any>data.isFinanciallyDependant).toJSON ? new YesNoDefaultDto(data.isFinanciallyDependant) : <YesNoDefaultDto>this.isFinanciallyDependant;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.guardian = _data["guardian"];
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          this.dateOfBirth = _data["dateOfBirth"];
          this.age = _data["age"];
          this.taxNumber = _data["taxNumber"];
          this.relation = _data["relation"] ? PersonalRelationDto.fromJS(_data["relation"]) : <any>undefined;
          this.employmentStatus = _data["employmentStatus"] ? EmploymentStatusDto.fromJS(_data["employmentStatus"]) : <any>undefined;
          this.sex = _data["sex"];
          this.isIncapacitated = _data["isIncapacitated"] ? YesNoDefaultDto.fromJS(_data["isIncapacitated"]) : <any>undefined;
          this.isOver65 = _data["isOver65"] ? YesNoDefaultDto.fromJS(_data["isOver65"]) : <any>undefined;
          this.isWidowWidower = _data["isWidowWidower"] ? YesNoDefaultDto.fromJS(_data["isWidowWidower"]) : <any>undefined;
          this.isFinanciallyDependant = _data["isFinanciallyDependant"] ? YesNoDefaultDto.fromJS(_data["isFinanciallyDependant"]) : <any>undefined;
      }
  }

  static fromJS(data: any): FactFindDependentDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindDependentDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["guardian"] = this.guardian;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["dateOfBirth"] = this.dateOfBirth;
      data["age"] = this.age;
      data["taxNumber"] = this.taxNumber;
      data["relation"] = this.relation ? this.relation.toJSON() : <any>undefined;
      data["employmentStatus"] = this.employmentStatus ? this.employmentStatus.toJSON() : <any>undefined;
      data["sex"] = this.sex;
      data["isIncapacitated"] = this.isIncapacitated ? this.isIncapacitated.toJSON() : <any>undefined;
      data["isOver65"] = this.isOver65 ? this.isOver65.toJSON() : <any>undefined;
      data["isWidowWidower"] = this.isWidowWidower ? this.isWidowWidower.toJSON() : <any>undefined;
      data["isFinanciallyDependant"] = this.isFinanciallyDependant ? this.isFinanciallyDependant.toJSON() : <any>undefined;
      return data;
  }
}

export interface IFactFindDependentDto {
  id: number;
  guardian: ClientSelector;
  firstName: string | undefined;
  lastName: string | undefined;
  dateOfBirth: string;
  age: number;
  taxNumber: string | undefined;
  relation: IPersonalRelationDto | undefined;
  employmentStatus: IEmploymentStatusDto | undefined;
  sex: string | undefined;
  isIncapacitated: IYesNoDefaultDto | undefined;
  isOver65: IYesNoDefaultDto | undefined;
  isWidowWidower: IYesNoDefaultDto | undefined;
  isFinanciallyDependant: IYesNoDefaultDto | undefined;
}

export class CreateDependantCommand extends _FactFindCreateCommandBase implements ICreateDependantCommand {
  guardian!: ClientSelector;
  firstName!: string | undefined;
  lastName!: string | undefined;
  dateOfBirth!: string | undefined;
  age!: number;
  taxNumber!: string | undefined;
  relationId!: number;
  employmentStatusID!: number;
  sex!: string | undefined;
  isIncapacitatedId!: number;
  isOver65Id!: number;
  isWidowWidowerId!: number;
  isFinanciallyDependantId!: number;

  constructor(data?: ICreateDependantCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.guardian = _data["guardian"];
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          this.dateOfBirth = _data["dateOfBirth"];
          this.age = _data["age"];
          this.taxNumber = _data["taxNumber"];
          this.relationId = _data["relationId"];
          this.employmentStatusID = _data["employmentStatusID"];
          this.sex = _data["sex"];
          this.isIncapacitatedId = _data["isIncapacitatedId"];
          this.isOver65Id = _data["isOver65Id"];
          this.isWidowWidowerId = _data["isWidowWidowerId"];
          this.isFinanciallyDependantId = _data["isFinanciallyDependantId"];
      }
  }

  static fromJS(data: any): CreateDependantCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateDependantCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["guardian"] = this.guardian;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["dateOfBirth"] = this.dateOfBirth;
      data["age"] = this.age;
      data["taxNumber"] = this.taxNumber;
      data["relationId"] = this.relationId;
      data["employmentStatusID"] = this.employmentStatusID;
      data["sex"] = this.sex;
      data["isIncapacitatedId"] = this.isIncapacitatedId;
      data["isOver65Id"] = this.isOver65Id;
      data["isWidowWidowerId"] = this.isWidowWidowerId;
      data["isFinanciallyDependantId"] = this.isFinanciallyDependantId;
      super.toJSON(data);
      return data;
  }
}

export interface ICreateDependantCommand extends I_FactFindCreateCommandBase {
  guardian: ClientSelector;
  firstName: string | undefined;
  lastName: string | undefined;
  dateOfBirth: string | undefined;
  age: number;
  taxNumber: string | undefined;
  relationId: number;
  employmentStatusID: number;
  sex: string | undefined;
  isIncapacitatedId: number;
  isOver65Id: number;
  isWidowWidowerId: number;
  isFinanciallyDependantId: number;
}

export class UpdateDependantCommand extends _FactFindUpdateCommandBase implements IUpdateDependantCommand {
  guardian!: ClientSelector;
  firstName!: string | undefined;
  lastName!: string | undefined;
  dateOfBirth!: string | undefined;
  age!: number;
  taxNumber!: string | undefined;
  relationId!: number;
  employmentStatusID!: number;
  sex!: string | undefined;
  isIncapacitatedId!: number;
  isOver65Id!: number;
  isWidowWidowerId!: number;
  isFinanciallyDependantId!: number;

  constructor(data?: IUpdateDependantCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.guardian = _data["guardian"];
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          this.dateOfBirth = _data["dateOfBirth"];
          this.age = _data["age"];
          this.taxNumber = _data["taxNumber"];
          this.relationId = _data["relationId"];
          this.employmentStatusID = _data["employmentStatusID"];
          this.sex = _data["sex"];
          this.isIncapacitatedId = _data["isIncapacitatedId"];
          this.isOver65Id = _data["isOver65Id"];
          this.isWidowWidowerId = _data["isWidowWidowerId"];
          this.isFinanciallyDependantId = _data["isFinanciallyDependantId"];
      }
  }

  static fromJS(data: any): UpdateDependantCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateDependantCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["guardian"] = this.guardian;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["dateOfBirth"] = this.dateOfBirth;
      data["age"] = this.age;
      data["taxNumber"] = this.taxNumber;
      data["relationId"] = this.relationId;
      data["employmentStatusID"] = this.employmentStatusID;
      data["sex"] = this.sex;
      data["isIncapacitatedId"] = this.isIncapacitatedId;
      data["isOver65Id"] = this.isOver65Id;
      data["isWidowWidowerId"] = this.isWidowWidowerId;
      data["isFinanciallyDependantId"] = this.isFinanciallyDependantId;
      super.toJSON(data);
      return data;
  }
}

export interface IUpdateDependantCommand extends I_FactFindUpdateCommandBase {
  guardian: ClientSelector;
  firstName: string | undefined;
  lastName: string | undefined;
  dateOfBirth: string | undefined;
  age: number;
  taxNumber: string | undefined;
  relationId: number;
  employmentStatusID: number;
  sex: string | undefined;
  isIncapacitatedId: number;
  isOver65Id: number;
  isWidowWidowerId: number;
  isFinanciallyDependantId: number;
}

export class FactFindDetailsDto implements IFactFindDetailsDto {
  id!: number;
  title!: TitleDto | undefined;
  firstName!: string | undefined;
  lastName!: string | undefined;
  schemeName!: string | undefined;
  dateOfBirth!: string;
  gender!: GenderDto | undefined;
  maritalStatus!: MaritalStatusDto | undefined;
  taxBasisAssessment!: TaxBasisAssessmentDto | undefined;
  phoneNo!: string | undefined;
  mobileNo!: string | undefined;
  workNo!: string | undefined;
  faxNo!: string | undefined;
  smokerStatus!: YesNoDefaultDto | undefined;
  healthStatus!: HealthStatusDto | undefined;
  healthStatusOther!: string | undefined;
  ppsNumber!: string | undefined;
  nationalDomicile!: CountryDto | undefined;
  addressLine_1!: string | undefined;
  addressLine_2!: string | undefined;
  addressLine_3!: string | undefined;
  addressLine_4!: string | undefined;
  addressCounty!: CountyDto | undefined;
  addressCountry!: CountryDto | undefined;
  postCode!: string | undefined;
  email!: string | undefined;
  isVunerableContact!: boolean;
  optInAllMarketingComms!: boolean;
  noComms!: boolean;
  employmentStatus!: EmploymentStatusDto | undefined;
  mainOccupation!: OccupationDto | undefined;
  employerName!: string | undefined;
  sP_Title!: TitleDto | undefined;
  sP_PPSNumber!: string | undefined;
  sP_FirstName!: string | undefined;
  sP_LastName!: string | undefined;
  sP_SchemeName!: string | undefined;
  sP_DateOfBirth!: string | undefined;
  sP_Gender!: GenderDto | undefined;
  sP_MaritalStatus!: MaritalStatusDto | undefined;
  sP_TaxBasisAssessment!: TaxBasisAssessmentDto | undefined;
  sP_PhoneNo!: string | undefined;
  sP_MobileNo!: string | undefined;
  sP_WorkNo!: string | undefined;
  sP_SmokerStatus!: YesNoDefaultDto | undefined;
  sP_HealthStatus!: HealthStatusDto | undefined;
  sP_HealthStatusOther!: string | undefined;
  sP_NationalDomicile!: CountryDto | undefined;
  sP_AddressLine_1!: string | undefined;
  sP_AddressLine_2!: string | undefined;
  sP_AddressLine_3!: string | undefined;
  sP_AddressLine_4!: string | undefined;
  sP_AddressCounty!: CountyDto | undefined;
  sP_AddressCountry!: CountryDto | undefined;
  sP_PostCode!: string | undefined;
  sP_Email!: string | undefined;
  sP_IsVunerableContact!: boolean;
  sP_OptInAllMarketingComms!: boolean;
  sP_NoComms!: boolean;
  sP_EmploymentStatus!: EmploymentStatusDto | undefined;
  sP_MainOccupation!: OccupationDto | undefined;
  sP_EmployerName!: string | undefined;

  constructor(data?: IFactFindDetailsDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.title = data.title && !(<any>data.title).toJSON ? new TitleDto(data.title) : <TitleDto>this.title;
          this.gender = data.gender && !(<any>data.gender).toJSON ? new GenderDto(data.gender) : <GenderDto>this.gender;
          this.maritalStatus = data.maritalStatus && !(<any>data.maritalStatus).toJSON ? new MaritalStatusDto(data.maritalStatus) : <MaritalStatusDto>this.maritalStatus;
          this.taxBasisAssessment = data.taxBasisAssessment && !(<any>data.taxBasisAssessment).toJSON ? new TaxBasisAssessmentDto(data.taxBasisAssessment) : <TaxBasisAssessmentDto>this.taxBasisAssessment;
          this.smokerStatus = data.smokerStatus && !(<any>data.smokerStatus).toJSON ? new YesNoDefaultDto(data.smokerStatus) : <YesNoDefaultDto>this.smokerStatus;
          this.healthStatus = data.healthStatus && !(<any>data.healthStatus).toJSON ? new HealthStatusDto(data.healthStatus) : <HealthStatusDto>this.healthStatus;
          this.nationalDomicile = data.nationalDomicile && !(<any>data.nationalDomicile).toJSON ? new CountryDto(data.nationalDomicile) : <CountryDto>this.nationalDomicile;
          this.addressCounty = data.addressCounty && !(<any>data.addressCounty).toJSON ? new CountyDto(data.addressCounty) : <CountyDto>this.addressCounty;
          this.addressCountry = data.addressCountry && !(<any>data.addressCountry).toJSON ? new CountryDto(data.addressCountry) : <CountryDto>this.addressCountry;
          this.employmentStatus = data.employmentStatus && !(<any>data.employmentStatus).toJSON ? new EmploymentStatusDto(data.employmentStatus) : <EmploymentStatusDto>this.employmentStatus;
          this.mainOccupation = data.mainOccupation && !(<any>data.mainOccupation).toJSON ? new OccupationDto(data.mainOccupation) : <OccupationDto>this.mainOccupation;
          this.sP_Title = data.sP_Title && !(<any>data.sP_Title).toJSON ? new TitleDto(data.sP_Title) : <TitleDto>this.sP_Title;
          this.sP_Gender = data.sP_Gender && !(<any>data.sP_Gender).toJSON ? new GenderDto(data.sP_Gender) : <GenderDto>this.sP_Gender;
          this.sP_MaritalStatus = data.sP_MaritalStatus && !(<any>data.sP_MaritalStatus).toJSON ? new MaritalStatusDto(data.sP_MaritalStatus) : <MaritalStatusDto>this.sP_MaritalStatus;
          this.sP_TaxBasisAssessment = data.sP_TaxBasisAssessment && !(<any>data.sP_TaxBasisAssessment).toJSON ? new TaxBasisAssessmentDto(data.sP_TaxBasisAssessment) : <TaxBasisAssessmentDto>this.sP_TaxBasisAssessment;
          this.sP_SmokerStatus = data.sP_SmokerStatus && !(<any>data.sP_SmokerStatus).toJSON ? new YesNoDefaultDto(data.sP_SmokerStatus) : <YesNoDefaultDto>this.sP_SmokerStatus;
          this.sP_HealthStatus = data.sP_HealthStatus && !(<any>data.sP_HealthStatus).toJSON ? new HealthStatusDto(data.sP_HealthStatus) : <HealthStatusDto>this.sP_HealthStatus;
          this.sP_NationalDomicile = data.sP_NationalDomicile && !(<any>data.sP_NationalDomicile).toJSON ? new CountryDto(data.sP_NationalDomicile) : <CountryDto>this.sP_NationalDomicile;
          this.sP_AddressCounty = data.sP_AddressCounty && !(<any>data.sP_AddressCounty).toJSON ? new CountyDto(data.sP_AddressCounty) : <CountyDto>this.sP_AddressCounty;
          this.sP_AddressCountry = data.sP_AddressCountry && !(<any>data.sP_AddressCountry).toJSON ? new CountryDto(data.sP_AddressCountry) : <CountryDto>this.sP_AddressCountry;
          this.sP_EmploymentStatus = data.sP_EmploymentStatus && !(<any>data.sP_EmploymentStatus).toJSON ? new EmploymentStatusDto(data.sP_EmploymentStatus) : <EmploymentStatusDto>this.sP_EmploymentStatus;
          this.sP_MainOccupation = data.sP_MainOccupation && !(<any>data.sP_MainOccupation).toJSON ? new OccupationDto(data.sP_MainOccupation) : <OccupationDto>this.sP_MainOccupation;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.title = _data["title"] ? TitleDto.fromJS(_data["title"]) : <any>undefined;
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          this.schemeName = _data["schemeName"];
          this.dateOfBirth = _data["dateOfBirth"];
          this.gender = _data["gender"] ? GenderDto.fromJS(_data["gender"]) : <any>undefined;
          this.maritalStatus = _data["maritalStatus"] ? MaritalStatusDto.fromJS(_data["maritalStatus"]) : <any>undefined;
          this.taxBasisAssessment = _data["taxBasisAssessment"] ? TaxBasisAssessmentDto.fromJS(_data["taxBasisAssessment"]) : <any>undefined;
          this.phoneNo = _data["phoneNo"];
          this.mobileNo = _data["mobileNo"];
          this.workNo = _data["workNo"];
          this.faxNo = _data["faxNo"];
          this.smokerStatus = _data["smokerStatus"] ? YesNoDefaultDto.fromJS(_data["smokerStatus"]) : <any>undefined;
          this.healthStatus = _data["healthStatus"] ? HealthStatusDto.fromJS(_data["healthStatus"]) : <any>undefined;
          this.healthStatusOther = _data["healthStatusOther"];
          this.ppsNumber = _data["ppsNumber"];
          this.nationalDomicile = _data["nationalDomicile"] ? CountryDto.fromJS(_data["nationalDomicile"]) : <any>undefined;
          this.addressLine_1 = _data["addressLine_1"];
          this.addressLine_2 = _data["addressLine_2"];
          this.addressLine_3 = _data["addressLine_3"];
          this.addressLine_4 = _data["addressLine_4"];
          this.addressCounty = _data["addressCounty"] ? CountyDto.fromJS(_data["addressCounty"]) : <any>undefined;
          this.addressCountry = _data["addressCountry"] ? CountryDto.fromJS(_data["addressCountry"]) : <any>undefined;
          this.postCode = _data["postCode"];
          this.email = _data["email"];
          this.isVunerableContact = _data["isVunerableContact"];
          this.optInAllMarketingComms = _data["optInAllMarketingComms"];
          this.noComms = _data["noComms"];
          this.employmentStatus = _data["employmentStatus"] ? EmploymentStatusDto.fromJS(_data["employmentStatus"]) : <any>undefined;
          this.mainOccupation = _data["mainOccupation"] ? OccupationDto.fromJS(_data["mainOccupation"]) : <any>undefined;
          this.employerName = _data["employerName"];
          this.sP_Title = _data["sP_Title"] ? TitleDto.fromJS(_data["sP_Title"]) : <any>undefined;
          this.sP_PPSNumber = _data["sP_PPSNumber"];
          this.sP_FirstName = _data["sP_FirstName"];
          this.sP_LastName = _data["sP_LastName"];
          this.sP_SchemeName = _data["sP_SchemeName"];
          this.sP_DateOfBirth = _data["sP_DateOfBirth"];
          this.sP_Gender = _data["sP_Gender"] ? GenderDto.fromJS(_data["sP_Gender"]) : <any>undefined;
          this.sP_MaritalStatus = _data["sP_MaritalStatus"] ? MaritalStatusDto.fromJS(_data["sP_MaritalStatus"]) : <any>undefined;
          this.sP_TaxBasisAssessment = _data["sP_TaxBasisAssessment"] ? TaxBasisAssessmentDto.fromJS(_data["sP_TaxBasisAssessment"]) : <any>undefined;
          this.sP_PhoneNo = _data["sP_PhoneNo"];
          this.sP_MobileNo = _data["sP_MobileNo"];
          this.sP_WorkNo = _data["sP_WorkNo"];
          this.sP_SmokerStatus = _data["sP_SmokerStatus"] ? YesNoDefaultDto.fromJS(_data["sP_SmokerStatus"]) : <any>undefined;
          this.sP_HealthStatus = _data["sP_HealthStatus"] ? HealthStatusDto.fromJS(_data["sP_HealthStatus"]) : <any>undefined;
          this.sP_HealthStatusOther = _data["sP_HealthStatusOther"];
          this.sP_NationalDomicile = _data["sP_NationalDomicile"] ? CountryDto.fromJS(_data["sP_NationalDomicile"]) : <any>undefined;
          this.sP_AddressLine_1 = _data["sP_AddressLine_1"];
          this.sP_AddressLine_2 = _data["sP_AddressLine_2"];
          this.sP_AddressLine_3 = _data["sP_AddressLine_3"];
          this.sP_AddressLine_4 = _data["sP_AddressLine_4"];
          this.sP_AddressCounty = _data["sP_AddressCounty"] ? CountyDto.fromJS(_data["sP_AddressCounty"]) : <any>undefined;
          this.sP_AddressCountry = _data["sP_AddressCountry"] ? CountryDto.fromJS(_data["sP_AddressCountry"]) : <any>undefined;
          this.sP_PostCode = _data["sP_PostCode"];
          this.sP_Email = _data["sP_Email"];
          this.sP_IsVunerableContact = _data["sP_IsVunerableContact"];
          this.sP_OptInAllMarketingComms = _data["sP_OptInAllMarketingComms"];
          this.sP_NoComms = _data["sP_NoComms"];
          this.sP_EmploymentStatus = _data["sP_EmploymentStatus"] ? EmploymentStatusDto.fromJS(_data["sP_EmploymentStatus"]) : <any>undefined;
          this.sP_MainOccupation = _data["sP_MainOccupation"] ? OccupationDto.fromJS(_data["sP_MainOccupation"]) : <any>undefined;
          this.sP_EmployerName = _data["sP_EmployerName"];
      }
  }

  static fromJS(data: any): FactFindDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindDetailsDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["title"] = this.title ? this.title.toJSON() : <any>undefined;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["schemeName"] = this.schemeName;
      data["dateOfBirth"] = this.dateOfBirth;
      data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
      data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : <any>undefined;
      data["taxBasisAssessment"] = this.taxBasisAssessment ? this.taxBasisAssessment.toJSON() : <any>undefined;
      data["phoneNo"] = this.phoneNo;
      data["mobileNo"] = this.mobileNo;
      data["workNo"] = this.workNo;
      data["faxNo"] = this.faxNo;
      data["smokerStatus"] = this.smokerStatus ? this.smokerStatus.toJSON() : <any>undefined;
      data["healthStatus"] = this.healthStatus ? this.healthStatus.toJSON() : <any>undefined;
      data["healthStatusOther"] = this.healthStatusOther;
      data["ppsNumber"] = this.ppsNumber;
      data["nationalDomicile"] = this.nationalDomicile ? this.nationalDomicile.toJSON() : <any>undefined;
      data["addressLine_1"] = this.addressLine_1;
      data["addressLine_2"] = this.addressLine_2;
      data["addressLine_3"] = this.addressLine_3;
      data["addressLine_4"] = this.addressLine_4;
      data["addressCounty"] = this.addressCounty ? this.addressCounty.toJSON() : <any>undefined;
      data["addressCountry"] = this.addressCountry ? this.addressCountry.toJSON() : <any>undefined;
      data["postCode"] = this.postCode;
      data["email"] = this.email;
      data["isVunerableContact"] = this.isVunerableContact;
      data["optInAllMarketingComms"] = this.optInAllMarketingComms;
      data["noComms"] = this.noComms;
      data["employmentStatus"] = this.employmentStatus ? this.employmentStatus.toJSON() : <any>undefined;
      data["mainOccupation"] = this.mainOccupation ? this.mainOccupation.toJSON() : <any>undefined;
      data["employerName"] = this.employerName;
      data["sP_Title"] = this.sP_Title ? this.sP_Title.toJSON() : <any>undefined;
      data["sP_PPSNumber"] = this.sP_PPSNumber;
      data["sP_FirstName"] = this.sP_FirstName;
      data["sP_LastName"] = this.sP_LastName;
      data["sP_SchemeName"] = this.sP_SchemeName;
      data["sP_DateOfBirth"] = this.sP_DateOfBirth;
      data["sP_Gender"] = this.sP_Gender ? this.sP_Gender.toJSON() : <any>undefined;
      data["sP_MaritalStatus"] = this.sP_MaritalStatus ? this.sP_MaritalStatus.toJSON() : <any>undefined;
      data["sP_TaxBasisAssessment"] = this.sP_TaxBasisAssessment ? this.sP_TaxBasisAssessment.toJSON() : <any>undefined;
      data["sP_PhoneNo"] = this.sP_PhoneNo;
      data["sP_MobileNo"] = this.sP_MobileNo;
      data["sP_WorkNo"] = this.sP_WorkNo;
      data["sP_SmokerStatus"] = this.sP_SmokerStatus ? this.sP_SmokerStatus.toJSON() : <any>undefined;
      data["sP_HealthStatus"] = this.sP_HealthStatus ? this.sP_HealthStatus.toJSON() : <any>undefined;
      data["sP_HealthStatusOther"] = this.sP_HealthStatusOther;
      data["sP_NationalDomicile"] = this.sP_NationalDomicile ? this.sP_NationalDomicile.toJSON() : <any>undefined;
      data["sP_AddressLine_1"] = this.sP_AddressLine_1;
      data["sP_AddressLine_2"] = this.sP_AddressLine_2;
      data["sP_AddressLine_3"] = this.sP_AddressLine_3;
      data["sP_AddressLine_4"] = this.sP_AddressLine_4;
      data["sP_AddressCounty"] = this.sP_AddressCounty ? this.sP_AddressCounty.toJSON() : <any>undefined;
      data["sP_AddressCountry"] = this.sP_AddressCountry ? this.sP_AddressCountry.toJSON() : <any>undefined;
      data["sP_PostCode"] = this.sP_PostCode;
      data["sP_Email"] = this.sP_Email;
      data["sP_IsVunerableContact"] = this.sP_IsVunerableContact;
      data["sP_OptInAllMarketingComms"] = this.sP_OptInAllMarketingComms;
      data["sP_NoComms"] = this.sP_NoComms;
      data["sP_EmploymentStatus"] = this.sP_EmploymentStatus ? this.sP_EmploymentStatus.toJSON() : <any>undefined;
      data["sP_MainOccupation"] = this.sP_MainOccupation ? this.sP_MainOccupation.toJSON() : <any>undefined;
      data["sP_EmployerName"] = this.sP_EmployerName;
      return data;
  }
}

export interface IFactFindDetailsDto {
  id: number;
  title: ITitleDto | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  schemeName: string | undefined;
  dateOfBirth: string;
  gender: IGenderDto | undefined;
  maritalStatus: IMaritalStatusDto | undefined;
  taxBasisAssessment: ITaxBasisAssessmentDto | undefined;
  phoneNo: string | undefined;
  mobileNo: string | undefined;
  workNo: string | undefined;
  faxNo: string | undefined;
  smokerStatus: IYesNoDefaultDto | undefined;
  healthStatus: IHealthStatusDto | undefined;
  healthStatusOther: string | undefined;
  ppsNumber: string | undefined;
  nationalDomicile: ICountryDto | undefined;
  addressLine_1: string | undefined;
  addressLine_2: string | undefined;
  addressLine_3: string | undefined;
  addressLine_4: string | undefined;
  addressCounty: ICountyDto | undefined;
  addressCountry: ICountryDto | undefined;
  postCode: string | undefined;
  email: string | undefined;
  isVunerableContact: boolean;
  optInAllMarketingComms: boolean;
  noComms: boolean;
  employmentStatus: IEmploymentStatusDto | undefined;
  mainOccupation: IOccupationDto | undefined;
  employerName: string | undefined;
  sP_Title: ITitleDto | undefined;
  sP_PPSNumber: string | undefined;
  sP_FirstName: string | undefined;
  sP_LastName: string | undefined;
  sP_SchemeName: string | undefined;
  sP_DateOfBirth: string | undefined;
  sP_Gender: IGenderDto | undefined;
  sP_MaritalStatus: IMaritalStatusDto | undefined;
  sP_TaxBasisAssessment: ITaxBasisAssessmentDto | undefined;
  sP_PhoneNo: string | undefined;
  sP_MobileNo: string | undefined;
  sP_WorkNo: string | undefined;
  sP_SmokerStatus: IYesNoDefaultDto | undefined;
  sP_HealthStatus: IHealthStatusDto | undefined;
  sP_HealthStatusOther: string | undefined;
  sP_NationalDomicile: ICountryDto | undefined;
  sP_AddressLine_1: string | undefined;
  sP_AddressLine_2: string | undefined;
  sP_AddressLine_3: string | undefined;
  sP_AddressLine_4: string | undefined;
  sP_AddressCounty: ICountyDto | undefined;
  sP_AddressCountry: ICountryDto | undefined;
  sP_PostCode: string | undefined;
  sP_Email: string | undefined;
  sP_IsVunerableContact: boolean;
  sP_OptInAllMarketingComms: boolean;
  sP_NoComms: boolean;
  sP_EmploymentStatus: IEmploymentStatusDto | undefined;
  sP_MainOccupation: IOccupationDto | undefined;
  sP_EmployerName: string | undefined;
}

export class UpdateDetailsCommand extends _FactFindUpdateCommandBase implements IUpdateDetailsCommand {
  titleId!: number;
  firstName!: string | undefined;
  lastName!: string | undefined;
  schemeName!: string | undefined;
  dateOfBirth!: string;
  genderId!: number;
  maritalStatusId!: number;
  taxBasisAssessmentId!: number;
  phoneNo!: string | undefined;
  mobileNo!: string | undefined;
  workNo!: string | undefined;
  faxNo!: string | undefined;
  smokerStatusId!: number;
  healthStatusId!: number;
  healthStatusOther!: string | undefined;
  ppsNumber!: string | undefined;
  nationalDomicileId!: number;
  addressLine_1!: string | undefined;
  addressLine_2!: string | undefined;
  addressLine_3!: string | undefined;
  addressLine_4!: string | undefined;
  addressCountyId!: number;
  addressCountryId!: number;
  postCode!: string | undefined;
  email!: string | undefined;
  isVunerableContact!: boolean;
  optInAllMarketingComms!: boolean;
  noComms!: boolean;
  employmentStatusId!: number;
  mainOccupationId!: number;
  employerName!: string | undefined;
  sP_TitleId!: number;
  sP_PPSNumber!: string | undefined;
  sP_FirstName!: string | undefined;
  sP_LastName!: string | undefined;
  sP_SchemeName!: string | undefined;
  sP_DateOfBirth!: string | undefined;
  sP_GenderId!: number | undefined;
  sP_MaritalStatusId!: number | undefined;
  sP_TaxBasisAssessmentId!: number | undefined;
  sP_PhoneNo!: string | undefined;
  sP_MobileNo!: string | undefined;
  sP_WorkNo!: string | undefined;
  sP_SmokerStatusId!: number | undefined;
  sP_HealthStatusId!: number | undefined;
  sP_HealthStatusOther!: string | undefined;
  sP_NationalDomicileId!: number | undefined;
  sP_AddressLine_1!: string | undefined;
  sP_AddressLine_2!: string | undefined;
  sP_AddressLine_3!: string | undefined;
  sP_AddressLine_4!: string | undefined;
  sP_AddressCountyId!: number | undefined;
  sP_AddressCountryId!: number | undefined;
  sP_PostCode!: string | undefined;
  sP_Email!: string | undefined;
  sP_IsVunerableContact!: boolean;
  sP_OptInAllMarketingComms!: boolean;
  sP_NoComms!: boolean;
  sP_EmploymentStatusId!: number | undefined;
  sP_MainOccupationId!: number | undefined;
  sP_EmployerName!: string | undefined;

  constructor(data?: IUpdateDetailsCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.titleId = _data["titleId"];
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          this.schemeName = _data["schemeName"];
          this.dateOfBirth = _data["dateOfBirth"];
          this.genderId = _data["genderId"];
          this.maritalStatusId = _data["maritalStatusId"];
          this.taxBasisAssessmentId = _data["taxBasisAssessmentId"];
          this.phoneNo = _data["phoneNo"];
          this.mobileNo = _data["mobileNo"];
          this.workNo = _data["workNo"];
          this.faxNo = _data["faxNo"];
          this.smokerStatusId = _data["smokerStatusId"];
          this.healthStatusId = _data["healthStatusId"];
          this.healthStatusOther = _data["healthStatusOther"];
          this.ppsNumber = _data["ppsNumber"];
          this.nationalDomicileId = _data["nationalDomicileId"];
          this.addressLine_1 = _data["addressLine_1"];
          this.addressLine_2 = _data["addressLine_2"];
          this.addressLine_3 = _data["addressLine_3"];
          this.addressLine_4 = _data["addressLine_4"];
          this.addressCountyId = _data["addressCountyId"];
          this.addressCountryId = _data["addressCountryId"];
          this.postCode = _data["postCode"];
          this.email = _data["email"];
          this.isVunerableContact = _data["isVunerableContact"];
          this.optInAllMarketingComms = _data["optInAllMarketingComms"];
          this.noComms = _data["noComms"];
          this.employmentStatusId = _data["employmentStatusId"];
          this.mainOccupationId = _data["mainOccupationId"];
          this.employerName = _data["employerName"];
          this.sP_TitleId = _data["sP_TitleId"];
          this.sP_PPSNumber = _data["sP_PPSNumber"];
          this.sP_FirstName = _data["sP_FirstName"];
          this.sP_LastName = _data["sP_LastName"];
          this.sP_SchemeName = _data["sP_SchemeName"];
          this.sP_DateOfBirth = _data["sP_DateOfBirth"];
          this.sP_GenderId = _data["sP_GenderId"];
          this.sP_MaritalStatusId = _data["sP_MaritalStatusId"];
          this.sP_TaxBasisAssessmentId = _data["sP_TaxBasisAssessmentId"];
          this.sP_PhoneNo = _data["sP_PhoneNo"];
          this.sP_MobileNo = _data["sP_MobileNo"];
          this.sP_WorkNo = _data["sP_WorkNo"];
          this.sP_SmokerStatusId = _data["sP_SmokerStatusId"];
          this.sP_HealthStatusId = _data["sP_HealthStatusId"];
          this.sP_HealthStatusOther = _data["sP_HealthStatusOther"];
          this.sP_NationalDomicileId = _data["sP_NationalDomicileId"];
          this.sP_AddressLine_1 = _data["sP_AddressLine_1"];
          this.sP_AddressLine_2 = _data["sP_AddressLine_2"];
          this.sP_AddressLine_3 = _data["sP_AddressLine_3"];
          this.sP_AddressLine_4 = _data["sP_AddressLine_4"];
          this.sP_AddressCountyId = _data["sP_AddressCountyId"];
          this.sP_AddressCountryId = _data["sP_AddressCountryId"];
          this.sP_PostCode = _data["sP_PostCode"];
          this.sP_Email = _data["sP_Email"];
          this.sP_IsVunerableContact = _data["sP_IsVunerableContact"];
          this.sP_OptInAllMarketingComms = _data["sP_OptInAllMarketingComms"];
          this.sP_NoComms = _data["sP_NoComms"];
          this.sP_EmploymentStatusId = _data["sP_EmploymentStatusId"];
          this.sP_MainOccupationId = _data["sP_MainOccupationId"];
          this.sP_EmployerName = _data["sP_EmployerName"];
      }
  }

  static fromJS(data: any): UpdateDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateDetailsCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["titleId"] = this.titleId;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["schemeName"] = this.schemeName;
      data["dateOfBirth"] = this.dateOfBirth;
      data["genderId"] = this.genderId;
      data["maritalStatusId"] = this.maritalStatusId;
      data["taxBasisAssessmentId"] = this.taxBasisAssessmentId;
      data["phoneNo"] = this.phoneNo;
      data["mobileNo"] = this.mobileNo;
      data["workNo"] = this.workNo;
      data["faxNo"] = this.faxNo;
      data["smokerStatusId"] = this.smokerStatusId;
      data["healthStatusId"] = this.healthStatusId;
      data["healthStatusOther"] = this.healthStatusOther;
      data["ppsNumber"] = this.ppsNumber;
      data["nationalDomicileId"] = this.nationalDomicileId;
      data["addressLine_1"] = this.addressLine_1;
      data["addressLine_2"] = this.addressLine_2;
      data["addressLine_3"] = this.addressLine_3;
      data["addressLine_4"] = this.addressLine_4;
      data["addressCountyId"] = this.addressCountyId;
      data["addressCountryId"] = this.addressCountryId;
      data["postCode"] = this.postCode;
      data["email"] = this.email;
      data["isVunerableContact"] = this.isVunerableContact;
      data["optInAllMarketingComms"] = this.optInAllMarketingComms;
      data["noComms"] = this.noComms;
      data["employmentStatusId"] = this.employmentStatusId;
      data["mainOccupationId"] = this.mainOccupationId;
      data["employerName"] = this.employerName;
      data["sP_TitleId"] = this.sP_TitleId;
      data["sP_PPSNumber"] = this.sP_PPSNumber;
      data["sP_FirstName"] = this.sP_FirstName;
      data["sP_LastName"] = this.sP_LastName;
      data["sP_SchemeName"] = this.sP_SchemeName;
      data["sP_DateOfBirth"] = this.sP_DateOfBirth;
      data["sP_GenderId"] = this.sP_GenderId;
      data["sP_MaritalStatusId"] = this.sP_MaritalStatusId;
      data["sP_TaxBasisAssessmentId"] = this.sP_TaxBasisAssessmentId;
      data["sP_PhoneNo"] = this.sP_PhoneNo;
      data["sP_MobileNo"] = this.sP_MobileNo;
      data["sP_WorkNo"] = this.sP_WorkNo;
      data["sP_SmokerStatusId"] = this.sP_SmokerStatusId;
      data["sP_HealthStatusId"] = this.sP_HealthStatusId;
      data["sP_HealthStatusOther"] = this.sP_HealthStatusOther;
      data["sP_NationalDomicileId"] = this.sP_NationalDomicileId;
      data["sP_AddressLine_1"] = this.sP_AddressLine_1;
      data["sP_AddressLine_2"] = this.sP_AddressLine_2;
      data["sP_AddressLine_3"] = this.sP_AddressLine_3;
      data["sP_AddressLine_4"] = this.sP_AddressLine_4;
      data["sP_AddressCountyId"] = this.sP_AddressCountyId;
      data["sP_AddressCountryId"] = this.sP_AddressCountryId;
      data["sP_PostCode"] = this.sP_PostCode;
      data["sP_Email"] = this.sP_Email;
      data["sP_IsVunerableContact"] = this.sP_IsVunerableContact;
      data["sP_OptInAllMarketingComms"] = this.sP_OptInAllMarketingComms;
      data["sP_NoComms"] = this.sP_NoComms;
      data["sP_EmploymentStatusId"] = this.sP_EmploymentStatusId;
      data["sP_MainOccupationId"] = this.sP_MainOccupationId;
      data["sP_EmployerName"] = this.sP_EmployerName;
      super.toJSON(data);
      return data;
  }
}

export interface IUpdateDetailsCommand extends I_FactFindUpdateCommandBase {
  titleId: number;
  firstName: string | undefined;
  lastName: string | undefined;
  schemeName: string | undefined;
  dateOfBirth: string;
  genderId: number;
  maritalStatusId: number;
  taxBasisAssessmentId: number;
  phoneNo: string | undefined;
  mobileNo: string | undefined;
  workNo: string | undefined;
  faxNo: string | undefined;
  smokerStatusId: number;
  healthStatusId: number;
  healthStatusOther: string | undefined;
  ppsNumber: string | undefined;
  nationalDomicileId: number;
  addressLine_1: string | undefined;
  addressLine_2: string | undefined;
  addressLine_3: string | undefined;
  addressLine_4: string | undefined;
  addressCountyId: number;
  addressCountryId: number;
  postCode: string | undefined;
  email: string | undefined;
  isVunerableContact: boolean;
  optInAllMarketingComms: boolean;
  noComms: boolean;
  employmentStatusId: number;
  mainOccupationId: number;
  employerName: string | undefined;
  sP_TitleId: number;
  sP_PPSNumber: string | undefined;
  sP_FirstName: string | undefined;
  sP_LastName: string | undefined;
  sP_SchemeName: string | undefined;
  sP_DateOfBirth: string | undefined;
  sP_GenderId: number | undefined;
  sP_MaritalStatusId: number | undefined;
  sP_TaxBasisAssessmentId: number | undefined;
  sP_PhoneNo: string | undefined;
  sP_MobileNo: string | undefined;
  sP_WorkNo: string | undefined;
  sP_SmokerStatusId: number | undefined;
  sP_HealthStatusId: number | undefined;
  sP_HealthStatusOther: string | undefined;
  sP_NationalDomicileId: number | undefined;
  sP_AddressLine_1: string | undefined;
  sP_AddressLine_2: string | undefined;
  sP_AddressLine_3: string | undefined;
  sP_AddressLine_4: string | undefined;
  sP_AddressCountyId: number | undefined;
  sP_AddressCountryId: number | undefined;
  sP_PostCode: string | undefined;
  sP_Email: string | undefined;
  sP_IsVunerableContact: boolean;
  sP_OptInAllMarketingComms: boolean;
  sP_NoComms: boolean;
  sP_EmploymentStatusId: number | undefined;
  sP_MainOccupationId: number | undefined;
  sP_EmployerName: string | undefined;
}

export class FactFindEmploymentDto implements IFactFindEmploymentDto {
  id!: number;
  client!: ClientSelector;
  employmentStatus!: EmploymentStatusDto | undefined;
  occupation!: string | undefined;
  jobDescription!: string | undefined;
  employerName!: string | undefined;
  employerAddressLine_1!: string | undefined;
  employerAddressLine_2!: string | undefined;
  employerAddressLine_3!: string | undefined;
  employerAddressLine_4!: string | undefined;
  employerAddressLine_5!: string | undefined;
  startDate!: string;
  endDate!: string;
  isInProbationPeriod!: YesNoDefaultDto | undefined;
  probationPeriodLength!: string | undefined;
  probationPeriodEndDate!: string;
  plansToChangeJob!: YesNoDefaultDto | undefined;
  plansToChangeJobTimeFrame!: string | undefined;
  retirementAge!: number;
  employmentDate!: string;
  revenueNumber!: string | undefined;
  isDirector!: YesNoDefaultDto | undefined;
  shareholdingPercentage!: number;
  notes!: string | undefined;

  constructor(data?: IFactFindEmploymentDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.employmentStatus = data.employmentStatus && !(<any>data.employmentStatus).toJSON ? new EmploymentStatusDto(data.employmentStatus) : <EmploymentStatusDto>this.employmentStatus;
          this.isInProbationPeriod = data.isInProbationPeriod && !(<any>data.isInProbationPeriod).toJSON ? new YesNoDefaultDto(data.isInProbationPeriod) : <YesNoDefaultDto>this.isInProbationPeriod;
          this.plansToChangeJob = data.plansToChangeJob && !(<any>data.plansToChangeJob).toJSON ? new YesNoDefaultDto(data.plansToChangeJob) : <YesNoDefaultDto>this.plansToChangeJob;
          this.isDirector = data.isDirector && !(<any>data.isDirector).toJSON ? new YesNoDefaultDto(data.isDirector) : <YesNoDefaultDto>this.isDirector;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.client = _data["client"];
          this.employmentStatus = _data["employmentStatus"] ? EmploymentStatusDto.fromJS(_data["employmentStatus"]) : <any>undefined;
          this.occupation = _data["occupation"];
          this.jobDescription = _data["jobDescription"];
          this.employerName = _data["employerName"];
          this.employerAddressLine_1 = _data["employerAddressLine_1"];
          this.employerAddressLine_2 = _data["employerAddressLine_2"];
          this.employerAddressLine_3 = _data["employerAddressLine_3"];
          this.employerAddressLine_4 = _data["employerAddressLine_4"];
          this.employerAddressLine_5 = _data["employerAddressLine_5"];
          this.startDate = _data["startDate"];
          this.endDate = _data["endDate"];
          this.isInProbationPeriod = _data["isInProbationPeriod"] ? YesNoDefaultDto.fromJS(_data["isInProbationPeriod"]) : <any>undefined;
          this.probationPeriodLength = _data["probationPeriodLength"];
          this.probationPeriodEndDate = _data["probationPeriodEndDate"];
          this.plansToChangeJob = _data["plansToChangeJob"] ? YesNoDefaultDto.fromJS(_data["plansToChangeJob"]) : <any>undefined;
          this.plansToChangeJobTimeFrame = _data["plansToChangeJobTimeFrame"];
          this.retirementAge = _data["retirementAge"];
          this.employmentDate = _data["employmentDate"];
          this.revenueNumber = _data["revenueNumber"];
          this.isDirector = _data["isDirector"] ? YesNoDefaultDto.fromJS(_data["isDirector"]) : <any>undefined;
          this.shareholdingPercentage = _data["shareholdingPercentage"];
          this.notes = _data["notes"];
      }
  }

  static fromJS(data: any): FactFindEmploymentDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindEmploymentDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["client"] = this.client;
      data["employmentStatus"] = this.employmentStatus ? this.employmentStatus.toJSON() : <any>undefined;
      data["occupation"] = this.occupation;
      data["jobDescription"] = this.jobDescription;
      data["employerName"] = this.employerName;
      data["employerAddressLine_1"] = this.employerAddressLine_1;
      data["employerAddressLine_2"] = this.employerAddressLine_2;
      data["employerAddressLine_3"] = this.employerAddressLine_3;
      data["employerAddressLine_4"] = this.employerAddressLine_4;
      data["employerAddressLine_5"] = this.employerAddressLine_5;
      data["startDate"] = this.startDate;
      data["endDate"] = this.endDate;
      data["isInProbationPeriod"] = this.isInProbationPeriod ? this.isInProbationPeriod.toJSON() : <any>undefined;
      data["probationPeriodLength"] = this.probationPeriodLength;
      data["probationPeriodEndDate"] = this.probationPeriodEndDate;
      data["plansToChangeJob"] = this.plansToChangeJob ? this.plansToChangeJob.toJSON() : <any>undefined;
      data["plansToChangeJobTimeFrame"] = this.plansToChangeJobTimeFrame;
      data["retirementAge"] = this.retirementAge;
      data["employmentDate"] = this.employmentDate;
      data["revenueNumber"] = this.revenueNumber;
      data["isDirector"] = this.isDirector ? this.isDirector.toJSON() : <any>undefined;
      data["shareholdingPercentage"] = this.shareholdingPercentage;
      data["notes"] = this.notes;
      return data;
  }
}

export interface IFactFindEmploymentDto {
  id: number;
  client: ClientSelector;
  employmentStatus: IEmploymentStatusDto | undefined;
  occupation: string | undefined;
  jobDescription: string | undefined;
  employerName: string | undefined;
  employerAddressLine_1: string | undefined;
  employerAddressLine_2: string | undefined;
  employerAddressLine_3: string | undefined;
  employerAddressLine_4: string | undefined;
  employerAddressLine_5: string | undefined;
  startDate: string;
  endDate: string;
  isInProbationPeriod: IYesNoDefaultDto | undefined;
  probationPeriodLength: string | undefined;
  probationPeriodEndDate: string;
  plansToChangeJob: IYesNoDefaultDto | undefined;
  plansToChangeJobTimeFrame: string | undefined;
  retirementAge: number;
  employmentDate: string;
  revenueNumber: string | undefined;
  isDirector: IYesNoDefaultDto | undefined;
  shareholdingPercentage: number;
  notes: string | undefined;
}

export class CreateEmploymentCommand extends _FactFindCreateCommandBase implements ICreateEmploymentCommand {
  client!: ClientSelector;
  employmentStatusId!: number;
  occupation!: string | undefined;
  jobDescription!: string | undefined;
  employerName!: string | undefined;
  employerAddressLine_1!: string | undefined;
  employerAddressLine_2!: string | undefined;
  employerAddressLine_3!: string | undefined;
  employerAddressLine_4!: string | undefined;
  employerAddressLine_5!: string | undefined;
  startDate!: string;
  endDate!: string;
  isInProbationPeriodId!: number;
  probationPeriodLength!: string | undefined;
  probationPeriodEndDate!: string;
  plansToChangeJobId!: number;
  plansToChangeJobTimeFrame!: string | undefined;
  retirementAge!: number;
  employmentDate!: string;
  revenueNumber!: string | undefined;
  isDirectorId!: number;
  shareholdingPercentage!: number;
  notes!: string | undefined;

  constructor(data?: ICreateEmploymentCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.client = _data["client"];
          this.employmentStatusId = _data["employmentStatusId"];
          this.occupation = _data["occupation"];
          this.jobDescription = _data["jobDescription"];
          this.employerName = _data["employerName"];
          this.employerAddressLine_1 = _data["employerAddressLine_1"];
          this.employerAddressLine_2 = _data["employerAddressLine_2"];
          this.employerAddressLine_3 = _data["employerAddressLine_3"];
          this.employerAddressLine_4 = _data["employerAddressLine_4"];
          this.employerAddressLine_5 = _data["employerAddressLine_5"];
          this.startDate = _data["startDate"];
          this.endDate = _data["endDate"];
          this.isInProbationPeriodId = _data["isInProbationPeriodId"];
          this.probationPeriodLength = _data["probationPeriodLength"];
          this.probationPeriodEndDate = _data["probationPeriodEndDate"];
          this.plansToChangeJobId = _data["plansToChangeJobId"];
          this.plansToChangeJobTimeFrame = _data["plansToChangeJobTimeFrame"];
          this.retirementAge = _data["retirementAge"];
          this.employmentDate = _data["employmentDate"];
          this.revenueNumber = _data["revenueNumber"];
          this.isDirectorId = _data["isDirectorId"];
          this.shareholdingPercentage = _data["shareholdingPercentage"];
          this.notes = _data["notes"];
      }
  }

  static fromJS(data: any): CreateEmploymentCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateEmploymentCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["client"] = this.client;
      data["employmentStatusId"] = this.employmentStatusId;
      data["occupation"] = this.occupation;
      data["jobDescription"] = this.jobDescription;
      data["employerName"] = this.employerName;
      data["employerAddressLine_1"] = this.employerAddressLine_1;
      data["employerAddressLine_2"] = this.employerAddressLine_2;
      data["employerAddressLine_3"] = this.employerAddressLine_3;
      data["employerAddressLine_4"] = this.employerAddressLine_4;
      data["employerAddressLine_5"] = this.employerAddressLine_5;
      data["startDate"] = this.startDate;
      data["endDate"] = this.endDate;
      data["isInProbationPeriodId"] = this.isInProbationPeriodId;
      data["probationPeriodLength"] = this.probationPeriodLength;
      data["probationPeriodEndDate"] = this.probationPeriodEndDate;
      data["plansToChangeJobId"] = this.plansToChangeJobId;
      data["plansToChangeJobTimeFrame"] = this.plansToChangeJobTimeFrame;
      data["retirementAge"] = this.retirementAge;
      data["employmentDate"] = this.employmentDate;
      data["revenueNumber"] = this.revenueNumber;
      data["isDirectorId"] = this.isDirectorId;
      data["shareholdingPercentage"] = this.shareholdingPercentage;
      data["notes"] = this.notes;
      super.toJSON(data);
      return data;
  }
}

export interface ICreateEmploymentCommand extends I_FactFindCreateCommandBase {
  client: ClientSelector;
  employmentStatusId: number;
  occupation: string | undefined;
  jobDescription: string | undefined;
  employerName: string | undefined;
  employerAddressLine_1: string | undefined;
  employerAddressLine_2: string | undefined;
  employerAddressLine_3: string | undefined;
  employerAddressLine_4: string | undefined;
  employerAddressLine_5: string | undefined;
  startDate: string;
  endDate: string;
  isInProbationPeriodId: number;
  probationPeriodLength: string | undefined;
  probationPeriodEndDate: string;
  plansToChangeJobId: number;
  plansToChangeJobTimeFrame: string | undefined;
  retirementAge: number;
  employmentDate: string;
  revenueNumber: string | undefined;
  isDirectorId: number;
  shareholdingPercentage: number;
  notes: string | undefined;
}

export class UpdateEmploymentCommand extends _FactFindUpdateCommandBase implements IUpdateEmploymentCommand {
  client!: ClientSelector;
  employmentStatusId!: number;
  occupation!: string | undefined;
  jobDescription!: string | undefined;
  employerName!: string | undefined;
  employerAddressLine_1!: string | undefined;
  employerAddressLine_2!: string | undefined;
  employerAddressLine_3!: string | undefined;
  employerAddressLine_4!: string | undefined;
  employerAddressLine_5!: string | undefined;
  startDate!: string;
  endDate!: string;
  isInProbationPeriodId!: number;
  probationPeriodLength!: string | undefined;
  probationPeriodEndDate!: string;
  plansToChangeJobId!: number;
  plansToChangeJobTimeFrame!: string | undefined;
  retirementAge!: number;
  employmentDate!: string;
  revenueNumber!: string | undefined;
  isDirectorId!: number;
  shareholdingPercentage!: number;
  notes!: string | undefined;

  constructor(data?: IUpdateEmploymentCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.client = _data["client"];
          this.employmentStatusId = _data["employmentStatusId"];
          this.occupation = _data["occupation"];
          this.jobDescription = _data["jobDescription"];
          this.employerName = _data["employerName"];
          this.employerAddressLine_1 = _data["employerAddressLine_1"];
          this.employerAddressLine_2 = _data["employerAddressLine_2"];
          this.employerAddressLine_3 = _data["employerAddressLine_3"];
          this.employerAddressLine_4 = _data["employerAddressLine_4"];
          this.employerAddressLine_5 = _data["employerAddressLine_5"];
          this.startDate = _data["startDate"];
          this.endDate = _data["endDate"];
          this.isInProbationPeriodId = _data["isInProbationPeriodId"];
          this.probationPeriodLength = _data["probationPeriodLength"];
          this.probationPeriodEndDate = _data["probationPeriodEndDate"];
          this.plansToChangeJobId = _data["plansToChangeJobId"];
          this.plansToChangeJobTimeFrame = _data["plansToChangeJobTimeFrame"];
          this.retirementAge = _data["retirementAge"];
          this.employmentDate = _data["employmentDate"];
          this.revenueNumber = _data["revenueNumber"];
          this.isDirectorId = _data["isDirectorId"];
          this.shareholdingPercentage = _data["shareholdingPercentage"];
          this.notes = _data["notes"];
      }
  }

  static fromJS(data: any): UpdateEmploymentCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateEmploymentCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["client"] = this.client;
      data["employmentStatusId"] = this.employmentStatusId;
      data["occupation"] = this.occupation;
      data["jobDescription"] = this.jobDescription;
      data["employerName"] = this.employerName;
      data["employerAddressLine_1"] = this.employerAddressLine_1;
      data["employerAddressLine_2"] = this.employerAddressLine_2;
      data["employerAddressLine_3"] = this.employerAddressLine_3;
      data["employerAddressLine_4"] = this.employerAddressLine_4;
      data["employerAddressLine_5"] = this.employerAddressLine_5;
      data["startDate"] = this.startDate;
      data["endDate"] = this.endDate;
      data["isInProbationPeriodId"] = this.isInProbationPeriodId;
      data["probationPeriodLength"] = this.probationPeriodLength;
      data["probationPeriodEndDate"] = this.probationPeriodEndDate;
      data["plansToChangeJobId"] = this.plansToChangeJobId;
      data["plansToChangeJobTimeFrame"] = this.plansToChangeJobTimeFrame;
      data["retirementAge"] = this.retirementAge;
      data["employmentDate"] = this.employmentDate;
      data["revenueNumber"] = this.revenueNumber;
      data["isDirectorId"] = this.isDirectorId;
      data["shareholdingPercentage"] = this.shareholdingPercentage;
      data["notes"] = this.notes;
      super.toJSON(data);
      return data;
  }
}

export interface IUpdateEmploymentCommand extends I_FactFindUpdateCommandBase {
  client: ClientSelector;
  employmentStatusId: number;
  occupation: string | undefined;
  jobDescription: string | undefined;
  employerName: string | undefined;
  employerAddressLine_1: string | undefined;
  employerAddressLine_2: string | undefined;
  employerAddressLine_3: string | undefined;
  employerAddressLine_4: string | undefined;
  employerAddressLine_5: string | undefined;
  startDate: string;
  endDate: string;
  isInProbationPeriodId: number;
  probationPeriodLength: string | undefined;
  probationPeriodEndDate: string;
  plansToChangeJobId: number;
  plansToChangeJobTimeFrame: string | undefined;
  retirementAge: number;
  employmentDate: string;
  revenueNumber: string | undefined;
  isDirectorId: number;
  shareholdingPercentage: number;
  notes: string | undefined;
}

export class FactFindExpenseDto implements IFactFindExpenseDto {
  id!: number;
  client!: ClientSelector;
  expenseType!: ExpenseTypeDto | undefined;
  expenseAmount!: number;
  monthlyExpenseAmount!: number;
  paymentFrequency!: PaymentFrequencyDto | undefined;
  paymentMethod!: PaymentMethodDto | undefined;

  constructor(data?: IFactFindExpenseDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.expenseType = data.expenseType && !(<any>data.expenseType).toJSON ? new ExpenseTypeDto(data.expenseType) : <ExpenseTypeDto>this.expenseType;
          this.paymentFrequency = data.paymentFrequency && !(<any>data.paymentFrequency).toJSON ? new PaymentFrequencyDto(data.paymentFrequency) : <PaymentFrequencyDto>this.paymentFrequency;
          this.paymentMethod = data.paymentMethod && !(<any>data.paymentMethod).toJSON ? new PaymentMethodDto(data.paymentMethod) : <PaymentMethodDto>this.paymentMethod;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.client = _data["client"];
          this.expenseType = _data["expenseType"] ? ExpenseTypeDto.fromJS(_data["expenseType"]) : <any>undefined;
          this.expenseAmount = _data["expenseAmount"];
          this.monthlyExpenseAmount = _data["monthlyExpenseAmount"];
          this.paymentFrequency = _data["paymentFrequency"] ? PaymentFrequencyDto.fromJS(_data["paymentFrequency"]) : <any>undefined;
          this.paymentMethod = _data["paymentMethod"] ? PaymentMethodDto.fromJS(_data["paymentMethod"]) : <any>undefined;
      }
  }

  static fromJS(data: any): FactFindExpenseDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindExpenseDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["client"] = this.client;
      data["expenseType"] = this.expenseType ? this.expenseType.toJSON() : <any>undefined;
      data["expenseAmount"] = this.expenseAmount;
      data["monthlyExpenseAmount"] = this.monthlyExpenseAmount;
      data["paymentFrequency"] = this.paymentFrequency ? this.paymentFrequency.toJSON() : <any>undefined;
      data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
      return data;
  }
}

export interface IFactFindExpenseDto {
  id: number;
  client: ClientSelector;
  expenseType: IExpenseTypeDto | undefined;
  expenseAmount: number;
  monthlyExpenseAmount: number;
  paymentFrequency: IPaymentFrequencyDto | undefined;
  paymentMethod: IPaymentMethodDto | undefined;
}

export class CreateExpenseCommand extends _FactFindCreateCommandBase implements ICreateExpenseCommand {
  client!: ClientSelector;
  expenseTypeId!: number;
  expenseAmount!: number;
  monthlyExpenseAmount!: number;
  paymentFrequencyId!: number;
  paymentMethodId!: number;

  constructor(data?: ICreateExpenseCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.client = _data["client"];
          this.expenseTypeId = _data["expenseTypeId"];
          this.expenseAmount = _data["expenseAmount"];
          this.monthlyExpenseAmount = _data["monthlyExpenseAmount"];
          this.paymentFrequencyId = _data["paymentFrequencyId"];
          this.paymentMethodId = _data["paymentMethodId"];
      }
  }

  static fromJS(data: any): CreateExpenseCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateExpenseCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["client"] = this.client;
      data["expenseTypeId"] = this.expenseTypeId;
      data["expenseAmount"] = this.expenseAmount;
      data["monthlyExpenseAmount"] = this.monthlyExpenseAmount;
      data["paymentFrequencyId"] = this.paymentFrequencyId;
      data["paymentMethodId"] = this.paymentMethodId;
      super.toJSON(data);
      return data;
  }
}

export interface ICreateExpenseCommand extends I_FactFindCreateCommandBase {
  client: ClientSelector;
  expenseTypeId: number;
  expenseAmount: number;
  monthlyExpenseAmount: number;
  paymentFrequencyId: number;
  paymentMethodId: number;
}

export class UpdateExpenseCommand extends _FactFindUpdateCommandBase implements IUpdateExpenseCommand {
  client!: ClientSelector;
  expenseTypeId!: number;
  expenseAmount!: number;
  monthlyExpenseAmount!: number;
  paymentFrequencyId!: number;
  paymentMethodId!: number;

  constructor(data?: IUpdateExpenseCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.client = _data["client"];
          this.expenseTypeId = _data["expenseTypeId"];
          this.expenseAmount = _data["expenseAmount"];
          this.monthlyExpenseAmount = _data["monthlyExpenseAmount"];
          this.paymentFrequencyId = _data["paymentFrequencyId"];
          this.paymentMethodId = _data["paymentMethodId"];
      }
  }

  static fromJS(data: any): UpdateExpenseCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateExpenseCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["client"] = this.client;
      data["expenseTypeId"] = this.expenseTypeId;
      data["expenseAmount"] = this.expenseAmount;
      data["monthlyExpenseAmount"] = this.monthlyExpenseAmount;
      data["paymentFrequencyId"] = this.paymentFrequencyId;
      data["paymentMethodId"] = this.paymentMethodId;
      super.toJSON(data);
      return data;
  }
}

export interface IUpdateExpenseCommand extends I_FactFindUpdateCommandBase {
  client: ClientSelector;
  expenseTypeId: number;
  expenseAmount: number;
  monthlyExpenseAmount: number;
  paymentFrequencyId: number;
  paymentMethodId: number;
}

export class FactFindIncomeDto implements IFactFindIncomeDto {
  id!: number;
  incomeOwner!: ClientSelector;
  companySource!: string | undefined;
  incomeType!: IncomeTypeDto | undefined;
  incomeTypeOthers!: string | undefined;
  incomeCategory!: IncomeCategoryDto | undefined;
  taxTreatment!: TaxTreatmentDto | undefined;
  taxTreatmentDetails!: string | undefined;
  dateStarted!: string;
  dateEnded!: string | undefined;
  amountPerYear!: number;
  isDomesticIncome!: YesNoDefaultDto | undefined;

  constructor(data?: IFactFindIncomeDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.incomeType = data.incomeType && !(<any>data.incomeType).toJSON ? new IncomeTypeDto(data.incomeType) : <IncomeTypeDto>this.incomeType;
          this.incomeCategory = data.incomeCategory && !(<any>data.incomeCategory).toJSON ? new IncomeCategoryDto(data.incomeCategory) : <IncomeCategoryDto>this.incomeCategory;
          this.taxTreatment = data.taxTreatment && !(<any>data.taxTreatment).toJSON ? new TaxTreatmentDto(data.taxTreatment) : <TaxTreatmentDto>this.taxTreatment;
          this.isDomesticIncome = data.isDomesticIncome && !(<any>data.isDomesticIncome).toJSON ? new YesNoDefaultDto(data.isDomesticIncome) : <YesNoDefaultDto>this.isDomesticIncome;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.incomeOwner = _data["incomeOwner"];
          this.companySource = _data["companySource"];
          this.incomeType = _data["incomeType"] ? IncomeTypeDto.fromJS(_data["incomeType"]) : <any>undefined;
          this.incomeTypeOthers = _data["incomeTypeOthers"];
          this.incomeCategory = _data["incomeCategory"] ? IncomeCategoryDto.fromJS(_data["incomeCategory"]) : <any>undefined;
          this.taxTreatment = _data["taxTreatment"] ? TaxTreatmentDto.fromJS(_data["taxTreatment"]) : <any>undefined;
          this.taxTreatmentDetails = _data["taxTreatmentDetails"];
          this.dateStarted = _data["dateStarted"];
          this.dateEnded = _data["dateEnded"];
          this.amountPerYear = _data["amountPerYear"];
          this.isDomesticIncome = _data["isDomesticIncome"] ? YesNoDefaultDto.fromJS(_data["isDomesticIncome"]) : <any>undefined;
      }
  }

  static fromJS(data: any): FactFindIncomeDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindIncomeDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["incomeOwner"] = this.incomeOwner;
      data["companySource"] = this.companySource;
      data["incomeType"] = this.incomeType ? this.incomeType.toJSON() : <any>undefined;
      data["incomeTypeOthers"] = this.incomeTypeOthers;
      data["incomeCategory"] = this.incomeCategory ? this.incomeCategory.toJSON() : <any>undefined;
      data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
      data["taxTreatmentDetails"] = this.taxTreatmentDetails;
      data["dateStarted"] = this.dateStarted;
      data["dateEnded"] = this.dateEnded;
      data["amountPerYear"] = this.amountPerYear;
      data["isDomesticIncome"] = this.isDomesticIncome ? this.isDomesticIncome.toJSON() : <any>undefined;
      return data;
  }
}

export interface IFactFindIncomeDto {
  id: number;
  incomeOwner: ClientSelector;
  companySource: string | undefined;
  incomeType: IIncomeTypeDto | undefined;
  incomeTypeOthers: string | undefined;
  incomeCategory: IIncomeCategoryDto | undefined;
  taxTreatment: ITaxTreatmentDto | undefined;
  taxTreatmentDetails: string | undefined;
  dateStarted: string;
  dateEnded: string | undefined;
  amountPerYear: number;
  isDomesticIncome: IYesNoDefaultDto | undefined;
}

export class CreateIncomeCommand extends _FactFindCreateCommandBase implements ICreateIncomeCommand {
  incomeOwner!: ClientSelector;
  companySource!: string | undefined;
  incomeTypeId!: number;
  incomeTypeOthers!: string | undefined;
  incomeCategoryId!: number;
  taxTreatmentId!: number;
  taxTreatmentDetails!: string | undefined;
  dateStarted!: string | undefined;
  dateEnded!: string | undefined;
  amountPerYear!: number | undefined;
  isDomesticIncomeId!: number;

  constructor(data?: ICreateIncomeCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.incomeOwner = _data["incomeOwner"];
          this.companySource = _data["companySource"];
          this.incomeTypeId = _data["incomeTypeId"];
          this.incomeTypeOthers = _data["incomeTypeOthers"];
          this.incomeCategoryId = _data["incomeCategoryId"];
          this.taxTreatmentId = _data["taxTreatmentId"];
          this.taxTreatmentDetails = _data["taxTreatmentDetails"];
          this.dateStarted = _data["dateStarted"];
          this.dateEnded = _data["dateEnded"];
          this.amountPerYear = _data["amountPerYear"];
          this.isDomesticIncomeId = _data["isDomesticIncomeId"];
      }
  }

  static fromJS(data: any): CreateIncomeCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateIncomeCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["incomeOwner"] = this.incomeOwner;
      data["companySource"] = this.companySource;
      data["incomeTypeId"] = this.incomeTypeId;
      data["incomeTypeOthers"] = this.incomeTypeOthers;
      data["incomeCategoryId"] = this.incomeCategoryId;
      data["taxTreatmentId"] = this.taxTreatmentId;
      data["taxTreatmentDetails"] = this.taxTreatmentDetails;
      data["dateStarted"] = this.dateStarted;
      data["dateEnded"] = this.dateEnded;
      data["amountPerYear"] = this.amountPerYear;
      data["isDomesticIncomeId"] = this.isDomesticIncomeId;
      super.toJSON(data);
      return data;
  }
}

export interface ICreateIncomeCommand extends I_FactFindCreateCommandBase {
  incomeOwner: ClientSelector;
  companySource: string | undefined;
  incomeTypeId: number;
  incomeTypeOthers: string | undefined;
  incomeCategoryId: number;
  taxTreatmentId: number;
  taxTreatmentDetails: string | undefined;
  dateStarted: string | undefined;
  dateEnded: string | undefined;
  amountPerYear: number | undefined;
  isDomesticIncomeId: number;
}

export class UpdateIncomeCommand extends _FactFindUpdateCommandBase implements IUpdateIncomeCommand {
  incomeOwner!: ClientSelector;
  companySource!: string | undefined;
  incomeTypeId!: number;
  incomeTypeOthers!: string | undefined;
  incomeCategoryId!: number;
  taxTreatmentId!: number;
  taxTreatmentDetails!: string | undefined;
  dateStarted!: string | undefined;
  dateEnded!: string | undefined;
  amountPerYear!: number | undefined;
  isDomesticIncomeId!: number;

  constructor(data?: IUpdateIncomeCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.incomeOwner = _data["incomeOwner"];
          this.companySource = _data["companySource"];
          this.incomeTypeId = _data["incomeTypeId"];
          this.incomeTypeOthers = _data["incomeTypeOthers"];
          this.incomeCategoryId = _data["incomeCategoryId"];
          this.taxTreatmentId = _data["taxTreatmentId"];
          this.taxTreatmentDetails = _data["taxTreatmentDetails"];
          this.dateStarted = _data["dateStarted"];
          this.dateEnded = _data["dateEnded"];
          this.amountPerYear = _data["amountPerYear"];
          this.isDomesticIncomeId = _data["isDomesticIncomeId"];
      }
  }

  static fromJS(data: any): UpdateIncomeCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateIncomeCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["incomeOwner"] = this.incomeOwner;
      data["companySource"] = this.companySource;
      data["incomeTypeId"] = this.incomeTypeId;
      data["incomeTypeOthers"] = this.incomeTypeOthers;
      data["incomeCategoryId"] = this.incomeCategoryId;
      data["taxTreatmentId"] = this.taxTreatmentId;
      data["taxTreatmentDetails"] = this.taxTreatmentDetails;
      data["dateStarted"] = this.dateStarted;
      data["dateEnded"] = this.dateEnded;
      data["amountPerYear"] = this.amountPerYear;
      data["isDomesticIncomeId"] = this.isDomesticIncomeId;
      super.toJSON(data);
      return data;
  }
}

export interface IUpdateIncomeCommand extends I_FactFindUpdateCommandBase {
  incomeOwner: ClientSelector;
  companySource: string | undefined;
  incomeTypeId: number;
  incomeTypeOthers: string | undefined;
  incomeCategoryId: number;
  taxTreatmentId: number;
  taxTreatmentDetails: string | undefined;
  dateStarted: string | undefined;
  dateEnded: string | undefined;
  amountPerYear: number | undefined;
  isDomesticIncomeId: number;
}

export class FactFindDto implements IFactFindDto {

  constructor(data?: IFactFindDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
  }

  static fromJS(data: any): FactFindDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
  }
}

export interface IFactFindDto {
}

export class FactFindLiabilityCardDto extends FactFindDto implements IFactFindLiabilityCardDto {
  id!: number;
  cardOwner!: ClientSelector;
  cardCompany!: ProductProviderDto | undefined;
  creditLimit!: number;
  currentBalance!: number;
  monthlyRepayment!: number;
  annualPercentageRate!: number;
  percentageRepaidMonthly!: number;
  cardProtection!: YesNoDefaultDto | undefined;
  monthlyProtectionAmount!: number;

  constructor(data?: IFactFindLiabilityCardDto) {
      super(data);
      if (data) {
          this.cardCompany = data.cardCompany && !(<any>data.cardCompany).toJSON ? new ProductProviderDto(data.cardCompany) : <ProductProviderDto>this.cardCompany;
          this.cardProtection = data.cardProtection && !(<any>data.cardProtection).toJSON ? new YesNoDefaultDto(data.cardProtection) : <YesNoDefaultDto>this.cardProtection;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.cardOwner = _data["cardOwner"];
          this.cardCompany = _data["cardCompany"] ? ProductProviderDto.fromJS(_data["cardCompany"]) : <any>undefined;
          this.creditLimit = _data["creditLimit"];
          this.currentBalance = _data["currentBalance"];
          this.monthlyRepayment = _data["monthlyRepayment"];
          this.annualPercentageRate = _data["annualPercentageRate"];
          this.percentageRepaidMonthly = _data["percentageRepaidMonthly"];
          this.cardProtection = _data["cardProtection"] ? YesNoDefaultDto.fromJS(_data["cardProtection"]) : <any>undefined;
          this.monthlyProtectionAmount = _data["monthlyProtectionAmount"];
      }
  }

  static fromJS(data: any): FactFindLiabilityCardDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindLiabilityCardDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["cardOwner"] = this.cardOwner;
      data["cardCompany"] = this.cardCompany ? this.cardCompany.toJSON() : <any>undefined;
      data["creditLimit"] = this.creditLimit;
      data["currentBalance"] = this.currentBalance;
      data["monthlyRepayment"] = this.monthlyRepayment;
      data["annualPercentageRate"] = this.annualPercentageRate;
      data["percentageRepaidMonthly"] = this.percentageRepaidMonthly;
      data["cardProtection"] = this.cardProtection ? this.cardProtection.toJSON() : <any>undefined;
      data["monthlyProtectionAmount"] = this.monthlyProtectionAmount;
      super.toJSON(data);
      return data;
  }
}

export interface IFactFindLiabilityCardDto extends IFactFindDto {
  id: number;
  cardOwner: ClientSelector;
  cardCompany: IProductProviderDto | undefined;
  creditLimit: number;
  currentBalance: number;
  monthlyRepayment: number;
  annualPercentageRate: number;
  percentageRepaidMonthly: number;
  cardProtection: IYesNoDefaultDto | undefined;
  monthlyProtectionAmount: number;
}

export class CreateLiabilityCardCommand extends _FactFindCreateCommandBase implements ICreateLiabilityCardCommand {
  cardOwner!: ClientSelector;
  cardCompnanyId!: number;
  creditLimit!: number;
  currentBalance!: number;
  monthlyRepayment!: number;
  annualPercentageRate!: number;
  percentageRepaidMonthly!: number;
  cardProtectionId!: number;
  monthlyProtectionAmount!: number;

  constructor(data?: ICreateLiabilityCardCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.cardOwner = _data["cardOwner"];
          this.cardCompnanyId = _data["cardCompnanyId"];
          this.creditLimit = _data["creditLimit"];
          this.currentBalance = _data["currentBalance"];
          this.monthlyRepayment = _data["monthlyRepayment"];
          this.annualPercentageRate = _data["annualPercentageRate"];
          this.percentageRepaidMonthly = _data["percentageRepaidMonthly"];
          this.cardProtectionId = _data["cardProtectionId"];
          this.monthlyProtectionAmount = _data["monthlyProtectionAmount"];
      }
  }

  static fromJS(data: any): CreateLiabilityCardCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateLiabilityCardCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["cardOwner"] = this.cardOwner;
      data["cardCompnanyId"] = this.cardCompnanyId;
      data["creditLimit"] = this.creditLimit;
      data["currentBalance"] = this.currentBalance;
      data["monthlyRepayment"] = this.monthlyRepayment;
      data["annualPercentageRate"] = this.annualPercentageRate;
      data["percentageRepaidMonthly"] = this.percentageRepaidMonthly;
      data["cardProtectionId"] = this.cardProtectionId;
      data["monthlyProtectionAmount"] = this.monthlyProtectionAmount;
      super.toJSON(data);
      return data;
  }
}

export interface ICreateLiabilityCardCommand extends I_FactFindCreateCommandBase {
  cardOwner: ClientSelector;
  cardCompnanyId: number;
  creditLimit: number;
  currentBalance: number;
  monthlyRepayment: number;
  annualPercentageRate: number;
  percentageRepaidMonthly: number;
  cardProtectionId: number;
  monthlyProtectionAmount: number;
}

export class UpdateLiabilityCardCommand extends _FactFindUpdateCommandBase implements IUpdateLiabilityCardCommand {
  cardOwner!: ClientSelector;
  cardCompnanyId!: number;
  creditLimit!: number;
  currentBalance!: number;
  monthlyRepayment!: number;
  annualPercentageRate!: number;
  percentageRepaidMonthly!: number;
  cardProtectionId!: number;
  monthlyProtectionAmount!: number;

  constructor(data?: IUpdateLiabilityCardCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.cardOwner = _data["cardOwner"];
          this.cardCompnanyId = _data["cardCompnanyId"];
          this.creditLimit = _data["creditLimit"];
          this.currentBalance = _data["currentBalance"];
          this.monthlyRepayment = _data["monthlyRepayment"];
          this.annualPercentageRate = _data["annualPercentageRate"];
          this.percentageRepaidMonthly = _data["percentageRepaidMonthly"];
          this.cardProtectionId = _data["cardProtectionId"];
          this.monthlyProtectionAmount = _data["monthlyProtectionAmount"];
      }
  }

  static fromJS(data: any): UpdateLiabilityCardCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateLiabilityCardCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["cardOwner"] = this.cardOwner;
      data["cardCompnanyId"] = this.cardCompnanyId;
      data["creditLimit"] = this.creditLimit;
      data["currentBalance"] = this.currentBalance;
      data["monthlyRepayment"] = this.monthlyRepayment;
      data["annualPercentageRate"] = this.annualPercentageRate;
      data["percentageRepaidMonthly"] = this.percentageRepaidMonthly;
      data["cardProtectionId"] = this.cardProtectionId;
      data["monthlyProtectionAmount"] = this.monthlyProtectionAmount;
      super.toJSON(data);
      return data;
  }
}

export interface IUpdateLiabilityCardCommand extends I_FactFindUpdateCommandBase {
  cardOwner: ClientSelector;
  cardCompnanyId: number;
  creditLimit: number;
  currentBalance: number;
  monthlyRepayment: number;
  annualPercentageRate: number;
  percentageRepaidMonthly: number;
  cardProtectionId: number;
  monthlyProtectionAmount: number;
}

export class FactFindLiabilityLoanDto extends FactFindDto implements IFactFindLiabilityLoanDto {
  id!: number;
  owner!: ClientSelector;
  lender!: ProductProviderDto | undefined;
  dateStarted!: string;
  termInYears!: number;
  amountBorrowed!: number;
  currentBalance!: number;
  monthlyRepayment!: number;
  annualPercentageRate!: number;
  monthlyOverpaymentAmount!: number;
  loanProtected!: YesNoDefaultDto | undefined;
  monthlyProtectionAmount!: number;

  constructor(data?: IFactFindLiabilityLoanDto) {
      super(data);
      if (data) {
          this.lender = data.lender && !(<any>data.lender).toJSON ? new ProductProviderDto(data.lender) : <ProductProviderDto>this.lender;
          this.loanProtected = data.loanProtected && !(<any>data.loanProtected).toJSON ? new YesNoDefaultDto(data.loanProtected) : <YesNoDefaultDto>this.loanProtected;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.owner = _data["owner"];
          this.lender = _data["lender"] ? ProductProviderDto.fromJS(_data["lender"]) : <any>undefined;
          this.dateStarted = _data["dateStarted"];
          this.termInYears = _data["termInYears"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.currentBalance = _data["currentBalance"];
          this.monthlyRepayment = _data["monthlyRepayment"];
          this.annualPercentageRate = _data["annualPercentageRate"];
          this.monthlyOverpaymentAmount = _data["monthlyOverpaymentAmount"];
          this.loanProtected = _data["loanProtected"] ? YesNoDefaultDto.fromJS(_data["loanProtected"]) : <any>undefined;
          this.monthlyProtectionAmount = _data["monthlyProtectionAmount"];
      }
  }

  static fromJS(data: any): FactFindLiabilityLoanDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindLiabilityLoanDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["owner"] = this.owner;
      data["lender"] = this.lender ? this.lender.toJSON() : <any>undefined;
      data["dateStarted"] = this.dateStarted;
      data["termInYears"] = this.termInYears;
      data["amountBorrowed"] = this.amountBorrowed;
      data["currentBalance"] = this.currentBalance;
      data["monthlyRepayment"] = this.monthlyRepayment;
      data["annualPercentageRate"] = this.annualPercentageRate;
      data["monthlyOverpaymentAmount"] = this.monthlyOverpaymentAmount;
      data["loanProtected"] = this.loanProtected ? this.loanProtected.toJSON() : <any>undefined;
      data["monthlyProtectionAmount"] = this.monthlyProtectionAmount;
      super.toJSON(data);
      return data;
  }
}

export interface IFactFindLiabilityLoanDto extends IFactFindDto {
  id: number;
  owner: ClientSelector;
  lender: IProductProviderDto | undefined;
  dateStarted: string;
  termInYears: number;
  amountBorrowed: number;
  currentBalance: number;
  monthlyRepayment: number;
  annualPercentageRate: number;
  monthlyOverpaymentAmount: number;
  loanProtected: IYesNoDefaultDto | undefined;
  monthlyProtectionAmount: number;
}

export class CreateLiabilityLoanCommand extends _FactFindCreateCommandBase implements ICreateLiabilityLoanCommand {
  owner!: ClientSelector;
  lenderId!: number;
  dateStarted!: string;
  termInYears!: number;
  amountBorrowed!: number;
  currentBalance!: number;
  monthlyRepayment!: number;
  annualPercentageRate!: number;
  monthlyOverpaymentAmount!: number;
  loanProtectedId!: number;
  monthlyProtectionAmount!: number;

  constructor(data?: ICreateLiabilityLoanCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.owner = _data["owner"];
          this.lenderId = _data["lenderId"];
          this.dateStarted = _data["dateStarted"];
          this.termInYears = _data["termInYears"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.currentBalance = _data["currentBalance"];
          this.monthlyRepayment = _data["monthlyRepayment"];
          this.annualPercentageRate = _data["annualPercentageRate"];
          this.monthlyOverpaymentAmount = _data["monthlyOverpaymentAmount"];
          this.loanProtectedId = _data["loanProtectedId"];
          this.monthlyProtectionAmount = _data["monthlyProtectionAmount"];
      }
  }

  static fromJS(data: any): CreateLiabilityLoanCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateLiabilityLoanCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["owner"] = this.owner;
      data["lenderId"] = this.lenderId;
      data["dateStarted"] = this.dateStarted;
      data["termInYears"] = this.termInYears;
      data["amountBorrowed"] = this.amountBorrowed;
      data["currentBalance"] = this.currentBalance;
      data["monthlyRepayment"] = this.monthlyRepayment;
      data["annualPercentageRate"] = this.annualPercentageRate;
      data["monthlyOverpaymentAmount"] = this.monthlyOverpaymentAmount;
      data["loanProtectedId"] = this.loanProtectedId;
      data["monthlyProtectionAmount"] = this.monthlyProtectionAmount;
      super.toJSON(data);
      return data;
  }
}

export interface ICreateLiabilityLoanCommand extends I_FactFindCreateCommandBase {
  owner: ClientSelector;
  lenderId: number;
  dateStarted: string;
  termInYears: number;
  amountBorrowed: number;
  currentBalance: number;
  monthlyRepayment: number;
  annualPercentageRate: number;
  monthlyOverpaymentAmount: number;
  loanProtectedId: number;
  monthlyProtectionAmount: number;
}

export class UpdateLiabilityLoanCommand extends _FactFindUpdateCommandBase implements IUpdateLiabilityLoanCommand {
  owner!: ClientSelector;
  lenderId!: number;
  dateStarted!: string;
  termInYears!: number;
  amountBorrowed!: number;
  currentBalance!: number;
  monthlyRepayment!: number;
  annualPercentageRate!: number;
  monthlyOverpaymentAmount!: number;
  loanProtectedId!: number;
  monthlyProtectionAmount!: number;

  constructor(data?: IUpdateLiabilityLoanCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.owner = _data["owner"];
          this.lenderId = _data["lenderId"];
          this.dateStarted = _data["dateStarted"];
          this.termInYears = _data["termInYears"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.currentBalance = _data["currentBalance"];
          this.monthlyRepayment = _data["monthlyRepayment"];
          this.annualPercentageRate = _data["annualPercentageRate"];
          this.monthlyOverpaymentAmount = _data["monthlyOverpaymentAmount"];
          this.loanProtectedId = _data["loanProtectedId"];
          this.monthlyProtectionAmount = _data["monthlyProtectionAmount"];
      }
  }

  static fromJS(data: any): UpdateLiabilityLoanCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateLiabilityLoanCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["owner"] = this.owner;
      data["lenderId"] = this.lenderId;
      data["dateStarted"] = this.dateStarted;
      data["termInYears"] = this.termInYears;
      data["amountBorrowed"] = this.amountBorrowed;
      data["currentBalance"] = this.currentBalance;
      data["monthlyRepayment"] = this.monthlyRepayment;
      data["annualPercentageRate"] = this.annualPercentageRate;
      data["monthlyOverpaymentAmount"] = this.monthlyOverpaymentAmount;
      data["loanProtectedId"] = this.loanProtectedId;
      data["monthlyProtectionAmount"] = this.monthlyProtectionAmount;
      super.toJSON(data);
      return data;
  }
}

export interface IUpdateLiabilityLoanCommand extends I_FactFindUpdateCommandBase {
  owner: ClientSelector;
  lenderId: number;
  dateStarted: string;
  termInYears: number;
  amountBorrowed: number;
  currentBalance: number;
  monthlyRepayment: number;
  annualPercentageRate: number;
  monthlyOverpaymentAmount: number;
  loanProtectedId: number;
  monthlyProtectionAmount: number;
}

export class FactFindPolicyDto extends FactFindDto implements IFactFindPolicyDto {
  id!: number;
  policyTermInYears!: number;
  contactOwnerId_AddedBy!: number | undefined;
  contactOwnerId_LastUpdatedBy!: number | undefined;
  policyOwner!: ClientSelector;
  description!: string | undefined;
  isAgencyPolicy!: boolean;
  policyNo!: string | undefined;
  premium!: number | undefined;
  nra!: number | undefined;
  inceptionDate!: string | undefined;
  maturityDate!: string | undefined;
  fundValueDate!: string | undefined;
  amountBorrowed!: number;
  currentValue!: number;
  currentPercentageRate!: number;
  currentRateEndDate!: string | undefined;
  totalPremiumsPaid!: number | undefined;
  additionalDetails!: PolicyAdditionalDetailsDto | undefined;
  provider!: ProductProviderDto | undefined;
  paymentFrequency!: PaymentFrequencyDto | undefined;
  policyBasis!: PolicyBasisDto | undefined;
  status!: PolicyStatusDto | undefined;
  category!: ProductCategoryDto | undefined;
  subCategory!: ProductSubCategoryDto | undefined;
  indexation!: YesNoDefaultDto | undefined;
  convertible!: YesNoDefaultDto | undefined;
  benefits!: PolicyBenefitDto[] | undefined;
  policyRoles!: PolicyRoleDto[] | undefined;
  policyFunds!: PolicyFundDto[] | undefined;

  constructor(data?: IFactFindPolicyDto) {
      super(data);
      if (data) {
          this.additionalDetails = data.additionalDetails && !(<any>data.additionalDetails).toJSON ? new PolicyAdditionalDetailsDto(data.additionalDetails) : <PolicyAdditionalDetailsDto>this.additionalDetails;
          this.provider = data.provider && !(<any>data.provider).toJSON ? new ProductProviderDto(data.provider) : <ProductProviderDto>this.provider;
          this.paymentFrequency = data.paymentFrequency && !(<any>data.paymentFrequency).toJSON ? new PaymentFrequencyDto(data.paymentFrequency) : <PaymentFrequencyDto>this.paymentFrequency;
          this.policyBasis = data.policyBasis && !(<any>data.policyBasis).toJSON ? new PolicyBasisDto(data.policyBasis) : <PolicyBasisDto>this.policyBasis;
          this.status = data.status && !(<any>data.status).toJSON ? new PolicyStatusDto(data.status) : <PolicyStatusDto>this.status;
          this.category = data.category && !(<any>data.category).toJSON ? new ProductCategoryDto(data.category) : <ProductCategoryDto>this.category;
          this.subCategory = data.subCategory && !(<any>data.subCategory).toJSON ? new ProductSubCategoryDto(data.subCategory) : <ProductSubCategoryDto>this.subCategory;
          this.indexation = data.indexation && !(<any>data.indexation).toJSON ? new YesNoDefaultDto(data.indexation) : <YesNoDefaultDto>this.indexation;
          this.convertible = data.convertible && !(<any>data.convertible).toJSON ? new YesNoDefaultDto(data.convertible) : <YesNoDefaultDto>this.convertible;
          if (data.benefits) {
              this.benefits = [];
              for (let i = 0; i < data.benefits.length; i++) {
                  let item = data.benefits[i];
                  this.benefits[i] = item && !(<any>item).toJSON ? new PolicyBenefitDto(item) : <PolicyBenefitDto>item;
              }
          }
          if (data.policyRoles) {
              this.policyRoles = [];
              for (let i = 0; i < data.policyRoles.length; i++) {
                  let item = data.policyRoles[i];
                  this.policyRoles[i] = item && !(<any>item).toJSON ? new PolicyRoleDto(item) : <PolicyRoleDto>item;
              }
          }
          if (data.policyFunds) {
              this.policyFunds = [];
              for (let i = 0; i < data.policyFunds.length; i++) {
                  let item = data.policyFunds[i];
                  this.policyFunds[i] = item && !(<any>item).toJSON ? new PolicyFundDto(item) : <PolicyFundDto>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.policyTermInYears = _data["policyTermInYears"];
          this.contactOwnerId_AddedBy = _data["contactOwnerId_AddedBy"];
          this.contactOwnerId_LastUpdatedBy = _data["contactOwnerId_LastUpdatedBy"];
          this.policyOwner = _data["policyOwner"];
          this.description = _data["description"];
          this.isAgencyPolicy = _data["isAgencyPolicy"];
          this.policyNo = _data["policyNo"];
          this.premium = _data["premium"];
          this.nra = _data["nra"];
          this.inceptionDate = _data["inceptionDate"];
          this.maturityDate = _data["maturityDate"];
          this.fundValueDate = _data["fundValueDate"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.currentValue = _data["currentValue"];
          this.currentPercentageRate = _data["currentPercentageRate"];
          this.currentRateEndDate = _data["currentRateEndDate"];
          this.totalPremiumsPaid = _data["totalPremiumsPaid"];
          this.additionalDetails = _data["additionalDetails"] ? PolicyAdditionalDetailsDto.fromJS(_data["additionalDetails"]) : <any>undefined;
          this.provider = _data["provider"] ? ProductProviderDto.fromJS(_data["provider"]) : <any>undefined;
          this.paymentFrequency = _data["paymentFrequency"] ? PaymentFrequencyDto.fromJS(_data["paymentFrequency"]) : <any>undefined;
          this.policyBasis = _data["policyBasis"] ? PolicyBasisDto.fromJS(_data["policyBasis"]) : <any>undefined;
          this.status = _data["status"] ? PolicyStatusDto.fromJS(_data["status"]) : <any>undefined;
          this.category = _data["category"] ? ProductCategoryDto.fromJS(_data["category"]) : <any>undefined;
          this.subCategory = _data["subCategory"] ? ProductSubCategoryDto.fromJS(_data["subCategory"]) : <any>undefined;
          this.indexation = _data["indexation"] ? YesNoDefaultDto.fromJS(_data["indexation"]) : <any>undefined;
          this.convertible = _data["convertible"] ? YesNoDefaultDto.fromJS(_data["convertible"]) : <any>undefined;
          if (Array.isArray(_data["benefits"])) {
              this.benefits = [] as any;
              for (let item of _data["benefits"])
                  this.benefits!.push(PolicyBenefitDto.fromJS(item));
          }
          if (Array.isArray(_data["policyRoles"])) {
              this.policyRoles = [] as any;
              for (let item of _data["policyRoles"])
                  this.policyRoles!.push(PolicyRoleDto.fromJS(item));
          }
          if (Array.isArray(_data["policyFunds"])) {
              this.policyFunds = [] as any;
              for (let item of _data["policyFunds"])
                  this.policyFunds!.push(PolicyFundDto.fromJS(item));
          }
      }
  }

  static fromJS(data: any): FactFindPolicyDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindPolicyDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["policyTermInYears"] = this.policyTermInYears;
      data["contactOwnerId_AddedBy"] = this.contactOwnerId_AddedBy;
      data["contactOwnerId_LastUpdatedBy"] = this.contactOwnerId_LastUpdatedBy;
      data["policyOwner"] = this.policyOwner;
      data["description"] = this.description;
      data["isAgencyPolicy"] = this.isAgencyPolicy;
      data["policyNo"] = this.policyNo;
      data["premium"] = this.premium;
      data["nra"] = this.nra;
      data["inceptionDate"] = this.inceptionDate;
      data["maturityDate"] = this.maturityDate;
      data["fundValueDate"] = this.fundValueDate;
      data["amountBorrowed"] = this.amountBorrowed;
      data["currentValue"] = this.currentValue;
      data["currentPercentageRate"] = this.currentPercentageRate;
      data["currentRateEndDate"] = this.currentRateEndDate;
      data["totalPremiumsPaid"] = this.totalPremiumsPaid;
      data["additionalDetails"] = this.additionalDetails ? this.additionalDetails.toJSON() : <any>undefined;
      data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
      data["paymentFrequency"] = this.paymentFrequency ? this.paymentFrequency.toJSON() : <any>undefined;
      data["policyBasis"] = this.policyBasis ? this.policyBasis.toJSON() : <any>undefined;
      data["status"] = this.status ? this.status.toJSON() : <any>undefined;
      data["category"] = this.category ? this.category.toJSON() : <any>undefined;
      data["subCategory"] = this.subCategory ? this.subCategory.toJSON() : <any>undefined;
      data["indexation"] = this.indexation ? this.indexation.toJSON() : <any>undefined;
      data["convertible"] = this.convertible ? this.convertible.toJSON() : <any>undefined;
      if (Array.isArray(this.benefits)) {
          data["benefits"] = [];
          for (let item of this.benefits)
              data["benefits"].push(item.toJSON());
      }
      if (Array.isArray(this.policyRoles)) {
          data["policyRoles"] = [];
          for (let item of this.policyRoles)
              data["policyRoles"].push(item.toJSON());
      }
      if (Array.isArray(this.policyFunds)) {
          data["policyFunds"] = [];
          for (let item of this.policyFunds)
              data["policyFunds"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IFactFindPolicyDto extends IFactFindDto {
  id: number;
  policyTermInYears: number;
  contactOwnerId_AddedBy: number | undefined;
  contactOwnerId_LastUpdatedBy: number | undefined;
  policyOwner: ClientSelector;
  description: string | undefined;
  isAgencyPolicy: boolean;
  policyNo: string | undefined;
  premium: number | undefined;
  nra: number | undefined;
  inceptionDate: string | undefined;
  maturityDate: string | undefined;
  fundValueDate: string | undefined;
  amountBorrowed: number;
  currentValue: number;
  currentPercentageRate: number;
  currentRateEndDate: string | undefined;
  totalPremiumsPaid: number | undefined;
  additionalDetails: IPolicyAdditionalDetailsDto | undefined;
  provider: IProductProviderDto | undefined;
  paymentFrequency: IPaymentFrequencyDto | undefined;
  policyBasis: IPolicyBasisDto | undefined;
  status: IPolicyStatusDto | undefined;
  category: IProductCategoryDto | undefined;
  subCategory: IProductSubCategoryDto | undefined;
  indexation: IYesNoDefaultDto | undefined;
  convertible: IYesNoDefaultDto | undefined;
  benefits: IPolicyBenefitDto[] | undefined;
  policyRoles: IPolicyRoleDto[] | undefined;
  policyFunds: IPolicyFundDto[] | undefined;
}

export class PolicyAdditionalDetailsDto implements IPolicyAdditionalDetailsDto {
  id!: number;
  contactPolicy!: FactFindPolicyDto | undefined;
  policyOccupationClass!: string | undefined;
  deferredPeriodInWeeks!: number;
  ageIncomePayableTo!: number;
  normalRetirementAge!: number;
  schemeName!: string | undefined;
  isWholeOfLife!: boolean;
  ceasingAge!: number;
  others!: string | undefined;
  currentBalance!: number;
  fixedRateStartDate!: string;
  fixedRateTermYears!: number;
  monthlyRepaymentAmount!: number;
  monthlyOverPaymentAmount!: number;
  missedLatePayments!: number | undefined;
  valuationAmount!: number;
  purchaseAmount!: number;
  sitePrice!: number;
  propertyValue!: number;
  mortgageRequired!: number;
  propertyAddressLine_1!: string | undefined;
  propertyAddressLine_2!: string | undefined;
  propertyAddressLine_3!: string | undefined;
  propertyAddressLine_4!: string | undefined;
  propertyAddressLine_5!: string | undefined;
  amountBorrowed!: number;
  currentValue!: number;
  currentPercentageRate!: number;
  currentRateEndDate!: string;
  principalPrivateResidence!: YesNoDefaultDto | undefined;
  investmentProperty!: YesNoDefaultDto | undefined;
  rentalIncome!: YesNoDefaultDto | undefined;
  isVacantPossession!: YesNoDefaultDto | undefined;
  isSoleOccupant!: YesNoDefaultDto | undefined;
  isBusiness!: YesNoDefaultDto | undefined;
  propertyStatus!: PropertyStatusDto | undefined;
  mortgageCategory!: MortgageCategoryDto | undefined;
  mortgageType!: MortgageTypeDto | undefined;
  mortgageRateType!: MortgageRateDto | undefined;
  approvalStatus!: ApprovalStatusDto | undefined;

  constructor(data?: IPolicyAdditionalDetailsDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.contactPolicy = data.contactPolicy && !(<any>data.contactPolicy).toJSON ? new FactFindPolicyDto(data.contactPolicy) : <FactFindPolicyDto>this.contactPolicy;
          this.principalPrivateResidence = data.principalPrivateResidence && !(<any>data.principalPrivateResidence).toJSON ? new YesNoDefaultDto(data.principalPrivateResidence) : <YesNoDefaultDto>this.principalPrivateResidence;
          this.investmentProperty = data.investmentProperty && !(<any>data.investmentProperty).toJSON ? new YesNoDefaultDto(data.investmentProperty) : <YesNoDefaultDto>this.investmentProperty;
          this.rentalIncome = data.rentalIncome && !(<any>data.rentalIncome).toJSON ? new YesNoDefaultDto(data.rentalIncome) : <YesNoDefaultDto>this.rentalIncome;
          this.isVacantPossession = data.isVacantPossession && !(<any>data.isVacantPossession).toJSON ? new YesNoDefaultDto(data.isVacantPossession) : <YesNoDefaultDto>this.isVacantPossession;
          this.isSoleOccupant = data.isSoleOccupant && !(<any>data.isSoleOccupant).toJSON ? new YesNoDefaultDto(data.isSoleOccupant) : <YesNoDefaultDto>this.isSoleOccupant;
          this.isBusiness = data.isBusiness && !(<any>data.isBusiness).toJSON ? new YesNoDefaultDto(data.isBusiness) : <YesNoDefaultDto>this.isBusiness;
          this.propertyStatus = data.propertyStatus && !(<any>data.propertyStatus).toJSON ? new PropertyStatusDto(data.propertyStatus) : <PropertyStatusDto>this.propertyStatus;
          this.mortgageCategory = data.mortgageCategory && !(<any>data.mortgageCategory).toJSON ? new MortgageCategoryDto(data.mortgageCategory) : <MortgageCategoryDto>this.mortgageCategory;
          this.mortgageType = data.mortgageType && !(<any>data.mortgageType).toJSON ? new MortgageTypeDto(data.mortgageType) : <MortgageTypeDto>this.mortgageType;
          this.mortgageRateType = data.mortgageRateType && !(<any>data.mortgageRateType).toJSON ? new MortgageRateDto(data.mortgageRateType) : <MortgageRateDto>this.mortgageRateType;
          this.approvalStatus = data.approvalStatus && !(<any>data.approvalStatus).toJSON ? new ApprovalStatusDto(data.approvalStatus) : <ApprovalStatusDto>this.approvalStatus;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.contactPolicy = _data["contactPolicy"] ? FactFindPolicyDto.fromJS(_data["contactPolicy"]) : <any>undefined;
          this.policyOccupationClass = _data["policyOccupationClass"];
          this.deferredPeriodInWeeks = _data["deferredPeriodInWeeks"];
          this.ageIncomePayableTo = _data["ageIncomePayableTo"];
          this.normalRetirementAge = _data["normalRetirementAge"];
          this.schemeName = _data["schemeName"];
          this.isWholeOfLife = _data["isWholeOfLife"];
          this.ceasingAge = _data["ceasingAge"];
          this.others = _data["others"];
          this.currentBalance = _data["currentBalance"];
          this.fixedRateStartDate = _data["fixedRateStartDate"];
          this.fixedRateTermYears = _data["fixedRateTermYears"];
          this.monthlyRepaymentAmount = _data["monthlyRepaymentAmount"];
          this.monthlyOverPaymentAmount = _data["monthlyOverPaymentAmount"];
          this.missedLatePayments = _data["missedLatePayments"];
          this.valuationAmount = _data["valuationAmount"];
          this.purchaseAmount = _data["purchaseAmount"];
          this.sitePrice = _data["sitePrice"];
          this.propertyValue = _data["propertyValue"];
          this.mortgageRequired = _data["mortgageRequired"];
          this.propertyAddressLine_1 = _data["propertyAddressLine_1"];
          this.propertyAddressLine_2 = _data["propertyAddressLine_2"];
          this.propertyAddressLine_3 = _data["propertyAddressLine_3"];
          this.propertyAddressLine_4 = _data["propertyAddressLine_4"];
          this.propertyAddressLine_5 = _data["propertyAddressLine_5"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.currentValue = _data["currentValue"];
          this.currentPercentageRate = _data["currentPercentageRate"];
          this.currentRateEndDate = _data["currentRateEndDate"];
          this.principalPrivateResidence = _data["principalPrivateResidence"] ? YesNoDefaultDto.fromJS(_data["principalPrivateResidence"]) : <any>undefined;
          this.investmentProperty = _data["investmentProperty"] ? YesNoDefaultDto.fromJS(_data["investmentProperty"]) : <any>undefined;
          this.rentalIncome = _data["rentalIncome"] ? YesNoDefaultDto.fromJS(_data["rentalIncome"]) : <any>undefined;
          this.isVacantPossession = _data["isVacantPossession"] ? YesNoDefaultDto.fromJS(_data["isVacantPossession"]) : <any>undefined;
          this.isSoleOccupant = _data["isSoleOccupant"] ? YesNoDefaultDto.fromJS(_data["isSoleOccupant"]) : <any>undefined;
          this.isBusiness = _data["isBusiness"] ? YesNoDefaultDto.fromJS(_data["isBusiness"]) : <any>undefined;
          this.propertyStatus = _data["propertyStatus"] ? PropertyStatusDto.fromJS(_data["propertyStatus"]) : <any>undefined;
          this.mortgageCategory = _data["mortgageCategory"] ? MortgageCategoryDto.fromJS(_data["mortgageCategory"]) : <any>undefined;
          this.mortgageType = _data["mortgageType"] ? MortgageTypeDto.fromJS(_data["mortgageType"]) : <any>undefined;
          this.mortgageRateType = _data["mortgageRateType"] ? MortgageRateDto.fromJS(_data["mortgageRateType"]) : <any>undefined;
          this.approvalStatus = _data["approvalStatus"] ? ApprovalStatusDto.fromJS(_data["approvalStatus"]) : <any>undefined;
      }
  }

  static fromJS(data: any): PolicyAdditionalDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyAdditionalDetailsDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["contactPolicy"] = this.contactPolicy ? this.contactPolicy.toJSON() : <any>undefined;
      data["policyOccupationClass"] = this.policyOccupationClass;
      data["deferredPeriodInWeeks"] = this.deferredPeriodInWeeks;
      data["ageIncomePayableTo"] = this.ageIncomePayableTo;
      data["normalRetirementAge"] = this.normalRetirementAge;
      data["schemeName"] = this.schemeName;
      data["isWholeOfLife"] = this.isWholeOfLife;
      data["ceasingAge"] = this.ceasingAge;
      data["others"] = this.others;
      data["currentBalance"] = this.currentBalance;
      data["fixedRateStartDate"] = this.fixedRateStartDate;
      data["fixedRateTermYears"] = this.fixedRateTermYears;
      data["monthlyRepaymentAmount"] = this.monthlyRepaymentAmount;
      data["monthlyOverPaymentAmount"] = this.monthlyOverPaymentAmount;
      data["missedLatePayments"] = this.missedLatePayments;
      data["valuationAmount"] = this.valuationAmount;
      data["purchaseAmount"] = this.purchaseAmount;
      data["sitePrice"] = this.sitePrice;
      data["propertyValue"] = this.propertyValue;
      data["mortgageRequired"] = this.mortgageRequired;
      data["propertyAddressLine_1"] = this.propertyAddressLine_1;
      data["propertyAddressLine_2"] = this.propertyAddressLine_2;
      data["propertyAddressLine_3"] = this.propertyAddressLine_3;
      data["propertyAddressLine_4"] = this.propertyAddressLine_4;
      data["propertyAddressLine_5"] = this.propertyAddressLine_5;
      data["amountBorrowed"] = this.amountBorrowed;
      data["currentValue"] = this.currentValue;
      data["currentPercentageRate"] = this.currentPercentageRate;
      data["currentRateEndDate"] = this.currentRateEndDate;
      data["principalPrivateResidence"] = this.principalPrivateResidence ? this.principalPrivateResidence.toJSON() : <any>undefined;
      data["investmentProperty"] = this.investmentProperty ? this.investmentProperty.toJSON() : <any>undefined;
      data["rentalIncome"] = this.rentalIncome ? this.rentalIncome.toJSON() : <any>undefined;
      data["isVacantPossession"] = this.isVacantPossession ? this.isVacantPossession.toJSON() : <any>undefined;
      data["isSoleOccupant"] = this.isSoleOccupant ? this.isSoleOccupant.toJSON() : <any>undefined;
      data["isBusiness"] = this.isBusiness ? this.isBusiness.toJSON() : <any>undefined;
      data["propertyStatus"] = this.propertyStatus ? this.propertyStatus.toJSON() : <any>undefined;
      data["mortgageCategory"] = this.mortgageCategory ? this.mortgageCategory.toJSON() : <any>undefined;
      data["mortgageType"] = this.mortgageType ? this.mortgageType.toJSON() : <any>undefined;
      data["mortgageRateType"] = this.mortgageRateType ? this.mortgageRateType.toJSON() : <any>undefined;
      data["approvalStatus"] = this.approvalStatus ? this.approvalStatus.toJSON() : <any>undefined;
      return data;
  }
}

export interface IPolicyAdditionalDetailsDto {
  id: number;
  contactPolicy: IFactFindPolicyDto | undefined;
  policyOccupationClass: string | undefined;
  deferredPeriodInWeeks: number;
  ageIncomePayableTo: number;
  normalRetirementAge: number;
  schemeName: string | undefined;
  isWholeOfLife: boolean;
  ceasingAge: number;
  others: string | undefined;
  currentBalance: number;
  fixedRateStartDate: string;
  fixedRateTermYears: number;
  monthlyRepaymentAmount: number;
  monthlyOverPaymentAmount: number;
  missedLatePayments: number | undefined;
  valuationAmount: number;
  purchaseAmount: number;
  sitePrice: number;
  propertyValue: number;
  mortgageRequired: number;
  propertyAddressLine_1: string | undefined;
  propertyAddressLine_2: string | undefined;
  propertyAddressLine_3: string | undefined;
  propertyAddressLine_4: string | undefined;
  propertyAddressLine_5: string | undefined;
  amountBorrowed: number;
  currentValue: number;
  currentPercentageRate: number;
  currentRateEndDate: string;
  principalPrivateResidence: IYesNoDefaultDto | undefined;
  investmentProperty: IYesNoDefaultDto | undefined;
  rentalIncome: IYesNoDefaultDto | undefined;
  isVacantPossession: IYesNoDefaultDto | undefined;
  isSoleOccupant: IYesNoDefaultDto | undefined;
  isBusiness: IYesNoDefaultDto | undefined;
  propertyStatus: IPropertyStatusDto | undefined;
  mortgageCategory: IMortgageCategoryDto | undefined;
  mortgageType: IMortgageTypeDto | undefined;
  mortgageRateType: IMortgageRateDto | undefined;
  approvalStatus: IApprovalStatusDto | undefined;
}

export class ProductCategoryDto implements IProductCategoryDto {
  id!: number;
  name!: string | undefined;

  constructor(data?: IProductCategoryDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): ProductCategoryDto {
      data = typeof data === 'object' ? data : {};
      let result = new ProductCategoryDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      return data;
  }
}

export interface IProductCategoryDto {
  id: number;
  name: string | undefined;
}

export class ProductSubCategoryDto implements IProductSubCategoryDto {
  id!: number;
  name!: string | undefined;

  constructor(data?: IProductSubCategoryDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): ProductSubCategoryDto {
      data = typeof data === 'object' ? data : {};
      let result = new ProductSubCategoryDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      return data;
  }
}

export interface IProductSubCategoryDto {
  id: number;
  name: string | undefined;
}

export class CreateLiabilityMortgageCommand extends _FactFindCreateCommandBase implements ICreateLiabilityMortgageCommand {
  contactOwnerId_AddedBy!: number;
  contactOwnerId_LastUpdatedBy!: number;
  policyOwner!: ClientSelector;
  policyTermInYears!: number;
  description!: string | undefined;
  isAgencyPolicy!: boolean;
  policyNo!: string | undefined;
  premium!: number | undefined;
  inceptionDate!: string | undefined;
  maturityDate!: string | undefined;
  fundValueDate!: string | undefined;
  totalPremiumsPaid!: number | undefined;
  providerId!: number | undefined;
  paymentFrequencyId!: number | undefined;
  policyBasisId!: number | undefined;
  statusId!: number | undefined;
  categoryId!: number | undefined;
  subCategoryId!: number | undefined;
  indexedId!: number | undefined;
  convertibleId!: number | undefined;
  additionalDetails!: CreatePolicyDetailsCommand | undefined;
  benefits!: PolicyBenefitDto[] | undefined;
  policyRoles!: PolicyRole[] | undefined;
  policyFunds!: PolicyFund[] | undefined;

  constructor(data?: ICreateLiabilityMortgageCommand) {
      super(data);
      if (data) {
          this.additionalDetails = data.additionalDetails && !(<any>data.additionalDetails).toJSON ? new CreatePolicyDetailsCommand(data.additionalDetails) : <CreatePolicyDetailsCommand>this.additionalDetails;
          if (data.benefits) {
              this.benefits = [];
              for (let i = 0; i < data.benefits.length; i++) {
                  let item = data.benefits[i];
                  this.benefits[i] = item && !(<any>item).toJSON ? new PolicyBenefitDto(item) : <PolicyBenefitDto>item;
              }
          }
          if (data.policyRoles) {
              this.policyRoles = [];
              for (let i = 0; i < data.policyRoles.length; i++) {
                  let item = data.policyRoles[i];
                  this.policyRoles[i] = item && !(<any>item).toJSON ? new PolicyRole(item) : <PolicyRole>item;
              }
          }
          if (data.policyFunds) {
              this.policyFunds = [];
              for (let i = 0; i < data.policyFunds.length; i++) {
                  let item = data.policyFunds[i];
                  this.policyFunds[i] = item && !(<any>item).toJSON ? new PolicyFund(item) : <PolicyFund>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.contactOwnerId_AddedBy = _data["contactOwnerId_AddedBy"];
          this.contactOwnerId_LastUpdatedBy = _data["contactOwnerId_LastUpdatedBy"];
          this.policyOwner = _data["policyOwner"];
          this.policyTermInYears = _data["policyTermInYears"];
          this.description = _data["description"];
          this.isAgencyPolicy = _data["isAgencyPolicy"];
          this.policyNo = _data["policyNo"];
          this.premium = _data["premium"];
          this.inceptionDate = _data["inceptionDate"];
          this.maturityDate = _data["maturityDate"];
          this.fundValueDate = _data["fundValueDate"];
          this.totalPremiumsPaid = _data["totalPremiumsPaid"];
          this.providerId = _data["providerId"];
          this.paymentFrequencyId = _data["paymentFrequencyId"];
          this.policyBasisId = _data["policyBasisId"];
          this.statusId = _data["statusId"];
          this.categoryId = _data["categoryId"];
          this.subCategoryId = _data["subCategoryId"];
          this.indexedId = _data["indexedId"];
          this.convertibleId = _data["convertibleId"];
          this.additionalDetails = _data["additionalDetails"] ? CreatePolicyDetailsCommand.fromJS(_data["additionalDetails"]) : <any>undefined;
          if (Array.isArray(_data["benefits"])) {
              this.benefits = [] as any;
              for (let item of _data["benefits"])
                  this.benefits!.push(PolicyBenefitDto.fromJS(item));
          }
          if (Array.isArray(_data["policyRoles"])) {
              this.policyRoles = [] as any;
              for (let item of _data["policyRoles"])
                  this.policyRoles!.push(PolicyRole.fromJS(item));
          }
          if (Array.isArray(_data["policyFunds"])) {
              this.policyFunds = [] as any;
              for (let item of _data["policyFunds"])
                  this.policyFunds!.push(PolicyFund.fromJS(item));
          }
      }
  }

  static fromJS(data: any): CreateLiabilityMortgageCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateLiabilityMortgageCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["contactOwnerId_AddedBy"] = this.contactOwnerId_AddedBy;
      data["contactOwnerId_LastUpdatedBy"] = this.contactOwnerId_LastUpdatedBy;
      data["policyOwner"] = this.policyOwner;
      data["policyTermInYears"] = this.policyTermInYears;
      data["description"] = this.description;
      data["isAgencyPolicy"] = this.isAgencyPolicy;
      data["policyNo"] = this.policyNo;
      data["premium"] = this.premium;
      data["inceptionDate"] = this.inceptionDate;
      data["maturityDate"] = this.maturityDate;
      data["fundValueDate"] = this.fundValueDate;
      data["totalPremiumsPaid"] = this.totalPremiumsPaid;
      data["providerId"] = this.providerId;
      data["paymentFrequencyId"] = this.paymentFrequencyId;
      data["policyBasisId"] = this.policyBasisId;
      data["statusId"] = this.statusId;
      data["categoryId"] = this.categoryId;
      data["subCategoryId"] = this.subCategoryId;
      data["indexedId"] = this.indexedId;
      data["convertibleId"] = this.convertibleId;
      data["additionalDetails"] = this.additionalDetails ? this.additionalDetails.toJSON() : <any>undefined;
      if (Array.isArray(this.benefits)) {
          data["benefits"] = [];
          for (let item of this.benefits)
              data["benefits"].push(item.toJSON());
      }
      if (Array.isArray(this.policyRoles)) {
          data["policyRoles"] = [];
          for (let item of this.policyRoles)
              data["policyRoles"].push(item.toJSON());
      }
      if (Array.isArray(this.policyFunds)) {
          data["policyFunds"] = [];
          for (let item of this.policyFunds)
              data["policyFunds"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface ICreateLiabilityMortgageCommand extends I_FactFindCreateCommandBase {
  contactOwnerId_AddedBy: number;
  contactOwnerId_LastUpdatedBy: number;
  policyOwner: ClientSelector;
  policyTermInYears: number;
  description: string | undefined;
  isAgencyPolicy: boolean;
  policyNo: string | undefined;
  premium: number | undefined;
  inceptionDate: string | undefined;
  maturityDate: string | undefined;
  fundValueDate: string | undefined;
  totalPremiumsPaid: number | undefined;
  providerId: number | undefined;
  paymentFrequencyId: number | undefined;
  policyBasisId: number | undefined;
  statusId: number | undefined;
  categoryId: number | undefined;
  subCategoryId: number | undefined;
  indexedId: number | undefined;
  convertibleId: number | undefined;
  additionalDetails: ICreatePolicyDetailsCommand | undefined;
  benefits: IPolicyBenefitDto[] | undefined;
  policyRoles: IPolicyRole[] | undefined;
  policyFunds: IPolicyFund[] | undefined;
}

export class CreatePolicyDetailsCommand implements ICreatePolicyDetailsCommand {
  fK_ContactPolicyID!: number;
  policyOccupationClass!: string | undefined;
  deferredPeriodInWeeks!: number;
  ageIncomePayableTo!: number;
  normalRetirementAge!: number;
  schemeName!: string | undefined;
  ceasingAge!: number;
  others!: string | undefined;
  currentBalance!: number;
  fixedRateStartDate!: string;
  fixedRateTermYears!: number;
  monthlyRepaymentAmount!: number;
  monthlyOverPaymentAmount!: number;
  missedLatePayments!: number | undefined;
  valuationAmount!: number;
  purchaseAmount!: number;
  sitePrice!: number;
  propertyValue!: number;
  mortgageRequired!: number;
  propertyAddressLine_1!: string | undefined;
  propertyAddressLine_2!: string | undefined;
  propertyAddressLine_3!: string | undefined;
  propertyAddressLine_4!: string | undefined;
  propertyAddressLine_5!: string | undefined;
  amountBorrowed!: number;
  currentValue!: number;
  currentPercentageRate!: number;
  currentRateEndDate!: string;
  principalPrivateResidenceId!: number | undefined;
  investmentPropertyId!: number | undefined;
  rentalIncomeId!: number | undefined;
  isVacantPossessionId!: number | undefined;
  isSoleOccupantId!: number | undefined;
  isBusinessId!: number | undefined;
  propertyStatusId!: number | undefined;
  mortgageCategoryId!: number | undefined;
  mortgageTypeId!: number | undefined;
  mortgageRateTypeId!: number | undefined;
  approvalStatusId!: number | undefined;

  constructor(data?: ICreatePolicyDetailsCommand) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.fK_ContactPolicyID = _data["fK_ContactPolicyID"];
          this.policyOccupationClass = _data["policyOccupationClass"];
          this.deferredPeriodInWeeks = _data["deferredPeriodInWeeks"];
          this.ageIncomePayableTo = _data["ageIncomePayableTo"];
          this.normalRetirementAge = _data["normalRetirementAge"];
          this.schemeName = _data["schemeName"];
          this.ceasingAge = _data["ceasingAge"];
          this.others = _data["others"];
          this.currentBalance = _data["currentBalance"];
          this.fixedRateStartDate = _data["fixedRateStartDate"];
          this.fixedRateTermYears = _data["fixedRateTermYears"];
          this.monthlyRepaymentAmount = _data["monthlyRepaymentAmount"];
          this.monthlyOverPaymentAmount = _data["monthlyOverPaymentAmount"];
          this.missedLatePayments = _data["missedLatePayments"];
          this.valuationAmount = _data["valuationAmount"];
          this.purchaseAmount = _data["purchaseAmount"];
          this.sitePrice = _data["sitePrice"];
          this.propertyValue = _data["propertyValue"];
          this.mortgageRequired = _data["mortgageRequired"];
          this.propertyAddressLine_1 = _data["propertyAddressLine_1"];
          this.propertyAddressLine_2 = _data["propertyAddressLine_2"];
          this.propertyAddressLine_3 = _data["propertyAddressLine_3"];
          this.propertyAddressLine_4 = _data["propertyAddressLine_4"];
          this.propertyAddressLine_5 = _data["propertyAddressLine_5"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.currentValue = _data["currentValue"];
          this.currentPercentageRate = _data["currentPercentageRate"];
          this.currentRateEndDate = _data["currentRateEndDate"];
          this.principalPrivateResidenceId = _data["principalPrivateResidenceId"];
          this.investmentPropertyId = _data["investmentPropertyId"];
          this.rentalIncomeId = _data["rentalIncomeId"];
          this.isVacantPossessionId = _data["isVacantPossessionId"];
          this.isSoleOccupantId = _data["isSoleOccupantId"];
          this.isBusinessId = _data["isBusinessId"];
          this.propertyStatusId = _data["propertyStatusId"];
          this.mortgageCategoryId = _data["mortgageCategoryId"];
          this.mortgageTypeId = _data["mortgageTypeId"];
          this.mortgageRateTypeId = _data["mortgageRateTypeId"];
          this.approvalStatusId = _data["approvalStatusId"];
      }
  }

  static fromJS(data: any): CreatePolicyDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreatePolicyDetailsCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["fK_ContactPolicyID"] = this.fK_ContactPolicyID;
      data["policyOccupationClass"] = this.policyOccupationClass;
      data["deferredPeriodInWeeks"] = this.deferredPeriodInWeeks;
      data["ageIncomePayableTo"] = this.ageIncomePayableTo;
      data["normalRetirementAge"] = this.normalRetirementAge;
      data["schemeName"] = this.schemeName;
      data["ceasingAge"] = this.ceasingAge;
      data["others"] = this.others;
      data["currentBalance"] = this.currentBalance;
      data["fixedRateStartDate"] = this.fixedRateStartDate;
      data["fixedRateTermYears"] = this.fixedRateTermYears;
      data["monthlyRepaymentAmount"] = this.monthlyRepaymentAmount;
      data["monthlyOverPaymentAmount"] = this.monthlyOverPaymentAmount;
      data["missedLatePayments"] = this.missedLatePayments;
      data["valuationAmount"] = this.valuationAmount;
      data["purchaseAmount"] = this.purchaseAmount;
      data["sitePrice"] = this.sitePrice;
      data["propertyValue"] = this.propertyValue;
      data["mortgageRequired"] = this.mortgageRequired;
      data["propertyAddressLine_1"] = this.propertyAddressLine_1;
      data["propertyAddressLine_2"] = this.propertyAddressLine_2;
      data["propertyAddressLine_3"] = this.propertyAddressLine_3;
      data["propertyAddressLine_4"] = this.propertyAddressLine_4;
      data["propertyAddressLine_5"] = this.propertyAddressLine_5;
      data["amountBorrowed"] = this.amountBorrowed;
      data["currentValue"] = this.currentValue;
      data["currentPercentageRate"] = this.currentPercentageRate;
      data["currentRateEndDate"] = this.currentRateEndDate;
      data["principalPrivateResidenceId"] = this.principalPrivateResidenceId;
      data["investmentPropertyId"] = this.investmentPropertyId;
      data["rentalIncomeId"] = this.rentalIncomeId;
      data["isVacantPossessionId"] = this.isVacantPossessionId;
      data["isSoleOccupantId"] = this.isSoleOccupantId;
      data["isBusinessId"] = this.isBusinessId;
      data["propertyStatusId"] = this.propertyStatusId;
      data["mortgageCategoryId"] = this.mortgageCategoryId;
      data["mortgageTypeId"] = this.mortgageTypeId;
      data["mortgageRateTypeId"] = this.mortgageRateTypeId;
      data["approvalStatusId"] = this.approvalStatusId;
      return data;
  }
}

export interface ICreatePolicyDetailsCommand {
  fK_ContactPolicyID: number;
  policyOccupationClass: string | undefined;
  deferredPeriodInWeeks: number;
  ageIncomePayableTo: number;
  normalRetirementAge: number;
  schemeName: string | undefined;
  ceasingAge: number;
  others: string | undefined;
  currentBalance: number;
  fixedRateStartDate: string;
  fixedRateTermYears: number;
  monthlyRepaymentAmount: number;
  monthlyOverPaymentAmount: number;
  missedLatePayments: number | undefined;
  valuationAmount: number;
  purchaseAmount: number;
  sitePrice: number;
  propertyValue: number;
  mortgageRequired: number;
  propertyAddressLine_1: string | undefined;
  propertyAddressLine_2: string | undefined;
  propertyAddressLine_3: string | undefined;
  propertyAddressLine_4: string | undefined;
  propertyAddressLine_5: string | undefined;
  amountBorrowed: number;
  currentValue: number;
  currentPercentageRate: number;
  currentRateEndDate: string;
  principalPrivateResidenceId: number | undefined;
  investmentPropertyId: number | undefined;
  rentalIncomeId: number | undefined;
  isVacantPossessionId: number | undefined;
  isSoleOccupantId: number | undefined;
  isBusinessId: number | undefined;
  propertyStatusId: number | undefined;
  mortgageCategoryId: number | undefined;
  mortgageTypeId: number | undefined;
  mortgageRateTypeId: number | undefined;
  approvalStatusId: number | undefined;
}

export class PolicyRole implements IPolicyRole {
  id!: number;
  contactId!: number;
  contact!: ContactProfile | undefined;
  clientSelector!: ClientSelector;
  policyId!: number;
  policy!: FactFindPolicy | undefined;
  typeId!: number;
  type!: PolicyRoleType | undefined;

  constructor(data?: IPolicyRole) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.contact = data.contact && !(<any>data.contact).toJSON ? new ContactProfile(data.contact) : <ContactProfile>this.contact;
          this.policy = data.policy && !(<any>data.policy).toJSON ? new FactFindPolicy(data.policy) : <FactFindPolicy>this.policy;
          this.type = data.type && !(<any>data.type).toJSON ? new PolicyRoleType(data.type) : <PolicyRoleType>this.type;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.contactId = _data["contactId"];
          this.contact = _data["contact"] ? ContactProfile.fromJS(_data["contact"]) : <any>undefined;
          this.clientSelector = _data["clientSelector"];
          this.policyId = _data["policyId"];
          this.policy = _data["policy"] ? FactFindPolicy.fromJS(_data["policy"]) : <any>undefined;
          this.typeId = _data["typeId"];
          this.type = _data["type"] ? PolicyRoleType.fromJS(_data["type"]) : <any>undefined;
      }
  }

  static fromJS(data: any): PolicyRole {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyRole();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["contactId"] = this.contactId;
      data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
      data["clientSelector"] = this.clientSelector;
      data["policyId"] = this.policyId;
      data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
      data["typeId"] = this.typeId;
      data["type"] = this.type ? this.type.toJSON() : <any>undefined;
      return data;
  }
}

export interface IPolicyRole {
  id: number;
  contactId: number;
  contact: IContactProfile | undefined;
  clientSelector: ClientSelector;
  policyId: number;
  policy: IFactFindPolicy | undefined;
  typeId: number;
  type: IPolicyRoleType | undefined;
}

export class ContactProfile implements IContactProfile {
  id!: number;
  titleId!: number | undefined;
  title!: Title | undefined;
  firstName!: string | undefined;
  lastName!: string | undefined;
  schemeName!: string | undefined;
  dateOfBirth!: string | undefined;
  genderId!: number | undefined;
  gender!: Gender | undefined;
  maritalStatusId!: number | undefined;
  maritalStatus!: MaritalStatus | undefined;
  taxBasisAssessmentId!: number | undefined;
  taxBasisAssessment!: TaxBasisAssessment | undefined;
  phoneNo!: string | undefined;
  mobileNo!: string | undefined;
  workNo!: string | undefined;
  faxNo!: string | undefined;
  smokerStatusId!: number | undefined;
  smokerStatus!: YesNoDefault | undefined;
  healthStatusId!: number | undefined;
  healthStatus!: HealthStatus | undefined;
  healthStatusOther!: string | undefined;
  ppsNumber!: string | undefined;
  nationalDomicileId!: number | undefined;
  nationalDomicile!: Country | undefined;
  addressLine_1!: string | undefined;
  addressLine_2!: string | undefined;
  addressLine_3!: string | undefined;
  addressLine_4!: string | undefined;
  addressCountyId!: number | undefined;
  addressCounty!: County | undefined;
  addressCountryId!: number | undefined;
  addressCountry!: Country | undefined;
  postCode!: string | undefined;
  email!: string | undefined;
  isVunerableContact!: boolean | undefined;
  optInAllMarketingComms!: boolean | undefined;
  noComms!: boolean | undefined;
  employmentStatusId!: number | undefined;
  employmentStatus!: EmploymentStatus | undefined;
  employmentId!: number | undefined;
  employment!: FactFindEmployment | undefined;
  employerName!: string | undefined;
  sP_FirstName!: string | undefined;
  sP_LastName!: string | undefined;
  sP_SchemeName!: string | undefined;
  sP_DateOfBirth!: string | undefined;
  dateAdded!: string | undefined;
  sP_TitleId!: number | undefined;
  sP_Title!: Title | undefined;
  sP_GenderId!: number | undefined;
  sP_Gender!: Gender | undefined;
  sP_MaritalStatusId!: number | undefined;
  sP_MaritalStatus!: MaritalStatus | undefined;
  sP_TaxBasisAssessmentId!: number | undefined;
  sP_TaxBasisAssessment!: TaxBasisAssessment | undefined;
  sP_PhoneNo!: string | undefined;
  sP_MobileNo!: string | undefined;
  sP_WorkNo!: string | undefined;
  contactStatusId!: number;
  contactStatus!: ContactStatus | undefined;
  sP_SmokerStatusId!: number | undefined;
  sP_SmokerStatus!: YesNoDefault | undefined;
  sP_HealthStatusId!: number | undefined;
  sP_HealthStatus!: HealthStatus | undefined;
  sP_HealthStatusOther!: string | undefined;
  sP_PPSNumber!: string | undefined;
  sP_NationalDomicileId!: number | undefined;
  sP_NationalDomicile!: Country | undefined;
  sP_AddressLine_1!: string | undefined;
  sP_AddressLine_2!: string | undefined;
  sP_AddressLine_3!: string | undefined;
  sP_AddressLine_4!: string | undefined;
  sP_AddressCountyId!: number | undefined;
  sP_AddressCounty!: County | undefined;
  sP_AddressCountryId!: number | undefined;
  sP_AddressCountry!: Country | undefined;
  sP_PostCode!: string | undefined;
  sP_Email!: string | undefined;
  sP_IsVunerableContact!: boolean | undefined;
  sP_OptInAllMarketingComms!: boolean | undefined;
  sP_NoComms!: boolean | undefined;
  sP_EmploymentStatusId!: number | undefined;
  sP_EmploymentStatus!: EmploymentStatus | undefined;
  sP_EmploymentId!: number | undefined;
  sP_EmployerName!: string | undefined;
  ownerId!: number;
  owner!: ContactOwnerProfile | undefined;
  contactTypeId!: number | undefined;
  contactType!: ContactType | undefined;
  brokerId!: number;
  leadSourceId!: number | undefined;
  masterProductId!: number | undefined;
  fileRef!: string | undefined;
  assets!: FactFindAsset[] | undefined;
  dependents!: FactFindDependent[] | undefined;
  employments!: FactFindEmployment[] | undefined;
  expenses!: FactFindExpense[] | undefined;
  incomes!: FactFindIncome[] | undefined;
  complianceItems!: ContactComplianceItem[] | undefined;
  dataFeedIdentifiers!: DataFeedIdentifier[] | undefined;

  constructor(data?: IContactProfile) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.title = data.title && !(<any>data.title).toJSON ? new Title(data.title) : <Title>this.title;
          this.gender = data.gender && !(<any>data.gender).toJSON ? new Gender(data.gender) : <Gender>this.gender;
          this.maritalStatus = data.maritalStatus && !(<any>data.maritalStatus).toJSON ? new MaritalStatus(data.maritalStatus) : <MaritalStatus>this.maritalStatus;
          this.taxBasisAssessment = data.taxBasisAssessment && !(<any>data.taxBasisAssessment).toJSON ? new TaxBasisAssessment(data.taxBasisAssessment) : <TaxBasisAssessment>this.taxBasisAssessment;
          this.smokerStatus = data.smokerStatus && !(<any>data.smokerStatus).toJSON ? new YesNoDefault(data.smokerStatus) : <YesNoDefault>this.smokerStatus;
          this.healthStatus = data.healthStatus && !(<any>data.healthStatus).toJSON ? new HealthStatus(data.healthStatus) : <HealthStatus>this.healthStatus;
          this.nationalDomicile = data.nationalDomicile && !(<any>data.nationalDomicile).toJSON ? new Country(data.nationalDomicile) : <Country>this.nationalDomicile;
          this.addressCounty = data.addressCounty && !(<any>data.addressCounty).toJSON ? new County(data.addressCounty) : <County>this.addressCounty;
          this.addressCountry = data.addressCountry && !(<any>data.addressCountry).toJSON ? new Country(data.addressCountry) : <Country>this.addressCountry;
          this.employmentStatus = data.employmentStatus && !(<any>data.employmentStatus).toJSON ? new EmploymentStatus(data.employmentStatus) : <EmploymentStatus>this.employmentStatus;
          this.employment = data.employment && !(<any>data.employment).toJSON ? new FactFindEmployment(data.employment) : <FactFindEmployment>this.employment;
          this.sP_Title = data.sP_Title && !(<any>data.sP_Title).toJSON ? new Title(data.sP_Title) : <Title>this.sP_Title;
          this.sP_Gender = data.sP_Gender && !(<any>data.sP_Gender).toJSON ? new Gender(data.sP_Gender) : <Gender>this.sP_Gender;
          this.sP_MaritalStatus = data.sP_MaritalStatus && !(<any>data.sP_MaritalStatus).toJSON ? new MaritalStatus(data.sP_MaritalStatus) : <MaritalStatus>this.sP_MaritalStatus;
          this.sP_TaxBasisAssessment = data.sP_TaxBasisAssessment && !(<any>data.sP_TaxBasisAssessment).toJSON ? new TaxBasisAssessment(data.sP_TaxBasisAssessment) : <TaxBasisAssessment>this.sP_TaxBasisAssessment;
          this.contactStatus = data.contactStatus && !(<any>data.contactStatus).toJSON ? new ContactStatus(data.contactStatus) : <ContactStatus>this.contactStatus;
          this.sP_SmokerStatus = data.sP_SmokerStatus && !(<any>data.sP_SmokerStatus).toJSON ? new YesNoDefault(data.sP_SmokerStatus) : <YesNoDefault>this.sP_SmokerStatus;
          this.sP_HealthStatus = data.sP_HealthStatus && !(<any>data.sP_HealthStatus).toJSON ? new HealthStatus(data.sP_HealthStatus) : <HealthStatus>this.sP_HealthStatus;
          this.sP_NationalDomicile = data.sP_NationalDomicile && !(<any>data.sP_NationalDomicile).toJSON ? new Country(data.sP_NationalDomicile) : <Country>this.sP_NationalDomicile;
          this.sP_AddressCounty = data.sP_AddressCounty && !(<any>data.sP_AddressCounty).toJSON ? new County(data.sP_AddressCounty) : <County>this.sP_AddressCounty;
          this.sP_AddressCountry = data.sP_AddressCountry && !(<any>data.sP_AddressCountry).toJSON ? new Country(data.sP_AddressCountry) : <Country>this.sP_AddressCountry;
          this.sP_EmploymentStatus = data.sP_EmploymentStatus && !(<any>data.sP_EmploymentStatus).toJSON ? new EmploymentStatus(data.sP_EmploymentStatus) : <EmploymentStatus>this.sP_EmploymentStatus;
          this.owner = data.owner && !(<any>data.owner).toJSON ? new ContactOwnerProfile(data.owner) : <ContactOwnerProfile>this.owner;
          this.contactType = data.contactType && !(<any>data.contactType).toJSON ? new ContactType(data.contactType) : <ContactType>this.contactType;
          if (data.complianceItems) {
              this.complianceItems = [];
              for (let i = 0; i < data.complianceItems.length; i++) {
                  let item = data.complianceItems[i];
                  this.complianceItems[i] = item && !(<any>item).toJSON ? new ContactComplianceItem(item) : <ContactComplianceItem>item;
              }
          }
          if (data.dataFeedIdentifiers) {
              this.dataFeedIdentifiers = [];
              for (let i = 0; i < data.dataFeedIdentifiers.length; i++) {
                  let item = data.dataFeedIdentifiers[i];
                  this.dataFeedIdentifiers[i] = item && !(<any>item).toJSON ? new DataFeedIdentifier(item) : <DataFeedIdentifier>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.titleId = _data["titleId"];
          this.title = _data["title"] ? Title.fromJS(_data["title"]) : <any>undefined;
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          this.schemeName = _data["schemeName"];
          this.dateOfBirth = _data["dateOfBirth"];
          this.genderId = _data["genderId"];
          this.gender = _data["gender"] ? Gender.fromJS(_data["gender"]) : <any>undefined;
          this.maritalStatusId = _data["maritalStatusId"];
          this.maritalStatus = _data["maritalStatus"] ? MaritalStatus.fromJS(_data["maritalStatus"]) : <any>undefined;
          this.taxBasisAssessmentId = _data["taxBasisAssessmentId"];
          this.taxBasisAssessment = _data["taxBasisAssessment"] ? TaxBasisAssessment.fromJS(_data["taxBasisAssessment"]) : <any>undefined;
          this.phoneNo = _data["phoneNo"];
          this.mobileNo = _data["mobileNo"];
          this.workNo = _data["workNo"];
          this.faxNo = _data["faxNo"];
          this.smokerStatusId = _data["smokerStatusId"];
          this.smokerStatus = _data["smokerStatus"] ? YesNoDefault.fromJS(_data["smokerStatus"]) : <any>undefined;
          this.healthStatusId = _data["healthStatusId"];
          this.healthStatus = _data["healthStatus"] ? HealthStatus.fromJS(_data["healthStatus"]) : <any>undefined;
          this.healthStatusOther = _data["healthStatusOther"];
          this.ppsNumber = _data["ppsNumber"];
          this.nationalDomicileId = _data["nationalDomicileId"];
          this.nationalDomicile = _data["nationalDomicile"] ? Country.fromJS(_data["nationalDomicile"]) : <any>undefined;
          this.addressLine_1 = _data["addressLine_1"];
          this.addressLine_2 = _data["addressLine_2"];
          this.addressLine_3 = _data["addressLine_3"];
          this.addressLine_4 = _data["addressLine_4"];
          this.addressCountyId = _data["addressCountyId"];
          this.addressCounty = _data["addressCounty"] ? County.fromJS(_data["addressCounty"]) : <any>undefined;
          this.addressCountryId = _data["addressCountryId"];
          this.addressCountry = _data["addressCountry"] ? Country.fromJS(_data["addressCountry"]) : <any>undefined;
          this.postCode = _data["postCode"];
          this.email = _data["email"];
          this.isVunerableContact = _data["isVunerableContact"];
          this.optInAllMarketingComms = _data["optInAllMarketingComms"];
          this.noComms = _data["noComms"];
          this.employmentStatusId = _data["employmentStatusId"];
          this.employmentStatus = _data["employmentStatus"] ? EmploymentStatus.fromJS(_data["employmentStatus"]) : <any>undefined;
          this.employmentId = _data["employmentId"];
          this.employment = _data["employment"] ? FactFindEmployment.fromJS(_data["employment"]) : <any>undefined;
          this.employerName = _data["employerName"];
          this.sP_FirstName = _data["sP_FirstName"];
          this.sP_LastName = _data["sP_LastName"];
          this.sP_SchemeName = _data["sP_SchemeName"];
          this.sP_DateOfBirth = _data["sP_DateOfBirth"];
          this.dateAdded = _data["dateAdded"];
          this.sP_TitleId = _data["sP_TitleId"];
          this.sP_Title = _data["sP_Title"] ? Title.fromJS(_data["sP_Title"]) : <any>undefined;
          this.sP_GenderId = _data["sP_GenderId"];
          this.sP_Gender = _data["sP_Gender"] ? Gender.fromJS(_data["sP_Gender"]) : <any>undefined;
          this.sP_MaritalStatusId = _data["sP_MaritalStatusId"];
          this.sP_MaritalStatus = _data["sP_MaritalStatus"] ? MaritalStatus.fromJS(_data["sP_MaritalStatus"]) : <any>undefined;
          this.sP_TaxBasisAssessmentId = _data["sP_TaxBasisAssessmentId"];
          this.sP_TaxBasisAssessment = _data["sP_TaxBasisAssessment"] ? TaxBasisAssessment.fromJS(_data["sP_TaxBasisAssessment"]) : <any>undefined;
          this.sP_PhoneNo = _data["sP_PhoneNo"];
          this.sP_MobileNo = _data["sP_MobileNo"];
          this.sP_WorkNo = _data["sP_WorkNo"];
          this.contactStatusId = _data["contactStatusId"];
          this.contactStatus = _data["contactStatus"] ? ContactStatus.fromJS(_data["contactStatus"]) : <any>undefined;
          this.sP_SmokerStatusId = _data["sP_SmokerStatusId"];
          this.sP_SmokerStatus = _data["sP_SmokerStatus"] ? YesNoDefault.fromJS(_data["sP_SmokerStatus"]) : <any>undefined;
          this.sP_HealthStatusId = _data["sP_HealthStatusId"];
          this.sP_HealthStatus = _data["sP_HealthStatus"] ? HealthStatus.fromJS(_data["sP_HealthStatus"]) : <any>undefined;
          this.sP_HealthStatusOther = _data["sP_HealthStatusOther"];
          this.sP_PPSNumber = _data["sP_PPSNumber"];
          this.sP_NationalDomicileId = _data["sP_NationalDomicileId"];
          this.sP_NationalDomicile = _data["sP_NationalDomicile"] ? Country.fromJS(_data["sP_NationalDomicile"]) : <any>undefined;
          this.sP_AddressLine_1 = _data["sP_AddressLine_1"];
          this.sP_AddressLine_2 = _data["sP_AddressLine_2"];
          this.sP_AddressLine_3 = _data["sP_AddressLine_3"];
          this.sP_AddressLine_4 = _data["sP_AddressLine_4"];
          this.sP_AddressCountyId = _data["sP_AddressCountyId"];
          this.sP_AddressCounty = _data["sP_AddressCounty"] ? County.fromJS(_data["sP_AddressCounty"]) : <any>undefined;
          this.sP_AddressCountryId = _data["sP_AddressCountryId"];
          this.sP_AddressCountry = _data["sP_AddressCountry"] ? Country.fromJS(_data["sP_AddressCountry"]) : <any>undefined;
          this.sP_PostCode = _data["sP_PostCode"];
          this.sP_Email = _data["sP_Email"];
          this.sP_IsVunerableContact = _data["sP_IsVunerableContact"];
          this.sP_OptInAllMarketingComms = _data["sP_OptInAllMarketingComms"];
          this.sP_NoComms = _data["sP_NoComms"];
          this.sP_EmploymentStatusId = _data["sP_EmploymentStatusId"];
          this.sP_EmploymentStatus = _data["sP_EmploymentStatus"] ? EmploymentStatus.fromJS(_data["sP_EmploymentStatus"]) : <any>undefined;
          this.sP_EmploymentId = _data["sP_EmploymentId"];
          this.sP_EmployerName = _data["sP_EmployerName"];
          this.ownerId = _data["ownerId"];
          this.owner = _data["owner"] ? ContactOwnerProfile.fromJS(_data["owner"]) : <any>undefined;
          this.contactTypeId = _data["contactTypeId"];
          this.contactType = _data["contactType"] ? ContactType.fromJS(_data["contactType"]) : <any>undefined;
          this.brokerId = _data["brokerId"];
          this.leadSourceId = _data["leadSourceId"];
          this.masterProductId = _data["masterProductId"];
          this.fileRef = _data["fileRef"];
          if (Array.isArray(_data["assets"])) {
              this.assets = [] as any;
              for (let item of _data["assets"])
                  this.assets!.push(FactFindAsset.fromJS(item));
          }
          if (Array.isArray(_data["dependents"])) {
              this.dependents = [] as any;
              for (let item of _data["dependents"])
                  this.dependents!.push(FactFindDependent.fromJS(item));
          }
          if (Array.isArray(_data["employments"])) {
              this.employments = [] as any;
              for (let item of _data["employments"])
                  this.employments!.push(FactFindEmployment.fromJS(item));
          }
          if (Array.isArray(_data["expenses"])) {
              this.expenses = [] as any;
              for (let item of _data["expenses"])
                  this.expenses!.push(FactFindExpense.fromJS(item));
          }
          if (Array.isArray(_data["incomes"])) {
              this.incomes = [] as any;
              for (let item of _data["incomes"])
                  this.incomes!.push(FactFindIncome.fromJS(item));
          }
          if (Array.isArray(_data["complianceItems"])) {
              this.complianceItems = [] as any;
              for (let item of _data["complianceItems"])
                  this.complianceItems!.push(ContactComplianceItem.fromJS(item));
          }
          if (Array.isArray(_data["dataFeedIdentifiers"])) {
              this.dataFeedIdentifiers = [] as any;
              for (let item of _data["dataFeedIdentifiers"])
                  this.dataFeedIdentifiers!.push(DataFeedIdentifier.fromJS(item));
          }
      }
  }

  static fromJS(data: any): ContactProfile {
      data = typeof data === 'object' ? data : {};
      let result = new ContactProfile();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["titleId"] = this.titleId;
      data["title"] = this.title ? this.title.toJSON() : <any>undefined;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["schemeName"] = this.schemeName;
      data["dateOfBirth"] = this.dateOfBirth;
      data["genderId"] = this.genderId;
      data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
      data["maritalStatusId"] = this.maritalStatusId;
      data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : <any>undefined;
      data["taxBasisAssessmentId"] = this.taxBasisAssessmentId;
      data["taxBasisAssessment"] = this.taxBasisAssessment ? this.taxBasisAssessment.toJSON() : <any>undefined;
      data["phoneNo"] = this.phoneNo;
      data["mobileNo"] = this.mobileNo;
      data["workNo"] = this.workNo;
      data["faxNo"] = this.faxNo;
      data["smokerStatusId"] = this.smokerStatusId;
      data["smokerStatus"] = this.smokerStatus ? this.smokerStatus.toJSON() : <any>undefined;
      data["healthStatusId"] = this.healthStatusId;
      data["healthStatus"] = this.healthStatus ? this.healthStatus.toJSON() : <any>undefined;
      data["healthStatusOther"] = this.healthStatusOther;
      data["ppsNumber"] = this.ppsNumber;
      data["nationalDomicileId"] = this.nationalDomicileId;
      data["nationalDomicile"] = this.nationalDomicile ? this.nationalDomicile.toJSON() : <any>undefined;
      data["addressLine_1"] = this.addressLine_1;
      data["addressLine_2"] = this.addressLine_2;
      data["addressLine_3"] = this.addressLine_3;
      data["addressLine_4"] = this.addressLine_4;
      data["addressCountyId"] = this.addressCountyId;
      data["addressCounty"] = this.addressCounty ? this.addressCounty.toJSON() : <any>undefined;
      data["addressCountryId"] = this.addressCountryId;
      data["addressCountry"] = this.addressCountry ? this.addressCountry.toJSON() : <any>undefined;
      data["postCode"] = this.postCode;
      data["email"] = this.email;
      data["isVunerableContact"] = this.isVunerableContact;
      data["optInAllMarketingComms"] = this.optInAllMarketingComms;
      data["noComms"] = this.noComms;
      data["employmentStatusId"] = this.employmentStatusId;
      data["employmentStatus"] = this.employmentStatus ? this.employmentStatus.toJSON() : <any>undefined;
      data["employmentId"] = this.employmentId;
      data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
      data["employerName"] = this.employerName;
      data["sP_FirstName"] = this.sP_FirstName;
      data["sP_LastName"] = this.sP_LastName;
      data["sP_SchemeName"] = this.sP_SchemeName;
      data["sP_DateOfBirth"] = this.sP_DateOfBirth;
      data["dateAdded"] = this.dateAdded;
      data["sP_TitleId"] = this.sP_TitleId;
      data["sP_Title"] = this.sP_Title ? this.sP_Title.toJSON() : <any>undefined;
      data["sP_GenderId"] = this.sP_GenderId;
      data["sP_Gender"] = this.sP_Gender ? this.sP_Gender.toJSON() : <any>undefined;
      data["sP_MaritalStatusId"] = this.sP_MaritalStatusId;
      data["sP_MaritalStatus"] = this.sP_MaritalStatus ? this.sP_MaritalStatus.toJSON() : <any>undefined;
      data["sP_TaxBasisAssessmentId"] = this.sP_TaxBasisAssessmentId;
      data["sP_TaxBasisAssessment"] = this.sP_TaxBasisAssessment ? this.sP_TaxBasisAssessment.toJSON() : <any>undefined;
      data["sP_PhoneNo"] = this.sP_PhoneNo;
      data["sP_MobileNo"] = this.sP_MobileNo;
      data["sP_WorkNo"] = this.sP_WorkNo;
      data["contactStatusId"] = this.contactStatusId;
      data["contactStatus"] = this.contactStatus ? this.contactStatus.toJSON() : <any>undefined;
      data["sP_SmokerStatusId"] = this.sP_SmokerStatusId;
      data["sP_SmokerStatus"] = this.sP_SmokerStatus ? this.sP_SmokerStatus.toJSON() : <any>undefined;
      data["sP_HealthStatusId"] = this.sP_HealthStatusId;
      data["sP_HealthStatus"] = this.sP_HealthStatus ? this.sP_HealthStatus.toJSON() : <any>undefined;
      data["sP_HealthStatusOther"] = this.sP_HealthStatusOther;
      data["sP_PPSNumber"] = this.sP_PPSNumber;
      data["sP_NationalDomicileId"] = this.sP_NationalDomicileId;
      data["sP_NationalDomicile"] = this.sP_NationalDomicile ? this.sP_NationalDomicile.toJSON() : <any>undefined;
      data["sP_AddressLine_1"] = this.sP_AddressLine_1;
      data["sP_AddressLine_2"] = this.sP_AddressLine_2;
      data["sP_AddressLine_3"] = this.sP_AddressLine_3;
      data["sP_AddressLine_4"] = this.sP_AddressLine_4;
      data["sP_AddressCountyId"] = this.sP_AddressCountyId;
      data["sP_AddressCounty"] = this.sP_AddressCounty ? this.sP_AddressCounty.toJSON() : <any>undefined;
      data["sP_AddressCountryId"] = this.sP_AddressCountryId;
      data["sP_AddressCountry"] = this.sP_AddressCountry ? this.sP_AddressCountry.toJSON() : <any>undefined;
      data["sP_PostCode"] = this.sP_PostCode;
      data["sP_Email"] = this.sP_Email;
      data["sP_IsVunerableContact"] = this.sP_IsVunerableContact;
      data["sP_OptInAllMarketingComms"] = this.sP_OptInAllMarketingComms;
      data["sP_NoComms"] = this.sP_NoComms;
      data["sP_EmploymentStatusId"] = this.sP_EmploymentStatusId;
      data["sP_EmploymentStatus"] = this.sP_EmploymentStatus ? this.sP_EmploymentStatus.toJSON() : <any>undefined;
      data["sP_EmploymentId"] = this.sP_EmploymentId;
      data["sP_EmployerName"] = this.sP_EmployerName;
      data["ownerId"] = this.ownerId;
      data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
      data["contactTypeId"] = this.contactTypeId;
      data["contactType"] = this.contactType ? this.contactType.toJSON() : <any>undefined;
      data["brokerId"] = this.brokerId;
      data["leadSourceId"] = this.leadSourceId;
      data["masterProductId"] = this.masterProductId;
      data["fileRef"] = this.fileRef;
      if (Array.isArray(this.assets)) {
          data["assets"] = [];
          for (let item of this.assets)
              data["assets"].push(item.toJSON());
      }
      if (Array.isArray(this.dependents)) {
          data["dependents"] = [];
          for (let item of this.dependents)
              data["dependents"].push(item.toJSON());
      }
      if (Array.isArray(this.employments)) {
          data["employments"] = [];
          for (let item of this.employments)
              data["employments"].push(item.toJSON());
      }
      if (Array.isArray(this.expenses)) {
          data["expenses"] = [];
          for (let item of this.expenses)
              data["expenses"].push(item.toJSON());
      }
      if (Array.isArray(this.incomes)) {
          data["incomes"] = [];
          for (let item of this.incomes)
              data["incomes"].push(item.toJSON());
      }
      if (Array.isArray(this.complianceItems)) {
          data["complianceItems"] = [];
          for (let item of this.complianceItems)
              data["complianceItems"].push(item.toJSON());
      }
      if (Array.isArray(this.dataFeedIdentifiers)) {
          data["dataFeedIdentifiers"] = [];
          for (let item of this.dataFeedIdentifiers)
              data["dataFeedIdentifiers"].push(item.toJSON());
      }
      return data;
  }
}

export interface IContactProfile {
  id: number;
  titleId: number | undefined;
  title: ITitle | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  schemeName: string | undefined;
  dateOfBirth: string | undefined;
  genderId: number | undefined;
  gender: IGender | undefined;
  maritalStatusId: number | undefined;
  maritalStatus: IMaritalStatus | undefined;
  taxBasisAssessmentId: number | undefined;
  taxBasisAssessment: ITaxBasisAssessment | undefined;
  phoneNo: string | undefined;
  mobileNo: string | undefined;
  workNo: string | undefined;
  faxNo: string | undefined;
  smokerStatusId: number | undefined;
  smokerStatus: IYesNoDefault | undefined;
  healthStatusId: number | undefined;
  healthStatus: IHealthStatus | undefined;
  healthStatusOther: string | undefined;
  ppsNumber: string | undefined;
  nationalDomicileId: number | undefined;
  nationalDomicile: ICountry | undefined;
  addressLine_1: string | undefined;
  addressLine_2: string | undefined;
  addressLine_3: string | undefined;
  addressLine_4: string | undefined;
  addressCountyId: number | undefined;
  addressCounty: ICounty | undefined;
  addressCountryId: number | undefined;
  addressCountry: ICountry | undefined;
  postCode: string | undefined;
  email: string | undefined;
  isVunerableContact: boolean | undefined;
  optInAllMarketingComms: boolean | undefined;
  noComms: boolean | undefined;
  employmentStatusId: number | undefined;
  employmentStatus: IEmploymentStatus | undefined;
  employmentId: number | undefined;
  employment: IFactFindEmployment | undefined;
  employerName: string | undefined;
  sP_FirstName: string | undefined;
  sP_LastName: string | undefined;
  sP_SchemeName: string | undefined;
  sP_DateOfBirth: string | undefined;
  dateAdded: string | undefined;
  sP_TitleId: number | undefined;
  sP_Title: ITitle | undefined;
  sP_GenderId: number | undefined;
  sP_Gender: IGender | undefined;
  sP_MaritalStatusId: number | undefined;
  sP_MaritalStatus: IMaritalStatus | undefined;
  sP_TaxBasisAssessmentId: number | undefined;
  sP_TaxBasisAssessment: ITaxBasisAssessment | undefined;
  sP_PhoneNo: string | undefined;
  sP_MobileNo: string | undefined;
  sP_WorkNo: string | undefined;
  contactStatusId: number;
  contactStatus: IContactStatus | undefined;
  sP_SmokerStatusId: number | undefined;
  sP_SmokerStatus: IYesNoDefault | undefined;
  sP_HealthStatusId: number | undefined;
  sP_HealthStatus: IHealthStatus | undefined;
  sP_HealthStatusOther: string | undefined;
  sP_PPSNumber: string | undefined;
  sP_NationalDomicileId: number | undefined;
  sP_NationalDomicile: ICountry | undefined;
  sP_AddressLine_1: string | undefined;
  sP_AddressLine_2: string | undefined;
  sP_AddressLine_3: string | undefined;
  sP_AddressLine_4: string | undefined;
  sP_AddressCountyId: number | undefined;
  sP_AddressCounty: ICounty | undefined;
  sP_AddressCountryId: number | undefined;
  sP_AddressCountry: ICountry | undefined;
  sP_PostCode: string | undefined;
  sP_Email: string | undefined;
  sP_IsVunerableContact: boolean | undefined;
  sP_OptInAllMarketingComms: boolean | undefined;
  sP_NoComms: boolean | undefined;
  sP_EmploymentStatusId: number | undefined;
  sP_EmploymentStatus: IEmploymentStatus | undefined;
  sP_EmploymentId: number | undefined;
  sP_EmployerName: string | undefined;
  ownerId: number;
  owner: IContactOwnerProfile | undefined;
  contactTypeId: number | undefined;
  contactType: IContactType | undefined;
  brokerId: number;
  leadSourceId: number | undefined;
  masterProductId: number | undefined;
  fileRef: string | undefined;
  assets: FactFindAsset[] | undefined;
  dependents: FactFindDependent[] | undefined;
  employments: FactFindEmployment[] | undefined;
  expenses: FactFindExpense[] | undefined;
  incomes: FactFindIncome[] | undefined;
  complianceItems: IContactComplianceItem[] | undefined;
  dataFeedIdentifiers: IDataFeedIdentifier[] | undefined;
}

export abstract class _LookupBase implements I_LookupBase {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  visibleInClientPortal!: boolean | undefined;

  constructor(data?: I_LookupBase) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          this.visibleInClientPortal = _data["visibleInClientPortal"];
      }
  }

  static fromJS(data: any): _LookupBase {
      data = typeof data === 'object' ? data : {};
      throw new Error("The abstract class '_LookupBase' cannot be instantiated.");
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      data["visibleInClientPortal"] = this.visibleInClientPortal;
      return data;
  }
}

export interface I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  visibleInClientPortal: boolean | undefined;
}

export class Title extends _LookupBase implements ITitle {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mainContacts!: ContactProfile[] | undefined;

  constructor(data?: ITitle) {
      super(data);
      if (data) {
          if (data.mainContacts) {
              this.mainContacts = [];
              for (let i = 0; i < data.mainContacts.length; i++) {
                  let item = data.mainContacts[i];
                  this.mainContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mainContacts"])) {
              this.mainContacts = [] as any;
              for (let item of _data["mainContacts"])
                  this.mainContacts!.push(ContactProfile.fromJS(item));
          }
      }
  }

  static fromJS(data: any): Title {
      data = typeof data === 'object' ? data : {};
      let result = new Title();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mainContacts)) {
          data["mainContacts"] = [];
          for (let item of this.mainContacts)
              data["mainContacts"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface ITitle extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mainContacts: IContactProfile[] | undefined;
}

export class Gender extends _LookupBase implements IGender {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mainContacts!: ContactProfile[] | undefined;
  spouseContacts!: ContactProfile[] | undefined;

  constructor(data?: IGender) {
      super(data);
      if (data) {
          if (data.mainContacts) {
              this.mainContacts = [];
              for (let i = 0; i < data.mainContacts.length; i++) {
                  let item = data.mainContacts[i];
                  this.mainContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
          if (data.spouseContacts) {
              this.spouseContacts = [];
              for (let i = 0; i < data.spouseContacts.length; i++) {
                  let item = data.spouseContacts[i];
                  this.spouseContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mainContacts"])) {
              this.mainContacts = [] as any;
              for (let item of _data["mainContacts"])
                  this.mainContacts!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["spouseContacts"])) {
              this.spouseContacts = [] as any;
              for (let item of _data["spouseContacts"])
                  this.spouseContacts!.push(ContactProfile.fromJS(item));
          }
      }
  }

  static fromJS(data: any): Gender {
      data = typeof data === 'object' ? data : {};
      let result = new Gender();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mainContacts)) {
          data["mainContacts"] = [];
          for (let item of this.mainContacts)
              data["mainContacts"].push(item.toJSON());
      }
      if (Array.isArray(this.spouseContacts)) {
          data["spouseContacts"] = [];
          for (let item of this.spouseContacts)
              data["spouseContacts"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IGender extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mainContacts: IContactProfile[] | undefined;
  spouseContacts: IContactProfile[] | undefined;
}

export class MaritalStatus extends _LookupBase implements IMaritalStatus {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mainContacts!: ContactProfile[] | undefined;
  spouseContacts!: ContactProfile[] | undefined;

  constructor(data?: IMaritalStatus) {
      super(data);
      if (data) {
          if (data.mainContacts) {
              this.mainContacts = [];
              for (let i = 0; i < data.mainContacts.length; i++) {
                  let item = data.mainContacts[i];
                  this.mainContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
          if (data.spouseContacts) {
              this.spouseContacts = [];
              for (let i = 0; i < data.spouseContacts.length; i++) {
                  let item = data.spouseContacts[i];
                  this.spouseContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mainContacts"])) {
              this.mainContacts = [] as any;
              for (let item of _data["mainContacts"])
                  this.mainContacts!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["spouseContacts"])) {
              this.spouseContacts = [] as any;
              for (let item of _data["spouseContacts"])
                  this.spouseContacts!.push(ContactProfile.fromJS(item));
          }
      }
  }

  static fromJS(data: any): MaritalStatus {
      data = typeof data === 'object' ? data : {};
      let result = new MaritalStatus();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mainContacts)) {
          data["mainContacts"] = [];
          for (let item of this.mainContacts)
              data["mainContacts"].push(item.toJSON());
      }
      if (Array.isArray(this.spouseContacts)) {
          data["spouseContacts"] = [];
          for (let item of this.spouseContacts)
              data["spouseContacts"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IMaritalStatus extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mainContacts: IContactProfile[] | undefined;
  spouseContacts: IContactProfile[] | undefined;
}

export class TaxBasisAssessment extends _LookupBase implements ITaxBasisAssessment {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mainContacts!: ContactProfile[] | undefined;
  spouseContacts!: ContactProfile[] | undefined;

  constructor(data?: ITaxBasisAssessment) {
      super(data);
      if (data) {
          if (data.mainContacts) {
              this.mainContacts = [];
              for (let i = 0; i < data.mainContacts.length; i++) {
                  let item = data.mainContacts[i];
                  this.mainContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
          if (data.spouseContacts) {
              this.spouseContacts = [];
              for (let i = 0; i < data.spouseContacts.length; i++) {
                  let item = data.spouseContacts[i];
                  this.spouseContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mainContacts"])) {
              this.mainContacts = [] as any;
              for (let item of _data["mainContacts"])
                  this.mainContacts!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["spouseContacts"])) {
              this.spouseContacts = [] as any;
              for (let item of _data["spouseContacts"])
                  this.spouseContacts!.push(ContactProfile.fromJS(item));
          }
      }
  }

  static fromJS(data: any): TaxBasisAssessment {
      data = typeof data === 'object' ? data : {};
      let result = new TaxBasisAssessment();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mainContacts)) {
          data["mainContacts"] = [];
          for (let item of this.mainContacts)
              data["mainContacts"].push(item.toJSON());
      }
      if (Array.isArray(this.spouseContacts)) {
          data["spouseContacts"] = [];
          for (let item of this.spouseContacts)
              data["spouseContacts"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface ITaxBasisAssessment extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mainContacts: IContactProfile[] | undefined;
  spouseContacts: IContactProfile[] | undefined;
}

export class YesNoDefault extends _LookupBase implements IYesNoDefault {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mainContactSmokerStatuss!: ContactProfile[] | undefined;
  spouseContactSmokerStatuss!: ContactProfile[] | undefined;
  assetIsOutSideCountry!: FactFindAsset[] | undefined;
  assetIsFamilyHome!: FactFindAsset[] | undefined;
  assetCanBeSold!: FactFindAsset[] | undefined;
  liabilityLoans!: FactFindLiabilityLoan[] | undefined;
  mortgageLiabilityIsBusiness!: PolicyAdditionalDetails[] | undefined;
  mortgageLiabilityIsSoleOccupant!: PolicyAdditionalDetails[] | undefined;
  mortgageLiabilityIsVacantPossession!: PolicyAdditionalDetails[] | undefined;
  mortgageLiabilityRentalIncome!: PolicyAdditionalDetails[] | undefined;
  mortgageLiabilityInvestmentProperty!: PolicyAdditionalDetails[] | undefined;
  mortgageLiabilityPrivateResidence!: PolicyAdditionalDetails[] | undefined;
  policyIndexation!: FactFindPolicy[] | undefined;
  policyConvertible!: FactFindPolicy[] | undefined;

  constructor(data?: IYesNoDefault) {
      super(data);
      if (data) {
          if (data.mainContactSmokerStatuss) {
              this.mainContactSmokerStatuss = [];
              for (let i = 0; i < data.mainContactSmokerStatuss.length; i++) {
                  let item = data.mainContactSmokerStatuss[i];
                  this.mainContactSmokerStatuss[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
          if (data.spouseContactSmokerStatuss) {
              this.spouseContactSmokerStatuss = [];
              for (let i = 0; i < data.spouseContactSmokerStatuss.length; i++) {
                  let item = data.spouseContactSmokerStatuss[i];
                  this.spouseContactSmokerStatuss[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
          if (data.mortgageLiabilityIsBusiness) {
              this.mortgageLiabilityIsBusiness = [];
              for (let i = 0; i < data.mortgageLiabilityIsBusiness.length; i++) {
                  let item = data.mortgageLiabilityIsBusiness[i];
                  this.mortgageLiabilityIsBusiness[i] = item && !(<any>item).toJSON ? new PolicyAdditionalDetails(item) : <PolicyAdditionalDetails>item;
              }
          }
          if (data.mortgageLiabilityIsSoleOccupant) {
              this.mortgageLiabilityIsSoleOccupant = [];
              for (let i = 0; i < data.mortgageLiabilityIsSoleOccupant.length; i++) {
                  let item = data.mortgageLiabilityIsSoleOccupant[i];
                  this.mortgageLiabilityIsSoleOccupant[i] = item && !(<any>item).toJSON ? new PolicyAdditionalDetails(item) : <PolicyAdditionalDetails>item;
              }
          }
          if (data.mortgageLiabilityIsVacantPossession) {
              this.mortgageLiabilityIsVacantPossession = [];
              for (let i = 0; i < data.mortgageLiabilityIsVacantPossession.length; i++) {
                  let item = data.mortgageLiabilityIsVacantPossession[i];
                  this.mortgageLiabilityIsVacantPossession[i] = item && !(<any>item).toJSON ? new PolicyAdditionalDetails(item) : <PolicyAdditionalDetails>item;
              }
          }
          if (data.mortgageLiabilityRentalIncome) {
              this.mortgageLiabilityRentalIncome = [];
              for (let i = 0; i < data.mortgageLiabilityRentalIncome.length; i++) {
                  let item = data.mortgageLiabilityRentalIncome[i];
                  this.mortgageLiabilityRentalIncome[i] = item && !(<any>item).toJSON ? new PolicyAdditionalDetails(item) : <PolicyAdditionalDetails>item;
              }
          }
          if (data.mortgageLiabilityInvestmentProperty) {
              this.mortgageLiabilityInvestmentProperty = [];
              for (let i = 0; i < data.mortgageLiabilityInvestmentProperty.length; i++) {
                  let item = data.mortgageLiabilityInvestmentProperty[i];
                  this.mortgageLiabilityInvestmentProperty[i] = item && !(<any>item).toJSON ? new PolicyAdditionalDetails(item) : <PolicyAdditionalDetails>item;
              }
          }
          if (data.mortgageLiabilityPrivateResidence) {
              this.mortgageLiabilityPrivateResidence = [];
              for (let i = 0; i < data.mortgageLiabilityPrivateResidence.length; i++) {
                  let item = data.mortgageLiabilityPrivateResidence[i];
                  this.mortgageLiabilityPrivateResidence[i] = item && !(<any>item).toJSON ? new PolicyAdditionalDetails(item) : <PolicyAdditionalDetails>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mainContactSmokerStatuss"])) {
              this.mainContactSmokerStatuss = [] as any;
              for (let item of _data["mainContactSmokerStatuss"])
                  this.mainContactSmokerStatuss!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["spouseContactSmokerStatuss"])) {
              this.spouseContactSmokerStatuss = [] as any;
              for (let item of _data["spouseContactSmokerStatuss"])
                  this.spouseContactSmokerStatuss!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["assetIsOutSideCountry"])) {
              this.assetIsOutSideCountry = [] as any;
              for (let item of _data["assetIsOutSideCountry"])
                  this.assetIsOutSideCountry!.push(FactFindAsset.fromJS(item));
          }
          if (Array.isArray(_data["assetIsFamilyHome"])) {
              this.assetIsFamilyHome = [] as any;
              for (let item of _data["assetIsFamilyHome"])
                  this.assetIsFamilyHome!.push(FactFindAsset.fromJS(item));
          }
          if (Array.isArray(_data["assetCanBeSold"])) {
              this.assetCanBeSold = [] as any;
              for (let item of _data["assetCanBeSold"])
                  this.assetCanBeSold!.push(FactFindAsset.fromJS(item));
          }
          if (Array.isArray(_data["liabilityLoans"])) {
              this.liabilityLoans = [] as any;
              for (let item of _data["liabilityLoans"])
                  this.liabilityLoans!.push(FactFindLiabilityLoan.fromJS(item));
          }
          if (Array.isArray(_data["mortgageLiabilityIsBusiness"])) {
              this.mortgageLiabilityIsBusiness = [] as any;
              for (let item of _data["mortgageLiabilityIsBusiness"])
                  this.mortgageLiabilityIsBusiness!.push(PolicyAdditionalDetails.fromJS(item));
          }
          if (Array.isArray(_data["mortgageLiabilityIsSoleOccupant"])) {
              this.mortgageLiabilityIsSoleOccupant = [] as any;
              for (let item of _data["mortgageLiabilityIsSoleOccupant"])
                  this.mortgageLiabilityIsSoleOccupant!.push(PolicyAdditionalDetails.fromJS(item));
          }
          if (Array.isArray(_data["mortgageLiabilityIsVacantPossession"])) {
              this.mortgageLiabilityIsVacantPossession = [] as any;
              for (let item of _data["mortgageLiabilityIsVacantPossession"])
                  this.mortgageLiabilityIsVacantPossession!.push(PolicyAdditionalDetails.fromJS(item));
          }
          if (Array.isArray(_data["mortgageLiabilityRentalIncome"])) {
              this.mortgageLiabilityRentalIncome = [] as any;
              for (let item of _data["mortgageLiabilityRentalIncome"])
                  this.mortgageLiabilityRentalIncome!.push(PolicyAdditionalDetails.fromJS(item));
          }
          if (Array.isArray(_data["mortgageLiabilityInvestmentProperty"])) {
              this.mortgageLiabilityInvestmentProperty = [] as any;
              for (let item of _data["mortgageLiabilityInvestmentProperty"])
                  this.mortgageLiabilityInvestmentProperty!.push(PolicyAdditionalDetails.fromJS(item));
          }
          if (Array.isArray(_data["mortgageLiabilityPrivateResidence"])) {
              this.mortgageLiabilityPrivateResidence = [] as any;
              for (let item of _data["mortgageLiabilityPrivateResidence"])
                  this.mortgageLiabilityPrivateResidence!.push(PolicyAdditionalDetails.fromJS(item));
          }
          if (Array.isArray(_data["policyIndexation"])) {
              this.policyIndexation = [] as any;
              for (let item of _data["policyIndexation"])
                  this.policyIndexation!.push(FactFindPolicy.fromJS(item));
          }
          if (Array.isArray(_data["policyConvertible"])) {
              this.policyConvertible = [] as any;
              for (let item of _data["policyConvertible"])
                  this.policyConvertible!.push(FactFindPolicy.fromJS(item));
          }
      }
  }

  static fromJS(data: any): YesNoDefault {
      data = typeof data === 'object' ? data : {};
      let result = new YesNoDefault();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mainContactSmokerStatuss)) {
          data["mainContactSmokerStatuss"] = [];
          for (let item of this.mainContactSmokerStatuss)
              data["mainContactSmokerStatuss"].push(item.toJSON());
      }
      if (Array.isArray(this.spouseContactSmokerStatuss)) {
          data["spouseContactSmokerStatuss"] = [];
          for (let item of this.spouseContactSmokerStatuss)
              data["spouseContactSmokerStatuss"].push(item.toJSON());
      }
      if (Array.isArray(this.assetIsOutSideCountry)) {
          data["assetIsOutSideCountry"] = [];
          for (let item of this.assetIsOutSideCountry)
              data["assetIsOutSideCountry"].push(item.toJSON());
      }
      if (Array.isArray(this.assetIsFamilyHome)) {
          data["assetIsFamilyHome"] = [];
          for (let item of this.assetIsFamilyHome)
              data["assetIsFamilyHome"].push(item.toJSON());
      }
      if (Array.isArray(this.assetCanBeSold)) {
          data["assetCanBeSold"] = [];
          for (let item of this.assetCanBeSold)
              data["assetCanBeSold"].push(item.toJSON());
      }
      if (Array.isArray(this.liabilityLoans)) {
          data["liabilityLoans"] = [];
          for (let item of this.liabilityLoans)
              data["liabilityLoans"].push(item.toJSON());
      }
      if (Array.isArray(this.mortgageLiabilityIsBusiness)) {
          data["mortgageLiabilityIsBusiness"] = [];
          for (let item of this.mortgageLiabilityIsBusiness)
              data["mortgageLiabilityIsBusiness"].push(item.toJSON());
      }
      if (Array.isArray(this.mortgageLiabilityIsSoleOccupant)) {
          data["mortgageLiabilityIsSoleOccupant"] = [];
          for (let item of this.mortgageLiabilityIsSoleOccupant)
              data["mortgageLiabilityIsSoleOccupant"].push(item.toJSON());
      }
      if (Array.isArray(this.mortgageLiabilityIsVacantPossession)) {
          data["mortgageLiabilityIsVacantPossession"] = [];
          for (let item of this.mortgageLiabilityIsVacantPossession)
              data["mortgageLiabilityIsVacantPossession"].push(item.toJSON());
      }
      if (Array.isArray(this.mortgageLiabilityRentalIncome)) {
          data["mortgageLiabilityRentalIncome"] = [];
          for (let item of this.mortgageLiabilityRentalIncome)
              data["mortgageLiabilityRentalIncome"].push(item.toJSON());
      }
      if (Array.isArray(this.mortgageLiabilityInvestmentProperty)) {
          data["mortgageLiabilityInvestmentProperty"] = [];
          for (let item of this.mortgageLiabilityInvestmentProperty)
              data["mortgageLiabilityInvestmentProperty"].push(item.toJSON());
      }
      if (Array.isArray(this.mortgageLiabilityPrivateResidence)) {
          data["mortgageLiabilityPrivateResidence"] = [];
          for (let item of this.mortgageLiabilityPrivateResidence)
              data["mortgageLiabilityPrivateResidence"].push(item.toJSON());
      }
      if (Array.isArray(this.policyIndexation)) {
          data["policyIndexation"] = [];
          for (let item of this.policyIndexation)
              data["policyIndexation"].push(item.toJSON());
      }
      if (Array.isArray(this.policyConvertible)) {
          data["policyConvertible"] = [];
          for (let item of this.policyConvertible)
              data["policyConvertible"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IYesNoDefault extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mainContactSmokerStatuss: IContactProfile[] | undefined;
  spouseContactSmokerStatuss: IContactProfile[] | undefined;
  assetIsOutSideCountry: FactFindAsset[] | undefined;
  assetIsFamilyHome: FactFindAsset[] | undefined;
  assetCanBeSold: FactFindAsset[] | undefined;
  liabilityLoans: FactFindLiabilityLoan[] | undefined;
  mortgageLiabilityIsBusiness: IPolicyAdditionalDetails[] | undefined;
  mortgageLiabilityIsSoleOccupant: IPolicyAdditionalDetails[] | undefined;
  mortgageLiabilityIsVacantPossession: IPolicyAdditionalDetails[] | undefined;
  mortgageLiabilityRentalIncome: IPolicyAdditionalDetails[] | undefined;
  mortgageLiabilityInvestmentProperty: IPolicyAdditionalDetails[] | undefined;
  mortgageLiabilityPrivateResidence: IPolicyAdditionalDetails[] | undefined;
  policyIndexation: FactFindPolicy[] | undefined;
  policyConvertible: FactFindPolicy[] | undefined;
}

export abstract class _FactFindEntityBase implements I_FactFindEntityBase {
  contactId!: number | undefined;
  contact!: ContactProfile | undefined;

  constructor(data?: I_FactFindEntityBase) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.contact = data.contact && !(<any>data.contact).toJSON ? new ContactProfile(data.contact) : <ContactProfile>this.contact;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.contactId = _data["contactId"];
          this.contact = _data["contact"] ? ContactProfile.fromJS(_data["contact"]) : <any>undefined;
      }
  }

  static fromJS(data: any): _FactFindEntityBase {
      data = typeof data === 'object' ? data : {};
      throw new Error("The abstract class '_FactFindEntityBase' cannot be instantiated.");
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["contactId"] = this.contactId;
      data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
      return data;
  }
}

export interface I_FactFindEntityBase {
  contactId: number | undefined;
  contact: IContactProfile | undefined;
}

export class FactFindAsset extends _FactFindEntityBase implements IFactFindAsset {
  id!: number;
  owner!: ClientSelector;
  typeId!: number;
  type!: AssetType | undefined;
  otherType!: string | undefined;
  approximateValue!: number | undefined;
  isOutsideContryId!: number | undefined;
  isOutsideCountry!: YesNoDefault | undefined;
  location!: string | undefined;
  isFamilyHomeId!: number | undefined;
  isFamilyHome!: YesNoDefault | undefined;
  canBeSoldId!: number | undefined;
  canBeSold!: YesNoDefault | undefined;
  approximateTimeframeId!: number | undefined;
  approximateTimeframe!: Timeframe | undefined;
  classificationId!: number | undefined;
  classification!: AssetClassification | undefined;
  annualGrowthDecline!: number | undefined;
  liabilityId!: number | undefined;
  liability!: FactFindPolicy | undefined;
  notes!: string | undefined;

  constructor(data?: IFactFindAsset) {
      super(data);
      if (data) {
          this.type = data.type && !(<any>data.type).toJSON ? new AssetType(data.type) : <AssetType>this.type;
          this.isOutsideCountry = data.isOutsideCountry && !(<any>data.isOutsideCountry).toJSON ? new YesNoDefault(data.isOutsideCountry) : <YesNoDefault>this.isOutsideCountry;
          this.isFamilyHome = data.isFamilyHome && !(<any>data.isFamilyHome).toJSON ? new YesNoDefault(data.isFamilyHome) : <YesNoDefault>this.isFamilyHome;
          this.canBeSold = data.canBeSold && !(<any>data.canBeSold).toJSON ? new YesNoDefault(data.canBeSold) : <YesNoDefault>this.canBeSold;
          this.approximateTimeframe = data.approximateTimeframe && !(<any>data.approximateTimeframe).toJSON ? new Timeframe(data.approximateTimeframe) : <Timeframe>this.approximateTimeframe;
          this.classification = data.classification && !(<any>data.classification).toJSON ? new AssetClassification(data.classification) : <AssetClassification>this.classification;
          this.liability = data.liability && !(<any>data.liability).toJSON ? new FactFindPolicy(data.liability) : <FactFindPolicy>this.liability;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.owner = _data["owner"];
          this.typeId = _data["typeId"];
          this.type = _data["type"] ? AssetType.fromJS(_data["type"]) : <any>undefined;
          this.otherType = _data["otherType"];
          this.approximateValue = _data["approximateValue"];
          this.isOutsideContryId = _data["isOutsideContryId"];
          this.isOutsideCountry = _data["isOutsideCountry"] ? YesNoDefault.fromJS(_data["isOutsideCountry"]) : <any>undefined;
          this.location = _data["location"];
          this.isFamilyHomeId = _data["isFamilyHomeId"];
          this.isFamilyHome = _data["isFamilyHome"] ? YesNoDefault.fromJS(_data["isFamilyHome"]) : <any>undefined;
          this.canBeSoldId = _data["canBeSoldId"];
          this.canBeSold = _data["canBeSold"] ? YesNoDefault.fromJS(_data["canBeSold"]) : <any>undefined;
          this.approximateTimeframeId = _data["approximateTimeframeId"];
          this.approximateTimeframe = _data["approximateTimeframe"] ? Timeframe.fromJS(_data["approximateTimeframe"]) : <any>undefined;
          this.classificationId = _data["classificationId"];
          this.classification = _data["classification"] ? AssetClassification.fromJS(_data["classification"]) : <any>undefined;
          this.annualGrowthDecline = _data["annualGrowthDecline"];
          this.liabilityId = _data["liabilityId"];
          this.liability = _data["liability"] ? FactFindPolicy.fromJS(_data["liability"]) : <any>undefined;
          this.notes = _data["notes"];
      }
  }

  static fromJS(data: any): FactFindAsset {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindAsset();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["owner"] = this.owner;
      data["typeId"] = this.typeId;
      data["type"] = this.type ? this.type.toJSON() : <any>undefined;
      data["otherType"] = this.otherType;
      data["approximateValue"] = this.approximateValue;
      data["isOutsideContryId"] = this.isOutsideContryId;
      data["isOutsideCountry"] = this.isOutsideCountry ? this.isOutsideCountry.toJSON() : <any>undefined;
      data["location"] = this.location;
      data["isFamilyHomeId"] = this.isFamilyHomeId;
      data["isFamilyHome"] = this.isFamilyHome ? this.isFamilyHome.toJSON() : <any>undefined;
      data["canBeSoldId"] = this.canBeSoldId;
      data["canBeSold"] = this.canBeSold ? this.canBeSold.toJSON() : <any>undefined;
      data["approximateTimeframeId"] = this.approximateTimeframeId;
      data["approximateTimeframe"] = this.approximateTimeframe ? this.approximateTimeframe.toJSON() : <any>undefined;
      data["classificationId"] = this.classificationId;
      data["classification"] = this.classification ? this.classification.toJSON() : <any>undefined;
      data["annualGrowthDecline"] = this.annualGrowthDecline;
      data["liabilityId"] = this.liabilityId;
      data["liability"] = this.liability ? this.liability.toJSON() : <any>undefined;
      data["notes"] = this.notes;
      super.toJSON(data);
      return data;
  }
}

export interface IFactFindAsset extends I_FactFindEntityBase {
  id: number;
  owner: ClientSelector;
  typeId: number;
  type: IAssetType | undefined;
  otherType: string | undefined;
  approximateValue: number | undefined;
  isOutsideContryId: number | undefined;
  isOutsideCountry: IYesNoDefault | undefined;
  location: string | undefined;
  isFamilyHomeId: number | undefined;
  isFamilyHome: IYesNoDefault | undefined;
  canBeSoldId: number | undefined;
  canBeSold: IYesNoDefault | undefined;
  approximateTimeframeId: number | undefined;
  approximateTimeframe: ITimeframe | undefined;
  classificationId: number | undefined;
  classification: IAssetClassification | undefined;
  annualGrowthDecline: number | undefined;
  liabilityId: number | undefined;
  liability: IFactFindPolicy | undefined;
  notes: string | undefined;
}

export class AssetType extends _LookupBase implements IAssetType {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  assets!: FactFindAsset[] | undefined;

  constructor(data?: IAssetType) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["assets"])) {
              this.assets = [] as any;
              for (let item of _data["assets"])
                  this.assets!.push(FactFindAsset.fromJS(item));
          }
      }
  }

  static fromJS(data: any): AssetType {
      data = typeof data === 'object' ? data : {};
      let result = new AssetType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.assets)) {
          data["assets"] = [];
          for (let item of this.assets)
              data["assets"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IAssetType extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  assets: FactFindAsset[] | undefined;
}

export class Timeframe extends _LookupBase implements ITimeframe {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  assetApproximateTimeframes!: FactFindAsset[] | undefined;

  constructor(data?: ITimeframe) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["assetApproximateTimeframes"])) {
              this.assetApproximateTimeframes = [] as any;
              for (let item of _data["assetApproximateTimeframes"])
                  this.assetApproximateTimeframes!.push(FactFindAsset.fromJS(item));
          }
      }
  }

  static fromJS(data: any): Timeframe {
      data = typeof data === 'object' ? data : {};
      let result = new Timeframe();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.assetApproximateTimeframes)) {
          data["assetApproximateTimeframes"] = [];
          for (let item of this.assetApproximateTimeframes)
              data["assetApproximateTimeframes"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface ITimeframe extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  assetApproximateTimeframes: FactFindAsset[] | undefined;
}

export class AssetClassification extends _LookupBase implements IAssetClassification {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  assetClassifications!: FactFindAsset[] | undefined;

  constructor(data?: IAssetClassification) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["assetClassifications"])) {
              this.assetClassifications = [] as any;
              for (let item of _data["assetClassifications"])
                  this.assetClassifications!.push(FactFindAsset.fromJS(item));
          }
      }
  }

  static fromJS(data: any): AssetClassification {
      data = typeof data === 'object' ? data : {};
      let result = new AssetClassification();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.assetClassifications)) {
          data["assetClassifications"] = [];
          for (let item of this.assetClassifications)
              data["assetClassifications"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IAssetClassification extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  assetClassifications: FactFindAsset[] | undefined;
}

export class FactFindPolicy extends _FactFindEntityBase implements IFactFindPolicy {
  id!: number;
  contactOwnerId_AddedBy!: number | undefined;
  contactOwnerId_LastUpdatedBy!: number | undefined;
  policyOwner!: ClientSelector | undefined;
  contactOwnerId_PolicyOwner!: number | undefined;
  policyTermInYears!: number | undefined;
  description!: string | undefined;
  isAgencyPolicy!: boolean | undefined;
  agencyCode!: string | undefined;
  policyNo!: string | undefined;
  premium!: number | undefined;
  annualPolicyPremium!: number | undefined;
  inceptionDate!: string | undefined;
  maturityDate!: string | undefined;
  addedDate!: string | undefined;
  paidToDate!: string | undefined;
  fundValueDate!: string | undefined;
  fundValue!: number | undefined;
  sumAssured!: number | undefined;
  totalPremiumsPaid!: number | undefined;
  dataFeedProductCode!: string | undefined;
  providerId!: number | undefined;
  provider!: ProductProvider | undefined;
  paymentMethodId!: number | undefined;
  paymentMethod!: PaymentMethod | undefined;
  paymentFrequencyId!: number | undefined;
  paymentFrequency!: PaymentFrequency | undefined;
  policyBasisId!: number | undefined;
  policyBasis!: PolicyBasis | undefined;
  statusId!: number | undefined;
  status!: PolicyStatus | undefined;
  statusChangedDate!: string | undefined;
  categoryId!: number | undefined;
  category!: ProductCategory | undefined;
  subCategoryId!: number | undefined;
  subCategory!: ProductSubCategory | undefined;
  notes!: string | undefined;
  mandateRefNo!: string | undefined;
  indexedId!: number | undefined;
  indexation!: YesNoDefault | undefined;
  convertibleId!: number | undefined;
  convertible!: YesNoDefault | undefined;
  benefits!: PolicyBenefit[] | undefined;
  policyRoles!: PolicyRole[] | undefined;
  policyFunds!: PolicyFund[] | undefined;
  documents!: ContactDocument[] | undefined;

  constructor(data?: IFactFindPolicy) {
      super(data);
      if (data) {
          this.provider = data.provider && !(<any>data.provider).toJSON ? new ProductProvider(data.provider) : <ProductProvider>this.provider;
          this.paymentMethod = data.paymentMethod && !(<any>data.paymentMethod).toJSON ? new PaymentMethod(data.paymentMethod) : <PaymentMethod>this.paymentMethod;
          this.paymentFrequency = data.paymentFrequency && !(<any>data.paymentFrequency).toJSON ? new PaymentFrequency(data.paymentFrequency) : <PaymentFrequency>this.paymentFrequency;
          this.policyBasis = data.policyBasis && !(<any>data.policyBasis).toJSON ? new PolicyBasis(data.policyBasis) : <PolicyBasis>this.policyBasis;
          this.status = data.status && !(<any>data.status).toJSON ? new PolicyStatus(data.status) : <PolicyStatus>this.status;
          this.category = data.category && !(<any>data.category).toJSON ? new ProductCategory(data.category) : <ProductCategory>this.category;
          this.subCategory = data.subCategory && !(<any>data.subCategory).toJSON ? new ProductSubCategory(data.subCategory) : <ProductSubCategory>this.subCategory;
          this.indexation = data.indexation && !(<any>data.indexation).toJSON ? new YesNoDefault(data.indexation) : <YesNoDefault>this.indexation;
          this.convertible = data.convertible && !(<any>data.convertible).toJSON ? new YesNoDefault(data.convertible) : <YesNoDefault>this.convertible;
          if (data.benefits) {
              this.benefits = [];
              for (let i = 0; i < data.benefits.length; i++) {
                  let item = data.benefits[i];
                  this.benefits[i] = item && !(<any>item).toJSON ? new PolicyBenefit(item) : <PolicyBenefit>item;
              }
          }
          if (data.policyRoles) {
              this.policyRoles = [];
              for (let i = 0; i < data.policyRoles.length; i++) {
                  let item = data.policyRoles[i];
                  this.policyRoles[i] = item && !(<any>item).toJSON ? new PolicyRole(item) : <PolicyRole>item;
              }
          }
          if (data.policyFunds) {
              this.policyFunds = [];
              for (let i = 0; i < data.policyFunds.length; i++) {
                  let item = data.policyFunds[i];
                  this.policyFunds[i] = item && !(<any>item).toJSON ? new PolicyFund(item) : <PolicyFund>item;
              }
          }
          if (data.documents) {
              this.documents = [];
              for (let i = 0; i < data.documents.length; i++) {
                  let item = data.documents[i];
                  this.documents[i] = item && !(<any>item).toJSON ? new ContactDocument(item) : <ContactDocument>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.contactOwnerId_AddedBy = _data["contactOwnerId_AddedBy"];
          this.contactOwnerId_LastUpdatedBy = _data["contactOwnerId_LastUpdatedBy"];
          this.policyOwner = _data["policyOwner"];
          this.contactOwnerId_PolicyOwner = _data["contactOwnerId_PolicyOwner"];
          this.policyTermInYears = _data["policyTermInYears"];
          this.description = _data["description"];
          this.isAgencyPolicy = _data["isAgencyPolicy"];
          this.agencyCode = _data["agencyCode"];
          this.policyNo = _data["policyNo"];
          this.premium = _data["premium"];
          this.annualPolicyPremium = _data["annualPolicyPremium"];
          this.inceptionDate = _data["inceptionDate"];
          this.maturityDate = _data["maturityDate"];
          this.addedDate = _data["addedDate"];
          this.paidToDate = _data["paidToDate"];
          this.fundValueDate = _data["fundValueDate"];
          this.fundValue = _data["fundValue"];
          this.sumAssured = _data["sumAssured"];
          this.totalPremiumsPaid = _data["totalPremiumsPaid"];
          this.dataFeedProductCode = _data["dataFeedProductCode"];
          this.providerId = _data["providerId"];
          this.provider = _data["provider"] ? ProductProvider.fromJS(_data["provider"]) : <any>undefined;
          this.paymentMethodId = _data["paymentMethodId"];
          this.paymentMethod = _data["paymentMethod"] ? PaymentMethod.fromJS(_data["paymentMethod"]) : <any>undefined;
          this.paymentFrequencyId = _data["paymentFrequencyId"];
          this.paymentFrequency = _data["paymentFrequency"] ? PaymentFrequency.fromJS(_data["paymentFrequency"]) : <any>undefined;
          this.policyBasisId = _data["policyBasisId"];
          this.policyBasis = _data["policyBasis"] ? PolicyBasis.fromJS(_data["policyBasis"]) : <any>undefined;
          this.statusId = _data["statusId"];
          this.status = _data["status"] ? PolicyStatus.fromJS(_data["status"]) : <any>undefined;
          this.statusChangedDate = _data["statusChangedDate"];
          this.categoryId = _data["categoryId"];
          this.category = _data["category"] ? ProductCategory.fromJS(_data["category"]) : <any>undefined;
          this.subCategoryId = _data["subCategoryId"];
          this.subCategory = _data["subCategory"] ? ProductSubCategory.fromJS(_data["subCategory"]) : <any>undefined;
          this.notes = _data["notes"];
          this.mandateRefNo = _data["mandateRefNo"];
          this.indexedId = _data["indexedId"];
          this.indexation = _data["indexation"] ? YesNoDefault.fromJS(_data["indexation"]) : <any>undefined;
          this.convertibleId = _data["convertibleId"];
          this.convertible = _data["convertible"] ? YesNoDefault.fromJS(_data["convertible"]) : <any>undefined;
          if (Array.isArray(_data["benefits"])) {
              this.benefits = [] as any;
              for (let item of _data["benefits"])
                  this.benefits!.push(PolicyBenefit.fromJS(item));
          }
          if (Array.isArray(_data["policyRoles"])) {
              this.policyRoles = [] as any;
              for (let item of _data["policyRoles"])
                  this.policyRoles!.push(PolicyRole.fromJS(item));
          }
          if (Array.isArray(_data["policyFunds"])) {
              this.policyFunds = [] as any;
              for (let item of _data["policyFunds"])
                  this.policyFunds!.push(PolicyFund.fromJS(item));
          }
          if (Array.isArray(_data["documents"])) {
              this.documents = [] as any;
              for (let item of _data["documents"])
                  this.documents!.push(ContactDocument.fromJS(item));
          }
      }
  }

  static fromJS(data: any): FactFindPolicy {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindPolicy();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["contactOwnerId_AddedBy"] = this.contactOwnerId_AddedBy;
      data["contactOwnerId_LastUpdatedBy"] = this.contactOwnerId_LastUpdatedBy;
      data["policyOwner"] = this.policyOwner;
      data["contactOwnerId_PolicyOwner"] = this.contactOwnerId_PolicyOwner;
      data["policyTermInYears"] = this.policyTermInYears;
      data["description"] = this.description;
      data["isAgencyPolicy"] = this.isAgencyPolicy;
      data["agencyCode"] = this.agencyCode;
      data["policyNo"] = this.policyNo;
      data["premium"] = this.premium;
      data["annualPolicyPremium"] = this.annualPolicyPremium;
      data["inceptionDate"] = this.inceptionDate;
      data["maturityDate"] = this.maturityDate;
      data["addedDate"] = this.addedDate;
      data["paidToDate"] = this.paidToDate;
      data["fundValueDate"] = this.fundValueDate;
      data["fundValue"] = this.fundValue;
      data["sumAssured"] = this.sumAssured;
      data["totalPremiumsPaid"] = this.totalPremiumsPaid;
      data["dataFeedProductCode"] = this.dataFeedProductCode;
      data["providerId"] = this.providerId;
      data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
      data["paymentMethodId"] = this.paymentMethodId;
      data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
      data["paymentFrequencyId"] = this.paymentFrequencyId;
      data["paymentFrequency"] = this.paymentFrequency ? this.paymentFrequency.toJSON() : <any>undefined;
      data["policyBasisId"] = this.policyBasisId;
      data["policyBasis"] = this.policyBasis ? this.policyBasis.toJSON() : <any>undefined;
      data["statusId"] = this.statusId;
      data["status"] = this.status ? this.status.toJSON() : <any>undefined;
      data["statusChangedDate"] = this.statusChangedDate;
      data["categoryId"] = this.categoryId;
      data["category"] = this.category ? this.category.toJSON() : <any>undefined;
      data["subCategoryId"] = this.subCategoryId;
      data["subCategory"] = this.subCategory ? this.subCategory.toJSON() : <any>undefined;
      data["notes"] = this.notes;
      data["mandateRefNo"] = this.mandateRefNo;
      data["indexedId"] = this.indexedId;
      data["indexation"] = this.indexation ? this.indexation.toJSON() : <any>undefined;
      data["convertibleId"] = this.convertibleId;
      data["convertible"] = this.convertible ? this.convertible.toJSON() : <any>undefined;
      if (Array.isArray(this.benefits)) {
          data["benefits"] = [];
          for (let item of this.benefits)
              data["benefits"].push(item.toJSON());
      }
      if (Array.isArray(this.policyRoles)) {
          data["policyRoles"] = [];
          for (let item of this.policyRoles)
              data["policyRoles"].push(item.toJSON());
      }
      if (Array.isArray(this.policyFunds)) {
          data["policyFunds"] = [];
          for (let item of this.policyFunds)
              data["policyFunds"].push(item.toJSON());
      }
      if (Array.isArray(this.documents)) {
          data["documents"] = [];
          for (let item of this.documents)
              data["documents"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IFactFindPolicy extends I_FactFindEntityBase {
  id: number;
  contactOwnerId_AddedBy: number | undefined;
  contactOwnerId_LastUpdatedBy: number | undefined;
  policyOwner: ClientSelector | undefined;
  contactOwnerId_PolicyOwner: number | undefined;
  policyTermInYears: number | undefined;
  description: string | undefined;
  isAgencyPolicy: boolean | undefined;
  agencyCode: string | undefined;
  policyNo: string | undefined;
  premium: number | undefined;
  annualPolicyPremium: number | undefined;
  inceptionDate: string | undefined;
  maturityDate: string | undefined;
  addedDate: string | undefined;
  paidToDate: string | undefined;
  fundValueDate: string | undefined;
  fundValue: number | undefined;
  sumAssured: number | undefined;
  totalPremiumsPaid: number | undefined;
  dataFeedProductCode: string | undefined;
  providerId: number | undefined;
  provider: IProductProvider | undefined;
  paymentMethodId: number | undefined;
  paymentMethod: IPaymentMethod | undefined;
  paymentFrequencyId: number | undefined;
  paymentFrequency: IPaymentFrequency | undefined;
  policyBasisId: number | undefined;
  policyBasis: IPolicyBasis | undefined;
  statusId: number | undefined;
  status: IPolicyStatus | undefined;
  statusChangedDate: string | undefined;
  categoryId: number | undefined;
  category: IProductCategory | undefined;
  subCategoryId: number | undefined;
  subCategory: IProductSubCategory | undefined;
  notes: string | undefined;
  mandateRefNo: string | undefined;
  indexedId: number | undefined;
  indexation: IYesNoDefault | undefined;
  convertibleId: number | undefined;
  convertible: IYesNoDefault | undefined;
  benefits: IPolicyBenefit[] | undefined;
  policyRoles: IPolicyRole[] | undefined;
  policyFunds: IPolicyFund[] | undefined;
  documents: IContactDocument[] | undefined;
}

export class ProductProvider extends _LookupBase implements IProductProvider {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  liabilityLoans!: FactFindLiabilityLoan[] | undefined;
  liabilityMortgages!: FactFindPolicy[] | undefined;

  constructor(data?: IProductProvider) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["liabilityLoans"])) {
              this.liabilityLoans = [] as any;
              for (let item of _data["liabilityLoans"])
                  this.liabilityLoans!.push(FactFindLiabilityLoan.fromJS(item));
          }
          if (Array.isArray(_data["liabilityMortgages"])) {
              this.liabilityMortgages = [] as any;
              for (let item of _data["liabilityMortgages"])
                  this.liabilityMortgages!.push(FactFindPolicy.fromJS(item));
          }
      }
  }

  static fromJS(data: any): ProductProvider {
      data = typeof data === 'object' ? data : {};
      let result = new ProductProvider();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.liabilityLoans)) {
          data["liabilityLoans"] = [];
          for (let item of this.liabilityLoans)
              data["liabilityLoans"].push(item.toJSON());
      }
      if (Array.isArray(this.liabilityMortgages)) {
          data["liabilityMortgages"] = [];
          for (let item of this.liabilityMortgages)
              data["liabilityMortgages"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IProductProvider extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  liabilityLoans: FactFindLiabilityLoan[] | undefined;
  liabilityMortgages: FactFindPolicy[] | undefined;
}

export class FactFindLiabilityLoan extends _FactFindEntityBase implements IFactFindLiabilityLoan {
  id!: number;
  owner!: ClientSelector;
  lenderId!: number | undefined;
  lender!: ProductProvider | undefined;
  dateStarted!: string;
  termInYears!: number;
  amountBorrowed!: number;
  currentBalance!: number;
  monthlyRepayment!: number;
  annualPercentageRate!: number;
  monthlyOverpaymentAmount!: number;
  loanProtectedId!: number | undefined;
  loanProtected!: YesNoDefault | undefined;
  monthlyProtectionAmount!: number;

  constructor(data?: IFactFindLiabilityLoan) {
      super(data);
      if (data) {
          this.lender = data.lender && !(<any>data.lender).toJSON ? new ProductProvider(data.lender) : <ProductProvider>this.lender;
          this.loanProtected = data.loanProtected && !(<any>data.loanProtected).toJSON ? new YesNoDefault(data.loanProtected) : <YesNoDefault>this.loanProtected;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.owner = _data["owner"];
          this.lenderId = _data["lenderId"];
          this.lender = _data["lender"] ? ProductProvider.fromJS(_data["lender"]) : <any>undefined;
          this.dateStarted = _data["dateStarted"];
          this.termInYears = _data["termInYears"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.currentBalance = _data["currentBalance"];
          this.monthlyRepayment = _data["monthlyRepayment"];
          this.annualPercentageRate = _data["annualPercentageRate"];
          this.monthlyOverpaymentAmount = _data["monthlyOverpaymentAmount"];
          this.loanProtectedId = _data["loanProtectedId"];
          this.loanProtected = _data["loanProtected"] ? YesNoDefault.fromJS(_data["loanProtected"]) : <any>undefined;
          this.monthlyProtectionAmount = _data["monthlyProtectionAmount"];
      }
  }

  static fromJS(data: any): FactFindLiabilityLoan {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindLiabilityLoan();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["owner"] = this.owner;
      data["lenderId"] = this.lenderId;
      data["lender"] = this.lender ? this.lender.toJSON() : <any>undefined;
      data["dateStarted"] = this.dateStarted;
      data["termInYears"] = this.termInYears;
      data["amountBorrowed"] = this.amountBorrowed;
      data["currentBalance"] = this.currentBalance;
      data["monthlyRepayment"] = this.monthlyRepayment;
      data["annualPercentageRate"] = this.annualPercentageRate;
      data["monthlyOverpaymentAmount"] = this.monthlyOverpaymentAmount;
      data["loanProtectedId"] = this.loanProtectedId;
      data["loanProtected"] = this.loanProtected ? this.loanProtected.toJSON() : <any>undefined;
      data["monthlyProtectionAmount"] = this.monthlyProtectionAmount;
      super.toJSON(data);
      return data;
  }
}

export interface IFactFindLiabilityLoan extends I_FactFindEntityBase {
  id: number;
  owner: ClientSelector;
  lenderId: number | undefined;
  lender: IProductProvider | undefined;
  dateStarted: string;
  termInYears: number;
  amountBorrowed: number;
  currentBalance: number;
  monthlyRepayment: number;
  annualPercentageRate: number;
  monthlyOverpaymentAmount: number;
  loanProtectedId: number | undefined;
  loanProtected: IYesNoDefault | undefined;
  monthlyProtectionAmount: number;
}

export class PaymentMethod extends _LookupBase implements IPaymentMethod {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  expenses!: FactFindExpense[] | undefined;
  policies!: FactFindPolicy[] | undefined;

  constructor(data?: IPaymentMethod) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["expenses"])) {
              this.expenses = [] as any;
              for (let item of _data["expenses"])
                  this.expenses!.push(FactFindExpense.fromJS(item));
          }
          if (Array.isArray(_data["policies"])) {
              this.policies = [] as any;
              for (let item of _data["policies"])
                  this.policies!.push(FactFindPolicy.fromJS(item));
          }
      }
  }

  static fromJS(data: any): PaymentMethod {
      data = typeof data === 'object' ? data : {};
      let result = new PaymentMethod();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.expenses)) {
          data["expenses"] = [];
          for (let item of this.expenses)
              data["expenses"].push(item.toJSON());
      }
      if (Array.isArray(this.policies)) {
          data["policies"] = [];
          for (let item of this.policies)
              data["policies"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IPaymentMethod extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  expenses: FactFindExpense[] | undefined;
  policies: FactFindPolicy[] | undefined;
}

export class FactFindExpense extends _FactFindEntityBase implements IFactFindExpense {
  id!: number;
  client!: ClientSelector;
  expenseTypeId!: number;
  expenseType!: ExpenseType | undefined;
  expenseAmount!: number;
  monthlyExpenseAmount!: number;
  paymentFrequencyId!: number | undefined;
  paymentFrequency!: PaymentFrequency | undefined;
  paymentMethodId!: number | undefined;
  paymentMethod!: PaymentMethod | undefined;

  constructor(data?: IFactFindExpense) {
      super(data);
      if (data) {
          this.expenseType = data.expenseType && !(<any>data.expenseType).toJSON ? new ExpenseType(data.expenseType) : <ExpenseType>this.expenseType;
          this.paymentFrequency = data.paymentFrequency && !(<any>data.paymentFrequency).toJSON ? new PaymentFrequency(data.paymentFrequency) : <PaymentFrequency>this.paymentFrequency;
          this.paymentMethod = data.paymentMethod && !(<any>data.paymentMethod).toJSON ? new PaymentMethod(data.paymentMethod) : <PaymentMethod>this.paymentMethod;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.client = _data["client"];
          this.expenseTypeId = _data["expenseTypeId"];
          this.expenseType = _data["expenseType"] ? ExpenseType.fromJS(_data["expenseType"]) : <any>undefined;
          this.expenseAmount = _data["expenseAmount"];
          this.monthlyExpenseAmount = _data["monthlyExpenseAmount"];
          this.paymentFrequencyId = _data["paymentFrequencyId"];
          this.paymentFrequency = _data["paymentFrequency"] ? PaymentFrequency.fromJS(_data["paymentFrequency"]) : <any>undefined;
          this.paymentMethodId = _data["paymentMethodId"];
          this.paymentMethod = _data["paymentMethod"] ? PaymentMethod.fromJS(_data["paymentMethod"]) : <any>undefined;
      }
  }

  static fromJS(data: any): FactFindExpense {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindExpense();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["client"] = this.client;
      data["expenseTypeId"] = this.expenseTypeId;
      data["expenseType"] = this.expenseType ? this.expenseType.toJSON() : <any>undefined;
      data["expenseAmount"] = this.expenseAmount;
      data["monthlyExpenseAmount"] = this.monthlyExpenseAmount;
      data["paymentFrequencyId"] = this.paymentFrequencyId;
      data["paymentFrequency"] = this.paymentFrequency ? this.paymentFrequency.toJSON() : <any>undefined;
      data["paymentMethodId"] = this.paymentMethodId;
      data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
      super.toJSON(data);
      return data;
  }
}

export interface IFactFindExpense extends I_FactFindEntityBase {
  id: number;
  client: ClientSelector;
  expenseTypeId: number;
  expenseType: IExpenseType | undefined;
  expenseAmount: number;
  monthlyExpenseAmount: number;
  paymentFrequencyId: number | undefined;
  paymentFrequency: IPaymentFrequency | undefined;
  paymentMethodId: number | undefined;
  paymentMethod: IPaymentMethod | undefined;
}

export class ExpenseType extends _LookupBase implements IExpenseType {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  expenses!: FactFindExpense[] | undefined;

  constructor(data?: IExpenseType) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["expenses"])) {
              this.expenses = [] as any;
              for (let item of _data["expenses"])
                  this.expenses!.push(FactFindExpense.fromJS(item));
          }
      }
  }

  static fromJS(data: any): ExpenseType {
      data = typeof data === 'object' ? data : {};
      let result = new ExpenseType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.expenses)) {
          data["expenses"] = [];
          for (let item of this.expenses)
              data["expenses"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IExpenseType extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  expenses: FactFindExpense[] | undefined;
}

export class PaymentFrequency extends _LookupBase implements IPaymentFrequency {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  expenses!: FactFindExpense[] | undefined;
  mortgageLiability!: FactFindPolicy[] | undefined;

  constructor(data?: IPaymentFrequency) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["expenses"])) {
              this.expenses = [] as any;
              for (let item of _data["expenses"])
                  this.expenses!.push(FactFindExpense.fromJS(item));
          }
          if (Array.isArray(_data["mortgageLiability"])) {
              this.mortgageLiability = [] as any;
              for (let item of _data["mortgageLiability"])
                  this.mortgageLiability!.push(FactFindPolicy.fromJS(item));
          }
      }
  }

  static fromJS(data: any): PaymentFrequency {
      data = typeof data === 'object' ? data : {};
      let result = new PaymentFrequency();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.expenses)) {
          data["expenses"] = [];
          for (let item of this.expenses)
              data["expenses"].push(item.toJSON());
      }
      if (Array.isArray(this.mortgageLiability)) {
          data["mortgageLiability"] = [];
          for (let item of this.mortgageLiability)
              data["mortgageLiability"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IPaymentFrequency extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  expenses: FactFindExpense[] | undefined;
  mortgageLiability: FactFindPolicy[] | undefined;
}

export class PolicyBasis extends _LookupBase implements IPolicyBasis {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  company!: Company | undefined;

  constructor(data?: IPolicyBasis) {
      super(data);
      if (data) {
          this.company = data.company && !(<any>data.company).toJSON ? new Company(data.company) : <Company>this.company;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
      }
  }

  static fromJS(data: any): PolicyBasis {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyBasis();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      data["company"] = this.company ? this.company.toJSON() : <any>undefined;
      super.toJSON(data);
      return data;
  }
}

export interface IPolicyBasis extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  company: ICompany | undefined;
}

export class Company implements ICompany {
  id!: number;
  name!: string | undefined;
  tradingAs!: string | undefined;
  addressLine1!: string | undefined;
  addressLine2!: string | undefined;
  addressLine3!: string | undefined;
  countyId!: number | undefined;
  county!: County | undefined;
  countryId!: number | undefined;
  country!: Country | undefined;
  vatNo!: string | undefined;
  phoneNo!: string | undefined;
  email!: string | undefined;
  website!: string | undefined;
  logo!: string | undefined;
  logoFilePath!: string | undefined;
  reportFooterText!: string | undefined;
  mobileNo!: string | undefined;
  accountCode!: string | undefined;
  complianceAreaTypes!: ComplianceAreaType[] | undefined;
  complianceItemTypes!: ComplianceItemType[] | undefined;

  constructor(data?: ICompany) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.county = data.county && !(<any>data.county).toJSON ? new County(data.county) : <County>this.county;
          this.country = data.country && !(<any>data.country).toJSON ? new Country(data.country) : <Country>this.country;
          if (data.complianceAreaTypes) {
              this.complianceAreaTypes = [];
              for (let i = 0; i < data.complianceAreaTypes.length; i++) {
                  let item = data.complianceAreaTypes[i];
                  this.complianceAreaTypes[i] = item && !(<any>item).toJSON ? new ComplianceAreaType(item) : <ComplianceAreaType>item;
              }
          }
          if (data.complianceItemTypes) {
              this.complianceItemTypes = [];
              for (let i = 0; i < data.complianceItemTypes.length; i++) {
                  let item = data.complianceItemTypes[i];
                  this.complianceItemTypes[i] = item && !(<any>item).toJSON ? new ComplianceItemType(item) : <ComplianceItemType>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.tradingAs = _data["tradingAs"];
          this.addressLine1 = _data["addressLine1"];
          this.addressLine2 = _data["addressLine2"];
          this.addressLine3 = _data["addressLine3"];
          this.countyId = _data["countyId"];
          this.county = _data["county"] ? County.fromJS(_data["county"]) : <any>undefined;
          this.countryId = _data["countryId"];
          this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
          this.vatNo = _data["vatNo"];
          this.phoneNo = _data["phoneNo"];
          this.email = _data["email"];
          this.website = _data["website"];
          this.logo = _data["logo"];
          this.logoFilePath = _data["logoFilePath"];
          this.reportFooterText = _data["reportFooterText"];
          this.mobileNo = _data["mobileNo"];
          this.accountCode = _data["accountCode"];
          if (Array.isArray(_data["complianceAreaTypes"])) {
              this.complianceAreaTypes = [] as any;
              for (let item of _data["complianceAreaTypes"])
                  this.complianceAreaTypes!.push(ComplianceAreaType.fromJS(item));
          }
          if (Array.isArray(_data["complianceItemTypes"])) {
              this.complianceItemTypes = [] as any;
              for (let item of _data["complianceItemTypes"])
                  this.complianceItemTypes!.push(ComplianceItemType.fromJS(item));
          }
      }
  }

  static fromJS(data: any): Company {
      data = typeof data === 'object' ? data : {};
      let result = new Company();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["tradingAs"] = this.tradingAs;
      data["addressLine1"] = this.addressLine1;
      data["addressLine2"] = this.addressLine2;
      data["addressLine3"] = this.addressLine3;
      data["countyId"] = this.countyId;
      data["county"] = this.county ? this.county.toJSON() : <any>undefined;
      data["countryId"] = this.countryId;
      data["country"] = this.country ? this.country.toJSON() : <any>undefined;
      data["vatNo"] = this.vatNo;
      data["phoneNo"] = this.phoneNo;
      data["email"] = this.email;
      data["website"] = this.website;
      data["logo"] = this.logo;
      data["logoFilePath"] = this.logoFilePath;
      data["reportFooterText"] = this.reportFooterText;
      data["mobileNo"] = this.mobileNo;
      data["accountCode"] = this.accountCode;
      if (Array.isArray(this.complianceAreaTypes)) {
          data["complianceAreaTypes"] = [];
          for (let item of this.complianceAreaTypes)
              data["complianceAreaTypes"].push(item.toJSON());
      }
      if (Array.isArray(this.complianceItemTypes)) {
          data["complianceItemTypes"] = [];
          for (let item of this.complianceItemTypes)
              data["complianceItemTypes"].push(item.toJSON());
      }
      return data;
  }
}

export interface ICompany {
  id: number;
  name: string | undefined;
  tradingAs: string | undefined;
  addressLine1: string | undefined;
  addressLine2: string | undefined;
  addressLine3: string | undefined;
  countyId: number | undefined;
  county: ICounty | undefined;
  countryId: number | undefined;
  country: ICountry | undefined;
  vatNo: string | undefined;
  phoneNo: string | undefined;
  email: string | undefined;
  website: string | undefined;
  logo: string | undefined;
  logoFilePath: string | undefined;
  reportFooterText: string | undefined;
  mobileNo: string | undefined;
  accountCode: string | undefined;
  complianceAreaTypes: IComplianceAreaType[] | undefined;
  complianceItemTypes: IComplianceItemType[] | undefined;
}

export class County extends _LookupBase implements ICounty {
  id!: number;
  name!: string | undefined;
  customSortId!: number;
  companyId!: number | undefined;
  mainContacts!: ContactProfile[] | undefined;
  spouseContacts!: ContactProfile[] | undefined;

  constructor(data?: ICounty) {
      super(data);
      if (data) {
          if (data.mainContacts) {
              this.mainContacts = [];
              for (let i = 0; i < data.mainContacts.length; i++) {
                  let item = data.mainContacts[i];
                  this.mainContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
          if (data.spouseContacts) {
              this.spouseContacts = [];
              for (let i = 0; i < data.spouseContacts.length; i++) {
                  let item = data.spouseContacts[i];
                  this.spouseContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.customSortId = _data["customSortId"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mainContacts"])) {
              this.mainContacts = [] as any;
              for (let item of _data["mainContacts"])
                  this.mainContacts!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["spouseContacts"])) {
              this.spouseContacts = [] as any;
              for (let item of _data["spouseContacts"])
                  this.spouseContacts!.push(ContactProfile.fromJS(item));
          }
      }
  }

  static fromJS(data: any): County {
      data = typeof data === 'object' ? data : {};
      let result = new County();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["customSortId"] = this.customSortId;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mainContacts)) {
          data["mainContacts"] = [];
          for (let item of this.mainContacts)
              data["mainContacts"].push(item.toJSON());
      }
      if (Array.isArray(this.spouseContacts)) {
          data["spouseContacts"] = [];
          for (let item of this.spouseContacts)
              data["spouseContacts"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface ICounty extends I_LookupBase {
  id: number;
  name: string | undefined;
  customSortId: number;
  companyId: number | undefined;
  mainContacts: IContactProfile[] | undefined;
  spouseContacts: IContactProfile[] | undefined;
}

export class Country extends _LookupBase implements ICountry {
  id!: number;
  name!: string | undefined;
  abbreviation!: string | undefined;
  companyId!: number | undefined;
  mainDomiciles!: ContactProfile[] | undefined;
  mainContacts!: ContactProfile[] | undefined;
  spouseDomiciles!: ContactProfile[] | undefined;
  spouseContacts!: ContactProfile[] | undefined;

  constructor(data?: ICountry) {
      super(data);
      if (data) {
          if (data.mainDomiciles) {
              this.mainDomiciles = [];
              for (let i = 0; i < data.mainDomiciles.length; i++) {
                  let item = data.mainDomiciles[i];
                  this.mainDomiciles[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
          if (data.mainContacts) {
              this.mainContacts = [];
              for (let i = 0; i < data.mainContacts.length; i++) {
                  let item = data.mainContacts[i];
                  this.mainContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
          if (data.spouseDomiciles) {
              this.spouseDomiciles = [];
              for (let i = 0; i < data.spouseDomiciles.length; i++) {
                  let item = data.spouseDomiciles[i];
                  this.spouseDomiciles[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
          if (data.spouseContacts) {
              this.spouseContacts = [];
              for (let i = 0; i < data.spouseContacts.length; i++) {
                  let item = data.spouseContacts[i];
                  this.spouseContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.abbreviation = _data["abbreviation"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mainDomiciles"])) {
              this.mainDomiciles = [] as any;
              for (let item of _data["mainDomiciles"])
                  this.mainDomiciles!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["mainContacts"])) {
              this.mainContacts = [] as any;
              for (let item of _data["mainContacts"])
                  this.mainContacts!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["spouseDomiciles"])) {
              this.spouseDomiciles = [] as any;
              for (let item of _data["spouseDomiciles"])
                  this.spouseDomiciles!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["spouseContacts"])) {
              this.spouseContacts = [] as any;
              for (let item of _data["spouseContacts"])
                  this.spouseContacts!.push(ContactProfile.fromJS(item));
          }
      }
  }

  static fromJS(data: any): Country {
      data = typeof data === 'object' ? data : {};
      let result = new Country();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["abbreviation"] = this.abbreviation;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mainDomiciles)) {
          data["mainDomiciles"] = [];
          for (let item of this.mainDomiciles)
              data["mainDomiciles"].push(item.toJSON());
      }
      if (Array.isArray(this.mainContacts)) {
          data["mainContacts"] = [];
          for (let item of this.mainContacts)
              data["mainContacts"].push(item.toJSON());
      }
      if (Array.isArray(this.spouseDomiciles)) {
          data["spouseDomiciles"] = [];
          for (let item of this.spouseDomiciles)
              data["spouseDomiciles"].push(item.toJSON());
      }
      if (Array.isArray(this.spouseContacts)) {
          data["spouseContacts"] = [];
          for (let item of this.spouseContacts)
              data["spouseContacts"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface ICountry extends I_LookupBase {
  id: number;
  name: string | undefined;
  abbreviation: string | undefined;
  companyId: number | undefined;
  mainDomiciles: IContactProfile[] | undefined;
  mainContacts: IContactProfile[] | undefined;
  spouseDomiciles: IContactProfile[] | undefined;
  spouseContacts: IContactProfile[] | undefined;
}

export class ComplianceAreaType implements IComplianceAreaType {
  id!: number;
  description!: string | undefined;
  companyId!: number;
  company!: Company | undefined;

  constructor(data?: IComplianceAreaType) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.company = data.company && !(<any>data.company).toJSON ? new Company(data.company) : <Company>this.company;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.description = _data["description"];
          this.companyId = _data["companyId"];
          this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
      }
  }

  static fromJS(data: any): ComplianceAreaType {
      data = typeof data === 'object' ? data : {};
      let result = new ComplianceAreaType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["description"] = this.description;
      data["companyId"] = this.companyId;
      data["company"] = this.company ? this.company.toJSON() : <any>undefined;
      return data;
  }
}

export interface IComplianceAreaType {
  id: number;
  description: string | undefined;
  companyId: number;
  company: ICompany | undefined;
}

export class ComplianceItemType implements IComplianceItemType {
  id!: number;
  complianceAreaTypeId!: number;
  complianceAreaType!: ComplianceAreaType | undefined;
  constantName!: string | undefined;
  description!: string | undefined;
  isMandatory!: boolean;
  companyId!: number;
  company!: Company | undefined;
  sortOrder!: number;

  constructor(data?: IComplianceItemType) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.complianceAreaType = data.complianceAreaType && !(<any>data.complianceAreaType).toJSON ? new ComplianceAreaType(data.complianceAreaType) : <ComplianceAreaType>this.complianceAreaType;
          this.company = data.company && !(<any>data.company).toJSON ? new Company(data.company) : <Company>this.company;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.complianceAreaTypeId = _data["complianceAreaTypeId"];
          this.complianceAreaType = _data["complianceAreaType"] ? ComplianceAreaType.fromJS(_data["complianceAreaType"]) : <any>undefined;
          this.constantName = _data["constantName"];
          this.description = _data["description"];
          this.isMandatory = _data["isMandatory"];
          this.companyId = _data["companyId"];
          this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
          this.sortOrder = _data["sortOrder"];
      }
  }

  static fromJS(data: any): ComplianceItemType {
      data = typeof data === 'object' ? data : {};
      let result = new ComplianceItemType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["complianceAreaTypeId"] = this.complianceAreaTypeId;
      data["complianceAreaType"] = this.complianceAreaType ? this.complianceAreaType.toJSON() : <any>undefined;
      data["constantName"] = this.constantName;
      data["description"] = this.description;
      data["isMandatory"] = this.isMandatory;
      data["companyId"] = this.companyId;
      data["company"] = this.company ? this.company.toJSON() : <any>undefined;
      data["sortOrder"] = this.sortOrder;
      return data;
  }
}

export interface IComplianceItemType {
  id: number;
  complianceAreaTypeId: number;
  complianceAreaType: IComplianceAreaType | undefined;
  constantName: string | undefined;
  description: string | undefined;
  isMandatory: boolean;
  companyId: number;
  company: ICompany | undefined;
  sortOrder: number;
}

export class PolicyStatus extends _LookupBase implements IPolicyStatus {
  id!: number;
  name!: string | undefined;
  masterCategoryId!: number | undefined;
  masterCategory!: MasterCategory | undefined;
  companyId!: number | undefined;

  constructor(data?: IPolicyStatus) {
      super(data);
      if (data) {
          this.masterCategory = data.masterCategory && !(<any>data.masterCategory).toJSON ? new MasterCategory(data.masterCategory) : <MasterCategory>this.masterCategory;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.masterCategoryId = _data["masterCategoryId"];
          this.masterCategory = _data["masterCategory"] ? MasterCategory.fromJS(_data["masterCategory"]) : <any>undefined;
          this.companyId = _data["companyId"];
      }
  }

  static fromJS(data: any): PolicyStatus {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyStatus();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["masterCategoryId"] = this.masterCategoryId;
      data["masterCategory"] = this.masterCategory ? this.masterCategory.toJSON() : <any>undefined;
      data["companyId"] = this.companyId;
      super.toJSON(data);
      return data;
  }
}

export interface IPolicyStatus extends I_LookupBase {
  id: number;
  name: string | undefined;
  masterCategoryId: number | undefined;
  masterCategory: IMasterCategory | undefined;
  companyId: number | undefined;
}

export class MasterCategory extends _LookupBase implements IMasterCategory {
  id!: number;
  name!: string | undefined;
  constant!: string | undefined;
  companyId!: number | undefined;

  constructor(data?: IMasterCategory) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.constant = _data["constant"];
          this.companyId = _data["companyId"];
      }
  }

  static fromJS(data: any): MasterCategory {
      data = typeof data === 'object' ? data : {};
      let result = new MasterCategory();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["constant"] = this.constant;
      data["companyId"] = this.companyId;
      super.toJSON(data);
      return data;
  }
}

export interface IMasterCategory extends I_LookupBase {
  id: number;
  name: string | undefined;
  constant: string | undefined;
  companyId: number | undefined;
}

export class ProductCategory extends _LookupBase implements IProductCategory {
  id!: number;
  name!: string | undefined;
  masterCategoryId!: number | undefined;
  masterCategory!: MasterCategory | undefined;
  companyId!: number | undefined;
  policies!: FactFindPolicy[] | undefined;

  constructor(data?: IProductCategory) {
      super(data);
      if (data) {
          this.masterCategory = data.masterCategory && !(<any>data.masterCategory).toJSON ? new MasterCategory(data.masterCategory) : <MasterCategory>this.masterCategory;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.masterCategoryId = _data["masterCategoryId"];
          this.masterCategory = _data["masterCategory"] ? MasterCategory.fromJS(_data["masterCategory"]) : <any>undefined;
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["policies"])) {
              this.policies = [] as any;
              for (let item of _data["policies"])
                  this.policies!.push(FactFindPolicy.fromJS(item));
          }
      }
  }

  static fromJS(data: any): ProductCategory {
      data = typeof data === 'object' ? data : {};
      let result = new ProductCategory();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["masterCategoryId"] = this.masterCategoryId;
      data["masterCategory"] = this.masterCategory ? this.masterCategory.toJSON() : <any>undefined;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.policies)) {
          data["policies"] = [];
          for (let item of this.policies)
              data["policies"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IProductCategory extends I_LookupBase {
  id: number;
  name: string | undefined;
  masterCategoryId: number | undefined;
  masterCategory: IMasterCategory | undefined;
  companyId: number | undefined;
  policies: FactFindPolicy[] | undefined;
}

export class ProductSubCategory implements IProductSubCategory {
  id!: number;
  productCategoryId!: number;
  productCategory!: ProductCategory | undefined;
  name!: string | undefined;
  policies!: FactFindPolicy[] | undefined;

  constructor(data?: IProductSubCategory) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.productCategory = data.productCategory && !(<any>data.productCategory).toJSON ? new ProductCategory(data.productCategory) : <ProductCategory>this.productCategory;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.productCategoryId = _data["productCategoryId"];
          this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>undefined;
          this.name = _data["name"];
          if (Array.isArray(_data["policies"])) {
              this.policies = [] as any;
              for (let item of _data["policies"])
                  this.policies!.push(FactFindPolicy.fromJS(item));
          }
      }
  }

  static fromJS(data: any): ProductSubCategory {
      data = typeof data === 'object' ? data : {};
      let result = new ProductSubCategory();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["productCategoryId"] = this.productCategoryId;
      data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
      data["name"] = this.name;
      if (Array.isArray(this.policies)) {
          data["policies"] = [];
          for (let item of this.policies)
              data["policies"].push(item.toJSON());
      }
      return data;
  }
}

export interface IProductSubCategory {
  id: number;
  productCategoryId: number;
  productCategory: IProductCategory | undefined;
  name: string | undefined;
  policies: FactFindPolicy[] | undefined;
}

export class PolicyBenefit implements IPolicyBenefit {
  id!: number;
  client!: ClientSelector;
  policyId!: number;
  policy!: FactFindPolicy | undefined;
  typeID!: number;
  type!: PolicyBenefitType | undefined;
  roleId!: number;
  role!: PolicyRole | undefined;
  statusId!: number | undefined;
  status!: PolicyStatus | undefined;
  benefitAmount!: number | undefined;
  benefitNotes!: string | undefined;

  constructor(data?: IPolicyBenefit) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.policy = data.policy && !(<any>data.policy).toJSON ? new FactFindPolicy(data.policy) : <FactFindPolicy>this.policy;
          this.type = data.type && !(<any>data.type).toJSON ? new PolicyBenefitType(data.type) : <PolicyBenefitType>this.type;
          this.role = data.role && !(<any>data.role).toJSON ? new PolicyRole(data.role) : <PolicyRole>this.role;
          this.status = data.status && !(<any>data.status).toJSON ? new PolicyStatus(data.status) : <PolicyStatus>this.status;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.client = _data["client"];
          this.policyId = _data["policyId"];
          this.policy = _data["policy"] ? FactFindPolicy.fromJS(_data["policy"]) : <any>undefined;
          this.typeID = _data["typeID"];
          this.type = _data["type"] ? PolicyBenefitType.fromJS(_data["type"]) : <any>undefined;
          this.roleId = _data["roleId"];
          this.role = _data["role"] ? PolicyRole.fromJS(_data["role"]) : <any>undefined;
          this.statusId = _data["statusId"];
          this.status = _data["status"] ? PolicyStatus.fromJS(_data["status"]) : <any>undefined;
          this.benefitAmount = _data["benefitAmount"];
          this.benefitNotes = _data["benefitNotes"];
      }
  }

  static fromJS(data: any): PolicyBenefit {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyBenefit();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["client"] = this.client;
      data["policyId"] = this.policyId;
      data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
      data["typeID"] = this.typeID;
      data["type"] = this.type ? this.type.toJSON() : <any>undefined;
      data["roleId"] = this.roleId;
      data["role"] = this.role ? this.role.toJSON() : <any>undefined;
      data["statusId"] = this.statusId;
      data["status"] = this.status ? this.status.toJSON() : <any>undefined;
      data["benefitAmount"] = this.benefitAmount;
      data["benefitNotes"] = this.benefitNotes;
      return data;
  }
}

export interface IPolicyBenefit {
  id: number;
  client: ClientSelector;
  policyId: number;
  policy: IFactFindPolicy | undefined;
  typeID: number;
  type: IPolicyBenefitType | undefined;
  roleId: number;
  role: IPolicyRole | undefined;
  statusId: number | undefined;
  status: IPolicyStatus | undefined;
  benefitAmount: number | undefined;
  benefitNotes: string | undefined;
}

export class PolicyBenefitType extends _LookupBase implements IPolicyBenefitType {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  policyBenefits!: PolicyBenefit[] | undefined;

  constructor(data?: IPolicyBenefitType) {
      super(data);
      if (data) {
          if (data.policyBenefits) {
              this.policyBenefits = [];
              for (let i = 0; i < data.policyBenefits.length; i++) {
                  let item = data.policyBenefits[i];
                  this.policyBenefits[i] = item && !(<any>item).toJSON ? new PolicyBenefit(item) : <PolicyBenefit>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["policyBenefits"])) {
              this.policyBenefits = [] as any;
              for (let item of _data["policyBenefits"])
                  this.policyBenefits!.push(PolicyBenefit.fromJS(item));
          }
      }
  }

  static fromJS(data: any): PolicyBenefitType {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyBenefitType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.policyBenefits)) {
          data["policyBenefits"] = [];
          for (let item of this.policyBenefits)
              data["policyBenefits"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IPolicyBenefitType extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  policyBenefits: IPolicyBenefit[] | undefined;
}

export class PolicyFund implements IPolicyFund {
  id!: number;
  policyId!: number | undefined;
  policy!: FactFindPolicy | undefined;
  typeID!: number | undefined;
  type!: PolicyFundType | undefined;
  rateId!: number | undefined;
  rate!: PolicyFundRate | undefined;
  description!: string | undefined;
  value!: number | undefined;
  valueDate!: string | undefined;
  notes!: string | undefined;

  constructor(data?: IPolicyFund) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.policy = data.policy && !(<any>data.policy).toJSON ? new FactFindPolicy(data.policy) : <FactFindPolicy>this.policy;
          this.type = data.type && !(<any>data.type).toJSON ? new PolicyFundType(data.type) : <PolicyFundType>this.type;
          this.rate = data.rate && !(<any>data.rate).toJSON ? new PolicyFundRate(data.rate) : <PolicyFundRate>this.rate;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.policyId = _data["policyId"];
          this.policy = _data["policy"] ? FactFindPolicy.fromJS(_data["policy"]) : <any>undefined;
          this.typeID = _data["typeID"];
          this.type = _data["type"] ? PolicyFundType.fromJS(_data["type"]) : <any>undefined;
          this.rateId = _data["rateId"];
          this.rate = _data["rate"] ? PolicyFundRate.fromJS(_data["rate"]) : <any>undefined;
          this.description = _data["description"];
          this.value = _data["value"];
          this.valueDate = _data["valueDate"];
          this.notes = _data["notes"];
      }
  }

  static fromJS(data: any): PolicyFund {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyFund();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["policyId"] = this.policyId;
      data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
      data["typeID"] = this.typeID;
      data["type"] = this.type ? this.type.toJSON() : <any>undefined;
      data["rateId"] = this.rateId;
      data["rate"] = this.rate ? this.rate.toJSON() : <any>undefined;
      data["description"] = this.description;
      data["value"] = this.value;
      data["valueDate"] = this.valueDate;
      data["notes"] = this.notes;
      return data;
  }
}

export interface IPolicyFund {
  id: number;
  policyId: number | undefined;
  policy: IFactFindPolicy | undefined;
  typeID: number | undefined;
  type: IPolicyFundType | undefined;
  rateId: number | undefined;
  rate: IPolicyFundRate | undefined;
  description: string | undefined;
  value: number | undefined;
  valueDate: string | undefined;
  notes: string | undefined;
}

export class PolicyFundType implements IPolicyFundType {
  id!: number;
  name!: string | undefined;
  policyFunds!: PolicyFund[] | undefined;

  constructor(data?: IPolicyFundType) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          if (data.policyFunds) {
              this.policyFunds = [];
              for (let i = 0; i < data.policyFunds.length; i++) {
                  let item = data.policyFunds[i];
                  this.policyFunds[i] = item && !(<any>item).toJSON ? new PolicyFund(item) : <PolicyFund>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          if (Array.isArray(_data["policyFunds"])) {
              this.policyFunds = [] as any;
              for (let item of _data["policyFunds"])
                  this.policyFunds!.push(PolicyFund.fromJS(item));
          }
      }
  }

  static fromJS(data: any): PolicyFundType {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyFundType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      if (Array.isArray(this.policyFunds)) {
          data["policyFunds"] = [];
          for (let item of this.policyFunds)
              data["policyFunds"].push(item.toJSON());
      }
      return data;
  }
}

export interface IPolicyFundType {
  id: number;
  name: string | undefined;
  policyFunds: IPolicyFund[] | undefined;
}

export class PolicyFundRate implements IPolicyFundRate {
  id!: number;
  fundId!: number;
  fund!: Fund | undefined;
  unitPrice!: number | undefined;
  unitPriceAccum!: number | undefined;
  valueDate!: string | undefined;

  constructor(data?: IPolicyFundRate) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.fund = data.fund && !(<any>data.fund).toJSON ? new Fund(data.fund) : <Fund>this.fund;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.fundId = _data["fundId"];
          this.fund = _data["fund"] ? Fund.fromJS(_data["fund"]) : <any>undefined;
          this.unitPrice = _data["unitPrice"];
          this.unitPriceAccum = _data["unitPriceAccum"];
          this.valueDate = _data["valueDate"];
      }
  }

  static fromJS(data: any): PolicyFundRate {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyFundRate();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["fundId"] = this.fundId;
      data["fund"] = this.fund ? this.fund.toJSON() : <any>undefined;
      data["unitPrice"] = this.unitPrice;
      data["unitPriceAccum"] = this.unitPriceAccum;
      data["valueDate"] = this.valueDate;
      return data;
  }
}

export interface IPolicyFundRate {
  id: number;
  fundId: number;
  fund: IFund | undefined;
  unitPrice: number | undefined;
  unitPriceAccum: number | undefined;
  valueDate: string | undefined;
}

export class Fund implements IFund {
  id!: number;
  lifeCompany!: string | undefined;
  description!: string | undefined;
  code!: string | undefined;
  isDF!: number | undefined;
  fk_ImportedID!: number | undefined;

  constructor(data?: IFund) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.lifeCompany = _data["lifeCompany"];
          this.description = _data["description"];
          this.code = _data["code"];
          this.isDF = _data["isDF"];
          this.fk_ImportedID = _data["fk_ImportedID"];
      }
  }

  static fromJS(data: any): Fund {
      data = typeof data === 'object' ? data : {};
      let result = new Fund();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["lifeCompany"] = this.lifeCompany;
      data["description"] = this.description;
      data["code"] = this.code;
      data["isDF"] = this.isDF;
      data["fk_ImportedID"] = this.fk_ImportedID;
      return data;
  }
}

export interface IFund {
  id: number;
  lifeCompany: string | undefined;
  description: string | undefined;
  code: string | undefined;
  isDF: number | undefined;
  fk_ImportedID: number | undefined;
}

export class ContactDocument implements IContactDocument {
  id!: number;
  contactId!: number;
  contact!: ContactProfile | undefined;
  opportunityId!: number | undefined;
  opportunity!: Opportunity | undefined;
  policyId!: number | undefined;
  policy!: FactFindPolicy | undefined;
  contactOwnerId!: number;
  contactOwner!: ContactOwnerProfile | undefined;
  activityId!: number | undefined;
  activity!: Activity | undefined;
  taskId!: number | undefined;
  documentFullPath!: string | undefined;
  dateAndTimeAdded!: string;
  documentNote!: string | undefined;
  documentCategoryTypeID!: number;
  documentType!: DocumentType | undefined;
  clientSelector!: ClientSelector;
  isSharedFile!: boolean;
  nodeID!: number;
  contactOwnerId_ModifiedBy!: number | undefined;
  contactOwner_ModifiedBy!: ContactOwnerProfile | undefined;
  dateAndTimeModified!: string | undefined;
  fK_ComplaintID!: number | undefined;

  constructor(data?: IContactDocument) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.contact = data.contact && !(<any>data.contact).toJSON ? new ContactProfile(data.contact) : <ContactProfile>this.contact;
          this.opportunity = data.opportunity && !(<any>data.opportunity).toJSON ? new Opportunity(data.opportunity) : <Opportunity>this.opportunity;
          this.policy = data.policy && !(<any>data.policy).toJSON ? new FactFindPolicy(data.policy) : <FactFindPolicy>this.policy;
          this.contactOwner = data.contactOwner && !(<any>data.contactOwner).toJSON ? new ContactOwnerProfile(data.contactOwner) : <ContactOwnerProfile>this.contactOwner;
          this.activity = data.activity && !(<any>data.activity).toJSON ? new Activity(data.activity) : <Activity>this.activity;
          this.documentType = data.documentType && !(<any>data.documentType).toJSON ? new DocumentType(data.documentType) : <DocumentType>this.documentType;
          this.contactOwner_ModifiedBy = data.contactOwner_ModifiedBy && !(<any>data.contactOwner_ModifiedBy).toJSON ? new ContactOwnerProfile(data.contactOwner_ModifiedBy) : <ContactOwnerProfile>this.contactOwner_ModifiedBy;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.contactId = _data["contactId"];
          this.contact = _data["contact"] ? ContactProfile.fromJS(_data["contact"]) : <any>undefined;
          this.opportunityId = _data["opportunityId"];
          this.opportunity = _data["opportunity"] ? Opportunity.fromJS(_data["opportunity"]) : <any>undefined;
          this.policyId = _data["policyId"];
          this.policy = _data["policy"] ? FactFindPolicy.fromJS(_data["policy"]) : <any>undefined;
          this.contactOwnerId = _data["contactOwnerId"];
          this.contactOwner = _data["contactOwner"] ? ContactOwnerProfile.fromJS(_data["contactOwner"]) : <any>undefined;
          this.activityId = _data["activityId"];
          this.activity = _data["activity"] ? Activity.fromJS(_data["activity"]) : <any>undefined;
          this.taskId = _data["taskId"];
          this.documentFullPath = _data["documentFullPath"];
          this.dateAndTimeAdded = _data["dateAndTimeAdded"];
          this.documentNote = _data["documentNote"];
          this.documentCategoryTypeID = _data["documentCategoryTypeID"];
          this.documentType = _data["documentType"] ? DocumentType.fromJS(_data["documentType"]) : <any>undefined;
          this.clientSelector = _data["clientSelector"];
          this.isSharedFile = _data["isSharedFile"];
          this.nodeID = _data["nodeID"];
          this.contactOwnerId_ModifiedBy = _data["contactOwnerId_ModifiedBy"];
          this.contactOwner_ModifiedBy = _data["contactOwner_ModifiedBy"] ? ContactOwnerProfile.fromJS(_data["contactOwner_ModifiedBy"]) : <any>undefined;
          this.dateAndTimeModified = _data["dateAndTimeModified"];
          this.fK_ComplaintID = _data["fK_ComplaintID"];
      }
  }

  static fromJS(data: any): ContactDocument {
      data = typeof data === 'object' ? data : {};
      let result = new ContactDocument();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["contactId"] = this.contactId;
      data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
      data["opportunityId"] = this.opportunityId;
      data["opportunity"] = this.opportunity ? this.opportunity.toJSON() : <any>undefined;
      data["policyId"] = this.policyId;
      data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
      data["contactOwnerId"] = this.contactOwnerId;
      data["contactOwner"] = this.contactOwner ? this.contactOwner.toJSON() : <any>undefined;
      data["activityId"] = this.activityId;
      data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
      data["taskId"] = this.taskId;
      data["documentFullPath"] = this.documentFullPath;
      data["dateAndTimeAdded"] = this.dateAndTimeAdded;
      data["documentNote"] = this.documentNote;
      data["documentCategoryTypeID"] = this.documentCategoryTypeID;
      data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
      data["clientSelector"] = this.clientSelector;
      data["isSharedFile"] = this.isSharedFile;
      data["nodeID"] = this.nodeID;
      data["contactOwnerId_ModifiedBy"] = this.contactOwnerId_ModifiedBy;
      data["contactOwner_ModifiedBy"] = this.contactOwner_ModifiedBy ? this.contactOwner_ModifiedBy.toJSON() : <any>undefined;
      data["dateAndTimeModified"] = this.dateAndTimeModified;
      data["fK_ComplaintID"] = this.fK_ComplaintID;
      return data;
  }
}

export interface IContactDocument {
  id: number;
  contactId: number;
  contact: IContactProfile | undefined;
  opportunityId: number | undefined;
  opportunity: IOpportunity | undefined;
  policyId: number | undefined;
  policy: IFactFindPolicy | undefined;
  contactOwnerId: number;
  contactOwner: IContactOwnerProfile | undefined;
  activityId: number | undefined;
  activity: IActivity | undefined;
  taskId: number | undefined;
  documentFullPath: string | undefined;
  dateAndTimeAdded: string;
  documentNote: string | undefined;
  documentCategoryTypeID: number;
  documentType: IDocumentType | undefined;
  clientSelector: ClientSelector;
  isSharedFile: boolean;
  nodeID: number;
  contactOwnerId_ModifiedBy: number | undefined;
  contactOwner_ModifiedBy: IContactOwnerProfile | undefined;
  dateAndTimeModified: string | undefined;
  fK_ComplaintID: number | undefined;
}

export class Opportunity implements IOpportunity {
  id!: number;
  dateCreated!: string | undefined;
  nextActionDate!: string | undefined;
  opportunityOwner!: ClientSelector;
  contactOwnerId!: number;
  contactOwner!: ContactOwnerProfile | undefined;
  contactId!: number;
  contact!: ContactProfile | undefined;
  masterProductId!: number;
  masterProduct!: ProductCategory | undefined;
  providerId!: number;
  provider!: ProductProvider | undefined;
  productDetail!: string | undefined;
  amount!: number;
  amountLumpSum!: number;
  amountRegularPremium!: number;
  opportunityStageId!: number;
  opportunityStage!: OpportunityStage | undefined;
  stageDate!: string | undefined;
  opportunityPercentId!: number;
  opportunityPercent!: OpportunityPercent | undefined;
  revenue!: number;
  revenueDate!: string | undefined;
  actualRevenueBankedAmount!: number;
  actualRevenueBankedDate!: string | undefined;
  paidToConsultant!: boolean;
  datePaidToConsultant!: string | undefined;
  fK_CompanyID_Import!: number;
  fK_ImportedID!: number;
  policyNumber!: string | undefined;
  fK_BusinessReferrerID!: number;
  fK_RecurrenceID!: number;
  fK_ImportID_Dynamics!: string;
  fK_SubProductID!: number;
  fK_RevenueCurrencyID!: number;
  fK_ContactPolicyID!: number;
  fK_ContactDepositID!: number;
  depositAccount!: string | undefined;
  expectedCommissionDayOne!: number;
  issueDayCommission!: number;
  commissionPaid!: number;
  variance!: number;
  fundsReceivedAmount!: number;
  fK_FundsReceivedCurrencyID!: number;
  fxRate!: number;
  convertedDate!: string | undefined;
  convertedAmount!: number;
  conversionOption!: boolean;
  fK_CreatedByOwnerID!: number;
  fK_AppointmentSetterID!: number;
  totalPaymentAmount!: number;
  feeBasis!: number;
  platformCase!: boolean;
  includePercentLevy!: boolean;
  isPrivate!: boolean;
  notes!: string | undefined;
  nextAction!: string | undefined;
  complianceItems!: ContactComplianceItem[] | undefined;

  constructor(data?: IOpportunity) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.contactOwner = data.contactOwner && !(<any>data.contactOwner).toJSON ? new ContactOwnerProfile(data.contactOwner) : <ContactOwnerProfile>this.contactOwner;
          this.contact = data.contact && !(<any>data.contact).toJSON ? new ContactProfile(data.contact) : <ContactProfile>this.contact;
          this.masterProduct = data.masterProduct && !(<any>data.masterProduct).toJSON ? new ProductCategory(data.masterProduct) : <ProductCategory>this.masterProduct;
          this.provider = data.provider && !(<any>data.provider).toJSON ? new ProductProvider(data.provider) : <ProductProvider>this.provider;
          this.opportunityStage = data.opportunityStage && !(<any>data.opportunityStage).toJSON ? new OpportunityStage(data.opportunityStage) : <OpportunityStage>this.opportunityStage;
          this.opportunityPercent = data.opportunityPercent && !(<any>data.opportunityPercent).toJSON ? new OpportunityPercent(data.opportunityPercent) : <OpportunityPercent>this.opportunityPercent;
          if (data.complianceItems) {
              this.complianceItems = [];
              for (let i = 0; i < data.complianceItems.length; i++) {
                  let item = data.complianceItems[i];
                  this.complianceItems[i] = item && !(<any>item).toJSON ? new ContactComplianceItem(item) : <ContactComplianceItem>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.dateCreated = _data["dateCreated"];
          this.nextActionDate = _data["nextActionDate"];
          this.opportunityOwner = _data["opportunityOwner"];
          this.contactOwnerId = _data["contactOwnerId"];
          this.contactOwner = _data["contactOwner"] ? ContactOwnerProfile.fromJS(_data["contactOwner"]) : <any>undefined;
          this.contactId = _data["contactId"];
          this.contact = _data["contact"] ? ContactProfile.fromJS(_data["contact"]) : <any>undefined;
          this.masterProductId = _data["masterProductId"];
          this.masterProduct = _data["masterProduct"] ? ProductCategory.fromJS(_data["masterProduct"]) : <any>undefined;
          this.providerId = _data["providerId"];
          this.provider = _data["provider"] ? ProductProvider.fromJS(_data["provider"]) : <any>undefined;
          this.productDetail = _data["productDetail"];
          this.amount = _data["amount"];
          this.amountLumpSum = _data["amountLumpSum"];
          this.amountRegularPremium = _data["amountRegularPremium"];
          this.opportunityStageId = _data["opportunityStageId"];
          this.opportunityStage = _data["opportunityStage"] ? OpportunityStage.fromJS(_data["opportunityStage"]) : <any>undefined;
          this.stageDate = _data["stageDate"];
          this.opportunityPercentId = _data["opportunityPercentId"];
          this.opportunityPercent = _data["opportunityPercent"] ? OpportunityPercent.fromJS(_data["opportunityPercent"]) : <any>undefined;
          this.revenue = _data["revenue"];
          this.revenueDate = _data["revenueDate"];
          this.actualRevenueBankedAmount = _data["actualRevenueBankedAmount"];
          this.actualRevenueBankedDate = _data["actualRevenueBankedDate"];
          this.paidToConsultant = _data["paidToConsultant"];
          this.datePaidToConsultant = _data["datePaidToConsultant"];
          this.fK_CompanyID_Import = _data["fK_CompanyID_Import"];
          this.fK_ImportedID = _data["fK_ImportedID"];
          this.policyNumber = _data["policyNumber"];
          this.fK_BusinessReferrerID = _data["fK_BusinessReferrerID"];
          this.fK_RecurrenceID = _data["fK_RecurrenceID"];
          this.fK_ImportID_Dynamics = _data["fK_ImportID_Dynamics"];
          this.fK_SubProductID = _data["fK_SubProductID"];
          this.fK_RevenueCurrencyID = _data["fK_RevenueCurrencyID"];
          this.fK_ContactPolicyID = _data["fK_ContactPolicyID"];
          this.fK_ContactDepositID = _data["fK_ContactDepositID"];
          this.depositAccount = _data["depositAccount"];
          this.expectedCommissionDayOne = _data["expectedCommissionDayOne"];
          this.issueDayCommission = _data["issueDayCommission"];
          this.commissionPaid = _data["commissionPaid"];
          this.variance = _data["variance"];
          this.fundsReceivedAmount = _data["fundsReceivedAmount"];
          this.fK_FundsReceivedCurrencyID = _data["fK_FundsReceivedCurrencyID"];
          this.fxRate = _data["fxRate"];
          this.convertedDate = _data["convertedDate"];
          this.convertedAmount = _data["convertedAmount"];
          this.conversionOption = _data["conversionOption"];
          this.fK_CreatedByOwnerID = _data["fK_CreatedByOwnerID"];
          this.fK_AppointmentSetterID = _data["fK_AppointmentSetterID"];
          this.totalPaymentAmount = _data["totalPaymentAmount"];
          this.feeBasis = _data["feeBasis"];
          this.platformCase = _data["platformCase"];
          this.includePercentLevy = _data["includePercentLevy"];
          this.isPrivate = _data["isPrivate"];
          this.notes = _data["notes"];
          this.nextAction = _data["nextAction"];
          if (Array.isArray(_data["complianceItems"])) {
              this.complianceItems = [] as any;
              for (let item of _data["complianceItems"])
                  this.complianceItems!.push(ContactComplianceItem.fromJS(item));
          }
      }
  }

  static fromJS(data: any): Opportunity {
      data = typeof data === 'object' ? data : {};
      let result = new Opportunity();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["dateCreated"] = this.dateCreated;
      data["nextActionDate"] = this.nextActionDate;
      data["opportunityOwner"] = this.opportunityOwner;
      data["contactOwnerId"] = this.contactOwnerId;
      data["contactOwner"] = this.contactOwner ? this.contactOwner.toJSON() : <any>undefined;
      data["contactId"] = this.contactId;
      data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
      data["masterProductId"] = this.masterProductId;
      data["masterProduct"] = this.masterProduct ? this.masterProduct.toJSON() : <any>undefined;
      data["providerId"] = this.providerId;
      data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
      data["productDetail"] = this.productDetail;
      data["amount"] = this.amount;
      data["amountLumpSum"] = this.amountLumpSum;
      data["amountRegularPremium"] = this.amountRegularPremium;
      data["opportunityStageId"] = this.opportunityStageId;
      data["opportunityStage"] = this.opportunityStage ? this.opportunityStage.toJSON() : <any>undefined;
      data["stageDate"] = this.stageDate;
      data["opportunityPercentId"] = this.opportunityPercentId;
      data["opportunityPercent"] = this.opportunityPercent ? this.opportunityPercent.toJSON() : <any>undefined;
      data["revenue"] = this.revenue;
      data["revenueDate"] = this.revenueDate;
      data["actualRevenueBankedAmount"] = this.actualRevenueBankedAmount;
      data["actualRevenueBankedDate"] = this.actualRevenueBankedDate;
      data["paidToConsultant"] = this.paidToConsultant;
      data["datePaidToConsultant"] = this.datePaidToConsultant;
      data["fK_CompanyID_Import"] = this.fK_CompanyID_Import;
      data["fK_ImportedID"] = this.fK_ImportedID;
      data["policyNumber"] = this.policyNumber;
      data["fK_BusinessReferrerID"] = this.fK_BusinessReferrerID;
      data["fK_RecurrenceID"] = this.fK_RecurrenceID;
      data["fK_ImportID_Dynamics"] = this.fK_ImportID_Dynamics;
      data["fK_SubProductID"] = this.fK_SubProductID;
      data["fK_RevenueCurrencyID"] = this.fK_RevenueCurrencyID;
      data["fK_ContactPolicyID"] = this.fK_ContactPolicyID;
      data["fK_ContactDepositID"] = this.fK_ContactDepositID;
      data["depositAccount"] = this.depositAccount;
      data["expectedCommissionDayOne"] = this.expectedCommissionDayOne;
      data["issueDayCommission"] = this.issueDayCommission;
      data["commissionPaid"] = this.commissionPaid;
      data["variance"] = this.variance;
      data["fundsReceivedAmount"] = this.fundsReceivedAmount;
      data["fK_FundsReceivedCurrencyID"] = this.fK_FundsReceivedCurrencyID;
      data["fxRate"] = this.fxRate;
      data["convertedDate"] = this.convertedDate;
      data["convertedAmount"] = this.convertedAmount;
      data["conversionOption"] = this.conversionOption;
      data["fK_CreatedByOwnerID"] = this.fK_CreatedByOwnerID;
      data["fK_AppointmentSetterID"] = this.fK_AppointmentSetterID;
      data["totalPaymentAmount"] = this.totalPaymentAmount;
      data["feeBasis"] = this.feeBasis;
      data["platformCase"] = this.platformCase;
      data["includePercentLevy"] = this.includePercentLevy;
      data["isPrivate"] = this.isPrivate;
      data["notes"] = this.notes;
      data["nextAction"] = this.nextAction;
      if (Array.isArray(this.complianceItems)) {
          data["complianceItems"] = [];
          for (let item of this.complianceItems)
              data["complianceItems"].push(item.toJSON());
      }
      return data;
  }
}

export interface IOpportunity {
  id: number;
  dateCreated: string | undefined;
  nextActionDate: string | undefined;
  opportunityOwner: ClientSelector;
  contactOwnerId: number;
  contactOwner: IContactOwnerProfile | undefined;
  contactId: number;
  contact: IContactProfile | undefined;
  masterProductId: number;
  masterProduct: IProductCategory | undefined;
  providerId: number;
  provider: IProductProvider | undefined;
  productDetail: string | undefined;
  amount: number;
  amountLumpSum: number;
  amountRegularPremium: number;
  opportunityStageId: number;
  opportunityStage: IOpportunityStage | undefined;
  stageDate: string | undefined;
  opportunityPercentId: number;
  opportunityPercent: IOpportunityPercent | undefined;
  revenue: number;
  revenueDate: string | undefined;
  actualRevenueBankedAmount: number;
  actualRevenueBankedDate: string | undefined;
  paidToConsultant: boolean;
  datePaidToConsultant: string | undefined;
  fK_CompanyID_Import: number;
  fK_ImportedID: number;
  policyNumber: string | undefined;
  fK_BusinessReferrerID: number;
  fK_RecurrenceID: number;
  fK_ImportID_Dynamics: string;
  fK_SubProductID: number;
  fK_RevenueCurrencyID: number;
  fK_ContactPolicyID: number;
  fK_ContactDepositID: number;
  depositAccount: string | undefined;
  expectedCommissionDayOne: number;
  issueDayCommission: number;
  commissionPaid: number;
  variance: number;
  fundsReceivedAmount: number;
  fK_FundsReceivedCurrencyID: number;
  fxRate: number;
  convertedDate: string | undefined;
  convertedAmount: number;
  conversionOption: boolean;
  fK_CreatedByOwnerID: number;
  fK_AppointmentSetterID: number;
  totalPaymentAmount: number;
  feeBasis: number;
  platformCase: boolean;
  includePercentLevy: boolean;
  isPrivate: boolean;
  notes: string | undefined;
  nextAction: string | undefined;
  complianceItems: IContactComplianceItem[] | undefined;
}

export class ContactOwnerProfile implements IContactOwnerProfile {
  id!: number;
  firstName!: string | undefined;
  lastName!: string | undefined;
  phone!: string | undefined;
  mobile!: string | undefined;
  email!: string | undefined;
  exchnageUserName!: string | undefined;
  exchangePassword!: string | undefined;
  companyId!: number;
  company!: Company | undefined;
  roleID!: number;
  securityRole!: SecurityRole | undefined;
  mainContacts!: ContactProfile[] | undefined;

  constructor(data?: IContactOwnerProfile) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.company = data.company && !(<any>data.company).toJSON ? new Company(data.company) : <Company>this.company;
          this.securityRole = data.securityRole && !(<any>data.securityRole).toJSON ? new SecurityRole(data.securityRole) : <SecurityRole>this.securityRole;
          if (data.mainContacts) {
              this.mainContacts = [];
              for (let i = 0; i < data.mainContacts.length; i++) {
                  let item = data.mainContacts[i];
                  this.mainContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          this.phone = _data["phone"];
          this.mobile = _data["mobile"];
          this.email = _data["email"];
          this.exchnageUserName = _data["exchnageUserName"];
          this.exchangePassword = _data["exchangePassword"];
          this.companyId = _data["companyId"];
          this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
          this.roleID = _data["roleID"];
          this.securityRole = _data["securityRole"] ? SecurityRole.fromJS(_data["securityRole"]) : <any>undefined;
          if (Array.isArray(_data["mainContacts"])) {
              this.mainContacts = [] as any;
              for (let item of _data["mainContacts"])
                  this.mainContacts!.push(ContactProfile.fromJS(item));
          }
      }
  }

  static fromJS(data: any): ContactOwnerProfile {
      data = typeof data === 'object' ? data : {};
      let result = new ContactOwnerProfile();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["phone"] = this.phone;
      data["mobile"] = this.mobile;
      data["email"] = this.email;
      data["exchnageUserName"] = this.exchnageUserName;
      data["exchangePassword"] = this.exchangePassword;
      data["companyId"] = this.companyId;
      data["company"] = this.company ? this.company.toJSON() : <any>undefined;
      data["roleID"] = this.roleID;
      data["securityRole"] = this.securityRole ? this.securityRole.toJSON() : <any>undefined;
      if (Array.isArray(this.mainContacts)) {
          data["mainContacts"] = [];
          for (let item of this.mainContacts)
              data["mainContacts"].push(item.toJSON());
      }
      return data;
  }
}

export interface IContactOwnerProfile {
  id: number;
  firstName: string | undefined;
  lastName: string | undefined;
  phone: string | undefined;
  mobile: string | undefined;
  email: string | undefined;
  exchnageUserName: string | undefined;
  exchangePassword: string | undefined;
  companyId: number;
  company: ICompany | undefined;
  roleID: number;
  securityRole: ISecurityRole | undefined;
  mainContacts: IContactProfile[] | undefined;
}

export class SecurityRole implements ISecurityRole {
  id!: number;
  name!: string | undefined;
  description!: string | undefined;
  securityRolePermissions!: SecurityRolePermissions[] | undefined;

  constructor(data?: ISecurityRole) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          if (data.securityRolePermissions) {
              this.securityRolePermissions = [];
              for (let i = 0; i < data.securityRolePermissions.length; i++) {
                  let item = data.securityRolePermissions[i];
                  this.securityRolePermissions[i] = item && !(<any>item).toJSON ? new SecurityRolePermissions(item) : <SecurityRolePermissions>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.description = _data["description"];
          if (Array.isArray(_data["securityRolePermissions"])) {
              this.securityRolePermissions = [] as any;
              for (let item of _data["securityRolePermissions"])
                  this.securityRolePermissions!.push(SecurityRolePermissions.fromJS(item));
          }
      }
  }

  static fromJS(data: any): SecurityRole {
      data = typeof data === 'object' ? data : {};
      let result = new SecurityRole();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["description"] = this.description;
      if (Array.isArray(this.securityRolePermissions)) {
          data["securityRolePermissions"] = [];
          for (let item of this.securityRolePermissions)
              data["securityRolePermissions"].push(item.toJSON());
      }
      return data;
  }
}

export interface ISecurityRole {
  id: number;
  name: string | undefined;
  description: string | undefined;
  securityRolePermissions: ISecurityRolePermissions[] | undefined;
}

export class SecurityRolePermissions implements ISecurityRolePermissions {
  id!: number;
  roleId!: number;
  securityRole!: SecurityRole | undefined;
  wtPermissionId!: number;
  securityWTPermissions!: SecurityWTPermissions | undefined;

  constructor(data?: ISecurityRolePermissions) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.securityRole = data.securityRole && !(<any>data.securityRole).toJSON ? new SecurityRole(data.securityRole) : <SecurityRole>this.securityRole;
          this.securityWTPermissions = data.securityWTPermissions && !(<any>data.securityWTPermissions).toJSON ? new SecurityWTPermissions(data.securityWTPermissions) : <SecurityWTPermissions>this.securityWTPermissions;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.roleId = _data["roleId"];
          this.securityRole = _data["securityRole"] ? SecurityRole.fromJS(_data["securityRole"]) : <any>undefined;
          this.wtPermissionId = _data["wtPermissionId"];
          this.securityWTPermissions = _data["securityWTPermissions"] ? SecurityWTPermissions.fromJS(_data["securityWTPermissions"]) : <any>undefined;
      }
  }

  static fromJS(data: any): SecurityRolePermissions {
      data = typeof data === 'object' ? data : {};
      let result = new SecurityRolePermissions();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["roleId"] = this.roleId;
      data["securityRole"] = this.securityRole ? this.securityRole.toJSON() : <any>undefined;
      data["wtPermissionId"] = this.wtPermissionId;
      data["securityWTPermissions"] = this.securityWTPermissions ? this.securityWTPermissions.toJSON() : <any>undefined;
      return data;
  }
}

export interface ISecurityRolePermissions {
  id: number;
  roleId: number;
  securityRole: ISecurityRole | undefined;
  wtPermissionId: number;
  securityWTPermissions: ISecurityWTPermissions | undefined;
}

export class SecurityWTPermissions implements ISecurityWTPermissions {
  id!: number;
  name!: string | undefined;

  constructor(data?: ISecurityWTPermissions) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
      }
  }

  static fromJS(data: any): SecurityWTPermissions {
      data = typeof data === 'object' ? data : {};
      let result = new SecurityWTPermissions();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      return data;
  }
}

export interface ISecurityWTPermissions {
  id: number;
  name: string | undefined;
}

export class OpportunityStage extends _LookupBase implements IOpportunityStage {
  id!: number;
  name!: string | undefined;
  sortOrder!: string | undefined;
  companyId!: number | undefined;
  opportunities!: Opportunity[] | undefined;

  constructor(data?: IOpportunityStage) {
      super(data);
      if (data) {
          if (data.opportunities) {
              this.opportunities = [];
              for (let i = 0; i < data.opportunities.length; i++) {
                  let item = data.opportunities[i];
                  this.opportunities[i] = item && !(<any>item).toJSON ? new Opportunity(item) : <Opportunity>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.sortOrder = _data["sortOrder"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["opportunities"])) {
              this.opportunities = [] as any;
              for (let item of _data["opportunities"])
                  this.opportunities!.push(Opportunity.fromJS(item));
          }
      }
  }

  static fromJS(data: any): OpportunityStage {
      data = typeof data === 'object' ? data : {};
      let result = new OpportunityStage();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["sortOrder"] = this.sortOrder;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.opportunities)) {
          data["opportunities"] = [];
          for (let item of this.opportunities)
              data["opportunities"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IOpportunityStage extends I_LookupBase {
  id: number;
  name: string | undefined;
  sortOrder: string | undefined;
  companyId: number | undefined;
  opportunities: IOpportunity[] | undefined;
}

export class OpportunityPercent extends _LookupBase implements IOpportunityPercent {
  id!: number;
  name!: string | undefined;
  fK_ImportedID!: number | undefined;
  companyId!: number | undefined;
  opportunities!: Opportunity[] | undefined;

  constructor(data?: IOpportunityPercent) {
      super(data);
      if (data) {
          if (data.opportunities) {
              this.opportunities = [];
              for (let i = 0; i < data.opportunities.length; i++) {
                  let item = data.opportunities[i];
                  this.opportunities[i] = item && !(<any>item).toJSON ? new Opportunity(item) : <Opportunity>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.fK_ImportedID = _data["fK_ImportedID"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["opportunities"])) {
              this.opportunities = [] as any;
              for (let item of _data["opportunities"])
                  this.opportunities!.push(Opportunity.fromJS(item));
          }
      }
  }

  static fromJS(data: any): OpportunityPercent {
      data = typeof data === 'object' ? data : {};
      let result = new OpportunityPercent();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["fK_ImportedID"] = this.fK_ImportedID;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.opportunities)) {
          data["opportunities"] = [];
          for (let item of this.opportunities)
              data["opportunities"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IOpportunityPercent extends I_LookupBase {
  id: number;
  name: string | undefined;
  fK_ImportedID: number | undefined;
  companyId: number | undefined;
  opportunities: IOpportunity[] | undefined;
}

export class ContactComplianceItem implements IContactComplianceItem {
  id!: number;
  complianceItemTypeID!: number;
  contactId!: number;
  contact!: ContactProfile | undefined;
  owner!: ClientSelector;
  opportunityId!: number;
  opportunity!: Opportunity | undefined;
  isReceivedOrCompleted!: number;
  dateReceivedOrCompleted!: string | undefined;
  isdataProtection!: boolean;
  fK_ImportID_Dynamics!: number;
  fK_Nationality_AML!: number;
  documentDate!: string | undefined;
  expiryDate!: string | undefined;

  constructor(data?: IContactComplianceItem) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.contact = data.contact && !(<any>data.contact).toJSON ? new ContactProfile(data.contact) : <ContactProfile>this.contact;
          this.opportunity = data.opportunity && !(<any>data.opportunity).toJSON ? new Opportunity(data.opportunity) : <Opportunity>this.opportunity;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.complianceItemTypeID = _data["complianceItemTypeID"];
          this.contactId = _data["contactId"];
          this.contact = _data["contact"] ? ContactProfile.fromJS(_data["contact"]) : <any>undefined;
          this.owner = _data["owner"];
          this.opportunityId = _data["opportunityId"];
          this.opportunity = _data["opportunity"] ? Opportunity.fromJS(_data["opportunity"]) : <any>undefined;
          this.isReceivedOrCompleted = _data["isReceivedOrCompleted"];
          this.dateReceivedOrCompleted = _data["dateReceivedOrCompleted"];
          this.isdataProtection = _data["isdataProtection"];
          this.fK_ImportID_Dynamics = _data["fK_ImportID_Dynamics"];
          this.fK_Nationality_AML = _data["fK_Nationality_AML"];
          this.documentDate = _data["documentDate"];
          this.expiryDate = _data["expiryDate"];
      }
  }

  static fromJS(data: any): ContactComplianceItem {
      data = typeof data === 'object' ? data : {};
      let result = new ContactComplianceItem();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["complianceItemTypeID"] = this.complianceItemTypeID;
      data["contactId"] = this.contactId;
      data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
      data["owner"] = this.owner;
      data["opportunityId"] = this.opportunityId;
      data["opportunity"] = this.opportunity ? this.opportunity.toJSON() : <any>undefined;
      data["isReceivedOrCompleted"] = this.isReceivedOrCompleted;
      data["dateReceivedOrCompleted"] = this.dateReceivedOrCompleted;
      data["isdataProtection"] = this.isdataProtection;
      data["fK_ImportID_Dynamics"] = this.fK_ImportID_Dynamics;
      data["fK_Nationality_AML"] = this.fK_Nationality_AML;
      data["documentDate"] = this.documentDate;
      data["expiryDate"] = this.expiryDate;
      return data;
  }
}

export interface IContactComplianceItem {
  id: number;
  complianceItemTypeID: number;
  contactId: number;
  contact: IContactProfile | undefined;
  owner: ClientSelector;
  opportunityId: number;
  opportunity: IOpportunity | undefined;
  isReceivedOrCompleted: number;
  dateReceivedOrCompleted: string | undefined;
  isdataProtection: boolean;
  fK_ImportID_Dynamics: number;
  fK_Nationality_AML: number;
  documentDate: string | undefined;
  expiryDate: string | undefined;
}

export class Activity implements IActivity {
  id!: number;
  contactId!: number;
  contact!: ContactProfile | undefined;
  typeId!: number;
  type!: CommunicationType | undefined;
  timeStamp!: string;
  content!: string | undefined;
  contentPlainText!: string | undefined;
  contactOwnerId!: number;
  contactOwner!: ContactOwnerProfile | undefined;
  opportunityId!: number;
  opportunity!: Opportunity | undefined;
  timeSpentOnActivity!: number;
  clientSelector!: ClientSelector;
  emailSentId!: number;
  sentEmail!: SentEmail | undefined;
  emailRecievedId!: number;
  taskId!: number;
  notes!: string | undefined;
  documentTypeId!: number;
  complaintId!: number;
  attachments!: ActivityAttachment[] | undefined;

  constructor(data?: IActivity) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.contact = data.contact && !(<any>data.contact).toJSON ? new ContactProfile(data.contact) : <ContactProfile>this.contact;
          this.type = data.type && !(<any>data.type).toJSON ? new CommunicationType(data.type) : <CommunicationType>this.type;
          this.contactOwner = data.contactOwner && !(<any>data.contactOwner).toJSON ? new ContactOwnerProfile(data.contactOwner) : <ContactOwnerProfile>this.contactOwner;
          this.opportunity = data.opportunity && !(<any>data.opportunity).toJSON ? new Opportunity(data.opportunity) : <Opportunity>this.opportunity;
          this.sentEmail = data.sentEmail && !(<any>data.sentEmail).toJSON ? new SentEmail(data.sentEmail) : <SentEmail>this.sentEmail;
          if (data.attachments) {
              this.attachments = [];
              for (let i = 0; i < data.attachments.length; i++) {
                  let item = data.attachments[i];
                  this.attachments[i] = item && !(<any>item).toJSON ? new ActivityAttachment(item) : <ActivityAttachment>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.contactId = _data["contactId"];
          this.contact = _data["contact"] ? ContactProfile.fromJS(_data["contact"]) : <any>undefined;
          this.typeId = _data["typeId"];
          this.type = _data["type"] ? CommunicationType.fromJS(_data["type"]) : <any>undefined;
          this.timeStamp = _data["timeStamp"];
          this.content = _data["content"];
          this.contentPlainText = _data["contentPlainText"];
          this.contactOwnerId = _data["contactOwnerId"];
          this.contactOwner = _data["contactOwner"] ? ContactOwnerProfile.fromJS(_data["contactOwner"]) : <any>undefined;
          this.opportunityId = _data["opportunityId"];
          this.opportunity = _data["opportunity"] ? Opportunity.fromJS(_data["opportunity"]) : <any>undefined;
          this.timeSpentOnActivity = _data["timeSpentOnActivity"];
          this.clientSelector = _data["clientSelector"];
          this.emailSentId = _data["emailSentId"];
          this.sentEmail = _data["sentEmail"] ? SentEmail.fromJS(_data["sentEmail"]) : <any>undefined;
          this.emailRecievedId = _data["emailRecievedId"];
          this.taskId = _data["taskId"];
          this.notes = _data["notes"];
          this.documentTypeId = _data["documentTypeId"];
          this.complaintId = _data["complaintId"];
          if (Array.isArray(_data["attachments"])) {
              this.attachments = [] as any;
              for (let item of _data["attachments"])
                  this.attachments!.push(ActivityAttachment.fromJS(item));
          }
      }
  }

  static fromJS(data: any): Activity {
      data = typeof data === 'object' ? data : {};
      let result = new Activity();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["contactId"] = this.contactId;
      data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
      data["typeId"] = this.typeId;
      data["type"] = this.type ? this.type.toJSON() : <any>undefined;
      data["timeStamp"] = this.timeStamp;
      data["content"] = this.content;
      data["contentPlainText"] = this.contentPlainText;
      data["contactOwnerId"] = this.contactOwnerId;
      data["contactOwner"] = this.contactOwner ? this.contactOwner.toJSON() : <any>undefined;
      data["opportunityId"] = this.opportunityId;
      data["opportunity"] = this.opportunity ? this.opportunity.toJSON() : <any>undefined;
      data["timeSpentOnActivity"] = this.timeSpentOnActivity;
      data["clientSelector"] = this.clientSelector;
      data["emailSentId"] = this.emailSentId;
      data["sentEmail"] = this.sentEmail ? this.sentEmail.toJSON() : <any>undefined;
      data["emailRecievedId"] = this.emailRecievedId;
      data["taskId"] = this.taskId;
      data["notes"] = this.notes;
      data["documentTypeId"] = this.documentTypeId;
      data["complaintId"] = this.complaintId;
      if (Array.isArray(this.attachments)) {
          data["attachments"] = [];
          for (let item of this.attachments)
              data["attachments"].push(item.toJSON());
      }
      return data;
  }
}

export interface IActivity {
  id: number;
  contactId: number;
  contact: IContactProfile | undefined;
  typeId: number;
  type: ICommunicationType | undefined;
  timeStamp: string;
  content: string | undefined;
  contentPlainText: string | undefined;
  contactOwnerId: number;
  contactOwner: IContactOwnerProfile | undefined;
  opportunityId: number;
  opportunity: IOpportunity | undefined;
  timeSpentOnActivity: number;
  clientSelector: ClientSelector;
  emailSentId: number;
  sentEmail: ISentEmail | undefined;
  emailRecievedId: number;
  taskId: number;
  notes: string | undefined;
  documentTypeId: number;
  complaintId: number;
  attachments: IActivityAttachment[] | undefined;
}

export class CommunicationType extends _LookupBase implements ICommunicationType {
  id!: number;
  name!: string | undefined;
  description!: string | undefined;
  companyId!: number | undefined;

  constructor(data?: ICommunicationType) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.description = _data["description"];
          this.companyId = _data["companyId"];
      }
  }

  static fromJS(data: any): CommunicationType {
      data = typeof data === 'object' ? data : {};
      let result = new CommunicationType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["description"] = this.description;
      data["companyId"] = this.companyId;
      super.toJSON(data);
      return data;
  }
}

export interface ICommunicationType extends I_LookupBase {
  id: number;
  name: string | undefined;
  description: string | undefined;
  companyId: number | undefined;
}

export class SentEmail implements ISentEmail {
  id!: number;
  contactId!: number;
  contact!: ContactProfile | undefined;
  clientSelector!: ClientSelector;
  contactOwnerId!: number;
  contactOwner!: ContactOwnerProfile | undefined;
  opportunityId!: number;
  opportunity!: Opportunity | undefined;
  policyId!: number;
  policy!: FactFindPolicy | undefined;
  documentCategoryId!: number;
  taskId!: number;
  commissionId!: number;
  addressTo!: string | undefined;
  addressCC!: string | undefined;
  addressBCC!: string | undefined;
  addressFrom!: string | undefined;
  nameFrom!: string | undefined;
  subject!: string | undefined;
  bodyPreview!: string | undefined;
  bodyFullText!: string | undefined;
  bodyPlainText!: string | undefined;
  priority!: string | undefined;
  timeStamp!: string;
  numberOfAttachments!: number;
  notes!: string | undefined;
  emailMessageType!: string | undefined;
  attachments!: SentEmail_Attachment[] | undefined;

  constructor(data?: ISentEmail) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.contact = data.contact && !(<any>data.contact).toJSON ? new ContactProfile(data.contact) : <ContactProfile>this.contact;
          this.contactOwner = data.contactOwner && !(<any>data.contactOwner).toJSON ? new ContactOwnerProfile(data.contactOwner) : <ContactOwnerProfile>this.contactOwner;
          this.opportunity = data.opportunity && !(<any>data.opportunity).toJSON ? new Opportunity(data.opportunity) : <Opportunity>this.opportunity;
          this.policy = data.policy && !(<any>data.policy).toJSON ? new FactFindPolicy(data.policy) : <FactFindPolicy>this.policy;
          if (data.attachments) {
              this.attachments = [];
              for (let i = 0; i < data.attachments.length; i++) {
                  let item = data.attachments[i];
                  this.attachments[i] = item && !(<any>item).toJSON ? new SentEmail_Attachment(item) : <SentEmail_Attachment>item;
              }
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.contactId = _data["contactId"];
          this.contact = _data["contact"] ? ContactProfile.fromJS(_data["contact"]) : <any>undefined;
          this.clientSelector = _data["clientSelector"];
          this.contactOwnerId = _data["contactOwnerId"];
          this.contactOwner = _data["contactOwner"] ? ContactOwnerProfile.fromJS(_data["contactOwner"]) : <any>undefined;
          this.opportunityId = _data["opportunityId"];
          this.opportunity = _data["opportunity"] ? Opportunity.fromJS(_data["opportunity"]) : <any>undefined;
          this.policyId = _data["policyId"];
          this.policy = _data["policy"] ? FactFindPolicy.fromJS(_data["policy"]) : <any>undefined;
          this.documentCategoryId = _data["documentCategoryId"];
          this.taskId = _data["taskId"];
          this.commissionId = _data["commissionId"];
          this.addressTo = _data["addressTo"];
          this.addressCC = _data["addressCC"];
          this.addressBCC = _data["addressBCC"];
          this.addressFrom = _data["addressFrom"];
          this.nameFrom = _data["nameFrom"];
          this.subject = _data["subject"];
          this.bodyPreview = _data["bodyPreview"];
          this.bodyFullText = _data["bodyFullText"];
          this.bodyPlainText = _data["bodyPlainText"];
          this.priority = _data["priority"];
          this.timeStamp = _data["timeStamp"];
          this.numberOfAttachments = _data["numberOfAttachments"];
          this.notes = _data["notes"];
          this.emailMessageType = _data["emailMessageType"];
          if (Array.isArray(_data["attachments"])) {
              this.attachments = [] as any;
              for (let item of _data["attachments"])
                  this.attachments!.push(SentEmail_Attachment.fromJS(item));
          }
      }
  }

  static fromJS(data: any): SentEmail {
      data = typeof data === 'object' ? data : {};
      let result = new SentEmail();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["contactId"] = this.contactId;
      data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
      data["clientSelector"] = this.clientSelector;
      data["contactOwnerId"] = this.contactOwnerId;
      data["contactOwner"] = this.contactOwner ? this.contactOwner.toJSON() : <any>undefined;
      data["opportunityId"] = this.opportunityId;
      data["opportunity"] = this.opportunity ? this.opportunity.toJSON() : <any>undefined;
      data["policyId"] = this.policyId;
      data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
      data["documentCategoryId"] = this.documentCategoryId;
      data["taskId"] = this.taskId;
      data["commissionId"] = this.commissionId;
      data["addressTo"] = this.addressTo;
      data["addressCC"] = this.addressCC;
      data["addressBCC"] = this.addressBCC;
      data["addressFrom"] = this.addressFrom;
      data["nameFrom"] = this.nameFrom;
      data["subject"] = this.subject;
      data["bodyPreview"] = this.bodyPreview;
      data["bodyFullText"] = this.bodyFullText;
      data["bodyPlainText"] = this.bodyPlainText;
      data["priority"] = this.priority;
      data["timeStamp"] = this.timeStamp;
      data["numberOfAttachments"] = this.numberOfAttachments;
      data["notes"] = this.notes;
      data["emailMessageType"] = this.emailMessageType;
      if (Array.isArray(this.attachments)) {
          data["attachments"] = [];
          for (let item of this.attachments)
              data["attachments"].push(item.toJSON());
      }
      return data;
  }
}

export interface ISentEmail {
  id: number;
  contactId: number;
  contact: IContactProfile | undefined;
  clientSelector: ClientSelector;
  contactOwnerId: number;
  contactOwner: IContactOwnerProfile | undefined;
  opportunityId: number;
  opportunity: IOpportunity | undefined;
  policyId: number;
  policy: IFactFindPolicy | undefined;
  documentCategoryId: number;
  taskId: number;
  commissionId: number;
  addressTo: string | undefined;
  addressCC: string | undefined;
  addressBCC: string | undefined;
  addressFrom: string | undefined;
  nameFrom: string | undefined;
  subject: string | undefined;
  bodyPreview: string | undefined;
  bodyFullText: string | undefined;
  bodyPlainText: string | undefined;
  priority: string | undefined;
  timeStamp: string;
  numberOfAttachments: number;
  notes: string | undefined;
  emailMessageType: string | undefined;
  attachments: ISentEmail_Attachment[] | undefined;
}

export class SentEmail_Attachment implements ISentEmail_Attachment {
  id!: number;
  sentEmailID!: number;
  sentEmail!: SentEmail | undefined;
  attachmentFilePath!: string | undefined;
  isSharedFile!: boolean;

  constructor(data?: ISentEmail_Attachment) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.sentEmail = data.sentEmail && !(<any>data.sentEmail).toJSON ? new SentEmail(data.sentEmail) : <SentEmail>this.sentEmail;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.sentEmailID = _data["sentEmailID"];
          this.sentEmail = _data["sentEmail"] ? SentEmail.fromJS(_data["sentEmail"]) : <any>undefined;
          this.attachmentFilePath = _data["attachmentFilePath"];
          this.isSharedFile = _data["isSharedFile"];
      }
  }

  static fromJS(data: any): SentEmail_Attachment {
      data = typeof data === 'object' ? data : {};
      let result = new SentEmail_Attachment();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["sentEmailID"] = this.sentEmailID;
      data["sentEmail"] = this.sentEmail ? this.sentEmail.toJSON() : <any>undefined;
      data["attachmentFilePath"] = this.attachmentFilePath;
      data["isSharedFile"] = this.isSharedFile;
      return data;
  }
}

export interface ISentEmail_Attachment {
  id: number;
  sentEmailID: number;
  sentEmail: ISentEmail | undefined;
  attachmentFilePath: string | undefined;
  isSharedFile: boolean;
}

export class ActivityAttachment implements IActivityAttachment {
  id!: number;
  activityId!: number;
  activity!: Activity | undefined;
  attachedDocumentPath!: string | undefined;
  isSharedFile!: boolean;

  constructor(data?: IActivityAttachment) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.activity = data.activity && !(<any>data.activity).toJSON ? new Activity(data.activity) : <Activity>this.activity;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.activityId = _data["activityId"];
          this.activity = _data["activity"] ? Activity.fromJS(_data["activity"]) : <any>undefined;
          this.attachedDocumentPath = _data["attachedDocumentPath"];
          this.isSharedFile = _data["isSharedFile"];
      }
  }

  static fromJS(data: any): ActivityAttachment {
      data = typeof data === 'object' ? data : {};
      let result = new ActivityAttachment();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["activityId"] = this.activityId;
      data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
      data["attachedDocumentPath"] = this.attachedDocumentPath;
      data["isSharedFile"] = this.isSharedFile;
      return data;
  }
}

export interface IActivityAttachment {
  id: number;
  activityId: number;
  activity: IActivity | undefined;
  attachedDocumentPath: string | undefined;
  isSharedFile: boolean;
}

export class DocumentType extends _LookupBase implements IDocumentType {
  id!: number;
  name!: string | undefined;
  description!: string | undefined;
  companyId!: number | undefined;

  constructor(data?: IDocumentType) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.description = _data["description"];
          this.companyId = _data["companyId"];
      }
  }

  static fromJS(data: any): DocumentType {
      data = typeof data === 'object' ? data : {};
      let result = new DocumentType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["description"] = this.description;
      data["companyId"] = this.companyId;
      super.toJSON(data);
      return data;
  }
}

export interface IDocumentType extends I_LookupBase {
  id: number;
  name: string | undefined;
  description: string | undefined;
  companyId: number | undefined;
}

export class PolicyAdditionalDetails implements IPolicyAdditionalDetails {
  id!: number;
  fK_ContactPolicyID!: number;
  contactPolicy!: FactFindPolicy | undefined;
  policyOccupationClass!: string | undefined;
  deferredPeriodInWeeks!: number | undefined;
  ageIncomePayableTo!: number | undefined;
  normalRetirementAge!: number | undefined;
  schemeName!: string | undefined;
  isWholeOfLife!: boolean | undefined;
  ceasingAge!: number | undefined;
  others!: string | undefined;
  currentBalance!: number | undefined;
  fixedRateStartDate!: string | undefined;
  fixedRateTermYears!: number | undefined;
  monthlyRepaymentAmount!: number | undefined;
  monthlyOverPaymentAmount!: number | undefined;
  missedLatePayments!: number | undefined;
  valuationAmount!: number | undefined;
  purchaseAmount!: number | undefined;
  sitePrice!: number | undefined;
  propertyValue!: number | undefined;
  mortgageRequired!: number | undefined;
  propertyAddressLine_1!: string | undefined;
  propertyAddressLine_2!: string | undefined;
  propertyAddressLine_3!: string | undefined;
  propertyAddressLine_4!: string | undefined;
  propertyAddressLine_5!: string | undefined;
  amountBorrowed!: number | undefined;
  amountInvested!: number | undefined;
  currentValue!: number | undefined;
  currentPercentageRate!: number | undefined;
  currentRateEndDate!: string | undefined;
  principalPrivateResidenceId!: number | undefined;
  principalPrivateResidence!: YesNoDefault | undefined;
  investmentPropertyId!: number | undefined;
  investmentProperty!: YesNoDefault | undefined;
  rentalIncomeId!: number | undefined;
  rentalIncome!: YesNoDefault | undefined;
  isVacantPossessionId!: number | undefined;
  isVacantPossession!: YesNoDefault | undefined;
  isSoleOccupantId!: number | undefined;
  isSoleOccupant!: YesNoDefault | undefined;
  isBusinessId!: number | undefined;
  isBusiness!: YesNoDefault | undefined;
  propertyStatusId!: number | undefined;
  propertyStatus!: PropertyStatus | undefined;
  mortgageCategoryId!: number | undefined;
  mortgageCategory!: MortgageCategory | undefined;
  mortgageTypeId!: number | undefined;
  mortgageType!: MortgageType | undefined;
  mortgageRateTypeId!: number | undefined;
  mortgageRateType!: MortgageRate | undefined;
  approvalStatusId!: number | undefined;
  approvalStatus!: ApprovalStatus | undefined;

  constructor(data?: IPolicyAdditionalDetails) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.contactPolicy = data.contactPolicy && !(<any>data.contactPolicy).toJSON ? new FactFindPolicy(data.contactPolicy) : <FactFindPolicy>this.contactPolicy;
          this.principalPrivateResidence = data.principalPrivateResidence && !(<any>data.principalPrivateResidence).toJSON ? new YesNoDefault(data.principalPrivateResidence) : <YesNoDefault>this.principalPrivateResidence;
          this.investmentProperty = data.investmentProperty && !(<any>data.investmentProperty).toJSON ? new YesNoDefault(data.investmentProperty) : <YesNoDefault>this.investmentProperty;
          this.rentalIncome = data.rentalIncome && !(<any>data.rentalIncome).toJSON ? new YesNoDefault(data.rentalIncome) : <YesNoDefault>this.rentalIncome;
          this.isVacantPossession = data.isVacantPossession && !(<any>data.isVacantPossession).toJSON ? new YesNoDefault(data.isVacantPossession) : <YesNoDefault>this.isVacantPossession;
          this.isSoleOccupant = data.isSoleOccupant && !(<any>data.isSoleOccupant).toJSON ? new YesNoDefault(data.isSoleOccupant) : <YesNoDefault>this.isSoleOccupant;
          this.isBusiness = data.isBusiness && !(<any>data.isBusiness).toJSON ? new YesNoDefault(data.isBusiness) : <YesNoDefault>this.isBusiness;
          this.propertyStatus = data.propertyStatus && !(<any>data.propertyStatus).toJSON ? new PropertyStatus(data.propertyStatus) : <PropertyStatus>this.propertyStatus;
          this.mortgageCategory = data.mortgageCategory && !(<any>data.mortgageCategory).toJSON ? new MortgageCategory(data.mortgageCategory) : <MortgageCategory>this.mortgageCategory;
          this.mortgageType = data.mortgageType && !(<any>data.mortgageType).toJSON ? new MortgageType(data.mortgageType) : <MortgageType>this.mortgageType;
          this.mortgageRateType = data.mortgageRateType && !(<any>data.mortgageRateType).toJSON ? new MortgageRate(data.mortgageRateType) : <MortgageRate>this.mortgageRateType;
          this.approvalStatus = data.approvalStatus && !(<any>data.approvalStatus).toJSON ? new ApprovalStatus(data.approvalStatus) : <ApprovalStatus>this.approvalStatus;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.fK_ContactPolicyID = _data["fK_ContactPolicyID"];
          this.contactPolicy = _data["contactPolicy"] ? FactFindPolicy.fromJS(_data["contactPolicy"]) : <any>undefined;
          this.policyOccupationClass = _data["policyOccupationClass"];
          this.deferredPeriodInWeeks = _data["deferredPeriodInWeeks"];
          this.ageIncomePayableTo = _data["ageIncomePayableTo"];
          this.normalRetirementAge = _data["normalRetirementAge"];
          this.schemeName = _data["schemeName"];
          this.isWholeOfLife = _data["isWholeOfLife"];
          this.ceasingAge = _data["ceasingAge"];
          this.others = _data["others"];
          this.currentBalance = _data["currentBalance"];
          this.fixedRateStartDate = _data["fixedRateStartDate"];
          this.fixedRateTermYears = _data["fixedRateTermYears"];
          this.monthlyRepaymentAmount = _data["monthlyRepaymentAmount"];
          this.monthlyOverPaymentAmount = _data["monthlyOverPaymentAmount"];
          this.missedLatePayments = _data["missedLatePayments"];
          this.valuationAmount = _data["valuationAmount"];
          this.purchaseAmount = _data["purchaseAmount"];
          this.sitePrice = _data["sitePrice"];
          this.propertyValue = _data["propertyValue"];
          this.mortgageRequired = _data["mortgageRequired"];
          this.propertyAddressLine_1 = _data["propertyAddressLine_1"];
          this.propertyAddressLine_2 = _data["propertyAddressLine_2"];
          this.propertyAddressLine_3 = _data["propertyAddressLine_3"];
          this.propertyAddressLine_4 = _data["propertyAddressLine_4"];
          this.propertyAddressLine_5 = _data["propertyAddressLine_5"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.amountInvested = _data["amountInvested"];
          this.currentValue = _data["currentValue"];
          this.currentPercentageRate = _data["currentPercentageRate"];
          this.currentRateEndDate = _data["currentRateEndDate"];
          this.principalPrivateResidenceId = _data["principalPrivateResidenceId"];
          this.principalPrivateResidence = _data["principalPrivateResidence"] ? YesNoDefault.fromJS(_data["principalPrivateResidence"]) : <any>undefined;
          this.investmentPropertyId = _data["investmentPropertyId"];
          this.investmentProperty = _data["investmentProperty"] ? YesNoDefault.fromJS(_data["investmentProperty"]) : <any>undefined;
          this.rentalIncomeId = _data["rentalIncomeId"];
          this.rentalIncome = _data["rentalIncome"] ? YesNoDefault.fromJS(_data["rentalIncome"]) : <any>undefined;
          this.isVacantPossessionId = _data["isVacantPossessionId"];
          this.isVacantPossession = _data["isVacantPossession"] ? YesNoDefault.fromJS(_data["isVacantPossession"]) : <any>undefined;
          this.isSoleOccupantId = _data["isSoleOccupantId"];
          this.isSoleOccupant = _data["isSoleOccupant"] ? YesNoDefault.fromJS(_data["isSoleOccupant"]) : <any>undefined;
          this.isBusinessId = _data["isBusinessId"];
          this.isBusiness = _data["isBusiness"] ? YesNoDefault.fromJS(_data["isBusiness"]) : <any>undefined;
          this.propertyStatusId = _data["propertyStatusId"];
          this.propertyStatus = _data["propertyStatus"] ? PropertyStatus.fromJS(_data["propertyStatus"]) : <any>undefined;
          this.mortgageCategoryId = _data["mortgageCategoryId"];
          this.mortgageCategory = _data["mortgageCategory"] ? MortgageCategory.fromJS(_data["mortgageCategory"]) : <any>undefined;
          this.mortgageTypeId = _data["mortgageTypeId"];
          this.mortgageType = _data["mortgageType"] ? MortgageType.fromJS(_data["mortgageType"]) : <any>undefined;
          this.mortgageRateTypeId = _data["mortgageRateTypeId"];
          this.mortgageRateType = _data["mortgageRateType"] ? MortgageRate.fromJS(_data["mortgageRateType"]) : <any>undefined;
          this.approvalStatusId = _data["approvalStatusId"];
          this.approvalStatus = _data["approvalStatus"] ? ApprovalStatus.fromJS(_data["approvalStatus"]) : <any>undefined;
      }
  }

  static fromJS(data: any): PolicyAdditionalDetails {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyAdditionalDetails();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["fK_ContactPolicyID"] = this.fK_ContactPolicyID;
      data["contactPolicy"] = this.contactPolicy ? this.contactPolicy.toJSON() : <any>undefined;
      data["policyOccupationClass"] = this.policyOccupationClass;
      data["deferredPeriodInWeeks"] = this.deferredPeriodInWeeks;
      data["ageIncomePayableTo"] = this.ageIncomePayableTo;
      data["normalRetirementAge"] = this.normalRetirementAge;
      data["schemeName"] = this.schemeName;
      data["isWholeOfLife"] = this.isWholeOfLife;
      data["ceasingAge"] = this.ceasingAge;
      data["others"] = this.others;
      data["currentBalance"] = this.currentBalance;
      data["fixedRateStartDate"] = this.fixedRateStartDate;
      data["fixedRateTermYears"] = this.fixedRateTermYears;
      data["monthlyRepaymentAmount"] = this.monthlyRepaymentAmount;
      data["monthlyOverPaymentAmount"] = this.monthlyOverPaymentAmount;
      data["missedLatePayments"] = this.missedLatePayments;
      data["valuationAmount"] = this.valuationAmount;
      data["purchaseAmount"] = this.purchaseAmount;
      data["sitePrice"] = this.sitePrice;
      data["propertyValue"] = this.propertyValue;
      data["mortgageRequired"] = this.mortgageRequired;
      data["propertyAddressLine_1"] = this.propertyAddressLine_1;
      data["propertyAddressLine_2"] = this.propertyAddressLine_2;
      data["propertyAddressLine_3"] = this.propertyAddressLine_3;
      data["propertyAddressLine_4"] = this.propertyAddressLine_4;
      data["propertyAddressLine_5"] = this.propertyAddressLine_5;
      data["amountBorrowed"] = this.amountBorrowed;
      data["amountInvested"] = this.amountInvested;
      data["currentValue"] = this.currentValue;
      data["currentPercentageRate"] = this.currentPercentageRate;
      data["currentRateEndDate"] = this.currentRateEndDate;
      data["principalPrivateResidenceId"] = this.principalPrivateResidenceId;
      data["principalPrivateResidence"] = this.principalPrivateResidence ? this.principalPrivateResidence.toJSON() : <any>undefined;
      data["investmentPropertyId"] = this.investmentPropertyId;
      data["investmentProperty"] = this.investmentProperty ? this.investmentProperty.toJSON() : <any>undefined;
      data["rentalIncomeId"] = this.rentalIncomeId;
      data["rentalIncome"] = this.rentalIncome ? this.rentalIncome.toJSON() : <any>undefined;
      data["isVacantPossessionId"] = this.isVacantPossessionId;
      data["isVacantPossession"] = this.isVacantPossession ? this.isVacantPossession.toJSON() : <any>undefined;
      data["isSoleOccupantId"] = this.isSoleOccupantId;
      data["isSoleOccupant"] = this.isSoleOccupant ? this.isSoleOccupant.toJSON() : <any>undefined;
      data["isBusinessId"] = this.isBusinessId;
      data["isBusiness"] = this.isBusiness ? this.isBusiness.toJSON() : <any>undefined;
      data["propertyStatusId"] = this.propertyStatusId;
      data["propertyStatus"] = this.propertyStatus ? this.propertyStatus.toJSON() : <any>undefined;
      data["mortgageCategoryId"] = this.mortgageCategoryId;
      data["mortgageCategory"] = this.mortgageCategory ? this.mortgageCategory.toJSON() : <any>undefined;
      data["mortgageTypeId"] = this.mortgageTypeId;
      data["mortgageType"] = this.mortgageType ? this.mortgageType.toJSON() : <any>undefined;
      data["mortgageRateTypeId"] = this.mortgageRateTypeId;
      data["mortgageRateType"] = this.mortgageRateType ? this.mortgageRateType.toJSON() : <any>undefined;
      data["approvalStatusId"] = this.approvalStatusId;
      data["approvalStatus"] = this.approvalStatus ? this.approvalStatus.toJSON() : <any>undefined;
      return data;
  }
}

export interface IPolicyAdditionalDetails {
  id: number;
  fK_ContactPolicyID: number;
  contactPolicy: IFactFindPolicy | undefined;
  policyOccupationClass: string | undefined;
  deferredPeriodInWeeks: number | undefined;
  ageIncomePayableTo: number | undefined;
  normalRetirementAge: number | undefined;
  schemeName: string | undefined;
  isWholeOfLife: boolean | undefined;
  ceasingAge: number | undefined;
  others: string | undefined;
  currentBalance: number | undefined;
  fixedRateStartDate: string | undefined;
  fixedRateTermYears: number | undefined;
  monthlyRepaymentAmount: number | undefined;
  monthlyOverPaymentAmount: number | undefined;
  missedLatePayments: number | undefined;
  valuationAmount: number | undefined;
  purchaseAmount: number | undefined;
  sitePrice: number | undefined;
  propertyValue: number | undefined;
  mortgageRequired: number | undefined;
  propertyAddressLine_1: string | undefined;
  propertyAddressLine_2: string | undefined;
  propertyAddressLine_3: string | undefined;
  propertyAddressLine_4: string | undefined;
  propertyAddressLine_5: string | undefined;
  amountBorrowed: number | undefined;
  amountInvested: number | undefined;
  currentValue: number | undefined;
  currentPercentageRate: number | undefined;
  currentRateEndDate: string | undefined;
  principalPrivateResidenceId: number | undefined;
  principalPrivateResidence: IYesNoDefault | undefined;
  investmentPropertyId: number | undefined;
  investmentProperty: IYesNoDefault | undefined;
  rentalIncomeId: number | undefined;
  rentalIncome: IYesNoDefault | undefined;
  isVacantPossessionId: number | undefined;
  isVacantPossession: IYesNoDefault | undefined;
  isSoleOccupantId: number | undefined;
  isSoleOccupant: IYesNoDefault | undefined;
  isBusinessId: number | undefined;
  isBusiness: IYesNoDefault | undefined;
  propertyStatusId: number | undefined;
  propertyStatus: IPropertyStatus | undefined;
  mortgageCategoryId: number | undefined;
  mortgageCategory: IMortgageCategory | undefined;
  mortgageTypeId: number | undefined;
  mortgageType: IMortgageType | undefined;
  mortgageRateTypeId: number | undefined;
  mortgageRateType: IMortgageRate | undefined;
  approvalStatusId: number | undefined;
  approvalStatus: IApprovalStatus | undefined;
}

export class PropertyStatus extends _LookupBase implements IPropertyStatus {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mortgageLiability!: PolicyAdditionalDetails[] | undefined;

  constructor(data?: IPropertyStatus) {
      super(data);
      if (data) {
          if (data.mortgageLiability) {
              this.mortgageLiability = [];
              for (let i = 0; i < data.mortgageLiability.length; i++) {
                  let item = data.mortgageLiability[i];
                  this.mortgageLiability[i] = item && !(<any>item).toJSON ? new PolicyAdditionalDetails(item) : <PolicyAdditionalDetails>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mortgageLiability"])) {
              this.mortgageLiability = [] as any;
              for (let item of _data["mortgageLiability"])
                  this.mortgageLiability!.push(PolicyAdditionalDetails.fromJS(item));
          }
      }
  }

  static fromJS(data: any): PropertyStatus {
      data = typeof data === 'object' ? data : {};
      let result = new PropertyStatus();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mortgageLiability)) {
          data["mortgageLiability"] = [];
          for (let item of this.mortgageLiability)
              data["mortgageLiability"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IPropertyStatus extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mortgageLiability: IPolicyAdditionalDetails[] | undefined;
}

export class MortgageCategory extends _LookupBase implements IMortgageCategory {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mortgageLiability!: PolicyAdditionalDetails[] | undefined;

  constructor(data?: IMortgageCategory) {
      super(data);
      if (data) {
          if (data.mortgageLiability) {
              this.mortgageLiability = [];
              for (let i = 0; i < data.mortgageLiability.length; i++) {
                  let item = data.mortgageLiability[i];
                  this.mortgageLiability[i] = item && !(<any>item).toJSON ? new PolicyAdditionalDetails(item) : <PolicyAdditionalDetails>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mortgageLiability"])) {
              this.mortgageLiability = [] as any;
              for (let item of _data["mortgageLiability"])
                  this.mortgageLiability!.push(PolicyAdditionalDetails.fromJS(item));
          }
      }
  }

  static fromJS(data: any): MortgageCategory {
      data = typeof data === 'object' ? data : {};
      let result = new MortgageCategory();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mortgageLiability)) {
          data["mortgageLiability"] = [];
          for (let item of this.mortgageLiability)
              data["mortgageLiability"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IMortgageCategory extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mortgageLiability: IPolicyAdditionalDetails[] | undefined;
}

export class MortgageType extends _LookupBase implements IMortgageType {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mortgageLiability!: PolicyAdditionalDetails[] | undefined;

  constructor(data?: IMortgageType) {
      super(data);
      if (data) {
          if (data.mortgageLiability) {
              this.mortgageLiability = [];
              for (let i = 0; i < data.mortgageLiability.length; i++) {
                  let item = data.mortgageLiability[i];
                  this.mortgageLiability[i] = item && !(<any>item).toJSON ? new PolicyAdditionalDetails(item) : <PolicyAdditionalDetails>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mortgageLiability"])) {
              this.mortgageLiability = [] as any;
              for (let item of _data["mortgageLiability"])
                  this.mortgageLiability!.push(PolicyAdditionalDetails.fromJS(item));
          }
      }
  }

  static fromJS(data: any): MortgageType {
      data = typeof data === 'object' ? data : {};
      let result = new MortgageType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mortgageLiability)) {
          data["mortgageLiability"] = [];
          for (let item of this.mortgageLiability)
              data["mortgageLiability"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IMortgageType extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mortgageLiability: IPolicyAdditionalDetails[] | undefined;
}

export class MortgageRate extends _LookupBase implements IMortgageRate {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mortgageLiability!: PolicyAdditionalDetails[] | undefined;

  constructor(data?: IMortgageRate) {
      super(data);
      if (data) {
          if (data.mortgageLiability) {
              this.mortgageLiability = [];
              for (let i = 0; i < data.mortgageLiability.length; i++) {
                  let item = data.mortgageLiability[i];
                  this.mortgageLiability[i] = item && !(<any>item).toJSON ? new PolicyAdditionalDetails(item) : <PolicyAdditionalDetails>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mortgageLiability"])) {
              this.mortgageLiability = [] as any;
              for (let item of _data["mortgageLiability"])
                  this.mortgageLiability!.push(PolicyAdditionalDetails.fromJS(item));
          }
      }
  }

  static fromJS(data: any): MortgageRate {
      data = typeof data === 'object' ? data : {};
      let result = new MortgageRate();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mortgageLiability)) {
          data["mortgageLiability"] = [];
          for (let item of this.mortgageLiability)
              data["mortgageLiability"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IMortgageRate extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mortgageLiability: IPolicyAdditionalDetails[] | undefined;
}

export class ApprovalStatus extends _LookupBase implements IApprovalStatus {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mortgageLiability!: PolicyAdditionalDetails[] | undefined;

  constructor(data?: IApprovalStatus) {
      super(data);
      if (data) {
          if (data.mortgageLiability) {
              this.mortgageLiability = [];
              for (let i = 0; i < data.mortgageLiability.length; i++) {
                  let item = data.mortgageLiability[i];
                  this.mortgageLiability[i] = item && !(<any>item).toJSON ? new PolicyAdditionalDetails(item) : <PolicyAdditionalDetails>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mortgageLiability"])) {
              this.mortgageLiability = [] as any;
              for (let item of _data["mortgageLiability"])
                  this.mortgageLiability!.push(PolicyAdditionalDetails.fromJS(item));
          }
      }
  }

  static fromJS(data: any): ApprovalStatus {
      data = typeof data === 'object' ? data : {};
      let result = new ApprovalStatus();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mortgageLiability)) {
          data["mortgageLiability"] = [];
          for (let item of this.mortgageLiability)
              data["mortgageLiability"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IApprovalStatus extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mortgageLiability: IPolicyAdditionalDetails[] | undefined;
}

export class HealthStatus extends _LookupBase implements IHealthStatus {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mainContacts!: ContactProfile[] | undefined;
  spouseContacts!: ContactProfile[] | undefined;

  constructor(data?: IHealthStatus) {
      super(data);
      if (data) {
          if (data.mainContacts) {
              this.mainContacts = [];
              for (let i = 0; i < data.mainContacts.length; i++) {
                  let item = data.mainContacts[i];
                  this.mainContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
          if (data.spouseContacts) {
              this.spouseContacts = [];
              for (let i = 0; i < data.spouseContacts.length; i++) {
                  let item = data.spouseContacts[i];
                  this.spouseContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mainContacts"])) {
              this.mainContacts = [] as any;
              for (let item of _data["mainContacts"])
                  this.mainContacts!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["spouseContacts"])) {
              this.spouseContacts = [] as any;
              for (let item of _data["spouseContacts"])
                  this.spouseContacts!.push(ContactProfile.fromJS(item));
          }
      }
  }

  static fromJS(data: any): HealthStatus {
      data = typeof data === 'object' ? data : {};
      let result = new HealthStatus();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mainContacts)) {
          data["mainContacts"] = [];
          for (let item of this.mainContacts)
              data["mainContacts"].push(item.toJSON());
      }
      if (Array.isArray(this.spouseContacts)) {
          data["spouseContacts"] = [];
          for (let item of this.spouseContacts)
              data["spouseContacts"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IHealthStatus extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mainContacts: IContactProfile[] | undefined;
  spouseContacts: IContactProfile[] | undefined;
}

export class EmploymentStatus extends _LookupBase implements IEmploymentStatus {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  mainContacts!: ContactProfile[] | undefined;
  souseContacts!: ContactProfile[] | undefined;
  employments!: FactFindEmployment[] | undefined;

  constructor(data?: IEmploymentStatus) {
      super(data);
      if (data) {
          if (data.mainContacts) {
              this.mainContacts = [];
              for (let i = 0; i < data.mainContacts.length; i++) {
                  let item = data.mainContacts[i];
                  this.mainContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
          if (data.souseContacts) {
              this.souseContacts = [];
              for (let i = 0; i < data.souseContacts.length; i++) {
                  let item = data.souseContacts[i];
                  this.souseContacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["mainContacts"])) {
              this.mainContacts = [] as any;
              for (let item of _data["mainContacts"])
                  this.mainContacts!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["souseContacts"])) {
              this.souseContacts = [] as any;
              for (let item of _data["souseContacts"])
                  this.souseContacts!.push(ContactProfile.fromJS(item));
          }
          if (Array.isArray(_data["employments"])) {
              this.employments = [] as any;
              for (let item of _data["employments"])
                  this.employments!.push(FactFindEmployment.fromJS(item));
          }
      }
  }

  static fromJS(data: any): EmploymentStatus {
      data = typeof data === 'object' ? data : {};
      let result = new EmploymentStatus();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.mainContacts)) {
          data["mainContacts"] = [];
          for (let item of this.mainContacts)
              data["mainContacts"].push(item.toJSON());
      }
      if (Array.isArray(this.souseContacts)) {
          data["souseContacts"] = [];
          for (let item of this.souseContacts)
              data["souseContacts"].push(item.toJSON());
      }
      if (Array.isArray(this.employments)) {
          data["employments"] = [];
          for (let item of this.employments)
              data["employments"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IEmploymentStatus extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  mainContacts: IContactProfile[] | undefined;
  souseContacts: IContactProfile[] | undefined;
  employments: FactFindEmployment[] | undefined;
}

export class FactFindEmployment extends _FactFindEntityBase implements IFactFindEmployment {
  id!: number;
  client!: ClientSelector;
  employmentStatusId!: number | undefined;
  employmentStatus!: EmploymentStatus | undefined;
  occupation!: string | undefined;
  jobDescription!: string | undefined;
  employerName!: string | undefined;
  employerAddressLine_1!: string | undefined;
  employerAddressLine_2!: string | undefined;
  employerAddressLine_3!: string | undefined;
  employerAddressLine_4!: string | undefined;
  employerAddressLine_5!: string | undefined;
  startDate!: string | undefined;
  endDate!: string | undefined;
  isInProbationPeriodId!: number | undefined;
  isInProbationPeriod!: YesNoDefault | undefined;
  probationPeriodLength!: string | undefined;
  plansToChangeJobId!: number | undefined;
  plansToChangeJob!: YesNoDefault | undefined;
  plansToChangeJobTimeFrame!: string | undefined;
  retirementAge!: number | undefined;
  employmentDate!: string | undefined;
  revenueNumber!: string | undefined;
  isDirectorId!: number | undefined;
  isDirector!: YesNoDefault | undefined;
  shareholdingPercentage!: number | undefined;
  notes!: string | undefined;

  constructor(data?: IFactFindEmployment) {
      super(data);
      if (data) {
          this.employmentStatus = data.employmentStatus && !(<any>data.employmentStatus).toJSON ? new EmploymentStatus(data.employmentStatus) : <EmploymentStatus>this.employmentStatus;
          this.isInProbationPeriod = data.isInProbationPeriod && !(<any>data.isInProbationPeriod).toJSON ? new YesNoDefault(data.isInProbationPeriod) : <YesNoDefault>this.isInProbationPeriod;
          this.plansToChangeJob = data.plansToChangeJob && !(<any>data.plansToChangeJob).toJSON ? new YesNoDefault(data.plansToChangeJob) : <YesNoDefault>this.plansToChangeJob;
          this.isDirector = data.isDirector && !(<any>data.isDirector).toJSON ? new YesNoDefault(data.isDirector) : <YesNoDefault>this.isDirector;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.client = _data["client"];
          this.employmentStatusId = _data["employmentStatusId"];
          this.employmentStatus = _data["employmentStatus"] ? EmploymentStatus.fromJS(_data["employmentStatus"]) : <any>undefined;
          this.occupation = _data["occupation"];
          this.jobDescription = _data["jobDescription"];
          this.employerName = _data["employerName"];
          this.employerAddressLine_1 = _data["employerAddressLine_1"];
          this.employerAddressLine_2 = _data["employerAddressLine_2"];
          this.employerAddressLine_3 = _data["employerAddressLine_3"];
          this.employerAddressLine_4 = _data["employerAddressLine_4"];
          this.employerAddressLine_5 = _data["employerAddressLine_5"];
          this.startDate = _data["startDate"];
          this.endDate = _data["endDate"];
          this.isInProbationPeriodId = _data["isInProbationPeriodId"];
          this.isInProbationPeriod = _data["isInProbationPeriod"] ? YesNoDefault.fromJS(_data["isInProbationPeriod"]) : <any>undefined;
          this.probationPeriodLength = _data["probationPeriodLength"];
          this.plansToChangeJobId = _data["plansToChangeJobId"];
          this.plansToChangeJob = _data["plansToChangeJob"] ? YesNoDefault.fromJS(_data["plansToChangeJob"]) : <any>undefined;
          this.plansToChangeJobTimeFrame = _data["plansToChangeJobTimeFrame"];
          this.retirementAge = _data["retirementAge"];
          this.employmentDate = _data["employmentDate"];
          this.revenueNumber = _data["revenueNumber"];
          this.isDirectorId = _data["isDirectorId"];
          this.isDirector = _data["isDirector"] ? YesNoDefault.fromJS(_data["isDirector"]) : <any>undefined;
          this.shareholdingPercentage = _data["shareholdingPercentage"];
          this.notes = _data["notes"];
      }
  }

  static fromJS(data: any): FactFindEmployment {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindEmployment();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["client"] = this.client;
      data["employmentStatusId"] = this.employmentStatusId;
      data["employmentStatus"] = this.employmentStatus ? this.employmentStatus.toJSON() : <any>undefined;
      data["occupation"] = this.occupation;
      data["jobDescription"] = this.jobDescription;
      data["employerName"] = this.employerName;
      data["employerAddressLine_1"] = this.employerAddressLine_1;
      data["employerAddressLine_2"] = this.employerAddressLine_2;
      data["employerAddressLine_3"] = this.employerAddressLine_3;
      data["employerAddressLine_4"] = this.employerAddressLine_4;
      data["employerAddressLine_5"] = this.employerAddressLine_5;
      data["startDate"] = this.startDate;
      data["endDate"] = this.endDate;
      data["isInProbationPeriodId"] = this.isInProbationPeriodId;
      data["isInProbationPeriod"] = this.isInProbationPeriod ? this.isInProbationPeriod.toJSON() : <any>undefined;
      data["probationPeriodLength"] = this.probationPeriodLength;
      data["plansToChangeJobId"] = this.plansToChangeJobId;
      data["plansToChangeJob"] = this.plansToChangeJob ? this.plansToChangeJob.toJSON() : <any>undefined;
      data["plansToChangeJobTimeFrame"] = this.plansToChangeJobTimeFrame;
      data["retirementAge"] = this.retirementAge;
      data["employmentDate"] = this.employmentDate;
      data["revenueNumber"] = this.revenueNumber;
      data["isDirectorId"] = this.isDirectorId;
      data["isDirector"] = this.isDirector ? this.isDirector.toJSON() : <any>undefined;
      data["shareholdingPercentage"] = this.shareholdingPercentage;
      data["notes"] = this.notes;
      super.toJSON(data);
      return data;
  }
}

export interface IFactFindEmployment extends I_FactFindEntityBase {
  id: number;
  client: ClientSelector;
  employmentStatusId: number | undefined;
  employmentStatus: IEmploymentStatus | undefined;
  occupation: string | undefined;
  jobDescription: string | undefined;
  employerName: string | undefined;
  employerAddressLine_1: string | undefined;
  employerAddressLine_2: string | undefined;
  employerAddressLine_3: string | undefined;
  employerAddressLine_4: string | undefined;
  employerAddressLine_5: string | undefined;
  startDate: string | undefined;
  endDate: string | undefined;
  isInProbationPeriodId: number | undefined;
  isInProbationPeriod: IYesNoDefault | undefined;
  probationPeriodLength: string | undefined;
  plansToChangeJobId: number | undefined;
  plansToChangeJob: IYesNoDefault | undefined;
  plansToChangeJobTimeFrame: string | undefined;
  retirementAge: number | undefined;
  employmentDate: string | undefined;
  revenueNumber: string | undefined;
  isDirectorId: number | undefined;
  isDirector: IYesNoDefault | undefined;
  shareholdingPercentage: number | undefined;
  notes: string | undefined;
}

export class ContactStatus extends _LookupBase implements IContactStatus {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  visibleInClientPortal!: boolean | undefined;

  constructor(data?: IContactStatus) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          this.visibleInClientPortal = _data["visibleInClientPortal"];
      }
  }

  static fromJS(data: any): ContactStatus {
      data = typeof data === 'object' ? data : {};
      let result = new ContactStatus();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      data["visibleInClientPortal"] = this.visibleInClientPortal;
      super.toJSON(data);
      return data;
  }
}

export interface IContactStatus extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  visibleInClientPortal: boolean | undefined;
}

export class ContactType extends _LookupBase implements IContactType {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  contacts!: ContactProfile[] | undefined;

  constructor(data?: IContactType) {
      super(data);
      if (data) {
          if (data.contacts) {
              this.contacts = [];
              for (let i = 0; i < data.contacts.length; i++) {
                  let item = data.contacts[i];
                  this.contacts[i] = item && !(<any>item).toJSON ? new ContactProfile(item) : <ContactProfile>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["contacts"])) {
              this.contacts = [] as any;
              for (let item of _data["contacts"])
                  this.contacts!.push(ContactProfile.fromJS(item));
          }
      }
  }

  static fromJS(data: any): ContactType {
      data = typeof data === 'object' ? data : {};
      let result = new ContactType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.contacts)) {
          data["contacts"] = [];
          for (let item of this.contacts)
              data["contacts"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IContactType extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  contacts: IContactProfile[] | undefined;
}

export class FactFindDependent extends _FactFindEntityBase implements IFactFindDependent {
  id!: number;
  guardian!: ClientSelector;
  firstName!: string | undefined;
  lastName!: string | undefined;
  dateOfBirth!: string | undefined;
  age!: number;
  taxNumber!: string | undefined;
  relationId!: number | undefined;
  relation!: PersonalRelation | undefined;
  employmentStatusID!: number | undefined;
  employmentStatus!: EmploymentStatus | undefined;
  sex!: string | undefined;
  isIncapacitatedId!: number | undefined;
  isIncapacitated!: YesNoDefault | undefined;
  isOver65Id!: number | undefined;
  isOver65!: YesNoDefault | undefined;
  isWidowWidowerId!: number | undefined;
  isWidowWidower!: YesNoDefault | undefined;
  isFinanciallyDependantId!: number | undefined;
  isFinanciallyDependant!: YesNoDefault | undefined;

  constructor(data?: IFactFindDependent) {
      super(data);
      if (data) {
          this.relation = data.relation && !(<any>data.relation).toJSON ? new PersonalRelation(data.relation) : <PersonalRelation>this.relation;
          this.employmentStatus = data.employmentStatus && !(<any>data.employmentStatus).toJSON ? new EmploymentStatus(data.employmentStatus) : <EmploymentStatus>this.employmentStatus;
          this.isIncapacitated = data.isIncapacitated && !(<any>data.isIncapacitated).toJSON ? new YesNoDefault(data.isIncapacitated) : <YesNoDefault>this.isIncapacitated;
          this.isOver65 = data.isOver65 && !(<any>data.isOver65).toJSON ? new YesNoDefault(data.isOver65) : <YesNoDefault>this.isOver65;
          this.isWidowWidower = data.isWidowWidower && !(<any>data.isWidowWidower).toJSON ? new YesNoDefault(data.isWidowWidower) : <YesNoDefault>this.isWidowWidower;
          this.isFinanciallyDependant = data.isFinanciallyDependant && !(<any>data.isFinanciallyDependant).toJSON ? new YesNoDefault(data.isFinanciallyDependant) : <YesNoDefault>this.isFinanciallyDependant;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.guardian = _data["guardian"];
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          this.dateOfBirth = _data["dateOfBirth"];
          this.age = _data["age"];
          this.taxNumber = _data["taxNumber"];
          this.relationId = _data["relationId"];
          this.relation = _data["relation"] ? PersonalRelation.fromJS(_data["relation"]) : <any>undefined;
          this.employmentStatusID = _data["employmentStatusID"];
          this.employmentStatus = _data["employmentStatus"] ? EmploymentStatus.fromJS(_data["employmentStatus"]) : <any>undefined;
          this.sex = _data["sex"];
          this.isIncapacitatedId = _data["isIncapacitatedId"];
          this.isIncapacitated = _data["isIncapacitated"] ? YesNoDefault.fromJS(_data["isIncapacitated"]) : <any>undefined;
          this.isOver65Id = _data["isOver65Id"];
          this.isOver65 = _data["isOver65"] ? YesNoDefault.fromJS(_data["isOver65"]) : <any>undefined;
          this.isWidowWidowerId = _data["isWidowWidowerId"];
          this.isWidowWidower = _data["isWidowWidower"] ? YesNoDefault.fromJS(_data["isWidowWidower"]) : <any>undefined;
          this.isFinanciallyDependantId = _data["isFinanciallyDependantId"];
          this.isFinanciallyDependant = _data["isFinanciallyDependant"] ? YesNoDefault.fromJS(_data["isFinanciallyDependant"]) : <any>undefined;
      }
  }

  static fromJS(data: any): FactFindDependent {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindDependent();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["guardian"] = this.guardian;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["dateOfBirth"] = this.dateOfBirth;
      data["age"] = this.age;
      data["taxNumber"] = this.taxNumber;
      data["relationId"] = this.relationId;
      data["relation"] = this.relation ? this.relation.toJSON() : <any>undefined;
      data["employmentStatusID"] = this.employmentStatusID;
      data["employmentStatus"] = this.employmentStatus ? this.employmentStatus.toJSON() : <any>undefined;
      data["sex"] = this.sex;
      data["isIncapacitatedId"] = this.isIncapacitatedId;
      data["isIncapacitated"] = this.isIncapacitated ? this.isIncapacitated.toJSON() : <any>undefined;
      data["isOver65Id"] = this.isOver65Id;
      data["isOver65"] = this.isOver65 ? this.isOver65.toJSON() : <any>undefined;
      data["isWidowWidowerId"] = this.isWidowWidowerId;
      data["isWidowWidower"] = this.isWidowWidower ? this.isWidowWidower.toJSON() : <any>undefined;
      data["isFinanciallyDependantId"] = this.isFinanciallyDependantId;
      data["isFinanciallyDependant"] = this.isFinanciallyDependant ? this.isFinanciallyDependant.toJSON() : <any>undefined;
      super.toJSON(data);
      return data;
  }
}

export interface IFactFindDependent extends I_FactFindEntityBase {
  id: number;
  guardian: ClientSelector;
  firstName: string | undefined;
  lastName: string | undefined;
  dateOfBirth: string | undefined;
  age: number;
  taxNumber: string | undefined;
  relationId: number | undefined;
  relation: IPersonalRelation | undefined;
  employmentStatusID: number | undefined;
  employmentStatus: IEmploymentStatus | undefined;
  sex: string | undefined;
  isIncapacitatedId: number | undefined;
  isIncapacitated: IYesNoDefault | undefined;
  isOver65Id: number | undefined;
  isOver65: IYesNoDefault | undefined;
  isWidowWidowerId: number | undefined;
  isWidowWidower: IYesNoDefault | undefined;
  isFinanciallyDependantId: number | undefined;
  isFinanciallyDependant: IYesNoDefault | undefined;
}

export class PersonalRelation extends _LookupBase implements IPersonalRelation {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;

  constructor(data?: IPersonalRelation) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
      }
  }

  static fromJS(data: any): PersonalRelation {
      data = typeof data === 'object' ? data : {};
      let result = new PersonalRelation();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      super.toJSON(data);
      return data;
  }
}

export interface IPersonalRelation extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
}

export class FactFindIncome extends _FactFindEntityBase implements IFactFindIncome {
  id!: number;
  incomeOwner!: ClientSelector;
  companySource!: string | undefined;
  incomeTypeId!: number;
  incomeType!: IncomeType | undefined;
  incomeTypeOthers!: string | undefined;
  incomeCategoryId!: number | undefined;
  incomeCategory!: IncomeCategory | undefined;
  taxTreatmentId!: number | undefined;
  taxTreatment!: TaxTreatment | undefined;
  taxTreatmentDetails!: string | undefined;
  dateStarted!: string | undefined;
  dateEnded!: string | undefined;
  amountPerYear!: number | undefined;
  isDomesticIncomeId!: number | undefined;
  isDomesticIncome!: YesNoDefault | undefined;

  constructor(data?: IFactFindIncome) {
      super(data);
      if (data) {
          this.incomeType = data.incomeType && !(<any>data.incomeType).toJSON ? new IncomeType(data.incomeType) : <IncomeType>this.incomeType;
          this.incomeCategory = data.incomeCategory && !(<any>data.incomeCategory).toJSON ? new IncomeCategory(data.incomeCategory) : <IncomeCategory>this.incomeCategory;
          this.taxTreatment = data.taxTreatment && !(<any>data.taxTreatment).toJSON ? new TaxTreatment(data.taxTreatment) : <TaxTreatment>this.taxTreatment;
          this.isDomesticIncome = data.isDomesticIncome && !(<any>data.isDomesticIncome).toJSON ? new YesNoDefault(data.isDomesticIncome) : <YesNoDefault>this.isDomesticIncome;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.incomeOwner = _data["incomeOwner"];
          this.companySource = _data["companySource"];
          this.incomeTypeId = _data["incomeTypeId"];
          this.incomeType = _data["incomeType"] ? IncomeType.fromJS(_data["incomeType"]) : <any>undefined;
          this.incomeTypeOthers = _data["incomeTypeOthers"];
          this.incomeCategoryId = _data["incomeCategoryId"];
          this.incomeCategory = _data["incomeCategory"] ? IncomeCategory.fromJS(_data["incomeCategory"]) : <any>undefined;
          this.taxTreatmentId = _data["taxTreatmentId"];
          this.taxTreatment = _data["taxTreatment"] ? TaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
          this.taxTreatmentDetails = _data["taxTreatmentDetails"];
          this.dateStarted = _data["dateStarted"];
          this.dateEnded = _data["dateEnded"];
          this.amountPerYear = _data["amountPerYear"];
          this.isDomesticIncomeId = _data["isDomesticIncomeId"];
          this.isDomesticIncome = _data["isDomesticIncome"] ? YesNoDefault.fromJS(_data["isDomesticIncome"]) : <any>undefined;
      }
  }

  static fromJS(data: any): FactFindIncome {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindIncome();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["incomeOwner"] = this.incomeOwner;
      data["companySource"] = this.companySource;
      data["incomeTypeId"] = this.incomeTypeId;
      data["incomeType"] = this.incomeType ? this.incomeType.toJSON() : <any>undefined;
      data["incomeTypeOthers"] = this.incomeTypeOthers;
      data["incomeCategoryId"] = this.incomeCategoryId;
      data["incomeCategory"] = this.incomeCategory ? this.incomeCategory.toJSON() : <any>undefined;
      data["taxTreatmentId"] = this.taxTreatmentId;
      data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
      data["taxTreatmentDetails"] = this.taxTreatmentDetails;
      data["dateStarted"] = this.dateStarted;
      data["dateEnded"] = this.dateEnded;
      data["amountPerYear"] = this.amountPerYear;
      data["isDomesticIncomeId"] = this.isDomesticIncomeId;
      data["isDomesticIncome"] = this.isDomesticIncome ? this.isDomesticIncome.toJSON() : <any>undefined;
      super.toJSON(data);
      return data;
  }
}

export interface IFactFindIncome extends I_FactFindEntityBase {
  id: number;
  incomeOwner: ClientSelector;
  companySource: string | undefined;
  incomeTypeId: number;
  incomeType: IIncomeType | undefined;
  incomeTypeOthers: string | undefined;
  incomeCategoryId: number | undefined;
  incomeCategory: IIncomeCategory | undefined;
  taxTreatmentId: number | undefined;
  taxTreatment: ITaxTreatment | undefined;
  taxTreatmentDetails: string | undefined;
  dateStarted: string | undefined;
  dateEnded: string | undefined;
  amountPerYear: number | undefined;
  isDomesticIncomeId: number | undefined;
  isDomesticIncome: IYesNoDefault | undefined;
}

export class IncomeType extends _LookupBase implements IIncomeType {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  incomes!: FactFindIncome[] | undefined;

  constructor(data?: IIncomeType) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["incomes"])) {
              this.incomes = [] as any;
              for (let item of _data["incomes"])
                  this.incomes!.push(FactFindIncome.fromJS(item));
          }
      }
  }

  static fromJS(data: any): IncomeType {
      data = typeof data === 'object' ? data : {};
      let result = new IncomeType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.incomes)) {
          data["incomes"] = [];
          for (let item of this.incomes)
              data["incomes"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IIncomeType extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  incomes: FactFindIncome[] | undefined;
}

export class IncomeCategory extends _LookupBase implements IIncomeCategory {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  incomes!: FactFindIncome[] | undefined;

  constructor(data?: IIncomeCategory) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["incomes"])) {
              this.incomes = [] as any;
              for (let item of _data["incomes"])
                  this.incomes!.push(FactFindIncome.fromJS(item));
          }
      }
  }

  static fromJS(data: any): IncomeCategory {
      data = typeof data === 'object' ? data : {};
      let result = new IncomeCategory();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.incomes)) {
          data["incomes"] = [];
          for (let item of this.incomes)
              data["incomes"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IIncomeCategory extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  incomes: FactFindIncome[] | undefined;
}

export class TaxTreatment extends _LookupBase implements ITaxTreatment {
  id!: number;
  name!: string | undefined;
  companyId!: number | undefined;
  incomes!: FactFindIncome[] | undefined;

  constructor(data?: ITaxTreatment) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.companyId = _data["companyId"];
          if (Array.isArray(_data["incomes"])) {
              this.incomes = [] as any;
              for (let item of _data["incomes"])
                  this.incomes!.push(FactFindIncome.fromJS(item));
          }
      }
  }

  static fromJS(data: any): TaxTreatment {
      data = typeof data === 'object' ? data : {};
      let result = new TaxTreatment();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["companyId"] = this.companyId;
      if (Array.isArray(this.incomes)) {
          data["incomes"] = [];
          for (let item of this.incomes)
              data["incomes"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface ITaxTreatment extends I_LookupBase {
  id: number;
  name: string | undefined;
  companyId: number | undefined;
  incomes: FactFindIncome[] | undefined;
}

/** The unique identifer assigned to a client by a data feed provider (life office). It's possible that a client can have multiple identifiers from a single provider if duplciate records have been merged. */
export class DataFeedIdentifier implements IDataFeedIdentifier {
  id!: number;
  contactId!: number;
  contact!: ContactProfile | undefined;
  clientSelector!: ClientSelector;
  provider!: string | undefined;
  identifier!: string | undefined;

  constructor(data?: IDataFeedIdentifier) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
          this.contact = data.contact && !(<any>data.contact).toJSON ? new ContactProfile(data.contact) : <ContactProfile>this.contact;
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.contactId = _data["contactId"];
          this.contact = _data["contact"] ? ContactProfile.fromJS(_data["contact"]) : <any>undefined;
          this.clientSelector = _data["clientSelector"];
          this.provider = _data["provider"];
          this.identifier = _data["identifier"];
      }
  }

  static fromJS(data: any): DataFeedIdentifier {
      data = typeof data === 'object' ? data : {};
      let result = new DataFeedIdentifier();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["contactId"] = this.contactId;
      data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
      data["clientSelector"] = this.clientSelector;
      data["provider"] = this.provider;
      data["identifier"] = this.identifier;
      return data;
  }
}

/** The unique identifer assigned to a client by a data feed provider (life office). It's possible that a client can have multiple identifiers from a single provider if duplciate records have been merged. */
export interface IDataFeedIdentifier {
  id: number;
  contactId: number;
  contact: IContactProfile | undefined;
  clientSelector: ClientSelector;
  provider: string | undefined;
  identifier: string | undefined;
}

export class PolicyRoleType extends _LookupBase implements IPolicyRoleType {
  id!: number;
  name!: string | undefined;
  constant!: string | undefined;
  companyId!: number | undefined;

  constructor(data?: IPolicyRoleType) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.constant = _data["constant"];
          this.companyId = _data["companyId"];
      }
  }

  static fromJS(data: any): PolicyRoleType {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyRoleType();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["constant"] = this.constant;
      data["companyId"] = this.companyId;
      super.toJSON(data);
      return data;
  }
}

export interface IPolicyRoleType extends I_LookupBase {
  id: number;
  name: string | undefined;
  constant: string | undefined;
  companyId: number | undefined;
}

export class UpdateLiabilityMortgageCommand extends _FactFindUpdateCommandBase implements IUpdateLiabilityMortgageCommand {
  contactOwnerId_AddedBy!: number;
  contactOwnerId_LastUpdatedBy!: number;
  policyOwner!: ClientSelector;
  policyTermInYears!: number;
  description!: string | undefined;
  isAgencyPolicy!: boolean;
  policyNo!: string | undefined;
  premium!: number | undefined;
  inceptionDate!: string | undefined;
  maturityDate!: string | undefined;
  fundValueDate!: string | undefined;
  totalPremiumsPaid!: number | undefined;
  providerId!: number | undefined;
  paymentFrequencyId!: number | undefined;
  policyBasisId!: number | undefined;
  statusId!: number | undefined;
  categoryId!: number | undefined;
  subCategoryId!: number | undefined;
  indexedId!: number | undefined;
  convertibleId!: number | undefined;
  additionalDetails!: UpdatePolicyDetailsCommand | undefined;
  benefits!: PolicyBenefitDto[] | undefined;
  policyRoles!: PolicyRole[] | undefined;
  policyFunds!: PolicyFund[] | undefined;

  constructor(data?: IUpdateLiabilityMortgageCommand) {
      super(data);
      if (data) {
          this.additionalDetails = data.additionalDetails && !(<any>data.additionalDetails).toJSON ? new UpdatePolicyDetailsCommand(data.additionalDetails) : <UpdatePolicyDetailsCommand>this.additionalDetails;
          if (data.benefits) {
              this.benefits = [];
              for (let i = 0; i < data.benefits.length; i++) {
                  let item = data.benefits[i];
                  this.benefits[i] = item && !(<any>item).toJSON ? new PolicyBenefitDto(item) : <PolicyBenefitDto>item;
              }
          }
          if (data.policyRoles) {
              this.policyRoles = [];
              for (let i = 0; i < data.policyRoles.length; i++) {
                  let item = data.policyRoles[i];
                  this.policyRoles[i] = item && !(<any>item).toJSON ? new PolicyRole(item) : <PolicyRole>item;
              }
          }
          if (data.policyFunds) {
              this.policyFunds = [];
              for (let i = 0; i < data.policyFunds.length; i++) {
                  let item = data.policyFunds[i];
                  this.policyFunds[i] = item && !(<any>item).toJSON ? new PolicyFund(item) : <PolicyFund>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.contactOwnerId_AddedBy = _data["contactOwnerId_AddedBy"];
          this.contactOwnerId_LastUpdatedBy = _data["contactOwnerId_LastUpdatedBy"];
          this.policyOwner = _data["policyOwner"];
          this.policyTermInYears = _data["policyTermInYears"];
          this.description = _data["description"];
          this.isAgencyPolicy = _data["isAgencyPolicy"];
          this.policyNo = _data["policyNo"];
          this.premium = _data["premium"];
          this.inceptionDate = _data["inceptionDate"];
          this.maturityDate = _data["maturityDate"];
          this.fundValueDate = _data["fundValueDate"];
          this.totalPremiumsPaid = _data["totalPremiumsPaid"];
          this.providerId = _data["providerId"];
          this.paymentFrequencyId = _data["paymentFrequencyId"];
          this.policyBasisId = _data["policyBasisId"];
          this.statusId = _data["statusId"];
          this.categoryId = _data["categoryId"];
          this.subCategoryId = _data["subCategoryId"];
          this.indexedId = _data["indexedId"];
          this.convertibleId = _data["convertibleId"];
          this.additionalDetails = _data["additionalDetails"] ? UpdatePolicyDetailsCommand.fromJS(_data["additionalDetails"]) : <any>undefined;
          if (Array.isArray(_data["benefits"])) {
              this.benefits = [] as any;
              for (let item of _data["benefits"])
                  this.benefits!.push(PolicyBenefitDto.fromJS(item));
          }
          if (Array.isArray(_data["policyRoles"])) {
              this.policyRoles = [] as any;
              for (let item of _data["policyRoles"])
                  this.policyRoles!.push(PolicyRole.fromJS(item));
          }
          if (Array.isArray(_data["policyFunds"])) {
              this.policyFunds = [] as any;
              for (let item of _data["policyFunds"])
                  this.policyFunds!.push(PolicyFund.fromJS(item));
          }
      }
  }

  static fromJS(data: any): UpdateLiabilityMortgageCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateLiabilityMortgageCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["contactOwnerId_AddedBy"] = this.contactOwnerId_AddedBy;
      data["contactOwnerId_LastUpdatedBy"] = this.contactOwnerId_LastUpdatedBy;
      data["policyOwner"] = this.policyOwner;
      data["policyTermInYears"] = this.policyTermInYears;
      data["description"] = this.description;
      data["isAgencyPolicy"] = this.isAgencyPolicy;
      data["policyNo"] = this.policyNo;
      data["premium"] = this.premium;
      data["inceptionDate"] = this.inceptionDate;
      data["maturityDate"] = this.maturityDate;
      data["fundValueDate"] = this.fundValueDate;
      data["totalPremiumsPaid"] = this.totalPremiumsPaid;
      data["providerId"] = this.providerId;
      data["paymentFrequencyId"] = this.paymentFrequencyId;
      data["policyBasisId"] = this.policyBasisId;
      data["statusId"] = this.statusId;
      data["categoryId"] = this.categoryId;
      data["subCategoryId"] = this.subCategoryId;
      data["indexedId"] = this.indexedId;
      data["convertibleId"] = this.convertibleId;
      data["additionalDetails"] = this.additionalDetails ? this.additionalDetails.toJSON() : <any>undefined;
      if (Array.isArray(this.benefits)) {
          data["benefits"] = [];
          for (let item of this.benefits)
              data["benefits"].push(item.toJSON());
      }
      if (Array.isArray(this.policyRoles)) {
          data["policyRoles"] = [];
          for (let item of this.policyRoles)
              data["policyRoles"].push(item.toJSON());
      }
      if (Array.isArray(this.policyFunds)) {
          data["policyFunds"] = [];
          for (let item of this.policyFunds)
              data["policyFunds"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IUpdateLiabilityMortgageCommand extends I_FactFindUpdateCommandBase {
  contactOwnerId_AddedBy: number;
  contactOwnerId_LastUpdatedBy: number;
  policyOwner: ClientSelector;
  policyTermInYears: number;
  description: string | undefined;
  isAgencyPolicy: boolean;
  policyNo: string | undefined;
  premium: number | undefined;
  inceptionDate: string | undefined;
  maturityDate: string | undefined;
  fundValueDate: string | undefined;
  totalPremiumsPaid: number | undefined;
  providerId: number | undefined;
  paymentFrequencyId: number | undefined;
  policyBasisId: number | undefined;
  statusId: number | undefined;
  categoryId: number | undefined;
  subCategoryId: number | undefined;
  indexedId: number | undefined;
  convertibleId: number | undefined;
  additionalDetails: IUpdatePolicyDetailsCommand | undefined;
  benefits: IPolicyBenefitDto[] | undefined;
  policyRoles: IPolicyRole[] | undefined;
  policyFunds: IPolicyFund[] | undefined;
}

export class UpdatePolicyDetailsCommand implements IUpdatePolicyDetailsCommand {
  id!: number;
  fK_ContactPolicyID!: number;
  policyOccupationClass!: string | undefined;
  deferredPeriodInWeeks!: number;
  ageIncomePayableTo!: number;
  normalRetirementAge!: number;
  schemeName!: string | undefined;
  ceasingAge!: number;
  others!: string | undefined;
  currentBalance!: number;
  fixedRateStartDate!: string;
  fixedRateTermYears!: number;
  monthlyRepaymentAmount!: number;
  monthlyOverPaymentAmount!: number;
  missedLatePayments!: number | undefined;
  valuationAmount!: number;
  purchaseAmount!: number;
  sitePrice!: number;
  propertyValue!: number;
  mortgageRequired!: number;
  propertyAddressLine_1!: string | undefined;
  propertyAddressLine_2!: string | undefined;
  propertyAddressLine_3!: string | undefined;
  propertyAddressLine_4!: string | undefined;
  propertyAddressLine_5!: string | undefined;
  amountBorrowed!: number;
  currentValue!: number;
  currentPercentageRate!: number;
  currentRateEndDate!: string;
  principalPrivateResidenceId!: number | undefined;
  investmentPropertyId!: number | undefined;
  rentalIncomeId!: number | undefined;
  isVacantPossessionId!: number | undefined;
  isSoleOccupantId!: number | undefined;
  isBusinessId!: number | undefined;
  propertyStatusId!: number | undefined;
  mortgageCategoryId!: number | undefined;
  mortgageTypeId!: number | undefined;
  mortgageRateTypeId!: number | undefined;
  approvalStatusId!: number | undefined;

  constructor(data?: IUpdatePolicyDetailsCommand) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.fK_ContactPolicyID = _data["fK_ContactPolicyID"];
          this.policyOccupationClass = _data["policyOccupationClass"];
          this.deferredPeriodInWeeks = _data["deferredPeriodInWeeks"];
          this.ageIncomePayableTo = _data["ageIncomePayableTo"];
          this.normalRetirementAge = _data["normalRetirementAge"];
          this.schemeName = _data["schemeName"];
          this.ceasingAge = _data["ceasingAge"];
          this.others = _data["others"];
          this.currentBalance = _data["currentBalance"];
          this.fixedRateStartDate = _data["fixedRateStartDate"];
          this.fixedRateTermYears = _data["fixedRateTermYears"];
          this.monthlyRepaymentAmount = _data["monthlyRepaymentAmount"];
          this.monthlyOverPaymentAmount = _data["monthlyOverPaymentAmount"];
          this.missedLatePayments = _data["missedLatePayments"];
          this.valuationAmount = _data["valuationAmount"];
          this.purchaseAmount = _data["purchaseAmount"];
          this.sitePrice = _data["sitePrice"];
          this.propertyValue = _data["propertyValue"];
          this.mortgageRequired = _data["mortgageRequired"];
          this.propertyAddressLine_1 = _data["propertyAddressLine_1"];
          this.propertyAddressLine_2 = _data["propertyAddressLine_2"];
          this.propertyAddressLine_3 = _data["propertyAddressLine_3"];
          this.propertyAddressLine_4 = _data["propertyAddressLine_4"];
          this.propertyAddressLine_5 = _data["propertyAddressLine_5"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.currentValue = _data["currentValue"];
          this.currentPercentageRate = _data["currentPercentageRate"];
          this.currentRateEndDate = _data["currentRateEndDate"];
          this.principalPrivateResidenceId = _data["principalPrivateResidenceId"];
          this.investmentPropertyId = _data["investmentPropertyId"];
          this.rentalIncomeId = _data["rentalIncomeId"];
          this.isVacantPossessionId = _data["isVacantPossessionId"];
          this.isSoleOccupantId = _data["isSoleOccupantId"];
          this.isBusinessId = _data["isBusinessId"];
          this.propertyStatusId = _data["propertyStatusId"];
          this.mortgageCategoryId = _data["mortgageCategoryId"];
          this.mortgageTypeId = _data["mortgageTypeId"];
          this.mortgageRateTypeId = _data["mortgageRateTypeId"];
          this.approvalStatusId = _data["approvalStatusId"];
      }
  }

  static fromJS(data: any): UpdatePolicyDetailsCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdatePolicyDetailsCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["fK_ContactPolicyID"] = this.fK_ContactPolicyID;
      data["policyOccupationClass"] = this.policyOccupationClass;
      data["deferredPeriodInWeeks"] = this.deferredPeriodInWeeks;
      data["ageIncomePayableTo"] = this.ageIncomePayableTo;
      data["normalRetirementAge"] = this.normalRetirementAge;
      data["schemeName"] = this.schemeName;
      data["ceasingAge"] = this.ceasingAge;
      data["others"] = this.others;
      data["currentBalance"] = this.currentBalance;
      data["fixedRateStartDate"] = this.fixedRateStartDate;
      data["fixedRateTermYears"] = this.fixedRateTermYears;
      data["monthlyRepaymentAmount"] = this.monthlyRepaymentAmount;
      data["monthlyOverPaymentAmount"] = this.monthlyOverPaymentAmount;
      data["missedLatePayments"] = this.missedLatePayments;
      data["valuationAmount"] = this.valuationAmount;
      data["purchaseAmount"] = this.purchaseAmount;
      data["sitePrice"] = this.sitePrice;
      data["propertyValue"] = this.propertyValue;
      data["mortgageRequired"] = this.mortgageRequired;
      data["propertyAddressLine_1"] = this.propertyAddressLine_1;
      data["propertyAddressLine_2"] = this.propertyAddressLine_2;
      data["propertyAddressLine_3"] = this.propertyAddressLine_3;
      data["propertyAddressLine_4"] = this.propertyAddressLine_4;
      data["propertyAddressLine_5"] = this.propertyAddressLine_5;
      data["amountBorrowed"] = this.amountBorrowed;
      data["currentValue"] = this.currentValue;
      data["currentPercentageRate"] = this.currentPercentageRate;
      data["currentRateEndDate"] = this.currentRateEndDate;
      data["principalPrivateResidenceId"] = this.principalPrivateResidenceId;
      data["investmentPropertyId"] = this.investmentPropertyId;
      data["rentalIncomeId"] = this.rentalIncomeId;
      data["isVacantPossessionId"] = this.isVacantPossessionId;
      data["isSoleOccupantId"] = this.isSoleOccupantId;
      data["isBusinessId"] = this.isBusinessId;
      data["propertyStatusId"] = this.propertyStatusId;
      data["mortgageCategoryId"] = this.mortgageCategoryId;
      data["mortgageTypeId"] = this.mortgageTypeId;
      data["mortgageRateTypeId"] = this.mortgageRateTypeId;
      data["approvalStatusId"] = this.approvalStatusId;
      return data;
  }
}

export interface IUpdatePolicyDetailsCommand {
  id: number;
  fK_ContactPolicyID: number;
  policyOccupationClass: string | undefined;
  deferredPeriodInWeeks: number;
  ageIncomePayableTo: number;
  normalRetirementAge: number;
  schemeName: string | undefined;
  ceasingAge: number;
  others: string | undefined;
  currentBalance: number;
  fixedRateStartDate: string;
  fixedRateTermYears: number;
  monthlyRepaymentAmount: number;
  monthlyOverPaymentAmount: number;
  missedLatePayments: number | undefined;
  valuationAmount: number;
  purchaseAmount: number;
  sitePrice: number;
  propertyValue: number;
  mortgageRequired: number;
  propertyAddressLine_1: string | undefined;
  propertyAddressLine_2: string | undefined;
  propertyAddressLine_3: string | undefined;
  propertyAddressLine_4: string | undefined;
  propertyAddressLine_5: string | undefined;
  amountBorrowed: number;
  currentValue: number;
  currentPercentageRate: number;
  currentRateEndDate: string;
  principalPrivateResidenceId: number | undefined;
  investmentPropertyId: number | undefined;
  rentalIncomeId: number | undefined;
  isVacantPossessionId: number | undefined;
  isSoleOccupantId: number | undefined;
  isBusinessId: number | undefined;
  propertyStatusId: number | undefined;
  mortgageCategoryId: number | undefined;
  mortgageTypeId: number | undefined;
  mortgageRateTypeId: number | undefined;
  approvalStatusId: number | undefined;
}

export class FactFindLiabilityOtherDto extends FactFindDto implements IFactFindLiabilityOtherDto {
  id!: number;
  owner!: ClientSelector;
  lender!: ProductProviderDto | undefined;
  liabilityType!: LiabilityTypeDto | undefined;
  dateStarted!: string;
  termInYears!: number;
  amountBorrowed!: number;
  currentBalance!: number;
  monthlyRepayment!: number;
  annualPercentageRate!: number;
  otherDetails!: string | undefined;

  constructor(data?: IFactFindLiabilityOtherDto) {
      super(data);
      if (data) {
          this.lender = data.lender && !(<any>data.lender).toJSON ? new ProductProviderDto(data.lender) : <ProductProviderDto>this.lender;
          this.liabilityType = data.liabilityType && !(<any>data.liabilityType).toJSON ? new LiabilityTypeDto(data.liabilityType) : <LiabilityTypeDto>this.liabilityType;
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.id = _data["id"];
          this.owner = _data["owner"];
          this.lender = _data["lender"] ? ProductProviderDto.fromJS(_data["lender"]) : <any>undefined;
          this.liabilityType = _data["liabilityType"] ? LiabilityTypeDto.fromJS(_data["liabilityType"]) : <any>undefined;
          this.dateStarted = _data["dateStarted"];
          this.termInYears = _data["termInYears"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.currentBalance = _data["currentBalance"];
          this.monthlyRepayment = _data["monthlyRepayment"];
          this.annualPercentageRate = _data["annualPercentageRate"];
          this.otherDetails = _data["otherDetails"];
      }
  }

  static fromJS(data: any): FactFindLiabilityOtherDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindLiabilityOtherDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["owner"] = this.owner;
      data["lender"] = this.lender ? this.lender.toJSON() : <any>undefined;
      data["liabilityType"] = this.liabilityType ? this.liabilityType.toJSON() : <any>undefined;
      data["dateStarted"] = this.dateStarted;
      data["termInYears"] = this.termInYears;
      data["amountBorrowed"] = this.amountBorrowed;
      data["currentBalance"] = this.currentBalance;
      data["monthlyRepayment"] = this.monthlyRepayment;
      data["annualPercentageRate"] = this.annualPercentageRate;
      data["otherDetails"] = this.otherDetails;
      super.toJSON(data);
      return data;
  }
}

export interface IFactFindLiabilityOtherDto extends IFactFindDto {
  id: number;
  owner: ClientSelector;
  lender: IProductProviderDto | undefined;
  liabilityType: ILiabilityTypeDto | undefined;
  dateStarted: string;
  termInYears: number;
  amountBorrowed: number;
  currentBalance: number;
  monthlyRepayment: number;
  annualPercentageRate: number;
  otherDetails: string | undefined;
}

export class CreateLiabilityOtherCommand extends _FactFindCreateCommandBase implements ICreateLiabilityOtherCommand {
  owner!: ClientSelector;
  lenderId!: number;
  liabilityTypeId!: number;
  dateStarted!: string;
  termInYears!: number;
  amountBorrowed!: number;
  currentBalance!: number;
  monthlyRepayment!: number;
  annualPercentageRate!: number;
  otherDetails!: string | undefined;

  constructor(data?: ICreateLiabilityOtherCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.owner = _data["owner"];
          this.lenderId = _data["lenderId"];
          this.liabilityTypeId = _data["liabilityTypeId"];
          this.dateStarted = _data["dateStarted"];
          this.termInYears = _data["termInYears"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.currentBalance = _data["currentBalance"];
          this.monthlyRepayment = _data["monthlyRepayment"];
          this.annualPercentageRate = _data["annualPercentageRate"];
          this.otherDetails = _data["otherDetails"];
      }
  }

  static fromJS(data: any): CreateLiabilityOtherCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateLiabilityOtherCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["owner"] = this.owner;
      data["lenderId"] = this.lenderId;
      data["liabilityTypeId"] = this.liabilityTypeId;
      data["dateStarted"] = this.dateStarted;
      data["termInYears"] = this.termInYears;
      data["amountBorrowed"] = this.amountBorrowed;
      data["currentBalance"] = this.currentBalance;
      data["monthlyRepayment"] = this.monthlyRepayment;
      data["annualPercentageRate"] = this.annualPercentageRate;
      data["otherDetails"] = this.otherDetails;
      super.toJSON(data);
      return data;
  }
}

export interface ICreateLiabilityOtherCommand extends I_FactFindCreateCommandBase {
  owner: ClientSelector;
  lenderId: number;
  liabilityTypeId: number;
  dateStarted: string;
  termInYears: number;
  amountBorrowed: number;
  currentBalance: number;
  monthlyRepayment: number;
  annualPercentageRate: number;
  otherDetails: string | undefined;
}

export class UpdateLiabilityOtherCommand extends _FactFindUpdateCommandBase implements IUpdateLiabilityOtherCommand {
  owner!: ClientSelector;
  lenderId!: number;
  liabilityTypeId!: number;
  dateStarted!: string;
  termInYears!: number;
  amountBorrowed!: number;
  currentBalance!: number;
  monthlyRepayment!: number;
  annualPercentageRate!: number;
  otherDetails!: string | undefined;

  constructor(data?: IUpdateLiabilityOtherCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.owner = _data["owner"];
          this.lenderId = _data["lenderId"];
          this.liabilityTypeId = _data["liabilityTypeId"];
          this.dateStarted = _data["dateStarted"];
          this.termInYears = _data["termInYears"];
          this.amountBorrowed = _data["amountBorrowed"];
          this.currentBalance = _data["currentBalance"];
          this.monthlyRepayment = _data["monthlyRepayment"];
          this.annualPercentageRate = _data["annualPercentageRate"];
          this.otherDetails = _data["otherDetails"];
      }
  }

  static fromJS(data: any): UpdateLiabilityOtherCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateLiabilityOtherCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["owner"] = this.owner;
      data["lenderId"] = this.lenderId;
      data["liabilityTypeId"] = this.liabilityTypeId;
      data["dateStarted"] = this.dateStarted;
      data["termInYears"] = this.termInYears;
      data["amountBorrowed"] = this.amountBorrowed;
      data["currentBalance"] = this.currentBalance;
      data["monthlyRepayment"] = this.monthlyRepayment;
      data["annualPercentageRate"] = this.annualPercentageRate;
      data["otherDetails"] = this.otherDetails;
      super.toJSON(data);
      return data;
  }
}

export interface IUpdateLiabilityOtherCommand extends I_FactFindUpdateCommandBase {
  owner: ClientSelector;
  lenderId: number;
  liabilityTypeId: number;
  dateStarted: string;
  termInYears: number;
  amountBorrowed: number;
  currentBalance: number;
  monthlyRepayment: number;
  annualPercentageRate: number;
  otherDetails: string | undefined;
}

export class CreatePensionCommand extends _FactFindCreateCommandBase implements ICreatePensionCommand {
  policyOwner!: ClientSelector;
  statusId!: number | undefined;
  categoryId!: number | undefined;
  subCategoryId!: number | undefined;
  description!: string | undefined;
  providerId!: number | undefined;
  paymentFrequencyId!: number | undefined;
  policyBasisId!: number | undefined;
  isAgencyPolicy!: boolean;
  agencyNumber!: string | undefined;
  totalPremiumsPaid!: number;
  policyNo!: string | undefined;
  premium!: number | undefined;
  inceptionDate!: string | undefined;
  maturityDate!: string | undefined;
  fundValueDate!: string | undefined;
  indexedId!: number | undefined;
  convertibleId!: number | undefined;
  nra!: number;
  policyRoles!: PolicyRoleDto[] | undefined;
  policyFunds!: PolicyFundDto[] | undefined;

  constructor(data?: ICreatePensionCommand) {
      super(data);
      if (data) {
          if (data.policyRoles) {
              this.policyRoles = [];
              for (let i = 0; i < data.policyRoles.length; i++) {
                  let item = data.policyRoles[i];
                  this.policyRoles[i] = item && !(<any>item).toJSON ? new PolicyRoleDto(item) : <PolicyRoleDto>item;
              }
          }
          if (data.policyFunds) {
              this.policyFunds = [];
              for (let i = 0; i < data.policyFunds.length; i++) {
                  let item = data.policyFunds[i];
                  this.policyFunds[i] = item && !(<any>item).toJSON ? new PolicyFundDto(item) : <PolicyFundDto>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.policyOwner = _data["policyOwner"];
          this.statusId = _data["statusId"];
          this.categoryId = _data["categoryId"];
          this.subCategoryId = _data["subCategoryId"];
          this.description = _data["description"];
          this.providerId = _data["providerId"];
          this.paymentFrequencyId = _data["paymentFrequencyId"];
          this.policyBasisId = _data["policyBasisId"];
          this.isAgencyPolicy = _data["isAgencyPolicy"];
          this.agencyNumber = _data["agencyNumber"];
          this.totalPremiumsPaid = _data["totalPremiumsPaid"];
          this.policyNo = _data["policyNo"];
          this.premium = _data["premium"];
          this.inceptionDate = _data["inceptionDate"];
          this.maturityDate = _data["maturityDate"];
          this.fundValueDate = _data["fundValueDate"];
          this.indexedId = _data["indexedId"];
          this.convertibleId = _data["convertibleId"];
          this.nra = _data["nra"];
          if (Array.isArray(_data["policyRoles"])) {
              this.policyRoles = [] as any;
              for (let item of _data["policyRoles"])
                  this.policyRoles!.push(PolicyRoleDto.fromJS(item));
          }
          if (Array.isArray(_data["policyFunds"])) {
              this.policyFunds = [] as any;
              for (let item of _data["policyFunds"])
                  this.policyFunds!.push(PolicyFundDto.fromJS(item));
          }
      }
  }

  static fromJS(data: any): CreatePensionCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreatePensionCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["policyOwner"] = this.policyOwner;
      data["statusId"] = this.statusId;
      data["categoryId"] = this.categoryId;
      data["subCategoryId"] = this.subCategoryId;
      data["description"] = this.description;
      data["providerId"] = this.providerId;
      data["paymentFrequencyId"] = this.paymentFrequencyId;
      data["policyBasisId"] = this.policyBasisId;
      data["isAgencyPolicy"] = this.isAgencyPolicy;
      data["agencyNumber"] = this.agencyNumber;
      data["totalPremiumsPaid"] = this.totalPremiumsPaid;
      data["policyNo"] = this.policyNo;
      data["premium"] = this.premium;
      data["inceptionDate"] = this.inceptionDate;
      data["maturityDate"] = this.maturityDate;
      data["fundValueDate"] = this.fundValueDate;
      data["indexedId"] = this.indexedId;
      data["convertibleId"] = this.convertibleId;
      data["nra"] = this.nra;
      if (Array.isArray(this.policyRoles)) {
          data["policyRoles"] = [];
          for (let item of this.policyRoles)
              data["policyRoles"].push(item.toJSON());
      }
      if (Array.isArray(this.policyFunds)) {
          data["policyFunds"] = [];
          for (let item of this.policyFunds)
              data["policyFunds"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface ICreatePensionCommand extends I_FactFindCreateCommandBase {
  policyOwner: ClientSelector;
  statusId: number | undefined;
  categoryId: number | undefined;
  subCategoryId: number | undefined;
  description: string | undefined;
  providerId: number | undefined;
  paymentFrequencyId: number | undefined;
  policyBasisId: number | undefined;
  isAgencyPolicy: boolean;
  agencyNumber: string | undefined;
  totalPremiumsPaid: number;
  policyNo: string | undefined;
  premium: number | undefined;
  inceptionDate: string | undefined;
  maturityDate: string | undefined;
  fundValueDate: string | undefined;
  indexedId: number | undefined;
  convertibleId: number | undefined;
  nra: number;
  policyRoles: IPolicyRoleDto[] | undefined;
  policyFunds: IPolicyFundDto[] | undefined;
}

export class UpdatePensionCommand extends _FactFindUpdateCommandBase implements IUpdatePensionCommand {
  policyOwner!: ClientSelector;
  statusId!: number | undefined;
  categoryId!: number | undefined;
  subCategoryId!: number | undefined;
  description!: string | undefined;
  providerId!: number | undefined;
  paymentFrequencyId!: number | undefined;
  policyBasisId!: number | undefined;
  isAgencyPolicy!: boolean;
  agencyNumber!: string | undefined;
  totalPremiumsPaid!: number;
  policyNo!: string | undefined;
  premium!: number | undefined;
  inceptionDate!: string | undefined;
  maturityDate!: string | undefined;
  fundValueDate!: string | undefined;
  indexedId!: number | undefined;
  convertibleId!: number | undefined;
  nra!: number;
  policyRoles!: PolicyRoleDto[] | undefined;
  policyFunds!: PolicyFundDto[] | undefined;

  constructor(data?: IUpdatePensionCommand) {
      super(data);
      if (data) {
          if (data.policyRoles) {
              this.policyRoles = [];
              for (let i = 0; i < data.policyRoles.length; i++) {
                  let item = data.policyRoles[i];
                  this.policyRoles[i] = item && !(<any>item).toJSON ? new PolicyRoleDto(item) : <PolicyRoleDto>item;
              }
          }
          if (data.policyFunds) {
              this.policyFunds = [];
              for (let i = 0; i < data.policyFunds.length; i++) {
                  let item = data.policyFunds[i];
                  this.policyFunds[i] = item && !(<any>item).toJSON ? new PolicyFundDto(item) : <PolicyFundDto>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.policyOwner = _data["policyOwner"];
          this.statusId = _data["statusId"];
          this.categoryId = _data["categoryId"];
          this.subCategoryId = _data["subCategoryId"];
          this.description = _data["description"];
          this.providerId = _data["providerId"];
          this.paymentFrequencyId = _data["paymentFrequencyId"];
          this.policyBasisId = _data["policyBasisId"];
          this.isAgencyPolicy = _data["isAgencyPolicy"];
          this.agencyNumber = _data["agencyNumber"];
          this.totalPremiumsPaid = _data["totalPremiumsPaid"];
          this.policyNo = _data["policyNo"];
          this.premium = _data["premium"];
          this.inceptionDate = _data["inceptionDate"];
          this.maturityDate = _data["maturityDate"];
          this.fundValueDate = _data["fundValueDate"];
          this.indexedId = _data["indexedId"];
          this.convertibleId = _data["convertibleId"];
          this.nra = _data["nra"];
          if (Array.isArray(_data["policyRoles"])) {
              this.policyRoles = [] as any;
              for (let item of _data["policyRoles"])
                  this.policyRoles!.push(PolicyRoleDto.fromJS(item));
          }
          if (Array.isArray(_data["policyFunds"])) {
              this.policyFunds = [] as any;
              for (let item of _data["policyFunds"])
                  this.policyFunds!.push(PolicyFundDto.fromJS(item));
          }
      }
  }

  static fromJS(data: any): UpdatePensionCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdatePensionCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["policyOwner"] = this.policyOwner;
      data["statusId"] = this.statusId;
      data["categoryId"] = this.categoryId;
      data["subCategoryId"] = this.subCategoryId;
      data["description"] = this.description;
      data["providerId"] = this.providerId;
      data["paymentFrequencyId"] = this.paymentFrequencyId;
      data["policyBasisId"] = this.policyBasisId;
      data["isAgencyPolicy"] = this.isAgencyPolicy;
      data["agencyNumber"] = this.agencyNumber;
      data["totalPremiumsPaid"] = this.totalPremiumsPaid;
      data["policyNo"] = this.policyNo;
      data["premium"] = this.premium;
      data["inceptionDate"] = this.inceptionDate;
      data["maturityDate"] = this.maturityDate;
      data["fundValueDate"] = this.fundValueDate;
      data["indexedId"] = this.indexedId;
      data["convertibleId"] = this.convertibleId;
      data["nra"] = this.nra;
      if (Array.isArray(this.policyRoles)) {
          data["policyRoles"] = [];
          for (let item of this.policyRoles)
              data["policyRoles"].push(item.toJSON());
      }
      if (Array.isArray(this.policyFunds)) {
          data["policyFunds"] = [];
          for (let item of this.policyFunds)
              data["policyFunds"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IUpdatePensionCommand extends I_FactFindUpdateCommandBase {
  policyOwner: ClientSelector;
  statusId: number | undefined;
  categoryId: number | undefined;
  subCategoryId: number | undefined;
  description: string | undefined;
  providerId: number | undefined;
  paymentFrequencyId: number | undefined;
  policyBasisId: number | undefined;
  isAgencyPolicy: boolean;
  agencyNumber: string | undefined;
  totalPremiumsPaid: number;
  policyNo: string | undefined;
  premium: number | undefined;
  inceptionDate: string | undefined;
  maturityDate: string | undefined;
  fundValueDate: string | undefined;
  indexedId: number | undefined;
  convertibleId: number | undefined;
  nra: number;
  policyRoles: IPolicyRoleDto[] | undefined;
  policyFunds: IPolicyFundDto[] | undefined;
}

export class CreatePolicyCommand extends _FactFindCreateCommandBase implements ICreatePolicyCommand {
  policyOwner!: ClientSelector;
  statusId!: number | undefined;
  categoryId!: number | undefined;
  subCategoryId!: number | undefined;
  description!: string | undefined;
  providerId!: number | undefined;
  paymentFrequencyId!: number | undefined;
  policyBasisId!: number | undefined;
  isAgencyPolicy!: boolean;
  policyNo!: string | undefined;
  premium!: number | undefined;
  inceptionDate!: string | undefined;
  maturityDate!: string | undefined;
  fundValueDate!: string | undefined;
  indexedId!: number | undefined;
  convertibleId!: number | undefined;
  policyRoles!: PolicyRoleDto[] | undefined;
  policyFunds!: PolicyFundDto[] | undefined;
  benefits!: PolicyBenefitDto[] | undefined;

  constructor(data?: ICreatePolicyCommand) {
      super(data);
      if (data) {
          if (data.policyRoles) {
              this.policyRoles = [];
              for (let i = 0; i < data.policyRoles.length; i++) {
                  let item = data.policyRoles[i];
                  this.policyRoles[i] = item && !(<any>item).toJSON ? new PolicyRoleDto(item) : <PolicyRoleDto>item;
              }
          }
          if (data.policyFunds) {
              this.policyFunds = [];
              for (let i = 0; i < data.policyFunds.length; i++) {
                  let item = data.policyFunds[i];
                  this.policyFunds[i] = item && !(<any>item).toJSON ? new PolicyFundDto(item) : <PolicyFundDto>item;
              }
          }
          if (data.benefits) {
              this.benefits = [];
              for (let i = 0; i < data.benefits.length; i++) {
                  let item = data.benefits[i];
                  this.benefits[i] = item && !(<any>item).toJSON ? new PolicyBenefitDto(item) : <PolicyBenefitDto>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.policyOwner = _data["policyOwner"];
          this.statusId = _data["statusId"];
          this.categoryId = _data["categoryId"];
          this.subCategoryId = _data["subCategoryId"];
          this.description = _data["description"];
          this.providerId = _data["providerId"];
          this.paymentFrequencyId = _data["paymentFrequencyId"];
          this.policyBasisId = _data["policyBasisId"];
          this.isAgencyPolicy = _data["isAgencyPolicy"];
          this.policyNo = _data["policyNo"];
          this.premium = _data["premium"];
          this.inceptionDate = _data["inceptionDate"];
          this.maturityDate = _data["maturityDate"];
          this.fundValueDate = _data["fundValueDate"];
          this.indexedId = _data["indexedId"];
          this.convertibleId = _data["convertibleId"];
          if (Array.isArray(_data["policyRoles"])) {
              this.policyRoles = [] as any;
              for (let item of _data["policyRoles"])
                  this.policyRoles!.push(PolicyRoleDto.fromJS(item));
          }
          if (Array.isArray(_data["policyFunds"])) {
              this.policyFunds = [] as any;
              for (let item of _data["policyFunds"])
                  this.policyFunds!.push(PolicyFundDto.fromJS(item));
          }
          if (Array.isArray(_data["benefits"])) {
              this.benefits = [] as any;
              for (let item of _data["benefits"])
                  this.benefits!.push(PolicyBenefitDto.fromJS(item));
          }
      }
  }

  static fromJS(data: any): CreatePolicyCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreatePolicyCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["policyOwner"] = this.policyOwner;
      data["statusId"] = this.statusId;
      data["categoryId"] = this.categoryId;
      data["subCategoryId"] = this.subCategoryId;
      data["description"] = this.description;
      data["providerId"] = this.providerId;
      data["paymentFrequencyId"] = this.paymentFrequencyId;
      data["policyBasisId"] = this.policyBasisId;
      data["isAgencyPolicy"] = this.isAgencyPolicy;
      data["policyNo"] = this.policyNo;
      data["premium"] = this.premium;
      data["inceptionDate"] = this.inceptionDate;
      data["maturityDate"] = this.maturityDate;
      data["fundValueDate"] = this.fundValueDate;
      data["indexedId"] = this.indexedId;
      data["convertibleId"] = this.convertibleId;
      if (Array.isArray(this.policyRoles)) {
          data["policyRoles"] = [];
          for (let item of this.policyRoles)
              data["policyRoles"].push(item.toJSON());
      }
      if (Array.isArray(this.policyFunds)) {
          data["policyFunds"] = [];
          for (let item of this.policyFunds)
              data["policyFunds"].push(item.toJSON());
      }
      if (Array.isArray(this.benefits)) {
          data["benefits"] = [];
          for (let item of this.benefits)
              data["benefits"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface ICreatePolicyCommand extends I_FactFindCreateCommandBase {
  policyOwner: ClientSelector;
  statusId: number | undefined;
  categoryId: number | undefined;
  subCategoryId: number | undefined;
  description: string | undefined;
  providerId: number | undefined;
  paymentFrequencyId: number | undefined;
  policyBasisId: number | undefined;
  isAgencyPolicy: boolean;
  policyNo: string | undefined;
  premium: number | undefined;
  inceptionDate: string | undefined;
  maturityDate: string | undefined;
  fundValueDate: string | undefined;
  indexedId: number | undefined;
  convertibleId: number | undefined;
  policyRoles: IPolicyRoleDto[] | undefined;
  policyFunds: IPolicyFundDto[] | undefined;
  benefits: IPolicyBenefitDto[] | undefined;
}

export class UpdatePolicyCommand extends _FactFindUpdateCommandBase implements IUpdatePolicyCommand {
  policyOwner!: ClientSelector;
  statusId!: number | undefined;
  categoryId!: number | undefined;
  subCategoryId!: number | undefined;
  description!: string | undefined;
  providerId!: number | undefined;
  paymentFrequencyId!: number | undefined;
  policyBasisId!: number | undefined;
  isAgencyPolicy!: boolean;
  policyNo!: string | undefined;
  premium!: number | undefined;
  inceptionDate!: string | undefined;
  maturityDate!: string | undefined;
  fundValueDate!: string | undefined;
  indexedId!: number | undefined;
  convertibleId!: number | undefined;
  policyRoles!: PolicyRoleDto[] | undefined;
  policyFunds!: PolicyFundDto[] | undefined;
  benefits!: PolicyBenefitDto[] | undefined;

  constructor(data?: IUpdatePolicyCommand) {
      super(data);
      if (data) {
          if (data.policyRoles) {
              this.policyRoles = [];
              for (let i = 0; i < data.policyRoles.length; i++) {
                  let item = data.policyRoles[i];
                  this.policyRoles[i] = item && !(<any>item).toJSON ? new PolicyRoleDto(item) : <PolicyRoleDto>item;
              }
          }
          if (data.policyFunds) {
              this.policyFunds = [];
              for (let i = 0; i < data.policyFunds.length; i++) {
                  let item = data.policyFunds[i];
                  this.policyFunds[i] = item && !(<any>item).toJSON ? new PolicyFundDto(item) : <PolicyFundDto>item;
              }
          }
          if (data.benefits) {
              this.benefits = [];
              for (let i = 0; i < data.benefits.length; i++) {
                  let item = data.benefits[i];
                  this.benefits[i] = item && !(<any>item).toJSON ? new PolicyBenefitDto(item) : <PolicyBenefitDto>item;
              }
          }
      }
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.policyOwner = _data["policyOwner"];
          this.statusId = _data["statusId"];
          this.categoryId = _data["categoryId"];
          this.subCategoryId = _data["subCategoryId"];
          this.description = _data["description"];
          this.providerId = _data["providerId"];
          this.paymentFrequencyId = _data["paymentFrequencyId"];
          this.policyBasisId = _data["policyBasisId"];
          this.isAgencyPolicy = _data["isAgencyPolicy"];
          this.policyNo = _data["policyNo"];
          this.premium = _data["premium"];
          this.inceptionDate = _data["inceptionDate"];
          this.maturityDate = _data["maturityDate"];
          this.fundValueDate = _data["fundValueDate"];
          this.indexedId = _data["indexedId"];
          this.convertibleId = _data["convertibleId"];
          if (Array.isArray(_data["policyRoles"])) {
              this.policyRoles = [] as any;
              for (let item of _data["policyRoles"])
                  this.policyRoles!.push(PolicyRoleDto.fromJS(item));
          }
          if (Array.isArray(_data["policyFunds"])) {
              this.policyFunds = [] as any;
              for (let item of _data["policyFunds"])
                  this.policyFunds!.push(PolicyFundDto.fromJS(item));
          }
          if (Array.isArray(_data["benefits"])) {
              this.benefits = [] as any;
              for (let item of _data["benefits"])
                  this.benefits!.push(PolicyBenefitDto.fromJS(item));
          }
      }
  }

  static fromJS(data: any): UpdatePolicyCommand {
      data = typeof data === 'object' ? data : {};
      let result = new UpdatePolicyCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["policyOwner"] = this.policyOwner;
      data["statusId"] = this.statusId;
      data["categoryId"] = this.categoryId;
      data["subCategoryId"] = this.subCategoryId;
      data["description"] = this.description;
      data["providerId"] = this.providerId;
      data["paymentFrequencyId"] = this.paymentFrequencyId;
      data["policyBasisId"] = this.policyBasisId;
      data["isAgencyPolicy"] = this.isAgencyPolicy;
      data["policyNo"] = this.policyNo;
      data["premium"] = this.premium;
      data["inceptionDate"] = this.inceptionDate;
      data["maturityDate"] = this.maturityDate;
      data["fundValueDate"] = this.fundValueDate;
      data["indexedId"] = this.indexedId;
      data["convertibleId"] = this.convertibleId;
      if (Array.isArray(this.policyRoles)) {
          data["policyRoles"] = [];
          for (let item of this.policyRoles)
              data["policyRoles"].push(item.toJSON());
      }
      if (Array.isArray(this.policyFunds)) {
          data["policyFunds"] = [];
          for (let item of this.policyFunds)
              data["policyFunds"].push(item.toJSON());
      }
      if (Array.isArray(this.benefits)) {
          data["benefits"] = [];
          for (let item of this.benefits)
              data["benefits"].push(item.toJSON());
      }
      super.toJSON(data);
      return data;
  }
}

export interface IUpdatePolicyCommand extends I_FactFindUpdateCommandBase {
  policyOwner: ClientSelector;
  statusId: number | undefined;
  categoryId: number | undefined;
  subCategoryId: number | undefined;
  description: string | undefined;
  providerId: number | undefined;
  paymentFrequencyId: number | undefined;
  policyBasisId: number | undefined;
  isAgencyPolicy: boolean;
  policyNo: string | undefined;
  premium: number | undefined;
  inceptionDate: string | undefined;
  maturityDate: string | undefined;
  fundValueDate: string | undefined;
  indexedId: number | undefined;
  convertibleId: number | undefined;
  policyRoles: IPolicyRoleDto[] | undefined;
  policyFunds: IPolicyFundDto[] | undefined;
  benefits: IPolicyBenefitDto[] | undefined;
}

export class CreateFactFindRequestCommand extends _BaseRequest implements ICreateFactFindRequestCommand {
  userId!: string | undefined;
  contactId!: number;
  contactOwnerId!: number;
  contactEmail!: string | undefined;
  password!: string | undefined;
  clientSelector!: number;
  requiresPortalAccount!: boolean;

  constructor(data?: ICreateFactFindRequestCommand) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.userId = _data["userId"];
          this.contactId = _data["contactId"];
          this.contactOwnerId = _data["contactOwnerId"];
          this.contactEmail = _data["contactEmail"];
          this.password = _data["password"];
          this.clientSelector = _data["clientSelector"];
          this.requiresPortalAccount = _data["requiresPortalAccount"];
      }
  }

  static fromJS(data: any): CreateFactFindRequestCommand {
      data = typeof data === 'object' ? data : {};
      let result = new CreateFactFindRequestCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["userId"] = this.userId;
      data["contactId"] = this.contactId;
      data["contactOwnerId"] = this.contactOwnerId;
      data["contactEmail"] = this.contactEmail;
      data["password"] = this.password;
      data["clientSelector"] = this.clientSelector;
      data["requiresPortalAccount"] = this.requiresPortalAccount;
      super.toJSON(data);
      return data;
  }
}

export interface ICreateFactFindRequestCommand extends I_BaseRequest {
  userId: string | undefined;
  contactId: number;
  contactOwnerId: number;
  contactEmail: string | undefined;
  password: string | undefined;
  clientSelector: number;
  requiresPortalAccount: boolean;
}

export class FactFindRequestDto implements IFactFindRequestDto {
  id!: number;
  contactOwnerId!: number;
  dateCreated!: string;
  dateCompleted!: string | undefined;

  constructor(data?: IFactFindRequestDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.contactOwnerId = _data["contactOwnerId"];
          this.dateCreated = _data["dateCreated"];
          this.dateCompleted = _data["dateCompleted"];
      }
  }

  static fromJS(data: any): FactFindRequestDto {
      data = typeof data === 'object' ? data : {};
      let result = new FactFindRequestDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["contactOwnerId"] = this.contactOwnerId;
      data["dateCreated"] = this.dateCreated;
      data["dateCompleted"] = this.dateCompleted;
      return data;
  }
}

export interface IFactFindRequestDto {
  id: number;
  contactOwnerId: number;
  dateCreated: string;
  dateCompleted: string | undefined;
}

export abstract class _BaseRequestOfFactFindRequestDto implements I_BaseRequestOfFactFindRequestDto {

  constructor(data?: I_BaseRequestOfFactFindRequestDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
  }

  static fromJS(data: any): _BaseRequestOfFactFindRequestDto {
      data = typeof data === 'object' ? data : {};
      throw new Error("The abstract class '_BaseRequestOfFactFindRequestDto' cannot be instantiated.");
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
  }
}

export interface I_BaseRequestOfFactFindRequestDto {
}

export class FindFactFindRequestByContactQuery extends _BaseRequestOfFactFindRequestDto implements IFindFactFindRequestByContactQuery {
  userId!: string | undefined;
  contactId!: number;

  constructor(data?: IFindFactFindRequestByContactQuery) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.userId = _data["userId"];
          this.contactId = _data["contactId"];
      }
  }

  static fromJS(data: any): FindFactFindRequestByContactQuery {
      data = typeof data === 'object' ? data : {};
      let result = new FindFactFindRequestByContactQuery();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["userId"] = this.userId;
      data["contactId"] = this.contactId;
      super.toJSON(data);
      return data;
  }
}

export interface IFindFactFindRequestByContactQuery extends I_BaseRequestOfFactFindRequestDto {
  userId: string | undefined;
  contactId: number;
}

export abstract class _BaseRequestOfICollectionOfFactFindRequestDto implements I_BaseRequestOfICollectionOfFactFindRequestDto {

  constructor(data?: I_BaseRequestOfICollectionOfFactFindRequestDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
  }

  static fromJS(data: any): _BaseRequestOfICollectionOfFactFindRequestDto {
      data = typeof data === 'object' ? data : {};
      throw new Error("The abstract class '_BaseRequestOfICollectionOfFactFindRequestDto' cannot be instantiated.");
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      return data;
  }
}

export interface I_BaseRequestOfICollectionOfFactFindRequestDto {
}

export class FindAllFactFindRequestsByOwnerQuery extends _BaseRequestOfICollectionOfFactFindRequestDto implements IFindAllFactFindRequestsByOwnerQuery {
  userId!: string | undefined;
  contactOwnerId!: number;

  constructor(data?: IFindAllFactFindRequestsByOwnerQuery) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.userId = _data["userId"];
          this.contactOwnerId = _data["contactOwnerId"];
      }
  }

  static fromJS(data: any): FindAllFactFindRequestsByOwnerQuery {
      data = typeof data === 'object' ? data : {};
      let result = new FindAllFactFindRequestsByOwnerQuery();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["userId"] = this.userId;
      data["contactOwnerId"] = this.contactOwnerId;
      super.toJSON(data);
      return data;
  }
}

export interface IFindAllFactFindRequestsByOwnerQuery extends I_BaseRequestOfICollectionOfFactFindRequestDto {
  userId: string | undefined;
  contactOwnerId: number;
}

export class FindFactFindRequestByOwnerAndContactQuery extends _BaseRequestOfFactFindRequestDto implements IFindFactFindRequestByOwnerAndContactQuery {
  userId!: string | undefined;
  contactId!: number;
  contactOwnerId!: number;

  constructor(data?: IFindFactFindRequestByOwnerAndContactQuery) {
      super(data);
  }

  init(_data?: any) {
      super.init(_data);
      if (_data) {
          this.userId = _data["userId"];
          this.contactId = _data["contactId"];
          this.contactOwnerId = _data["contactOwnerId"];
      }
  }

  static fromJS(data: any): FindFactFindRequestByOwnerAndContactQuery {
      data = typeof data === 'object' ? data : {};
      let result = new FindFactFindRequestByOwnerAndContactQuery();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["userId"] = this.userId;
      data["contactId"] = this.contactId;
      data["contactOwnerId"] = this.contactOwnerId;
      super.toJSON(data);
      return data;
  }
}

export interface IFindFactFindRequestByOwnerAndContactQuery extends I_BaseRequestOfFactFindRequestDto {
  userId: string | undefined;
  contactId: number;
  contactOwnerId: number;
}

export class BrokerDetailsDto implements IBrokerDetailsDto {
  name!: string | undefined;
  agencyCode!: string | undefined;

  constructor(data?: IBrokerDetailsDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.name = _data["name"];
          this.agencyCode = _data["agencyCode"];
      }
  }

  static fromJS(data: any): BrokerDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new BrokerDetailsDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["name"] = this.name;
      data["agencyCode"] = this.agencyCode;
      return data;
  }
}

export interface IBrokerDetailsDto {
  name: string | undefined;
  agencyCode: string | undefined;
}

export class ClientListRowDto implements IClientListRowDto {
  id!: number;
  firstName!: string | undefined;
  lastName!: string | undefined;
  dateOfBirth!: string;
  addressLine_1!: string | undefined;
  status!: string | undefined;

  constructor(data?: IClientListRowDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          this.dateOfBirth = _data["dateOfBirth"];
          this.addressLine_1 = _data["addressLine_1"];
          this.status = _data["status"];
      }
  }

  static fromJS(data: any): ClientListRowDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientListRowDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      data["dateOfBirth"] = this.dateOfBirth;
      data["addressLine_1"] = this.addressLine_1;
      data["status"] = this.status;
      return data;
  }
}

export interface IClientListRowDto {
  id: number;
  firstName: string | undefined;
  lastName: string | undefined;
  dateOfBirth: string;
  addressLine_1: string | undefined;
  status: string | undefined;
}

export class PolicyTransacionExportDto implements IPolicyTransacionExportDto {
  fileName!: string | undefined;
  contentType!: string | undefined;
  data!: string | undefined;

  constructor(data?: IPolicyTransacionExportDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.fileName = _data["fileName"];
          this.contentType = _data["contentType"];
          this.data = _data["data"];
      }
  }

  static fromJS(data: any): PolicyTransacionExportDto {
      data = typeof data === 'object' ? data : {};
      let result = new PolicyTransacionExportDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["fileName"] = this.fileName;
      data["contentType"] = this.contentType;
      data["data"] = this.data;
      return data;
  }
}

export interface IPolicyTransacionExportDto {
  fileName: string | undefined;
  contentType: string | undefined;
  data: string | undefined;
}

export class CompanyDto implements ICompanyDto {
  id!: number;
  name!: string | undefined;
  logo!: string | undefined;

  constructor(data?: ICompanyDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"];
          this.name = _data["name"];
          this.logo = _data["logo"];
      }
  }

  static fromJS(data: any): CompanyDto {
      data = typeof data === 'object' ? data : {};
      let result = new CompanyDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id;
      data["name"] = this.name;
      data["logo"] = this.logo;
      return data;
  }
}

export interface ICompanyDto {
  id: number;
  name: string | undefined;
  logo: string | undefined;
}

export class CompanyDetailsDto implements ICompanyDetailsDto {
  name!: string | undefined;
  logo!: string | undefined;
  databaseId!: number | undefined;

  constructor(data?: ICompanyDetailsDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.name = _data["name"];
          this.logo = _data["logo"];
          this.databaseId = _data["databaseId"];
      }
  }

  static fromJS(data: any): CompanyDetailsDto {
      data = typeof data === 'object' ? data : {};
      let result = new CompanyDetailsDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["name"] = this.name;
      data["logo"] = this.logo;
      data["databaseId"] = this.databaseId;
      return data;
  }
}

export interface ICompanyDetailsDto {
  name: string | undefined;
  logo: string | undefined;
  databaseId: number | undefined;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
      super();

      this.message = message;
      this.status = status;
      this.response = response;
      this.headers = headers;
      this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
      return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
  if (result !== null && result !== undefined)
      throw result;
  else
      throw new ApiException(message, status, response, headers, null);
}